//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class Client {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Insert new pe plant for current user, returns plant id (Auth)
     * @param body (optional) 
     * @return Entrance Plant successfully added
     */
    entranceplantPOST(body: EntrancePlantStructureCreateDTO | undefined, cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/entranceplant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEntranceplantPOST(_response);
        });
    }

    protected processEntranceplantPOST(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return Promise.resolve<number>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Get a plant for current user. If lastupdate is provided returns 204 if no updates are found (Auth)
     * @param lastupdate (optional) 
     * @return Plant
     */
    entranceplantGET(plantdesktopid: number, lastupdate: Date | undefined, cancelToken?: CancelToken | undefined): Promise<EntrancePlantDetailDTO> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}?";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (lastupdate === null)
            throw new Error("The parameter 'lastupdate' cannot be null.");
        else if (lastupdate !== undefined)
            url_ += "lastupdate=" + encodeURIComponent(lastupdate ? "" + lastupdate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEntranceplantGET(_response);
        });
    }

    protected processEntranceplantGET(response: AxiosResponse): Promise<EntrancePlantDetailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntrancePlantDetailDTO.fromJS(resultData200);
            return Promise.resolve<EntrancePlantDetailDTO>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            let result204: any = null;
            let resultData204  = _responseText;
            result204 = EntrancePlantDetailDTO.fromJS(resultData204);
            return Promise.resolve<EntrancePlantDetailDTO>(result204);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntrancePlantDetailDTO>(null as any);
    }

    /**
     * Delete apartment for current user (Auth)
     * @param body (optional) 
     * @return Apartment successfully deleted
     */
    apartmentDELETE(plantdesktopid: number, body: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/apartment";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApartmentDELETE(_response);
        });
    }

    protected processApartmentDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add apartments for current user (Auth)
     * @param body (optional) 
     * @return Apartments successfully added
     */
    apartmentAll(plantdesktopid: number, body: EntrancePlantStructureCreateDTO | undefined, cancelToken?: CancelToken | undefined): Promise<ApartmentDTO[]> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/apartment";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApartmentAll(_response);
        });
    }

    protected processApartmentAll(response: AxiosResponse): Promise<ApartmentDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item of resultData201)
                    result201!.push(ApartmentDTO.fromJS(item));
            }
            else {
                result201 = <any>null;
            }
            return Promise.resolve<ApartmentDTO[]>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApartmentDTO[]>(null as any);
    }

    /**
     * Edit apartment for current user (Auth)
     * @param body (optional) 
     * @return Apartment successfully updated
     */
    apartmentPUT(plantdesktopid: number, body: ApartmentDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/apartment";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApartmentPUT(_response);
        });
    }

    protected processApartmentPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add apartment label (Auth)
     * @param body (optional) 
     * @return Label successfully added
     */
    labelPOST(plantdesktopid: number, apartmentid: string, body: ApartmentLabelDTO | undefined, cancelToken?: CancelToken | undefined): Promise<ApartmentLabelDTO[]> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/apartment/{apartmentid}/label";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (apartmentid === undefined || apartmentid === null)
            throw new Error("The parameter 'apartmentid' must be defined.");
        url_ = url_.replace("{apartmentid}", encodeURIComponent("" + apartmentid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLabelPOST(_response);
        });
    }

    protected processLabelPOST(response: AxiosResponse): Promise<ApartmentLabelDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApartmentLabelDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ApartmentLabelDTO[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApartmentLabelDTO[]>(null as any);
    }

    /**
     * Edit apartment label (Auth)
     * @param body (optional) 
     * @return Label successfully updated
     */
    labelPUT(plantdesktopid: number, apartmentid: string, body: ApartmentLabelDTO | undefined, cancelToken?: CancelToken | undefined): Promise<ApartmentLabelDTO[]> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/apartment/{apartmentid}/label";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (apartmentid === undefined || apartmentid === null)
            throw new Error("The parameter 'apartmentid' must be defined.");
        url_ = url_.replace("{apartmentid}", encodeURIComponent("" + apartmentid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLabelPUT(_response);
        });
    }

    protected processLabelPUT(response: AxiosResponse): Promise<ApartmentLabelDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApartmentLabelDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ApartmentLabelDTO[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApartmentLabelDTO[]>(null as any);
    }

    /**
     * Delete apartment label (Auth)
     * @return Label successfully deleted
     */
    labelDELETE(plantdesktopid: number, apartmentid: string, labelid: string, cancelToken?: CancelToken | undefined): Promise<ApartmentLabelDTO[]> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/apartment/{apartmentid}/label/{labelid}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (apartmentid === undefined || apartmentid === null)
            throw new Error("The parameter 'apartmentid' must be defined.");
        url_ = url_.replace("{apartmentid}", encodeURIComponent("" + apartmentid));
        if (labelid === undefined || labelid === null)
            throw new Error("The parameter 'labelid' must be defined.");
        url_ = url_.replace("{labelid}", encodeURIComponent("" + labelid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLabelDELETE(_response);
        });
    }

    protected processLabelDELETE(response: AxiosResponse): Promise<ApartmentLabelDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApartmentLabelDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ApartmentLabelDTO[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApartmentLabelDTO[]>(null as any);
    }

    /**
     * Add apartment BRFA for current user (Auth)
     * @param body (optional) 
     * @return Apartment successfully added
     */
    apartmentbrfa(plantdesktopid: number, body: ApartmentDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/apartmentbrfa";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApartmentbrfa(_response);
        });
    }

    protected processApartmentbrfa(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add a backbone (Auth)
     * @param body (optional) 
     * @return Backbone successfully added
     */
    backbone(plantdesktopid: number, body: string | undefined, cancelToken?: CancelToken | undefined): Promise<PeInterfaceConfig> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/backbone";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBackbone(_response);
        });
    }

    protected processBackbone(response: AxiosResponse): Promise<PeInterfaceConfig> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = PeInterfaceConfig.fromJS(resultData201);
            return Promise.resolve<PeInterfaceConfig>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PeInterfaceConfig>(null as any);
    }

    /**
     * Delete badge for current user (Auth)
     * @param body (optional) 
     * @return Badge successfully deleted
     */
    badgeDELETE(plantdesktopid: number, body: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/badge";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBadgeDELETE(_response);
        });
    }

    protected processBadgeDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get badges for current user (Auth)
     * @return Badges
     */
    badgeAll(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<BadgeDTO[]> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/badge";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBadgeAll(_response);
        });
    }

    protected processBadgeAll(response: AxiosResponse): Promise<BadgeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BadgeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BadgeDTO[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BadgeDTO[]>(null as any);
    }

    /**
     * Insert new badge for current user (Auth)
     * @param body (optional) 
     * @return Badge successfully added
     */
    badgePOST(plantdesktopid: number, body: BadgeDTO[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/badge";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBadgePOST(_response);
        });
    }

    protected processBadgePOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get informations for calling code example (Auth)
     * @return Informations for calling code example
     */
    callingcoderecap(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<CallingCodeDTO> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/callingcoderecap";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCallingcoderecap(_response);
        });
    }

    protected processCallingcoderecap(response: AxiosResponse): Promise<CallingCodeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CallingCodeDTO.fromJS(resultData200);
            return Promise.resolve<CallingCodeDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallingCodeDTO>(null as any);
    }

    /**
     * Get csv for selected plant (Auth)
     * @return Returns CSV file
     */
    csv(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/csv";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCsv(_response);
        });
    }

    protected processCsv(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Edit plant info (Auth)
     * @param body (optional) 
     * @return Plant info succesfully edited
     */
    editinfo(plantdesktopid: number, body: EntrancePlantInfoCreateDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/editinfo";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditinfo(_response);
        });
    }

    protected processEditinfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Edit floor for current user (Auth)
     * @param body (optional) 
     * @return Floor successfully updated
     */
    floor(plantdesktopid: number, body: FloorDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/floor";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFloor(_response);
        });
    }

    protected processFloor(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete the gate (Auth)
     * @param body (optional) 
     * @return Delete selected gate
     */
    gateDELETE(plantdesktopid: number, body: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/gate";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGateDELETE(_response);
        });
    }

    protected processGateDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * create new gate (Auth)
     * @param body (optional) 
     * @return Gate successfully added
     */
    gatePOST(plantdesktopid: number, body: GateConfigDTO | undefined, cancelToken?: CancelToken | undefined): Promise<GateDTO> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/gate";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGatePOST(_response);
        });
    }

    protected processGatePOST(response: AxiosResponse): Promise<GateDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = GateDTO.fromJS(resultData201);
            return Promise.resolve<GateDTO>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GateDTO>(null as any);
    }

    /**
     * Update the gate (Auth)
     * @param body (optional) 
     * @return Updated selected gate
     */
    gatePUT(plantdesktopid: number, body: { [key: string]: GateConfigDTO; } | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/gate";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGatePUT(_response);
        });
    }

    protected processGatePUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete gate message (Auth)
     * @param body (optional) 
     * @return Gate message successfully deleted
     */
    gatemessageDELETE(plantdesktopid: number, body: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/gatemessage";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGatemessageDELETE(_response);
        });
    }

    protected processGatemessageDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add gate message (Auth)
     * @param body (optional) 
     * @return Gate message successfully added
     */
    gatemessagePOST(plantdesktopid: number, body: GateMessageDTO | undefined, cancelToken?: CancelToken | undefined): Promise<GateMessageDTO> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/gatemessage";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGatemessagePOST(_response);
        });
    }

    protected processGatemessagePOST(response: AxiosResponse): Promise<GateMessageDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = GateMessageDTO.fromJS(resultData201);
            return Promise.resolve<GateMessageDTO>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GateMessageDTO>(null as any);
    }

    /**
     * Edit gate message (Auth)
     * @param body (optional) 
     * @return Gate message successfully edited
     */
    gatemessagePUT(plantdesktopid: number, body: GateMessageDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/gatemessage";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGatemessagePUT(_response);
        });
    }

    protected processGatemessagePUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete guest for current user (Auth)
     * @param body (optional) 
     * @return guest successfully deleted
     */
    guestDELETE(plantdesktopid: number, body: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/guest";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGuestDELETE(_response);
        });
    }

    protected processGuestDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Insert new guest for current user, returns guest id (Auth)
     * @param body (optional) 
     * @return guest successfully added
     */
    guestPOST(plantdesktopid: number, body: GateGuestDTO | undefined, cancelToken?: CancelToken | undefined): Promise<GateGuestDTO> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/guest";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGuestPOST(_response);
        });
    }

    protected processGuestPOST(response: AxiosResponse): Promise<GateGuestDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = GateGuestDTO.fromJS(resultData201);
            return Promise.resolve<GateGuestDTO>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GateGuestDTO>(null as any);
    }

    /**
     * Edit guest for current user (Auth)
     * @param body (optional) 
     * @return guest successfully updated
     */
    guestPUT(plantdesktopid: number, body: GateGuestDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/guest";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGuestPUT(_response);
        });
    }

    protected processGuestPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get csv for massive invitation (Auth)
     * @return Returns CSV file
     */
    invitationCsv(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/invitation-csv";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvitationCsv(_response);
        });
    }

    protected processInvitationCsv(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Massive invite residents to their apartment (Auth)
     * @param body (optional) 
     * @return Invitations sent
     */
    massiveinvitation(plantdesktopid: number, body: ApartmentInvitationDTO[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/massiveinvitation";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassiveinvitation(_response);
        });
    }

    protected processMassiveinvitation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Remove resident invite (Auth)
     * @param body (optional) 
     * @return Invitation removed
     */
    residentinvitationDELETE(plantdesktopid: number, body: ApartmentInvitationDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/residentinvitation";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResidentinvitationDELETE(_response);
        });
    }

    protected processResidentinvitationDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Invite resident to their apartment (Auth)
     * @param body (optional) 
     * @return Invitation sent
     */
    residentinvitationPOST(plantdesktopid: number, body: ApartmentInvitationDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/residentinvitation";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResidentinvitationPOST(_response);
        });
    }

    protected processResidentinvitationPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Edit entrance plant residents (Auth)
     * @param body (optional) 
     * @return Entrance Plant successfully updated
     */
    residents(plantdesktopid: number, body: EntrancePlantDetailDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/residents";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResidents(_response);
        });
    }

    protected processResidents(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Import Labels (Auth)
     * @param body (optional) 
     * @return import labels from csv
     */
    import(plantdesktopid: number, body: BuildingImportDto | undefined, cancelToken?: CancelToken | undefined): Promise<CallingCodeDTO> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/residents/import";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<CallingCodeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CallingCodeDTO.fromJS(resultData200);
            return Promise.resolve<CallingCodeDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallingCodeDTO>(null as any);
    }

    /**
     * Delete riser (Auth)
     * @param body (optional) 
     * @return Riser successfully deleted
     */
    riserDELETE(plantdesktopid: number, body: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/riser";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRiserDELETE(_response);
        });
    }

    protected processRiserDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add risers (Auth)
     * @param body (optional) 
     * @return Risers successfully added
     */
    riserAll(plantdesktopid: number, body: PeRiserConfig[] | undefined, cancelToken?: CancelToken | undefined): Promise<PeRiserConfig[]> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/riser";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRiserAll(_response);
        });
    }

    protected processRiserAll(response: AxiosResponse): Promise<PeRiserConfig[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item of resultData201)
                    result201!.push(PeRiserConfig.fromJS(item));
            }
            else {
                result201 = <any>null;
            }
            return Promise.resolve<PeRiserConfig[]>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PeRiserConfig[]>(null as any);
    }

    /**
     * Edit riser (Auth)
     * @param body (optional) 
     * @return Riser successfully edited
     */
    riserPUT(plantdesktopid: number, body: RiserDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/riser";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRiserPUT(_response);
        });
    }

    protected processRiserPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Edit floor distribution for a riser (Auth) (Auth)
     * @param body (optional) 
     * @return Riser floors successfully updated
     */
    riserfloors(plantdesktopid: number, body: FloorConfigDTO[] | undefined, cancelToken?: CancelToken | undefined): Promise<BuildingDTO> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/riserfloors";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRiserfloors(_response);
        });
    }

    protected processRiserfloors(response: AxiosResponse): Promise<BuildingDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BuildingDTO.fromJS(resultData200);
            return Promise.resolve<BuildingDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BuildingDTO>(null as any);
    }

    /**
     * Edit riser and interfaces (Auth)
     * @param body (optional) 
     * @return Riser and interfaces successfully edited
     */
    riserinterfaces(plantdesktopid: number, body: PeInterfaceConfig[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/riserinterfaces";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRiserinterfaces(_response);
        });
    }

    protected processRiserinterfaces(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Un-share a plant to a user (Auth)
     * @param body (optional) 
     * @return Un-shared
     */
    sharingproDELETE(plantdesktopid: number, body: EpUserRole | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/sharingpro";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSharingproDELETE(_response);
        });
    }

    protected processSharingproDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Share a plant with a user and give role (Auth)
     * @param accept_Language (optional) 
     * @param body (optional) 
     * @return Shared
     */
    sharingproPOST(plantdesktopid: number, accept_Language: string | undefined, body: EpUserRole | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/sharingpro";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSharingproPOST(_response);
        });
    }

    protected processSharingproPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Revoke role of a plant user (Auth)
     * @param body (optional) 
     * @return Role revoked
     */
    sharingproPUT(plantdesktopid: number, body: EpUserRole | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/sharingpro";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSharingproPUT(_response);
        });
    }

    protected processSharingproPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Edit entrance plant for current user (Auth)
     * @param body (optional) 
     * @return Entrance Plant successfully updated
     */
    structure(plantdesktopid: number, body: EntrancePlantStructureCreateDTO | undefined, cancelToken?: CancelToken | undefined): Promise<EntrancePlantStructureCreateDTO> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/structure";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStructure(_response);
        });
    }

    protected processStructure(response: AxiosResponse): Promise<EntrancePlantStructureCreateDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EntrancePlantStructureCreateDTO.fromJS(resultData200);
            return Promise.resolve<EntrancePlantStructureCreateDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntrancePlantStructureCreateDTO>(null as any);
    }

    /**
     * Delete switchboard for current user (Auth)
     * @param body (optional) 
     * @return Switchboard successfully deleted
     */
    switchboardDELETE(plantdesktopid: number, body: SwitchboardDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/switchboard";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSwitchboardDELETE(_response);
        });
    }

    protected processSwitchboardDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Insert new switchboard for current user, returns switchboard id (Auth)
     * @param body (optional) 
     * @return Switchboard successfully added
     */
    switchboardPOST(plantdesktopid: number, body: SwitchboardConfigDTO | undefined, cancelToken?: CancelToken | undefined): Promise<SwitchboardDTO> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/switchboard";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSwitchboardPOST(_response);
        });
    }

    protected processSwitchboardPOST(response: AxiosResponse): Promise<SwitchboardDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = SwitchboardDTO.fromJS(resultData201);
            return Promise.resolve<SwitchboardDTO>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwitchboardDTO>(null as any);
    }

    /**
     * Edit switchboard for current user (Auth)
     * @param body (optional) 
     * @return Switchboard successfully updated
     */
    switchboardPUT(plantdesktopid: number, body: SwitchboardConfigDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/switchboard";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSwitchboardPUT(_response);
        });
    }

    protected processSwitchboardPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Sync plant (Auth)
     * @return Sync started
     */
    syncwitheliot(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<SyncInfo> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/syncwitheliot";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncwitheliot(_response);
        });
    }

    protected processSyncwitheliot(response: AxiosResponse): Promise<SyncInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SyncInfo.fromJS(resultData200);
            return Promise.resolve<SyncInfo>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SyncInfo>(null as any);
    }

    /**
     * Plant sync status (Auth)
     * @return Sync in progress
     */
    syncstatus(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<SyncInfo> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/syncwitheliot/syncstatus";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncstatus(_response);
        });
    }

    protected processSyncstatus(response: AxiosResponse): Promise<SyncInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SyncInfo.fromJS(resultData200);
            return Promise.resolve<SyncInfo>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SyncInfo>(null as any);
    }

    /**
     * Update virtual devices on Eliot (Auth)
     * @return Virtual devices updated
     */
    virtualdevices(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/syncwitheliot/virtualdevices";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVirtualdevices(_response);
        });
    }

    protected processVirtualdevices(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get users permissions for current entrance plant. (Auth)
     * @return Users role and permissions
     */
    userspermissions(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<EpUserRole[]> {
        let url_ = this.baseUrl + "/entranceplant/{plantdesktopid}/userspermissions";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserspermissions(_response);
        });
    }

    protected processUserspermissions(response: AxiosResponse): Promise<EpUserRole[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EpUserRole.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EpUserRole[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EpUserRole[]>(null as any);
    }

    /**
     * Get a random generated code (Auth)
     * @param length (optional) 
     * @return Random generated keypad code
     */
    randomkeypadcode(length: number | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/entranceplant/randomkeypadcode?";
        if (length === null)
            throw new Error("The parameter 'length' cannot be null.");
        else if (length !== undefined)
            url_ += "length=" + encodeURIComponent("" + length) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRandomkeypadcode(_response);
        });
    }

    protected processRandomkeypadcode(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Send devices log to graylog (Auth)
     * @param body (optional) 
     * @return Logs sent
     */
    sendlogs(body: GraylogEntrancePanelMessageDTO | undefined, cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/entranceplant/sendlogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendlogs(_response);
        });
    }

    protected processSendlogs(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Insert new plant for current user, returns plant id (Auth)
     * @param body (optional) 
     * @return Plant successfully added
     */
    plantPOST(body: PlantDTO | undefined, cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/plant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPlantPOST(_response);
        });
    }

    protected processPlantPOST(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return Promise.resolve<number>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Delete a plant (Auth)
     * @return Plant deleted
     */
    plantDELETE(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<PlantDetailDTO> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPlantDELETE(_response);
        });
    }

    protected processPlantDELETE(response: AxiosResponse): Promise<PlantDetailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlantDetailDTO.fromJS(resultData200);
            return Promise.resolve<PlantDetailDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlantDetailDTO>(null as any);
    }

    /**
     * Get a plant for current user. If lastupdate is provided returns 204 if no updates are found (Auth)
     * @param lastupdate (optional) 
     * @return Plant
     */
    plantGET(plantdesktopid: number, lastupdate: Date | undefined, cancelToken?: CancelToken | undefined): Promise<PlantDetailDTO> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}?";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (lastupdate === null)
            throw new Error("The parameter 'lastupdate' cannot be null.");
        else if (lastupdate !== undefined)
            url_ += "lastupdate=" + encodeURIComponent(lastupdate ? "" + lastupdate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPlantGET(_response);
        });
    }

    protected processPlantGET(response: AxiosResponse): Promise<PlantDetailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlantDetailDTO.fromJS(resultData200);
            return Promise.resolve<PlantDetailDTO>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            let result204: any = null;
            let resultData204  = _responseText;
            result204 = PlantDetailDTO.fromJS(resultData204);
            return Promise.resolve<PlantDetailDTO>(result204);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlantDetailDTO>(null as any);
    }

    /**
     * Edit a plant for current user (Auth)
     * @param body (optional) 
     * @return Plant successfully updated
     */
    plantPUT(plantdesktopid: number, body: PlantDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPlantPUT(_response);
        });
    }

    protected processPlantPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add fake plant devices (only for testing purpose) (Auth)
     * @return Fake devices added successfully
     */
    addFakeDevices(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/add-fake-devices";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddFakeDevices(_response);
        });
    }

    protected processAddFakeDevices(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 409) {
            const _responseText = response.data;
            return throwException("Plant has already some devices", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get plant general commands and groups (Auth)
     * @return List of aggregate commands
     */
    aggregateCommandsAll(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<AggregateCommandDTO[]> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/aggregate-commands";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAggregateCommandsAll(_response);
        });
    }

    protected processAggregateCommandsAll(response: AxiosResponse): Promise<AggregateCommandDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AggregateCommandDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AggregateCommandDTO[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AggregateCommandDTO[]>(null as any);
    }

    /**
     * Add a general command or group (Auth)
     * @param body (optional) 
     * @return AggregateCommandDTO
     */
    aggregateCommandsPOST(plantdesktopid: number, body: EditAggregateCommandDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/aggregate-commands";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAggregateCommandsPOST(_response);
        });
    }

    protected processAggregateCommandsPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some field are null, empty or invalid", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete a general command or group (Auth)
     * @return Aggregate command deleted
     */
    aggregateCommandsDELETE(plantdesktopid: number, commandid: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/aggregate-commands/{commandid}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (commandid === undefined || commandid === null)
            throw new Error("The parameter 'commandid' must be defined.");
        url_ = url_.replace("{commandid}", encodeURIComponent("" + commandid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAggregateCommandsDELETE(_response);
        });
    }

    protected processAggregateCommandsDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant or command doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get general command or group (Auth)
     * @return AggregateCommandDTO
     */
    aggregateCommandsGET(plantdesktopid: number, commandid: string, cancelToken?: CancelToken | undefined): Promise<AggregateCommandDTO> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/aggregate-commands/{commandid}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (commandid === undefined || commandid === null)
            throw new Error("The parameter 'commandid' must be defined.");
        url_ = url_.replace("{commandid}", encodeURIComponent("" + commandid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAggregateCommandsGET(_response);
        });
    }

    protected processAggregateCommandsGET(response: AxiosResponse): Promise<AggregateCommandDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AggregateCommandDTO.fromJS(resultData200);
            return Promise.resolve<AggregateCommandDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant or aggregate command doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AggregateCommandDTO>(null as any);
    }

    /**
     * Edit a general command or group (Auth)
     * @param body (optional) 
     * @return AggregateCommandDTO
     */
    aggregateCommandsPUT(plantdesktopid: number, commandid: string, body: EditAggregateCommandDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/aggregate-commands/{commandid}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (commandid === undefined || commandid === null)
            throw new Error("The parameter 'commandid' must be defined.");
        url_ = url_.replace("{commandid}", encodeURIComponent("" + commandid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAggregateCommandsPUT(_response);
        });
    }

    protected processAggregateCommandsPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some field are null, empty or invalid", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant or aggregate command doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get plant alarm system (Auth)
     * @return Plant alarm system
     */
    alarmsystem(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<PlantAlarmSystemDTO> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/alarmsystem";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAlarmsystem(_response);
        });
    }

    protected processAlarmsystem(response: AxiosResponse): Promise<PlantAlarmSystemDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlantAlarmSystemDTO.fromJS(resultData200);
            return Promise.resolve<PlantAlarmSystemDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlantAlarmSystemDTO>(null as any);
    }

    /**
     * Get plant devices (Auth)
     * @return List of plant devices
     */
    allDevices(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<DeviceDTO[]> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/all-devices";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAllDevices(_response);
        });
    }

    protected processAllDevices(response: AxiosResponse): Promise<DeviceDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DeviceDTO[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceDTO[]>(null as any);
    }

    /**
     * Get plant c300eos-settings (Auth)
     * @param lastupdate (optional) 
     * @return Plant mxserver
     */
    c300eosSettingsGET(plantdesktopid: number, lastupdate: Date | undefined, cancelToken?: CancelToken | undefined): Promise<PlantC300EOSSettingsDTO> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/c300eos-settings?";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (lastupdate === null)
            throw new Error("The parameter 'lastupdate' cannot be null.");
        else if (lastupdate !== undefined)
            url_ += "lastupdate=" + encodeURIComponent(lastupdate ? "" + lastupdate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processC300eosSettingsGET(_response);
        });
    }

    protected processC300eosSettingsGET(response: AxiosResponse): Promise<PlantC300EOSSettingsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlantC300EOSSettingsDTO.fromJS(resultData200);
            return Promise.resolve<PlantC300EOSSettingsDTO>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            let result204: any = null;
            let resultData204  = _responseText;
            result204 = PlantC300EOSSettingsDTO.fromJS(resultData204);
            return Promise.resolve<PlantC300EOSSettingsDTO>(result204);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlantC300EOSSettingsDTO>(null as any);
    }

    /**
     * Edit plant c300eos-settings (Auth)
     * @param body (optional) 
     * @return C300EOSSettings
     */
    c300eosSettingsPUT(plantdesktopid: number, body: PlantC300EOSSettingsDTO | undefined, cancelToken?: CancelToken | undefined): Promise<PlantC300EOSSettingsDTO> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/c300eos-settings";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processC300eosSettingsPUT(_response);
        });
    }

    protected processC300eosSettingsPUT(response: AxiosResponse): Promise<PlantC300EOSSettingsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlantC300EOSSettingsDTO.fromJS(resultData200);
            return Promise.resolve<PlantC300EOSSettingsDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("some fields are invalid", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlantC300EOSSettingsDTO>(null as any);
    }

    /**
     * Clone a plant for current user (Auth)
     * @return Plant successfully cloned
     */
    clonePlant(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/clone-plant";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClonePlant(_response);
        });
    }

    protected processClonePlant(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get commands devices from a plant (Auth)
     * @param linkableobjecttype (optional) 0 = Light

    1 = Shutter

    2 = Socket

    3 = Lock

    4 = Thermostat

    5 = Fancoil

    6 = TowelWarmer

    7 = WirelessCommand

    8 = Blind

    9 = Player

    10 = Xmeter

    11 = Alarm

    12 = ColoredLight

    13 = ScheduledScenarioPlus

    14 = None

    15 = Contact

    16 = AlarmSensor

    17 = Thermostat99zones

    18 = DimmerDmx

    19 = DimmerDali

    20 = Actuactor

    21 = CentralLoadControl

    22 = ActuactorLoadControl

    23 = VdeLock

    24 = StaircaseLight

    25 = FloorCall

    26 = Unknown
     * @return List of command devices from plant
     */
    commandDevices(plantdesktopid: number, linkableobjecttype: RoomObjectType | undefined, cancelToken?: CancelToken | undefined): Promise<DeviceDTO[]> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/command-devices?";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (linkableobjecttype === null)
            throw new Error("The parameter 'linkableobjecttype' cannot be null.");
        else if (linkableobjecttype !== undefined)
            url_ += "linkableobjecttype=" + encodeURIComponent("" + linkableobjecttype) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCommandDevices(_response);
        });
    }

    protected processCommandDevices(response: AxiosResponse): Promise<DeviceDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DeviceDTO[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant or room doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceDTO[]>(null as any);
    }

    /**
     * Duplicate a plant for current user (Auth)
     * @param names (optional) 
     * @return Plant successfully duplicated
     */
    duplicatePlant(plantdesktopid: number, names: string[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/duplicate-plant?";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (names === null)
            throw new Error("The parameter 'names' cannot be null.");
        else if (names !== undefined)
            names && names.forEach(item => { url_ += "names=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDuplicatePlant(_response);
        });
    }

    protected processDuplicatePlant(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Insert new rooms for current plant (Auth)
     * @param body (optional) 
     * @return Rooms successfully added to plant
     */
    roomsPOST(plantdesktopid: number, body: PlantRoomCount[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/rooms";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoomsPOST(_response);
        });
    }

    protected processRoomsPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete room (Auth)
     * @return Room deleted
     */
    roomsDELETE(plantdesktopid: number, roomid: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/rooms/{roomid}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (roomid === undefined || roomid === null)
            throw new Error("The parameter 'roomid' must be defined.");
        url_ = url_.replace("{roomid}", encodeURIComponent("" + roomid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoomsDELETE(_response);
        });
    }

    protected processRoomsDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant or Room don\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update a room for a plant (Auth)
     * @param body (optional) 
     * @return Room successfully updated
     */
    roomsPUT(plantdesktopid: number, roomid: string, body: RoomUpdateDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/rooms/{roomid}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (roomid === undefined || roomid === null)
            throw new Error("The parameter 'roomid' must be defined.");
        url_ = url_.replace("{roomid}", encodeURIComponent("" + roomid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoomsPUT(_response);
        });
    }

    protected processRoomsPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant or Room don\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Insert new objects for current room's plant (Auth)
     * @param body (optional) 
     * @return Objects successfully added to plant room
     */
    roomObjectsPOST(plantdesktopid: number, roomid: string, body: AddRoomObjectDTO[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/rooms/{roomid}/room-objects";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (roomid === undefined || roomid === null)
            throw new Error("The parameter 'roomid' must be defined.");
        url_ = url_.replace("{roomid}", encodeURIComponent("" + roomid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoomObjectsPOST(_response);
        });
    }

    protected processRoomObjectsPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some field are null, empty or invalid", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned or room not found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get a room object for a plant (Auth)
     * @return RoomObject
     */
    roomObjectsGET(plantdesktopid: number, roomid: string, roomobjectid: string, cancelToken?: CancelToken | undefined): Promise<RoomObjectDTO> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/rooms/{roomid}/room-objects/{roomobjectid}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (roomid === undefined || roomid === null)
            throw new Error("The parameter 'roomid' must be defined.");
        url_ = url_.replace("{roomid}", encodeURIComponent("" + roomid));
        if (roomobjectid === undefined || roomobjectid === null)
            throw new Error("The parameter 'roomobjectid' must be defined.");
        url_ = url_.replace("{roomobjectid}", encodeURIComponent("" + roomobjectid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoomObjectsGET(_response);
        });
    }

    protected processRoomObjectsGET(response: AxiosResponse): Promise<RoomObjectDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoomObjectDTO.fromJS(resultData200);
            return Promise.resolve<RoomObjectDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant, room or object doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoomObjectDTO>(null as any);
    }

    /**
     * Edit a room object for a plant (Auth)
     * @param body (optional) 
     * @return RoomObject
     */
    roomObjectsPUT(plantdesktopid: number, roomid: string, roomobjectid: string, body: EditRoomObjectDTO | undefined, cancelToken?: CancelToken | undefined): Promise<RoomObjectDTO> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/rooms/{roomid}/room-objects/{roomobjectid}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (roomid === undefined || roomid === null)
            throw new Error("The parameter 'roomid' must be defined.");
        url_ = url_.replace("{roomid}", encodeURIComponent("" + roomid));
        if (roomobjectid === undefined || roomobjectid === null)
            throw new Error("The parameter 'roomobjectid' must be defined.");
        url_ = url_.replace("{roomobjectid}", encodeURIComponent("" + roomobjectid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoomObjectsPUT(_response);
        });
    }

    protected processRoomObjectsPUT(response: AxiosResponse): Promise<RoomObjectDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoomObjectDTO.fromJS(resultData200);
            return Promise.resolve<RoomObjectDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some field are null, empty or invalid", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant, room or object doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoomObjectDTO>(null as any);
    }

    /**
     * Get compatible scanned devices into a plant (Auth)
     * @param filterDevices (optional) 0 = ALL

    1 = ACTUATORS

    2 = COMMANDS

    3 = THERMO

    4 = THERMO_PROBE

    5 = THERMO_HEATING_ACTUATORS

    6 = THERMO_COOLING_ACTUATORS

    7 = THERMO_HEATING_PUMPS

    8 = THERMO_COOLING_PUMPS

    9 = THERMO_SHARED_ACTUATORS

    10 = THERMO_SHARED_PUMPS
     * @param lightType (optional) 0 = None

    1 = OnOff

    2 = Dimmer

    3 = Unknown

    4 = DimmerDali
     * @param heatingSystemControlType (optional) 0 = None

    1 = OneOnOffValve

    2 = OneOpenCloseValve

    3 = OneProportionalValve

    4 = TwoTubesOnOffValve

    5 = TwoTubesProportionalValve

    6 = TwoTubesProportionalSpeedControlValve

    7 = FourTubesOnOffValve

    8 = FourTubesProportionalValve

    9 = FourTubesProportionalSpeedControlValve

    10 = GatewayMode

    11 = Pump
     * @param coolingSystemControlType (optional) 0 = None

    1 = OneOnOffValve

    2 = OneOpenCloseValve

    3 = OneProportionalValve

    4 = TwoTubesOnOffValve

    5 = TwoTubesProportionalValve

    6 = TwoTubesProportionalSpeedControlValve

    7 = FourTubesOnOffValve

    8 = FourTubesProportionalValve

    9 = FourTubesProportionalSpeedControlValve

    10 = GatewayMode

    11 = Pump
     * @param sharedSystemControlType (optional) 0 = None

    1 = OneOnOffValve

    2 = OneOpenCloseValve

    3 = OneProportionalValve

    4 = TwoTubesOnOffValve

    5 = TwoTubesProportionalValve

    6 = TwoTubesProportionalSpeedControlValve

    7 = FourTubesOnOffValve

    8 = FourTubesProportionalValve

    9 = FourTubesProportionalSpeedControlValve

    10 = GatewayMode

    11 = Pump
     * @return List of compatible devices from last scan
     */
    devices(plantdesktopid: number, roomid: string, roomobjectid: string, filterDevices: DevicesFilterByType | undefined, lightType: LightType | undefined, heatingSystemControlType: SystemControlType | undefined, coolingSystemControlType: SystemControlType | undefined, sharedSystemControlType: SystemControlType | undefined, cancelToken?: CancelToken | undefined): Promise<DeviceDTO[]> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/rooms/{roomid}/room-objects/{roomobjectid}/devices?";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (roomid === undefined || roomid === null)
            throw new Error("The parameter 'roomid' must be defined.");
        url_ = url_.replace("{roomid}", encodeURIComponent("" + roomid));
        if (roomobjectid === undefined || roomobjectid === null)
            throw new Error("The parameter 'roomobjectid' must be defined.");
        url_ = url_.replace("{roomobjectid}", encodeURIComponent("" + roomobjectid));
        if (filterDevices === null)
            throw new Error("The parameter 'filterDevices' cannot be null.");
        else if (filterDevices !== undefined)
            url_ += "filterDevices=" + encodeURIComponent("" + filterDevices) + "&";
        if (lightType === null)
            throw new Error("The parameter 'lightType' cannot be null.");
        else if (lightType !== undefined)
            url_ += "LightType=" + encodeURIComponent("" + lightType) + "&";
        if (heatingSystemControlType === null)
            throw new Error("The parameter 'heatingSystemControlType' cannot be null.");
        else if (heatingSystemControlType !== undefined)
            url_ += "HeatingSystemControlType=" + encodeURIComponent("" + heatingSystemControlType) + "&";
        if (coolingSystemControlType === null)
            throw new Error("The parameter 'coolingSystemControlType' cannot be null.");
        else if (coolingSystemControlType !== undefined)
            url_ += "CoolingSystemControlType=" + encodeURIComponent("" + coolingSystemControlType) + "&";
        if (sharedSystemControlType === null)
            throw new Error("The parameter 'sharedSystemControlType' cannot be null.");
        else if (sharedSystemControlType !== undefined)
            url_ += "SharedSystemControlType=" + encodeURIComponent("" + sharedSystemControlType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDevices(_response);
        });
    }

    protected processDevices(response: AxiosResponse): Promise<DeviceDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DeviceDTO[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant or room doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceDTO[]>(null as any);
    }

    /**
     * Get a thermo room object for a plant (Auth)
     * @return RoomObject
     */
    thermoGET(plantdesktopid: number, roomid: string, roomobjectid: string, cancelToken?: CancelToken | undefined): Promise<ThermoRoomObjectDTO> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/rooms/{roomid}/room-objects/thermo/{roomobjectid}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (roomid === undefined || roomid === null)
            throw new Error("The parameter 'roomid' must be defined.");
        url_ = url_.replace("{roomid}", encodeURIComponent("" + roomid));
        if (roomobjectid === undefined || roomobjectid === null)
            throw new Error("The parameter 'roomobjectid' must be defined.");
        url_ = url_.replace("{roomobjectid}", encodeURIComponent("" + roomobjectid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processThermoGET(_response);
        });
    }

    protected processThermoGET(response: AxiosResponse): Promise<ThermoRoomObjectDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ThermoRoomObjectDTO.fromJS(resultData200);
            return Promise.resolve<ThermoRoomObjectDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Room object is not a thermo", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant, room or object doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ThermoRoomObjectDTO>(null as any);
    }

    /**
     * Edit a thermo room object for a plant (Auth)
     * @param body (optional) 
     * @return RoomObject
     */
    thermoPUT(plantdesktopid: number, roomid: string, roomobjectid: string, body: EditThermoRoomObjectDTO | undefined, cancelToken?: CancelToken | undefined): Promise<ThermoRoomObjectDTO> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/rooms/{roomid}/room-objects/thermo/{roomobjectid}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (roomid === undefined || roomid === null)
            throw new Error("The parameter 'roomid' must be defined.");
        url_ = url_.replace("{roomid}", encodeURIComponent("" + roomid));
        if (roomobjectid === undefined || roomobjectid === null)
            throw new Error("The parameter 'roomobjectid' must be defined.");
        url_ = url_.replace("{roomobjectid}", encodeURIComponent("" + roomobjectid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processThermoPUT(_response);
        });
    }

    protected processThermoPUT(response: AxiosResponse): Promise<ThermoRoomObjectDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ThermoRoomObjectDTO.fromJS(resultData200);
            return Promise.resolve<ThermoRoomObjectDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Room object is not a thermo", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant, room or object doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ThermoRoomObjectDTO>(null as any);
    }

    /**
     * Get plant scene wizard actions list (Auth)
     * @return List of plant scene actions
     */
    sceneActionsList(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<SceneActionsListsDTO> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/scene-actions-list";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSceneActionsList(_response);
        });
    }

    protected processSceneActionsList(response: AxiosResponse): Promise<SceneActionsListsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SceneActionsListsDTO.fromJS(resultData200);
            return Promise.resolve<SceneActionsListsDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SceneActionsListsDTO>(null as any);
    }

    /**
     * Get plant scene wizard conditions list (Auth)
     * @return List of plant scene conditions
     */
    sceneConditionsList(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<SceneConditionsListsDTO> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/scene-conditions-list";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSceneConditionsList(_response);
        });
    }

    protected processSceneConditionsList(response: AxiosResponse): Promise<SceneConditionsListsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SceneConditionsListsDTO.fromJS(resultData200);
            return Promise.resolve<SceneConditionsListsDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SceneConditionsListsDTO>(null as any);
    }

    /**
     * Get plant scene wizard triggers list (Auth)
     * @return List of plant scene triggers
     */
    sceneTriggersList(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<SceneTriggersListsDTO> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/scene-triggers-list";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSceneTriggersList(_response);
        });
    }

    protected processSceneTriggersList(response: AxiosResponse): Promise<SceneTriggersListsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SceneTriggersListsDTO.fromJS(resultData200);
            return Promise.resolve<SceneTriggersListsDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SceneTriggersListsDTO>(null as any);
    }

    /**
     * Get plant scenes (Auth)
     * @return List of plant scenes
     */
    scenesAll(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<SceneDTO[]> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/scenes";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScenesAll(_response);
        });
    }

    protected processScenesAll(response: AxiosResponse): Promise<SceneDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SceneDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SceneDTO[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SceneDTO[]>(null as any);
    }

    /**
     * Add a scene (Auth)
     * @param body (optional) 
     * @return SceneDTO
     */
    scenesPOST(plantdesktopid: number, body: SceneDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/scenes";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScenesPOST(_response);
        });
    }

    protected processScenesPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some field are null, empty or invalid", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete a scene (Auth)
     * @return Scene deleted
     */
    scenesDELETE(plantdesktopid: number, sceneid: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/scenes/{sceneid}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (sceneid === undefined || sceneid === null)
            throw new Error("The parameter 'sceneid' must be defined.");
        url_ = url_.replace("{sceneid}", encodeURIComponent("" + sceneid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScenesDELETE(_response);
        });
    }

    protected processScenesDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant or scene doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get plant scene (Auth)
     * @return SceneDTO
     */
    scenesGET(plantdesktopid: number, sceneid: string, cancelToken?: CancelToken | undefined): Promise<SceneDTO> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/scenes/{sceneid}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (sceneid === undefined || sceneid === null)
            throw new Error("The parameter 'sceneid' must be defined.");
        url_ = url_.replace("{sceneid}", encodeURIComponent("" + sceneid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScenesGET(_response);
        });
    }

    protected processScenesGET(response: AxiosResponse): Promise<SceneDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SceneDTO.fromJS(resultData200);
            return Promise.resolve<SceneDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant or scene doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SceneDTO>(null as any);
    }

    /**
     * Edit a scene (Auth)
     * @param body (optional) 
     * @return SceneDTO
     */
    scenesPUT(plantdesktopid: number, sceneid: string, body: SceneDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/scenes/{sceneid}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (sceneid === undefined || sceneid === null)
            throw new Error("The parameter 'sceneid' must be defined.");
        url_ = url_.replace("{sceneid}", encodeURIComponent("" + sceneid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScenesPUT(_response);
        });
    }

    protected processScenesPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some field are null, empty or invalid", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant or scene doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Clone a scene (Auth)
     * @return Scene successfully cloned
     */
    cloneScene(plantdesktopid: number, sceneid: string, cancelToken?: CancelToken | undefined): Promise<SceneDTO> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/scenes/{sceneid}/clone-scene";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (sceneid === undefined || sceneid === null)
            throw new Error("The parameter 'sceneid' must be defined.");
        url_ = url_.replace("{sceneid}", encodeURIComponent("" + sceneid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloneScene(_response);
        });
    }

    protected processCloneScene(response: AxiosResponse): Promise<SceneDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = SceneDTO.fromJS(resultData201);
            return Promise.resolve<SceneDTO>(result201);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant or scene doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SceneDTO>(null as any);
    }

    /**
     * Toggle enable or disable scene (Auth)
     * @return Scene status successfully toggled, return status [enabled, disabled]
     */
    toggleDisable(plantdesktopid: number, sceneid: string, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/scenes/{sceneid}/toggle-disable";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (sceneid === undefined || sceneid === null)
            throw new Error("The parameter 'sceneid' must be defined.");
        url_ = url_.replace("{sceneid}", encodeURIComponent("" + sceneid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleDisable(_response);
        });
    }

    protected processToggleDisable(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant or scene doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Renew user session for a plant (Auth)
     * @return Session renewed
     */
    session(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<PlantSessionDTO> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/session";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSession(_response);
        });
    }

    protected processSession(response: AxiosResponse): Promise<PlantSessionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlantSessionDTO.fromJS(resultData200);
            return Promise.resolve<PlantSessionDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlantSessionDTO>(null as any);
    }

    /**
     * Un-share a plant to a user (Auth)
     * @param userEmail (optional) 
     * @return Un-shared
     */
    sharingDELETE(plantdesktopid: number, userEmail: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/sharing?";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (userEmail === null)
            throw new Error("The parameter 'userEmail' cannot be null.");
        else if (userEmail !== undefined)
            url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSharingDELETE(_response);
        });
    }

    protected processSharingDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Share a plant with a user (Auth)
     * @param userEmail (optional) 
     * @param accept_language (optional) 
     * @return Shared
     */
    sharingPOST(plantdesktopid: number, userEmail: string | undefined, accept_language: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/sharing?";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (userEmail === null)
            throw new Error("The parameter 'userEmail' cannot be null.");
        else if (userEmail !== undefined)
            url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSharingPOST(_response);
        });
    }

    protected processSharingPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Transfer ownership of a plant to another user (Auth)
     * @param userEmail (optional) 
     * @param body (optional) 
     * @return Ownership transfered successfully
     */
    transferOwnership(plantdesktopid: number, userEmail: string | undefined, body: TransferOwnershipDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/transfer-ownership?";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (userEmail === null)
            throw new Error("The parameter 'userEmail' cannot be null.");
        else if (userEmail !== undefined)
            url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransferOwnership(_response);
        });
    }

    protected processTransferOwnership(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Invalid field values: password field is null or empty or password is not valid", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("You are not the owner of this plant", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 409) {
            const _responseText = response.data;
            return throwException("The plant is not shared with the user inserted email", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update device settings (Auth)
     * @param body (optional) 
     * @return Device settings updated successfully
     */
    updateDeviceSettings(plantdesktopid: number, deviceuuid: string, body: DeviceGlobalSettingsDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/update-device-settings/{deviceuuid}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (deviceuuid === undefined || deviceuuid === null)
            throw new Error("The parameter 'deviceuuid' must be defined.");
        url_ = url_.replace("{deviceuuid}", encodeURIComponent("" + deviceuuid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDeviceSettings(_response);
        });
    }

    protected processUpdateDeviceSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some fields are null or empty", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant or device doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete room logical object (Auth)
     * @return Object deleted
     */
    deleteRoomObject(plantdesktopid: number, roomid: string, objectid: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/plant/delete-room-object/{plantdesktopid}/{roomid}/{objectid}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (roomid === undefined || roomid === null)
            throw new Error("The parameter 'roomid' must be defined.");
        url_ = url_.replace("{roomid}", encodeURIComponent("" + roomid));
        if (objectid === undefined || objectid === null)
            throw new Error("The parameter 'objectid' must be defined.");
        url_ = url_.replace("{objectid}", encodeURIComponent("" + objectid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRoomObject(_response);
        });
    }

    protected processDeleteRoomObject(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get All plants of current user (Auth)
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param plantsOrderBy (optional) 0 = PLANT_NAME

    1 = MODIFIED_DATE
     * @param plantsOrderByAsc (optional) 
     * @param filterPlantTagKeys (optional) 
     * @param searchText (optional) 
     * @param favoritesOnly (optional) 
     * @return List of user's plants
     */
    plantsList(pageNumber: number | undefined, pageSize: number | undefined, plantsOrderBy: PlantsOrderBy | undefined, plantsOrderByAsc: boolean | undefined, filterPlantTagKeys: string[] | undefined, searchText: string | undefined, favoritesOnly: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<PlantListDTOPaginatedResult> {
        let url_ = this.baseUrl + "/plants-list?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (plantsOrderBy === null)
            throw new Error("The parameter 'plantsOrderBy' cannot be null.");
        else if (plantsOrderBy !== undefined)
            url_ += "PlantsOrderBy=" + encodeURIComponent("" + plantsOrderBy) + "&";
        if (plantsOrderByAsc === null)
            throw new Error("The parameter 'plantsOrderByAsc' cannot be null.");
        else if (plantsOrderByAsc !== undefined)
            url_ += "PlantsOrderByAsc=" + encodeURIComponent("" + plantsOrderByAsc) + "&";
        if (filterPlantTagKeys === null)
            throw new Error("The parameter 'filterPlantTagKeys' cannot be null.");
        else if (filterPlantTagKeys !== undefined)
            filterPlantTagKeys && filterPlantTagKeys.forEach(item => { url_ += "FilterPlantTagKeys=" + encodeURIComponent("" + item) + "&"; });
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (favoritesOnly === null)
            throw new Error("The parameter 'favoritesOnly' cannot be null.");
        else if (favoritesOnly !== undefined)
            url_ += "FavoritesOnly=" + encodeURIComponent("" + favoritesOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPlantsList(_response);
        });
    }

    protected processPlantsList(response: AxiosResponse): Promise<PlantListDTOPaginatedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlantListDTOPaginatedResult.fromJS(resultData200);
            return Promise.resolve<PlantListDTOPaginatedResult>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Generic error", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlantListDTOPaginatedResult>(null as any);
    }

    /**
     * Get All tags associated to my plants (Auth)
     * @return List of all tags associated to my plants
     */
    tagsList( cancelToken?: CancelToken | undefined): Promise<PlantTagDTO[]> {
        let url_ = this.baseUrl + "/tags-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagsList(_response);
        });
    }

    protected processTagsList(response: AxiosResponse): Promise<PlantTagDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlantTagDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PlantTagDTO[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Generic error", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlantTagDTO[]>(null as any);
    }

    /**
     * Toggle plant from favorites for a user (Auth)
     * @return Plant successfully toggled, return favorite status
     */
    togglePlantFromFavorites(plantdesktopid: number, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/toggle-plant-from-favorites/{plantdesktopid}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTogglePlantFromFavorites(_response);
        });
    }

    protected processTogglePlantFromFavorites(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class Action implements IAction {
    id?: number;

    constructor(data?: IAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Action {
        data = typeof data === 'object' ? data : {};
        let result = new Action();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IAction {
    id?: number;
}

export class ActionDTO implements IActionDTO {
    objectName?: string | undefined;
    sceneObjectType?: SceneObjectType;
    energyObjectType?: EnergyMeterAndLoadControlType;
    actionParams?: Action | undefined;

    constructor(data?: IActionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectName = _data["objectName"];
            this.sceneObjectType = _data["sceneObjectType"];
            this.energyObjectType = _data["energyObjectType"];
            this.actionParams = _data["actionParams"] ? Action.fromJS(_data["actionParams"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectName"] = this.objectName;
        data["sceneObjectType"] = this.sceneObjectType;
        data["energyObjectType"] = this.energyObjectType;
        data["actionParams"] = this.actionParams ? this.actionParams.toJSON() : <any>undefined;
        return data;
    }
}

export interface IActionDTO {
    objectName?: string | undefined;
    sceneObjectType?: SceneObjectType;
    energyObjectType?: EnergyMeterAndLoadControlType;
    actionParams?: Action | undefined;
}

export class VdeFunction implements IVdeFunction {
    id?: number;
    description?: string | undefined;
    address?: number;

    constructor(data?: IVdeFunction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): VdeFunction {
        data = typeof data === 'object' ? data : {};
        let result = new VdeFunction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["address"] = this.address;
        return data;
    }
}

export interface IVdeFunction {
    id?: number;
    description?: string | undefined;
    address?: number;
}

export class ActivationFunction extends VdeFunction implements IActivationFunction {
    type?: ActivationType;

    constructor(data?: IActivationFunction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ActivationFunction {
        data = typeof data === 'object' ? data : {};
        let result = new ActivationFunction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IActivationFunction extends IVdeFunction {
    type?: ActivationType;
}

/** 0 = Generic 1 = Lock */
export enum ActivationType {
    Generic = 0,
    Lock = 1,
}

/** 0 = None 1 = Separate 2 = Shared 3 = Mixed */
export enum ActuatorModalityType {
    None = 0,
    Separate = 1,
    Shared = 2,
    Mixed = 3,
}

export class ActuatorSettings implements IActuatorSettings {

    constructor(data?: IActuatorSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ActuatorSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ActuatorSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IActuatorSettings {
}

export class AddRoomObjectDTO implements IAddRoomObjectDTO {
    name?: string | undefined;
    type?: RoomObjectType;
    devices?: Device[] | undefined;
    isHidden?: boolean;
    lightType?: LightType;
    isManagePosition?: boolean;
    thermoTypeOfObject?: ThermoTypeOfObject;
    thermoAssociatedPump?: ThermoAssociatedPump;

    constructor(data?: IAddRoomObjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(Device.fromJS(item));
            }
            this.isHidden = _data["isHidden"];
            this.lightType = _data["lightType"];
            this.isManagePosition = _data["isManagePosition"];
            this.thermoTypeOfObject = _data["thermoTypeOfObject"];
            this.thermoAssociatedPump = _data["thermoAssociatedPump"];
        }
    }

    static fromJS(data: any): AddRoomObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddRoomObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["isHidden"] = this.isHidden;
        data["lightType"] = this.lightType;
        data["isManagePosition"] = this.isManagePosition;
        data["thermoTypeOfObject"] = this.thermoTypeOfObject;
        data["thermoAssociatedPump"] = this.thermoAssociatedPump;
        return data;
    }
}

export interface IAddRoomObjectDTO {
    name?: string | undefined;
    type?: RoomObjectType;
    devices?: Device[] | undefined;
    isHidden?: boolean;
    lightType?: LightType;
    isManagePosition?: boolean;
    thermoTypeOfObject?: ThermoTypeOfObject;
    thermoAssociatedPump?: ThermoAssociatedPump;
}

/** 0 = Surname 1 = Apartment */
export enum AddressBookSorting {
    Surname = 0,
    Apartment = 1,
}

export class AddressPumps implements IAddressPumps {
    number?: string | undefined;
    idSlot?: string | undefined;
    deviceid?: string | undefined;
    linksId?: string[] | undefined;

    constructor(data?: IAddressPumps) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.idSlot = _data["idSlot"];
            this.deviceid = _data["deviceid"];
            if (Array.isArray(_data["linksId"])) {
                this.linksId = [] as any;
                for (let item of _data["linksId"])
                    this.linksId!.push(item);
            }
        }
    }

    static fromJS(data: any): AddressPumps {
        data = typeof data === 'object' ? data : {};
        let result = new AddressPumps();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["idSlot"] = this.idSlot;
        data["deviceid"] = this.deviceid;
        if (Array.isArray(this.linksId)) {
            data["linksId"] = [];
            for (let item of this.linksId)
                data["linksId"].push(item);
        }
        return data;
    }
}

export interface IAddressPumps {
    number?: string | undefined;
    idSlot?: string | undefined;
    deviceid?: string | undefined;
    linksId?: string[] | undefined;
}

/** 0 = AddressBook 1 = BuildingRiserFloorApartment 2 = DirectCall_Alphanumeric 3 = DirectCall_NumbersOnly */
export enum AddressingType {
    AddressBook = 0,
    BuildingRiserFloorApartment = 1,
    DirectCall_Alphanumeric = 2,
    DirectCall_NumbersOnly = 3,
}

export class LinkableObject implements ILinkableObject {
    id?: string | undefined;
    name?: string | undefined;
    devices?: Device[] | undefined;
    extDevices?: ExtDevice[] | undefined;

    constructor(data?: ILinkableObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(Device.fromJS(item));
            }
            if (Array.isArray(_data["extDevices"])) {
                this.extDevices = [] as any;
                for (let item of _data["extDevices"])
                    this.extDevices!.push(ExtDevice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LinkableObject {
        data = typeof data === 'object' ? data : {};
        let result = new LinkableObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        if (Array.isArray(this.extDevices)) {
            data["extDevices"] = [];
            for (let item of this.extDevices)
                data["extDevices"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILinkableObject {
    id?: string | undefined;
    name?: string | undefined;
    devices?: Device[] | undefined;
    extDevices?: ExtDevice[] | undefined;
}

export class AggregateCommand extends LinkableObject implements IAggregateCommand {
    hasGroupMembersMismatch?: boolean;
    rooms?: Room[] | undefined;
    objectsName?: string[] | undefined;
    type?: AggregateCommandType;
    roomObjectType?: RoomObjectType;
    address?: string | undefined;
    roomId?: string | undefined;
    isColor?: boolean;
    isTemperatureColor?: boolean;
    lightType?: LightType;
    hasCommands?: boolean;
    typeofProblem?: CompromisedType;
    isHidden?: boolean;
    ambienceA?: Action[] | undefined;
    ambienceB?: Action[] | undefined;
    ambienceC?: Action[] | undefined;
    ambienceD?: Action[] | undefined;
    nameAmbienceA?: string | undefined;
    nameAmbienceB?: string | undefined;
    nameAmbienceC?: string | undefined;
    nameAmbienceD?: string | undefined;
    readonly problemDescription?: string | undefined;
    isAmbience?: boolean;
    readonly descriptionA?: string | undefined;
    readonly descriptionB?: string | undefined;
    readonly descriptionC?: string | undefined;
    readonly descriptionD?: string | undefined;
    preset?: Preset;

    constructor(data?: IAggregateCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasGroupMembersMismatch = _data["hasGroupMembersMismatch"];
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(Room.fromJS(item));
            }
            if (Array.isArray(_data["objectsName"])) {
                this.objectsName = [] as any;
                for (let item of _data["objectsName"])
                    this.objectsName!.push(item);
            }
            this.type = _data["type"];
            this.roomObjectType = _data["roomObjectType"];
            this.address = _data["address"];
            this.roomId = _data["roomId"];
            this.isColor = _data["isColor"];
            this.isTemperatureColor = _data["isTemperatureColor"];
            this.lightType = _data["lightType"];
            this.hasCommands = _data["hasCommands"];
            this.typeofProblem = _data["typeofProblem"];
            this.isHidden = _data["isHidden"];
            if (Array.isArray(_data["ambienceA"])) {
                this.ambienceA = [] as any;
                for (let item of _data["ambienceA"])
                    this.ambienceA!.push(Action.fromJS(item));
            }
            if (Array.isArray(_data["ambienceB"])) {
                this.ambienceB = [] as any;
                for (let item of _data["ambienceB"])
                    this.ambienceB!.push(Action.fromJS(item));
            }
            if (Array.isArray(_data["ambienceC"])) {
                this.ambienceC = [] as any;
                for (let item of _data["ambienceC"])
                    this.ambienceC!.push(Action.fromJS(item));
            }
            if (Array.isArray(_data["ambienceD"])) {
                this.ambienceD = [] as any;
                for (let item of _data["ambienceD"])
                    this.ambienceD!.push(Action.fromJS(item));
            }
            this.nameAmbienceA = _data["nameAmbienceA"];
            this.nameAmbienceB = _data["nameAmbienceB"];
            this.nameAmbienceC = _data["nameAmbienceC"];
            this.nameAmbienceD = _data["nameAmbienceD"];
            (<any>this).problemDescription = _data["problemDescription"];
            this.isAmbience = _data["isAmbience"];
            (<any>this).descriptionA = _data["descriptionA"];
            (<any>this).descriptionB = _data["descriptionB"];
            (<any>this).descriptionC = _data["descriptionC"];
            (<any>this).descriptionD = _data["descriptionD"];
            this.preset = _data["preset"] ? Preset.fromJS(_data["preset"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AggregateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasGroupMembersMismatch"] = this.hasGroupMembersMismatch;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        if (Array.isArray(this.objectsName)) {
            data["objectsName"] = [];
            for (let item of this.objectsName)
                data["objectsName"].push(item);
        }
        data["type"] = this.type;
        data["roomObjectType"] = this.roomObjectType;
        data["address"] = this.address;
        data["roomId"] = this.roomId;
        data["isColor"] = this.isColor;
        data["isTemperatureColor"] = this.isTemperatureColor;
        data["lightType"] = this.lightType;
        data["hasCommands"] = this.hasCommands;
        data["typeofProblem"] = this.typeofProblem;
        data["isHidden"] = this.isHidden;
        if (Array.isArray(this.ambienceA)) {
            data["ambienceA"] = [];
            for (let item of this.ambienceA)
                data["ambienceA"].push(item.toJSON());
        }
        if (Array.isArray(this.ambienceB)) {
            data["ambienceB"] = [];
            for (let item of this.ambienceB)
                data["ambienceB"].push(item.toJSON());
        }
        if (Array.isArray(this.ambienceC)) {
            data["ambienceC"] = [];
            for (let item of this.ambienceC)
                data["ambienceC"].push(item.toJSON());
        }
        if (Array.isArray(this.ambienceD)) {
            data["ambienceD"] = [];
            for (let item of this.ambienceD)
                data["ambienceD"].push(item.toJSON());
        }
        data["nameAmbienceA"] = this.nameAmbienceA;
        data["nameAmbienceB"] = this.nameAmbienceB;
        data["nameAmbienceC"] = this.nameAmbienceC;
        data["nameAmbienceD"] = this.nameAmbienceD;
        data["problemDescription"] = this.problemDescription;
        data["isAmbience"] = this.isAmbience;
        data["descriptionA"] = this.descriptionA;
        data["descriptionB"] = this.descriptionB;
        data["descriptionC"] = this.descriptionC;
        data["descriptionD"] = this.descriptionD;
        data["preset"] = this.preset ? this.preset.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAggregateCommand extends ILinkableObject {
    hasGroupMembersMismatch?: boolean;
    rooms?: Room[] | undefined;
    objectsName?: string[] | undefined;
    type?: AggregateCommandType;
    roomObjectType?: RoomObjectType;
    address?: string | undefined;
    roomId?: string | undefined;
    isColor?: boolean;
    isTemperatureColor?: boolean;
    lightType?: LightType;
    hasCommands?: boolean;
    typeofProblem?: CompromisedType;
    isHidden?: boolean;
    ambienceA?: Action[] | undefined;
    ambienceB?: Action[] | undefined;
    ambienceC?: Action[] | undefined;
    ambienceD?: Action[] | undefined;
    nameAmbienceA?: string | undefined;
    nameAmbienceB?: string | undefined;
    nameAmbienceC?: string | undefined;
    nameAmbienceD?: string | undefined;
    problemDescription?: string | undefined;
    isAmbience?: boolean;
    descriptionA?: string | undefined;
    descriptionB?: string | undefined;
    descriptionC?: string | undefined;
    descriptionD?: string | undefined;
    preset?: Preset;
}

export class AggregateCommandActionListItemDTO implements IAggregateCommandActionListItemDTO {
    aggregateCommandType?: AggregateCommandType;
    subItemList?: SceneActionListItemDTO[] | undefined;
    name?: string | undefined;

    constructor(data?: IAggregateCommandActionListItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aggregateCommandType = _data["aggregateCommandType"];
            if (Array.isArray(_data["subItemList"])) {
                this.subItemList = [] as any;
                for (let item of _data["subItemList"])
                    this.subItemList!.push(SceneActionListItemDTO.fromJS(item));
            }
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AggregateCommandActionListItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateCommandActionListItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aggregateCommandType"] = this.aggregateCommandType;
        if (Array.isArray(this.subItemList)) {
            data["subItemList"] = [];
            for (let item of this.subItemList)
                data["subItemList"].push(item.toJSON());
        }
        data["name"] = this.name;
        return data;
    }
}

export interface IAggregateCommandActionListItemDTO {
    aggregateCommandType?: AggregateCommandType;
    subItemList?: SceneActionListItemDTO[] | undefined;
    name?: string | undefined;
}

export class AggregateCommandDTO implements IAggregateCommandDTO {
    id?: string | undefined;
    name?: string | undefined;
    devices?: DeviceDTO[] | undefined;
    type?: AggregateCommandType;
    isPlaceholder?: boolean;
    rooms?: RoomDTO[] | undefined;
    roomObjectType?: RoomObjectType;

    constructor(data?: IAggregateCommandDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(DeviceDTO.fromJS(item));
            }
            this.type = _data["type"];
            this.isPlaceholder = _data["isPlaceholder"];
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(RoomDTO.fromJS(item));
            }
            this.roomObjectType = _data["roomObjectType"];
        }
    }

    static fromJS(data: any): AggregateCommandDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateCommandDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["type"] = this.type;
        data["isPlaceholder"] = this.isPlaceholder;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        data["roomObjectType"] = this.roomObjectType;
        return data;
    }
}

export interface IAggregateCommandDTO {
    id?: string | undefined;
    name?: string | undefined;
    devices?: DeviceDTO[] | undefined;
    type?: AggregateCommandType;
    isPlaceholder?: boolean;
    rooms?: RoomDTO[] | undefined;
    roomObjectType?: RoomObjectType;
}

/** 0 = General 1 = Group 2 = Ambience */
export enum AggregateCommandType {
    General = 0,
    Group = 1,
    Ambience = 2,
}

export class AlarmAction extends Action implements IAlarmAction {
    isSuspended?: boolean;
    alarmType?: AlarmType;
    alarmState?: AlarmPartitionState;
    alarmPartitionOrSceneId?: string | undefined;
    alarmPin?: string | undefined;
    alarmName?: string | undefined;

    constructor(data?: IAlarmAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isSuspended = _data["isSuspended"];
            this.alarmType = _data["alarmType"];
            this.alarmState = _data["alarmState"];
            this.alarmPartitionOrSceneId = _data["alarmPartitionOrSceneId"];
            this.alarmPin = _data["alarmPin"];
            this.alarmName = _data["alarmName"];
        }
    }

    static fromJS(data: any): AlarmAction {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuspended"] = this.isSuspended;
        data["alarmType"] = this.alarmType;
        data["alarmState"] = this.alarmState;
        data["alarmPartitionOrSceneId"] = this.alarmPartitionOrSceneId;
        data["alarmPin"] = this.alarmPin;
        data["alarmName"] = this.alarmName;
        super.toJSON(data);
        return data;
    }
}

export interface IAlarmAction extends IAction {
    isSuspended?: boolean;
    alarmType?: AlarmType;
    alarmState?: AlarmPartitionState;
    alarmPartitionOrSceneId?: string | undefined;
    alarmPin?: string | undefined;
    alarmName?: string | undefined;
}

export class ExtDevice implements IExtDevice {
    componentType?: ExtComponentType;
    deviceConfiguration?: { [key: string]: string; } | undefined;

    constructor(data?: IExtDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentType = _data["componentType"];
            if (_data["deviceConfiguration"]) {
                this.deviceConfiguration = {} as any;
                for (let key in _data["deviceConfiguration"]) {
                    if (_data["deviceConfiguration"].hasOwnProperty(key))
                        (<any>this.deviceConfiguration)![key] = _data["deviceConfiguration"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExtDevice {
        data = typeof data === 'object' ? data : {};
        let result = new ExtDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentType"] = this.componentType;
        if (this.deviceConfiguration) {
            data["deviceConfiguration"] = {};
            for (let key in this.deviceConfiguration) {
                if (this.deviceConfiguration.hasOwnProperty(key))
                    (<any>data["deviceConfiguration"])[key] = (<any>this.deviceConfiguration)[key];
            }
        }
        return data;
    }
}

export interface IExtDevice {
    componentType?: ExtComponentType;
    deviceConfiguration?: { [key: string]: string; } | undefined;
}

export class AlarmCentralUnitExtDevice extends ExtDevice implements IAlarmCentralUnitExtDevice {
    readonly address?: string | undefined;

    constructor(data?: IAlarmCentralUnitExtDevice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            (<any>this).address = _data["address"];
        }
    }

    static fromJS(data: any): AlarmCentralUnitExtDevice {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmCentralUnitExtDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        super.toJSON(data);
        return data;
    }
}

export interface IAlarmCentralUnitExtDevice extends IExtDevice {
    address?: string | undefined;
}

export class Condition implements ICondition {
    id?: number;
    isSuspended?: boolean;

    constructor(data?: ICondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isSuspended = _data["isSuspended"];
        }
    }

    static fromJS(data: any): Condition {
        data = typeof data === 'object' ? data : {};
        let result = new Condition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSuspended"] = this.isSuspended;
        return data;
    }
}

export interface ICondition {
    id?: number;
    isSuspended?: boolean;
}

export class AlarmCondition extends Condition implements IAlarmCondition {
    alarmType?: AlarmType;
    alarmPartitionState?: AlarmPartitionState;
    alarmSensorState?: AlarmSensorStatus;
    alarmPartitionOrSceneId?: string | undefined;
    alarmName?: string | undefined;

    constructor(data?: IAlarmCondition) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.alarmType = _data["alarmType"];
            this.alarmPartitionState = _data["alarmPartitionState"];
            this.alarmSensorState = _data["alarmSensorState"];
            this.alarmPartitionOrSceneId = _data["alarmPartitionOrSceneId"];
            this.alarmName = _data["alarmName"];
        }
    }

    static fromJS(data: any): AlarmCondition {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarmType"] = this.alarmType;
        data["alarmPartitionState"] = this.alarmPartitionState;
        data["alarmSensorState"] = this.alarmSensorState;
        data["alarmPartitionOrSceneId"] = this.alarmPartitionOrSceneId;
        data["alarmName"] = this.alarmName;
        super.toJSON(data);
        return data;
    }
}

export interface IAlarmCondition extends ICondition {
    alarmType?: AlarmType;
    alarmPartitionState?: AlarmPartitionState;
    alarmSensorState?: AlarmSensorStatus;
    alarmPartitionOrSceneId?: string | undefined;
    alarmName?: string | undefined;
}

/** 0 = Disarmed 1 = Exit 2 = Armed 3 = PreAlarm 4 = Ready_To_Arm 5 = Alarm 6 = Armed_Immediate 7 = Tamper 8 = None */
export enum AlarmPartitionState {
    Disarmed = 0,
    Exit = 1,
    Armed = 2,
    PreAlarm = 3,
    Ready_To_Arm = 4,
    Alarm = 5,
    Armed_Immediate = 6,
    Tamper = 7,
    None = 8,
}

/** 0 = Disarm 1 = Arm_With_Delay 2 = Arm_Without_Delay */
export enum AlarmPartitionStatus {
    Disarm = 0,
    Arm_With_Delay = 1,
    Arm_Without_Delay = 2,
}

export class AlarmSensorExtDevice extends ExtDevice implements IAlarmSensorExtDevice {
    readonly address?: string | undefined;
    readonly senrosName?: string | undefined;

    constructor(data?: IAlarmSensorExtDevice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            (<any>this).address = _data["address"];
            (<any>this).senrosName = _data["senrosName"];
        }
    }

    static fromJS(data: any): AlarmSensorExtDevice {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmSensorExtDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["senrosName"] = this.senrosName;
        super.toJSON(data);
        return data;
    }
}

export interface IAlarmSensorExtDevice extends IExtDevice {
    address?: string | undefined;
    senrosName?: string | undefined;
}

/** 0 = Idle 1 = Tamper 2 = Trigger 3 = Mask */
export enum AlarmSensorStatus {
    Idle = 0,
    Tamper = 1,
    Trigger = 2,
    Mask = 3,
}

/** 0 = None 1 = Normal 2 = Alarm */
export enum AlarmSensorStatusScene {
    None = 0,
    Normal = 1,
    Alarm = 2,
}

export class AlarmSystemSensorDTO implements IAlarmSystemSensorDTO {
    sensorName?: string | undefined;
    sensorAddress?: string | undefined;
    roomName?: string | undefined;

    constructor(data?: IAlarmSystemSensorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sensorName = _data["sensorName"];
            this.sensorAddress = _data["sensorAddress"];
            this.roomName = _data["roomName"];
        }
    }

    static fromJS(data: any): AlarmSystemSensorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmSystemSensorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sensorName"] = this.sensorName;
        data["sensorAddress"] = this.sensorAddress;
        data["roomName"] = this.roomName;
        return data;
    }
}

export interface IAlarmSystemSensorDTO {
    sensorName?: string | undefined;
    sensorAddress?: string | undefined;
    roomName?: string | undefined;
}

export class Trigger implements ITrigger {
    id?: number;
    isSuspended?: boolean;
    address?: string | undefined;

    constructor(data?: ITrigger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isSuspended = _data["isSuspended"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): Trigger {
        data = typeof data === 'object' ? data : {};
        let result = new Trigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSuspended"] = this.isSuspended;
        data["address"] = this.address;
        return data;
    }
}

export interface ITrigger {
    id?: number;
    isSuspended?: boolean;
    address?: string | undefined;
}

export class AlarmTrigger extends Trigger implements IAlarmTrigger {
    alarmType?: AlarmType;
    alarmPartitionState?: AlarmPartitionState;
    alarmSensorState?: AlarmSensorStatus;
    alarmPartitionOrSceneId?: string | undefined;
    alarmName?: string | undefined;

    constructor(data?: IAlarmTrigger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.alarmType = _data["alarmType"];
            this.alarmPartitionState = _data["alarmPartitionState"];
            this.alarmSensorState = _data["alarmSensorState"];
            this.alarmPartitionOrSceneId = _data["alarmPartitionOrSceneId"];
            this.alarmName = _data["alarmName"];
        }
    }

    static fromJS(data: any): AlarmTrigger {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmTrigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarmType"] = this.alarmType;
        data["alarmPartitionState"] = this.alarmPartitionState;
        data["alarmSensorState"] = this.alarmSensorState;
        data["alarmPartitionOrSceneId"] = this.alarmPartitionOrSceneId;
        data["alarmName"] = this.alarmName;
        super.toJSON(data);
        return data;
    }
}

export interface IAlarmTrigger extends ITrigger {
    alarmType?: AlarmType;
    alarmPartitionState?: AlarmPartitionState;
    alarmSensorState?: AlarmSensorStatus;
    alarmPartitionOrSceneId?: string | undefined;
    alarmName?: string | undefined;
}

/** 0 = Partition 1 = AlarmSystemType */
export enum AlarmType {
    Partition = 0,
    AlarmSystemType = 1,
}

export class ApartmentDTO implements IApartmentDTO {
    apartmentId?: string;
    buildingId?: string | undefined;
    floorId?: string | undefined;
    riserId?: string | undefined;
    riserInterfaceId?: string;
    index?: number;
    name?: string | undefined;
    code?: string | undefined;
    internal?: string | undefined;
    scsAddr?: number;
    badgeList?: string[] | undefined;
    keypadCode?: string | undefined;
    buildingCode?: string | undefined;
    riserCode?: string | undefined;
    floorCode?: string | undefined;
    apartmentCode?: string | undefined;
    labels?: ApartmentLabelDTO[] | undefined;
    canInvite?: boolean;

    constructor(data?: IApartmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apartmentId = _data["apartmentId"];
            this.buildingId = _data["buildingId"];
            this.floorId = _data["floorId"];
            this.riserId = _data["riserId"];
            this.riserInterfaceId = _data["riserInterfaceId"];
            this.index = _data["index"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.internal = _data["internal"];
            this.scsAddr = _data["scsAddr"];
            if (Array.isArray(_data["badgeList"])) {
                this.badgeList = [] as any;
                for (let item of _data["badgeList"])
                    this.badgeList!.push(item);
            }
            this.keypadCode = _data["keypadCode"];
            this.buildingCode = _data["buildingCode"];
            this.riserCode = _data["riserCode"];
            this.floorCode = _data["floorCode"];
            this.apartmentCode = _data["apartmentCode"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(ApartmentLabelDTO.fromJS(item));
            }
            this.canInvite = _data["canInvite"];
        }
    }

    static fromJS(data: any): ApartmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApartmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apartmentId"] = this.apartmentId;
        data["buildingId"] = this.buildingId;
        data["floorId"] = this.floorId;
        data["riserId"] = this.riserId;
        data["riserInterfaceId"] = this.riserInterfaceId;
        data["index"] = this.index;
        data["name"] = this.name;
        data["code"] = this.code;
        data["internal"] = this.internal;
        data["scsAddr"] = this.scsAddr;
        if (Array.isArray(this.badgeList)) {
            data["badgeList"] = [];
            for (let item of this.badgeList)
                data["badgeList"].push(item);
        }
        data["keypadCode"] = this.keypadCode;
        data["buildingCode"] = this.buildingCode;
        data["riserCode"] = this.riserCode;
        data["floorCode"] = this.floorCode;
        data["apartmentCode"] = this.apartmentCode;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item.toJSON());
        }
        data["canInvite"] = this.canInvite;
        return data;
    }
}

export interface IApartmentDTO {
    apartmentId?: string;
    buildingId?: string | undefined;
    floorId?: string | undefined;
    riserId?: string | undefined;
    riserInterfaceId?: string;
    index?: number;
    name?: string | undefined;
    code?: string | undefined;
    internal?: string | undefined;
    scsAddr?: number;
    badgeList?: string[] | undefined;
    keypadCode?: string | undefined;
    buildingCode?: string | undefined;
    riserCode?: string | undefined;
    floorCode?: string | undefined;
    apartmentCode?: string | undefined;
    labels?: ApartmentLabelDTO[] | undefined;
    canInvite?: boolean;
}

export class ApartmentInvitationDTO implements IApartmentInvitationDTO {
    apartmentId?: string;
    email?: string | undefined;
    name?: string | undefined;
    status?: ApartmentInvitationStatus;

    constructor(data?: IApartmentInvitationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apartmentId = _data["apartmentId"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ApartmentInvitationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApartmentInvitationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apartmentId"] = this.apartmentId;
        data["email"] = this.email;
        data["name"] = this.name;
        data["status"] = this.status;
        return data;
    }
}

export interface IApartmentInvitationDTO {
    apartmentId?: string;
    email?: string | undefined;
    name?: string | undefined;
    status?: ApartmentInvitationStatus;
}

/** 0 = Pending 1 = Confirmed */
export enum ApartmentInvitationStatus {
    Pending = 0,
    Confirmed = 1,
}

export class ApartmentLabelDTO implements IApartmentLabelDTO {
    labelId?: string;
    surname?: string | undefined;
    name?: string | undefined;
    companyName?: string | undefined;
    information?: string | undefined;
    houseHolder?: boolean;
    isInformationHidden?: boolean;
    manuallyEdited?: boolean;
    labelType?: LabelType;
    isPrivate?: boolean;
    imageBase64?: string | undefined;
    imageName?: string | undefined;

    constructor(data?: IApartmentLabelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labelId = _data["labelId"];
            this.surname = _data["surname"];
            this.name = _data["name"];
            this.companyName = _data["companyName"];
            this.information = _data["information"];
            this.houseHolder = _data["houseHolder"];
            this.isInformationHidden = _data["isInformationHidden"];
            this.manuallyEdited = _data["manuallyEdited"];
            this.labelType = _data["labelType"];
            this.isPrivate = _data["isPrivate"];
            this.imageBase64 = _data["imageBase64"];
            this.imageName = _data["imageName"];
        }
    }

    static fromJS(data: any): ApartmentLabelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApartmentLabelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelId"] = this.labelId;
        data["surname"] = this.surname;
        data["name"] = this.name;
        data["companyName"] = this.companyName;
        data["information"] = this.information;
        data["houseHolder"] = this.houseHolder;
        data["isInformationHidden"] = this.isInformationHidden;
        data["manuallyEdited"] = this.manuallyEdited;
        data["labelType"] = this.labelType;
        data["isPrivate"] = this.isPrivate;
        data["imageBase64"] = this.imageBase64;
        data["imageName"] = this.imageName;
        return data;
    }
}

export interface IApartmentLabelDTO {
    labelId?: string;
    surname?: string | undefined;
    name?: string | undefined;
    companyName?: string | undefined;
    information?: string | undefined;
    houseHolder?: boolean;
    isInformationHidden?: boolean;
    manuallyEdited?: boolean;
    labelType?: LabelType;
    isPrivate?: boolean;
    imageBase64?: string | undefined;
    imageName?: string | undefined;
}

export class BadgeDTO implements IBadgeDTO {
    badgeCode?: string | undefined;
    apartment?: ApartmentDTO;
    gateGuest?: GateGuestDTO;

    constructor(data?: IBadgeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.badgeCode = _data["badgeCode"];
            this.apartment = _data["apartment"] ? ApartmentDTO.fromJS(_data["apartment"]) : <any>undefined;
            this.gateGuest = _data["gateGuest"] ? GateGuestDTO.fromJS(_data["gateGuest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BadgeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BadgeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["badgeCode"] = this.badgeCode;
        data["apartment"] = this.apartment ? this.apartment.toJSON() : <any>undefined;
        data["gateGuest"] = this.gateGuest ? this.gateGuest.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBadgeDTO {
    badgeCode?: string | undefined;
    apartment?: ApartmentDTO;
    gateGuest?: GateGuestDTO;
}

export class BaseShuttersCommandSettingsObjectDTO implements IBaseShuttersCommandSettingsObjectDTO {
    shutterMode?: ShutterMode;
    shutterPositionMode?: ShutterPositionMode;

    constructor(data?: IBaseShuttersCommandSettingsObjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shutterMode = _data["shutterMode"];
            this.shutterPositionMode = _data["shutterPositionMode"];
        }
    }

    static fromJS(data: any): BaseShuttersCommandSettingsObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BaseShuttersCommandSettingsObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shutterMode"] = this.shutterMode;
        data["shutterPositionMode"] = this.shutterPositionMode;
        return data;
    }
}

export interface IBaseShuttersCommandSettingsObjectDTO {
    shutterMode?: ShutterMode;
    shutterPositionMode?: ShutterPositionMode;
}

export class BaseShuttersCommandSettingsResult implements IBaseShuttersCommandSettingsResult {
    shutterMode?: ShutterMode;

    constructor(data?: IBaseShuttersCommandSettingsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shutterMode = _data["shutterMode"];
        }
    }

    static fromJS(data: any): BaseShuttersCommandSettingsResult {
        data = typeof data === 'object' ? data : {};
        let result = new BaseShuttersCommandSettingsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shutterMode"] = this.shutterMode;
        return data;
    }
}

export interface IBaseShuttersCommandSettingsResult {
    shutterMode?: ShutterMode;
}

/** 0 = None 1 = Dimmer 2 = ColorTemperature 4 = Color 8 = Color1 16 = Color2 */
export enum BitmaskDaliLoadTypes {
    None = 0,
    Dimmer = 1,
    ColorTemperature = 2,
    Color = 4,
    Color1 = 8,
    Color2 = 16,
}

export class BuildingCreateDTO implements IBuildingCreateDTO {
    buildingId?: string | undefined;
    name?: string | undefined;
    apartmentsCount?: number;
    floors?: FloorConfigDTO[] | undefined;
    linkedRisersIds?: string[] | undefined;

    constructor(data?: IBuildingCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            this.name = _data["name"];
            this.apartmentsCount = _data["apartmentsCount"];
            if (Array.isArray(_data["floors"])) {
                this.floors = [] as any;
                for (let item of _data["floors"])
                    this.floors!.push(FloorConfigDTO.fromJS(item));
            }
            if (Array.isArray(_data["linkedRisersIds"])) {
                this.linkedRisersIds = [] as any;
                for (let item of _data["linkedRisersIds"])
                    this.linkedRisersIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BuildingCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        data["name"] = this.name;
        data["apartmentsCount"] = this.apartmentsCount;
        if (Array.isArray(this.floors)) {
            data["floors"] = [];
            for (let item of this.floors)
                data["floors"].push(item.toJSON());
        }
        if (Array.isArray(this.linkedRisersIds)) {
            data["linkedRisersIds"] = [];
            for (let item of this.linkedRisersIds)
                data["linkedRisersIds"].push(item);
        }
        return data;
    }
}

export interface IBuildingCreateDTO {
    buildingId?: string | undefined;
    name?: string | undefined;
    apartmentsCount?: number;
    floors?: FloorConfigDTO[] | undefined;
    linkedRisersIds?: string[] | undefined;
}

export class BuildingDTO implements IBuildingDTO {
    buildingId?: string;
    index?: number;
    name?: string | undefined;
    code?: string | undefined;
    risers?: RiserDTO[] | undefined;
    floors?: FloorDTO[] | undefined;
    apartments?: ApartmentDTO[] | undefined;
    keypadCodePasspartoutCode?: string | undefined;
    backboneInterface?: RiserInterfaceDTO;

    constructor(data?: IBuildingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            this.index = _data["index"];
            this.name = _data["name"];
            this.code = _data["code"];
            if (Array.isArray(_data["risers"])) {
                this.risers = [] as any;
                for (let item of _data["risers"])
                    this.risers!.push(RiserDTO.fromJS(item));
            }
            if (Array.isArray(_data["floors"])) {
                this.floors = [] as any;
                for (let item of _data["floors"])
                    this.floors!.push(FloorDTO.fromJS(item));
            }
            if (Array.isArray(_data["apartments"])) {
                this.apartments = [] as any;
                for (let item of _data["apartments"])
                    this.apartments!.push(ApartmentDTO.fromJS(item));
            }
            this.keypadCodePasspartoutCode = _data["keypadCodePasspartoutCode"];
            this.backboneInterface = _data["backboneInterface"] ? RiserInterfaceDTO.fromJS(_data["backboneInterface"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BuildingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        data["index"] = this.index;
        data["name"] = this.name;
        data["code"] = this.code;
        if (Array.isArray(this.risers)) {
            data["risers"] = [];
            for (let item of this.risers)
                data["risers"].push(item.toJSON());
        }
        if (Array.isArray(this.floors)) {
            data["floors"] = [];
            for (let item of this.floors)
                data["floors"].push(item.toJSON());
        }
        if (Array.isArray(this.apartments)) {
            data["apartments"] = [];
            for (let item of this.apartments)
                data["apartments"].push(item.toJSON());
        }
        data["keypadCodePasspartoutCode"] = this.keypadCodePasspartoutCode;
        data["backboneInterface"] = this.backboneInterface ? this.backboneInterface.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBuildingDTO {
    buildingId?: string;
    index?: number;
    name?: string | undefined;
    code?: string | undefined;
    risers?: RiserDTO[] | undefined;
    floors?: FloorDTO[] | undefined;
    apartments?: ApartmentDTO[] | undefined;
    keypadCodePasspartoutCode?: string | undefined;
    backboneInterface?: RiserInterfaceDTO;
}

export class BuildingImportDto implements IBuildingImportDto {
    buildingId?: string;
    name?: string | undefined;
    keypadCode?: string | undefined;
    apartments?: ApartmentDTO[] | undefined;

    constructor(data?: IBuildingImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            this.name = _data["name"];
            this.keypadCode = _data["keypadCode"];
            if (Array.isArray(_data["apartments"])) {
                this.apartments = [] as any;
                for (let item of _data["apartments"])
                    this.apartments!.push(ApartmentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BuildingImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        data["name"] = this.name;
        data["keypadCode"] = this.keypadCode;
        if (Array.isArray(this.apartments)) {
            data["apartments"] = [];
            for (let item of this.apartments)
                data["apartments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBuildingImportDto {
    buildingId?: string;
    name?: string | undefined;
    keypadCode?: string | undefined;
    apartments?: ApartmentDTO[] | undefined;
}

export class ButtonTrigger extends Trigger implements IButtonTrigger {
    devices?: Device[] | undefined;

    constructor(data?: IButtonTrigger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(Device.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ButtonTrigger {
        data = typeof data === 'object' ? data : {};
        let result = new ButtonTrigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IButtonTrigger extends ITrigger {
    devices?: Device[] | undefined;
}

/** 0 = Pointtopoint 1 = ToAll */
export enum CallType {
    Pointtopoint = 0,
    ToAll = 1,
}

export class CallingCodeDTO implements ICallingCodeDTO {
    buildingCode?: string | undefined;
    riserCode?: string | undefined;
    floorCode?: string | undefined;
    apartmentCode?: string | undefined;
    riserDoubleChars?: boolean;
    floorDoubleChars?: boolean;
    apartmentDoubleChars?: boolean;

    constructor(data?: ICallingCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingCode = _data["buildingCode"];
            this.riserCode = _data["riserCode"];
            this.floorCode = _data["floorCode"];
            this.apartmentCode = _data["apartmentCode"];
            this.riserDoubleChars = _data["riserDoubleChars"];
            this.floorDoubleChars = _data["floorDoubleChars"];
            this.apartmentDoubleChars = _data["apartmentDoubleChars"];
        }
    }

    static fromJS(data: any): CallingCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CallingCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingCode"] = this.buildingCode;
        data["riserCode"] = this.riserCode;
        data["floorCode"] = this.floorCode;
        data["apartmentCode"] = this.apartmentCode;
        data["riserDoubleChars"] = this.riserDoubleChars;
        data["floorDoubleChars"] = this.floorDoubleChars;
        data["apartmentDoubleChars"] = this.apartmentDoubleChars;
        return data;
    }
}

export interface ICallingCodeDTO {
    buildingCode?: string | undefined;
    riserCode?: string | undefined;
    floorCode?: string | undefined;
    apartmentCode?: string | undefined;
    riserDoubleChars?: boolean;
    floorDoubleChars?: boolean;
    apartmentDoubleChars?: boolean;
}

export class CameraFunction extends VdeFunction implements ICameraFunction {
    type?: CameraType;

    constructor(data?: ICameraFunction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CameraFunction {
        data = typeof data === 'object' ? data : {};
        let result = new CameraFunction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface ICameraFunction extends IVdeFunction {
    type?: CameraType;
}

/** 0 = Private 1 = Public 2 = TVCC */
export enum CameraType {
    Private = 0,
    Public = 1,
    TVCC = 2,
}

export class Color implements IColor {
    readonly r?: number;
    readonly g?: number;
    readonly b?: number;
    readonly a?: number;
    readonly isKnownColor?: boolean;
    readonly isEmpty?: boolean;
    readonly isNamedColor?: boolean;
    readonly isSystemColor?: boolean;
    readonly name?: string | undefined;

    constructor(data?: IColor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).r = _data["r"];
            (<any>this).g = _data["g"];
            (<any>this).b = _data["b"];
            (<any>this).a = _data["a"];
            (<any>this).isKnownColor = _data["isKnownColor"];
            (<any>this).isEmpty = _data["isEmpty"];
            (<any>this).isNamedColor = _data["isNamedColor"];
            (<any>this).isSystemColor = _data["isSystemColor"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): Color {
        data = typeof data === 'object' ? data : {};
        let result = new Color();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["r"] = this.r;
        data["g"] = this.g;
        data["b"] = this.b;
        data["a"] = this.a;
        data["isKnownColor"] = this.isKnownColor;
        data["isEmpty"] = this.isEmpty;
        data["isNamedColor"] = this.isNamedColor;
        data["isSystemColor"] = this.isSystemColor;
        data["name"] = this.name;
        return data;
    }
}

export interface IColor {
    r?: number;
    g?: number;
    b?: number;
    a?: number;
    isKnownColor?: boolean;
    isEmpty?: boolean;
    isNamedColor?: boolean;
    isSystemColor?: boolean;
    name?: string | undefined;
}

export class ColoredLightExtDevice extends ExtDevice implements IColoredLightExtDevice {
    coloredLightType?: ColoredLightType;
    readonly philipsHueBridge?: string | undefined;
    readonly philipsHueLamp?: string | undefined;
    readonly philipsHueLampName?: string | undefined;
    readonly lifxLamp?: string | undefined;
    readonly dmxMacAddress?: string | undefined;
    readonly dmxNode?: string | undefined;

    constructor(data?: IColoredLightExtDevice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.coloredLightType = _data["coloredLightType"];
            (<any>this).philipsHueBridge = _data["philipsHueBridge"];
            (<any>this).philipsHueLamp = _data["philipsHueLamp"];
            (<any>this).philipsHueLampName = _data["philipsHueLampName"];
            (<any>this).lifxLamp = _data["lifxLamp"];
            (<any>this).dmxMacAddress = _data["dmxMacAddress"];
            (<any>this).dmxNode = _data["dmxNode"];
        }
    }

    static fromJS(data: any): ColoredLightExtDevice {
        data = typeof data === 'object' ? data : {};
        let result = new ColoredLightExtDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coloredLightType"] = this.coloredLightType;
        data["philipsHueBridge"] = this.philipsHueBridge;
        data["philipsHueLamp"] = this.philipsHueLamp;
        data["philipsHueLampName"] = this.philipsHueLampName;
        data["lifxLamp"] = this.lifxLamp;
        data["dmxMacAddress"] = this.dmxMacAddress;
        data["dmxNode"] = this.dmxNode;
        super.toJSON(data);
        return data;
    }
}

export interface IColoredLightExtDevice extends IExtDevice {
    coloredLightType?: ColoredLightType;
    philipsHueBridge?: string | undefined;
    philipsHueLamp?: string | undefined;
    philipsHueLampName?: string | undefined;
    lifxLamp?: string | undefined;
    dmxMacAddress?: string | undefined;
    dmxNode?: string | undefined;
}

/** 0 = None 1 = PhilipsHue 2 = Lifx 3 = Dmx */
export enum ColoredLightType {
    None = 0,
    PhilipsHue = 1,
    Lifx = 2,
    Dmx = 3,
}

/** 0 = None 1 = Up 2 = Down */
export enum CommandDirection {
    None = 0,
    Up = 1,
    Down = 2,
}

/** 0 = None 1 = Generic1 2 = Generic2 3 = Generic3 4 = Generic4 5 = Generic5 6 = Generic6 7 = Generic7 8 = Generic8 9 = Generic9 10 = Day 11 = Night 12 = Entrance 13 = Exit 14 = Key 15 = Fan 16 = Ring 17 = A 18 = B 19 = C 20 = D 21 = E 22 = F 23 = G 24 = H 25 = I 26 = J 27 = K 28 = L 29 = M 30 = N 31 = O 32 = P 33 = Q 34 = R 35 = S 36 = T 37 = U 38 = V 39 = W 40 = X 41 = Y 42 = Z 43 = Zero 44 = One 45 = Two 46 = Three 47 = Four 48 = Five 49 = Six 50 = Seven 51 = Eight 52 = Nine 53 = DefaultLoad 54 = Disabled1M 55 = Disabled2M 56 = Disabled3M 57 = LightGroup 58 = Shutter 59 = DimmerP2P 60 = DimmerGroup 61 = Player 62 = Disabled1Mb 63 = Disabled3Mb 64 = C_wrong */
export enum CommandIcon {
    None = 0,
    Generic1 = 1,
    Generic2 = 2,
    Generic3 = 3,
    Generic4 = 4,
    Generic5 = 5,
    Generic6 = 6,
    Generic7 = 7,
    Generic8 = 8,
    Generic9 = 9,
    Day = 10,
    Night = 11,
    Entrance = 12,
    Exit = 13,
    Key = 14,
    Fan = 15,
    Ring = 16,
    A = 17,
    B = 18,
    C = 19,
    D = 20,
    E = 21,
    F = 22,
    G = 23,
    H = 24,
    I = 25,
    J = 26,
    K = 27,
    L = 28,
    M = 29,
    N = 30,
    O = 31,
    P = 32,
    Q = 33,
    R = 34,
    S = 35,
    T = 36,
    U = 37,
    V = 38,
    W = 39,
    X = 40,
    Y = 41,
    Z = 42,
    Zero = 43,
    One = 44,
    Two = 45,
    Three = 46,
    Four = 47,
    Five = 48,
    Six = 49,
    Seven = 50,
    Eight = 51,
    Nine = 52,
    DefaultLoad = 53,
    Disabled1M = 54,
    Disabled2M = 55,
    Disabled3M = 56,
    LightGroup = 57,
    Shutter = 58,
    DimmerP2P = 59,
    DimmerGroup = 60,
    Player = 61,
    Disabled1Mb = 62,
    Disabled3Mb = 63,
    C_wrong = 64,
}

/** 0 = HalfSecond 1 = TwoSecond */
export enum CommandOpeningTime {
    HalfSecond = 0,
    TwoSecond = 1,
}

export class CommandSettings implements ICommandSettings {

    constructor(data?: ICommandSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CommandSettings {
        data = typeof data === 'object' ? data : {};
        let result = new CommandSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICommandSettings {
}

/** 0 = None 1 = Thermo 2 = Probe 3 = Actuator 4 = ShutterActuator 5 = DimmerActuator 6 = Command 7 = ShutterCommand 8 = ShutterActuatorCommand 9 = DimmerCommand 10 = SceneCommand 11 = Contact 12 = PlayerCommand 13 = BlindActuator 14 = MusicPlayer 15 = SensorCommand 16 = ColoredLight 17 = Xmeter 18 = DimmerDaliActuator 19 = GatewayDaliActuator 20 = EnergyMeter 21 = LoadCentralUnit 22 = LoadControlActuactor 23 = LoadControlCommand 24 = LockVDECommand 25 = ActuatorLockVDE 26 = StaircaseLightCommand 27 = FloorCallCommand 28 = ColorCommand 29 = Ambience */
export enum ComponentType {
    None = 0,
    Thermo = 1,
    Probe = 2,
    Actuator = 3,
    ShutterActuator = 4,
    DimmerActuator = 5,
    Command = 6,
    ShutterCommand = 7,
    ShutterActuatorCommand = 8,
    DimmerCommand = 9,
    SceneCommand = 10,
    Contact = 11,
    PlayerCommand = 12,
    BlindActuator = 13,
    MusicPlayer = 14,
    SensorCommand = 15,
    ColoredLight = 16,
    Xmeter = 17,
    DimmerDaliActuator = 18,
    GatewayDaliActuator = 19,
    EnergyMeter = 20,
    LoadCentralUnit = 21,
    LoadControlActuactor = 22,
    LoadControlCommand = 23,
    LockVDECommand = 24,
    ActuatorLockVDE = 25,
    StaircaseLightCommand = 26,
    FloorCallCommand = 27,
    ColorCommand = 28,
    Ambience = 29,
}

/** 0 = NoProblem 1 = NoCommand 2 = NoActuatorAndCommand 3 = NoActuator 4 = NoButtonTrigger 5 = NoAction 6 = NoButtonTriggerAndAction 7 = SceneObjectProblem 8 = NoRoomAssigned 9 = NoRoomAssignedNoActuator 10 = NoRoomAssignedNoCommand 11 = NoRoomAssignedNoActuatorAndCommand 12 = ContactProblem 13 = NoRoomAssignedNoActuatorNoAmbience 14 = NoRoomAssignedNoCommandNoAmbience 15 = NoRoomAssignedNoActuatorAndCommandNoAmbience 16 = NoAmbience 17 = NoActuactorNoAmbience 18 = NoCommandNoAmbience 19 = NoActuatorAndCommandNoAmbience 20 = AlarmSystemOffline 21 = GroupMembersMismatch */
export enum CompromisedType {
    NoProblem = 0,
    NoCommand = 1,
    NoActuatorAndCommand = 2,
    NoActuator = 3,
    NoButtonTrigger = 4,
    NoAction = 5,
    NoButtonTriggerAndAction = 6,
    SceneObjectProblem = 7,
    NoRoomAssigned = 8,
    NoRoomAssignedNoActuator = 9,
    NoRoomAssignedNoCommand = 10,
    NoRoomAssignedNoActuatorAndCommand = 11,
    ContactProblem = 12,
    NoRoomAssignedNoActuatorNoAmbience = 13,
    NoRoomAssignedNoCommandNoAmbience = 14,
    NoRoomAssignedNoActuatorAndCommandNoAmbience = 15,
    NoAmbience = 16,
    NoActuactorNoAmbience = 17,
    NoCommandNoAmbience = 18,
    NoActuatorAndCommandNoAmbience = 19,
    AlarmSystemOffline = 20,
    GroupMembersMismatch = 21,
}

/** 0 = None 1 = NormallyOpen 2 = NormallyClose */
export enum ConctactType {
    None = 0,
    NormallyOpen = 1,
    NormallyClose = 2,
}

export class ConditionDTO implements IConditionDTO {
    objectName?: string | undefined;
    sceneObjectType?: SceneObjectType;
    energyObjectType?: EnergyMeterAndLoadControlType;
    conditionParams?: Condition | undefined;

    constructor(data?: IConditionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectName = _data["objectName"];
            this.sceneObjectType = _data["sceneObjectType"];
            this.energyObjectType = _data["energyObjectType"];
            this.conditionParams = _data["conditionParams"] ? Condition.fromJS(_data["conditionParams"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConditionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectName"] = this.objectName;
        data["sceneObjectType"] = this.sceneObjectType;
        data["energyObjectType"] = this.energyObjectType;
        data["conditionParams"] = this.conditionParams ? this.conditionParams.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConditionDTO {
    objectName?: string | undefined;
    sceneObjectType?: SceneObjectType;
    energyObjectType?: EnergyMeterAndLoadControlType;
    conditionParams?: Condition | undefined;
}

/** 0 = None 1 = Mostrine 2 = Preset */
export enum ConfigurationType {
    None = 0,
    Mostrine = 1,
    Preset = 2,
}

/** 0 = NoAction 1 = Protection 2 = Manual 3 = PreviousState */
export enum ContactType {
    NoAction = 0,
    Protection = 1,
    Manual = 2,
    PreviousState = 3,
}

/** 0 = None 1 = DaliDimmer 2 = DaliGateway */
export enum DaliType {
    None = 0,
    DaliDimmer = 1,
    DaliGateway = 2,
}

export class DateAndTimeTrigger extends Trigger implements IDateAndTimeTrigger {
    time?: string;
    weekDays?: WeekDay[] | undefined;

    constructor(data?: IDateAndTimeTrigger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.time = _data["time"];
            if (Array.isArray(_data["weekDays"])) {
                this.weekDays = [] as any;
                for (let item of _data["weekDays"])
                    this.weekDays!.push(item);
            }
        }
    }

    static fromJS(data: any): DateAndTimeTrigger {
        data = typeof data === 'object' ? data : {};
        let result = new DateAndTimeTrigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time;
        if (Array.isArray(this.weekDays)) {
            data["weekDays"] = [];
            for (let item of this.weekDays)
                data["weekDays"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDateAndTimeTrigger extends ITrigger {
    time?: string;
    weekDays?: WeekDay[] | undefined;
}

export class DefaultDevicesSettingsDTO implements IDefaultDevicesSettingsDTO {
    deviceUid?: string | undefined;
    thermoProbeSettings?: ThermoProbeSettingsObjectParam;
    shuttersActuatorSettings?: ShuttersActuatorSettingsObjectParam;
    lightsActuatorSettings?: LightsActuatorSettingsObjectDTO;
    lockCommandSettings?: LockCommandSettingsObjectDTO;
    lockActuatorSettings?: LockActuatorSettingsObjectParam;
    lightsCommandSettings?: LightsCommandSettingsObjectDTO;
    shuttersCommandSettings?: ShuttersCommandSettingsObjectDTO;
    selectedCommandIcon?: CommandIcon;
    hasChangeIconButtonVisible?: boolean;
    activeLinksLabel?: string | undefined;
    selectedComponentType?: ComponentType;
    thermoActuatorType?: ThermoActuatorType;
    isAggregateRoomObject?: boolean;
    roomType?: RoomType;
    identifier?: string | undefined;

    constructor(data?: IDefaultDevicesSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceUid = _data["deviceUid"];
            this.thermoProbeSettings = _data["thermoProbeSettings"] ? ThermoProbeSettingsObjectParam.fromJS(_data["thermoProbeSettings"]) : <any>undefined;
            this.shuttersActuatorSettings = _data["shuttersActuatorSettings"] ? ShuttersActuatorSettingsObjectParam.fromJS(_data["shuttersActuatorSettings"]) : <any>undefined;
            this.lightsActuatorSettings = _data["lightsActuatorSettings"] ? LightsActuatorSettingsObjectDTO.fromJS(_data["lightsActuatorSettings"]) : <any>undefined;
            this.lockCommandSettings = _data["lockCommandSettings"] ? LockCommandSettingsObjectDTO.fromJS(_data["lockCommandSettings"]) : <any>undefined;
            this.lockActuatorSettings = _data["lockActuatorSettings"] ? LockActuatorSettingsObjectParam.fromJS(_data["lockActuatorSettings"]) : <any>undefined;
            this.lightsCommandSettings = _data["lightsCommandSettings"] ? LightsCommandSettingsObjectDTO.fromJS(_data["lightsCommandSettings"]) : <any>undefined;
            this.shuttersCommandSettings = _data["shuttersCommandSettings"] ? ShuttersCommandSettingsObjectDTO.fromJS(_data["shuttersCommandSettings"]) : <any>undefined;
            this.selectedCommandIcon = _data["selectedCommandIcon"];
            this.hasChangeIconButtonVisible = _data["hasChangeIconButtonVisible"];
            this.activeLinksLabel = _data["activeLinksLabel"];
            this.selectedComponentType = _data["selectedComponentType"];
            this.thermoActuatorType = _data["thermoActuatorType"];
            this.isAggregateRoomObject = _data["isAggregateRoomObject"];
            this.roomType = _data["roomType"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): DefaultDevicesSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultDevicesSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceUid"] = this.deviceUid;
        data["thermoProbeSettings"] = this.thermoProbeSettings ? this.thermoProbeSettings.toJSON() : <any>undefined;
        data["shuttersActuatorSettings"] = this.shuttersActuatorSettings ? this.shuttersActuatorSettings.toJSON() : <any>undefined;
        data["lightsActuatorSettings"] = this.lightsActuatorSettings ? this.lightsActuatorSettings.toJSON() : <any>undefined;
        data["lockCommandSettings"] = this.lockCommandSettings ? this.lockCommandSettings.toJSON() : <any>undefined;
        data["lockActuatorSettings"] = this.lockActuatorSettings ? this.lockActuatorSettings.toJSON() : <any>undefined;
        data["lightsCommandSettings"] = this.lightsCommandSettings ? this.lightsCommandSettings.toJSON() : <any>undefined;
        data["shuttersCommandSettings"] = this.shuttersCommandSettings ? this.shuttersCommandSettings.toJSON() : <any>undefined;
        data["selectedCommandIcon"] = this.selectedCommandIcon;
        data["hasChangeIconButtonVisible"] = this.hasChangeIconButtonVisible;
        data["activeLinksLabel"] = this.activeLinksLabel;
        data["selectedComponentType"] = this.selectedComponentType;
        data["thermoActuatorType"] = this.thermoActuatorType;
        data["isAggregateRoomObject"] = this.isAggregateRoomObject;
        data["roomType"] = this.roomType;
        data["identifier"] = this.identifier;
        return data;
    }
}

export interface IDefaultDevicesSettingsDTO {
    deviceUid?: string | undefined;
    thermoProbeSettings?: ThermoProbeSettingsObjectParam;
    shuttersActuatorSettings?: ShuttersActuatorSettingsObjectParam;
    lightsActuatorSettings?: LightsActuatorSettingsObjectDTO;
    lockCommandSettings?: LockCommandSettingsObjectDTO;
    lockActuatorSettings?: LockActuatorSettingsObjectParam;
    lightsCommandSettings?: LightsCommandSettingsObjectDTO;
    shuttersCommandSettings?: ShuttersCommandSettingsObjectDTO;
    selectedCommandIcon?: CommandIcon;
    hasChangeIconButtonVisible?: boolean;
    activeLinksLabel?: string | undefined;
    selectedComponentType?: ComponentType;
    thermoActuatorType?: ThermoActuatorType;
    isAggregateRoomObject?: boolean;
    roomType?: RoomType;
    identifier?: string | undefined;
}

export class ObjectAction extends Action implements IObjectAction {
    linkableObjectId?: string | undefined;
    sceneLightState?: SceneLightState;
    dimmerStatus?: DimmerStatus;
    dimmerPercentage?: number;
    dimmerFadeIn?: number;
    dimmerFadeOut?: number;
    selectedColor?: Color;
    workingMode?: DimmerWorkingMode;
    temperature?: number;
    sceneShutterState?: SceneShutterState;
    sceneShutterWithSlatState?: SceneShutterWithSlatState;
    sceneShutterPosition?: number;
    sceneShutterOrientation?: SceneShutterOrientation;
    isShutterPositionManagement?: boolean;
    isShutterSlatManagement?: boolean;
    sceneSocketState?: SceneSocketState;
    sceneBlindState?: SceneBlindState;
    sceneLockState?: SceneLockState;
    thermostatStatus?: ThermostatStatus;
    thermostatTypeOfObject?: ThermoTypeOfObject;
    coolingSystemControlType?: SystemControlType;
    heatingSystemControlType?: SystemControlType;
    sharedSystemControlType?: SystemControlType;
    thermostatTriggerTemperature?: number;
    sceneFancoilState?: SceneFancoilState;
    fancoilSpeed?: number;
    sceneTowelWarmerState?: SceneTowelWarmerState;
    sceneColoredLightsState?: SceneColoredLightsState;
    coloredLightsIntensity?: number;
    coloredLightsTemperature?: number;
    coloredLightsColor?: number;
    scenePlayerState?: ScenePlayerState;
    playerVolume?: number;
    playerSourceType?: number;
    playerSourceId?: string | undefined;
    playerSourceDescription?: string | undefined;
    alarmPin?: string | undefined;
    alarmPartitions?: Action[] | undefined;
    alarmPartitionStatus?: AlarmPartitionStatus;
    alarmSensorStatusScene?: AlarmSensorStatusScene;
    alarmPartitionorSceneId?: string | undefined;
    alarmType?: AlarmType;
    duration?: number | undefined;
    delay?: number | undefined;
    sceneLoadManagementStatus?: SceneLoadManagementState;
    isAmbience?: boolean;
    isGroup?: boolean;

    constructor(data?: IObjectAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.linkableObjectId = _data["linkableObjectId"];
            this.sceneLightState = _data["sceneLightState"];
            this.dimmerStatus = _data["dimmerStatus"];
            this.dimmerPercentage = _data["dimmerPercentage"];
            this.dimmerFadeIn = _data["dimmerFadeIn"];
            this.dimmerFadeOut = _data["dimmerFadeOut"];
            this.selectedColor = _data["selectedColor"] ? Color.fromJS(_data["selectedColor"]) : <any>undefined;
            this.workingMode = _data["workingMode"];
            this.temperature = _data["temperature"];
            this.sceneShutterState = _data["sceneShutterState"];
            this.sceneShutterWithSlatState = _data["sceneShutterWithSlatState"];
            this.sceneShutterPosition = _data["sceneShutterPosition"];
            this.sceneShutterOrientation = _data["sceneShutterOrientation"];
            this.isShutterPositionManagement = _data["isShutterPositionManagement"];
            this.isShutterSlatManagement = _data["isShutterSlatManagement"];
            this.sceneSocketState = _data["sceneSocketState"];
            this.sceneBlindState = _data["sceneBlindState"];
            this.sceneLockState = _data["sceneLockState"];
            this.thermostatStatus = _data["thermostatStatus"];
            this.thermostatTypeOfObject = _data["thermostatTypeOfObject"];
            this.coolingSystemControlType = _data["coolingSystemControlType"];
            this.heatingSystemControlType = _data["heatingSystemControlType"];
            this.sharedSystemControlType = _data["sharedSystemControlType"];
            this.thermostatTriggerTemperature = _data["thermostatTriggerTemperature"];
            this.sceneFancoilState = _data["sceneFancoilState"];
            this.fancoilSpeed = _data["fancoilSpeed"];
            this.sceneTowelWarmerState = _data["sceneTowelWarmerState"];
            this.sceneColoredLightsState = _data["sceneColoredLightsState"];
            this.coloredLightsIntensity = _data["coloredLightsIntensity"];
            this.coloredLightsTemperature = _data["coloredLightsTemperature"];
            this.coloredLightsColor = _data["coloredLightsColor"];
            this.scenePlayerState = _data["scenePlayerState"];
            this.playerVolume = _data["playerVolume"];
            this.playerSourceType = _data["playerSourceType"];
            this.playerSourceId = _data["playerSourceId"];
            this.playerSourceDescription = _data["playerSourceDescription"];
            this.alarmPin = _data["alarmPin"];
            if (Array.isArray(_data["alarmPartitions"])) {
                this.alarmPartitions = [] as any;
                for (let item of _data["alarmPartitions"])
                    this.alarmPartitions!.push(Action.fromJS(item));
            }
            this.alarmPartitionStatus = _data["alarmPartitionStatus"];
            this.alarmSensorStatusScene = _data["alarmSensorStatusScene"];
            this.alarmPartitionorSceneId = _data["alarmPartitionorSceneId"];
            this.alarmType = _data["alarmType"];
            this.duration = _data["duration"];
            this.delay = _data["delay"];
            this.sceneLoadManagementStatus = _data["sceneLoadManagementStatus"];
            this.isAmbience = _data["isAmbience"];
            this.isGroup = _data["isGroup"];
        }
    }

    static fromJS(data: any): ObjectAction {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkableObjectId"] = this.linkableObjectId;
        data["sceneLightState"] = this.sceneLightState;
        data["dimmerStatus"] = this.dimmerStatus;
        data["dimmerPercentage"] = this.dimmerPercentage;
        data["dimmerFadeIn"] = this.dimmerFadeIn;
        data["dimmerFadeOut"] = this.dimmerFadeOut;
        data["selectedColor"] = this.selectedColor ? this.selectedColor.toJSON() : <any>undefined;
        data["workingMode"] = this.workingMode;
        data["temperature"] = this.temperature;
        data["sceneShutterState"] = this.sceneShutterState;
        data["sceneShutterWithSlatState"] = this.sceneShutterWithSlatState;
        data["sceneShutterPosition"] = this.sceneShutterPosition;
        data["sceneShutterOrientation"] = this.sceneShutterOrientation;
        data["isShutterPositionManagement"] = this.isShutterPositionManagement;
        data["isShutterSlatManagement"] = this.isShutterSlatManagement;
        data["sceneSocketState"] = this.sceneSocketState;
        data["sceneBlindState"] = this.sceneBlindState;
        data["sceneLockState"] = this.sceneLockState;
        data["thermostatStatus"] = this.thermostatStatus;
        data["thermostatTypeOfObject"] = this.thermostatTypeOfObject;
        data["coolingSystemControlType"] = this.coolingSystemControlType;
        data["heatingSystemControlType"] = this.heatingSystemControlType;
        data["sharedSystemControlType"] = this.sharedSystemControlType;
        data["thermostatTriggerTemperature"] = this.thermostatTriggerTemperature;
        data["sceneFancoilState"] = this.sceneFancoilState;
        data["fancoilSpeed"] = this.fancoilSpeed;
        data["sceneTowelWarmerState"] = this.sceneTowelWarmerState;
        data["sceneColoredLightsState"] = this.sceneColoredLightsState;
        data["coloredLightsIntensity"] = this.coloredLightsIntensity;
        data["coloredLightsTemperature"] = this.coloredLightsTemperature;
        data["coloredLightsColor"] = this.coloredLightsColor;
        data["scenePlayerState"] = this.scenePlayerState;
        data["playerVolume"] = this.playerVolume;
        data["playerSourceType"] = this.playerSourceType;
        data["playerSourceId"] = this.playerSourceId;
        data["playerSourceDescription"] = this.playerSourceDescription;
        data["alarmPin"] = this.alarmPin;
        if (Array.isArray(this.alarmPartitions)) {
            data["alarmPartitions"] = [];
            for (let item of this.alarmPartitions)
                data["alarmPartitions"].push(item.toJSON());
        }
        data["alarmPartitionStatus"] = this.alarmPartitionStatus;
        data["alarmSensorStatusScene"] = this.alarmSensorStatusScene;
        data["alarmPartitionorSceneId"] = this.alarmPartitionorSceneId;
        data["alarmType"] = this.alarmType;
        data["duration"] = this.duration;
        data["delay"] = this.delay;
        data["sceneLoadManagementStatus"] = this.sceneLoadManagementStatus;
        data["isAmbience"] = this.isAmbience;
        data["isGroup"] = this.isGroup;
        super.toJSON(data);
        return data;
    }
}

export interface IObjectAction extends IAction {
    linkableObjectId?: string | undefined;
    sceneLightState?: SceneLightState;
    dimmerStatus?: DimmerStatus;
    dimmerPercentage?: number;
    dimmerFadeIn?: number;
    dimmerFadeOut?: number;
    selectedColor?: Color;
    workingMode?: DimmerWorkingMode;
    temperature?: number;
    sceneShutterState?: SceneShutterState;
    sceneShutterWithSlatState?: SceneShutterWithSlatState;
    sceneShutterPosition?: number;
    sceneShutterOrientation?: SceneShutterOrientation;
    isShutterPositionManagement?: boolean;
    isShutterSlatManagement?: boolean;
    sceneSocketState?: SceneSocketState;
    sceneBlindState?: SceneBlindState;
    sceneLockState?: SceneLockState;
    thermostatStatus?: ThermostatStatus;
    thermostatTypeOfObject?: ThermoTypeOfObject;
    coolingSystemControlType?: SystemControlType;
    heatingSystemControlType?: SystemControlType;
    sharedSystemControlType?: SystemControlType;
    thermostatTriggerTemperature?: number;
    sceneFancoilState?: SceneFancoilState;
    fancoilSpeed?: number;
    sceneTowelWarmerState?: SceneTowelWarmerState;
    sceneColoredLightsState?: SceneColoredLightsState;
    coloredLightsIntensity?: number;
    coloredLightsTemperature?: number;
    coloredLightsColor?: number;
    scenePlayerState?: ScenePlayerState;
    playerVolume?: number;
    playerSourceType?: number;
    playerSourceId?: string | undefined;
    playerSourceDescription?: string | undefined;
    alarmPin?: string | undefined;
    alarmPartitions?: Action[] | undefined;
    alarmPartitionStatus?: AlarmPartitionStatus;
    alarmSensorStatusScene?: AlarmSensorStatusScene;
    alarmPartitionorSceneId?: string | undefined;
    alarmType?: AlarmType;
    duration?: number | undefined;
    delay?: number | undefined;
    sceneLoadManagementStatus?: SceneLoadManagementState;
    isAmbience?: boolean;
    isGroup?: boolean;
}

export class DefaultObjectAction extends ObjectAction implements IDefaultObjectAction {
    isEnabled?: boolean;

    constructor(data?: IDefaultObjectAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): DefaultObjectAction {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultObjectAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        super.toJSON(data);
        return data;
    }
}

export interface IDefaultObjectAction extends IObjectAction {
    isEnabled?: boolean;
}

export class DelayValue implements IDelayValue {
    value?: number;
    description?: string | undefined;

    constructor(data?: IDelayValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DelayValue {
        data = typeof data === 'object' ? data : {};
        let result = new DelayValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["description"] = this.description;
        return data;
    }
}

export interface IDelayValue {
    value?: number;
    description?: string | undefined;
}

/** 0 = Numbers 1 = Letters */
export enum DenominationMode {
    Numbers = 0,
    Letters = 1,
}

export class Device implements IDevice {
    uid?: string | undefined;
    id?: string | undefined;
    model?: string | undefined;
    modelObject?: string | undefined;
    hasSubModule?: boolean;
    isManaged?: boolean;
    isShutterWithPosition?: boolean;
    hasStopFunction?: boolean;
    canHandlePreset?: boolean;
    isAnomaly?: boolean;
    isBlocking?: boolean;
    isF422Acompatible?: boolean;
    problemType?: ProblemType;
    isIgnored?: boolean;
    slots?: Slot[] | undefined;
    functionType?: FunctionType;
    systemType?: SystemType;
    componentTypes?: ComponentType[] | undefined;
    isDoubleDimmer?: boolean;
    canHandleDoubleDimmer?: boolean;
    thermoSystemControlType?: SystemControlType[] | undefined;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    deviceIconsVisibility?: DeviceIconsVisibility;
    ledIntensity?: number;
    interface?: number;
    ledModality?: DeviceLedModality;
    hasRefresherFeedback?: boolean;
    hasChanges?: boolean;
    fwVersion?: string | undefined;
    deviceConfiguration?: { [key: string]: string; } | undefined;
    readonly firmwareVersion?: string | undefined;

    constructor(data?: IDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.id = _data["id"];
            this.model = _data["model"];
            this.modelObject = _data["modelObject"];
            this.hasSubModule = _data["hasSubModule"];
            this.isManaged = _data["isManaged"];
            this.isShutterWithPosition = _data["isShutterWithPosition"];
            this.hasStopFunction = _data["hasStopFunction"];
            this.canHandlePreset = _data["canHandlePreset"];
            this.isAnomaly = _data["isAnomaly"];
            this.isBlocking = _data["isBlocking"];
            this.isF422Acompatible = _data["isF422Acompatible"];
            this.problemType = _data["problemType"];
            this.isIgnored = _data["isIgnored"];
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots!.push(Slot.fromJS(item));
            }
            this.functionType = _data["functionType"];
            this.systemType = _data["systemType"];
            if (Array.isArray(_data["componentTypes"])) {
                this.componentTypes = [] as any;
                for (let item of _data["componentTypes"])
                    this.componentTypes!.push(item);
            }
            this.isDoubleDimmer = _data["isDoubleDimmer"];
            this.canHandleDoubleDimmer = _data["canHandleDoubleDimmer"];
            if (Array.isArray(_data["thermoSystemControlType"])) {
                this.thermoSystemControlType = [] as any;
                for (let item of _data["thermoSystemControlType"])
                    this.thermoSystemControlType!.push(item);
            }
            this.deviceBrightness = _data["deviceBrightness"];
            this.showLedsInStandby = _data["showLedsInStandby"];
            this.isProximityEnabled = _data["isProximityEnabled"];
            this.deviceProximity = _data["deviceProximity"];
            this.deviceIconsVisibility = _data["deviceIconsVisibility"];
            this.ledIntensity = _data["ledIntensity"];
            this.interface = _data["interface"];
            this.ledModality = _data["ledModality"];
            this.hasRefresherFeedback = _data["hasRefresherFeedback"];
            this.hasChanges = _data["hasChanges"];
            this.fwVersion = _data["fwVersion"];
            if (_data["deviceConfiguration"]) {
                this.deviceConfiguration = {} as any;
                for (let key in _data["deviceConfiguration"]) {
                    if (_data["deviceConfiguration"].hasOwnProperty(key))
                        (<any>this.deviceConfiguration)![key] = _data["deviceConfiguration"][key];
                }
            }
            (<any>this).firmwareVersion = _data["firmwareVersion"];
        }
    }

    static fromJS(data: any): Device {
        data = typeof data === 'object' ? data : {};
        let result = new Device();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["id"] = this.id;
        data["model"] = this.model;
        data["modelObject"] = this.modelObject;
        data["hasSubModule"] = this.hasSubModule;
        data["isManaged"] = this.isManaged;
        data["isShutterWithPosition"] = this.isShutterWithPosition;
        data["hasStopFunction"] = this.hasStopFunction;
        data["canHandlePreset"] = this.canHandlePreset;
        data["isAnomaly"] = this.isAnomaly;
        data["isBlocking"] = this.isBlocking;
        data["isF422Acompatible"] = this.isF422Acompatible;
        data["problemType"] = this.problemType;
        data["isIgnored"] = this.isIgnored;
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item.toJSON());
        }
        data["functionType"] = this.functionType;
        data["systemType"] = this.systemType;
        if (Array.isArray(this.componentTypes)) {
            data["componentTypes"] = [];
            for (let item of this.componentTypes)
                data["componentTypes"].push(item);
        }
        data["isDoubleDimmer"] = this.isDoubleDimmer;
        data["canHandleDoubleDimmer"] = this.canHandleDoubleDimmer;
        if (Array.isArray(this.thermoSystemControlType)) {
            data["thermoSystemControlType"] = [];
            for (let item of this.thermoSystemControlType)
                data["thermoSystemControlType"].push(item);
        }
        data["deviceBrightness"] = this.deviceBrightness;
        data["showLedsInStandby"] = this.showLedsInStandby;
        data["isProximityEnabled"] = this.isProximityEnabled;
        data["deviceProximity"] = this.deviceProximity;
        data["deviceIconsVisibility"] = this.deviceIconsVisibility;
        data["ledIntensity"] = this.ledIntensity;
        data["interface"] = this.interface;
        data["ledModality"] = this.ledModality;
        data["hasRefresherFeedback"] = this.hasRefresherFeedback;
        data["hasChanges"] = this.hasChanges;
        data["fwVersion"] = this.fwVersion;
        if (this.deviceConfiguration) {
            data["deviceConfiguration"] = {};
            for (let key in this.deviceConfiguration) {
                if (this.deviceConfiguration.hasOwnProperty(key))
                    (<any>data["deviceConfiguration"])[key] = (<any>this.deviceConfiguration)[key];
            }
        }
        data["firmwareVersion"] = this.firmwareVersion;
        return data;
    }
}

export interface IDevice {
    uid?: string | undefined;
    id?: string | undefined;
    model?: string | undefined;
    modelObject?: string | undefined;
    hasSubModule?: boolean;
    isManaged?: boolean;
    isShutterWithPosition?: boolean;
    hasStopFunction?: boolean;
    canHandlePreset?: boolean;
    isAnomaly?: boolean;
    isBlocking?: boolean;
    isF422Acompatible?: boolean;
    problemType?: ProblemType;
    isIgnored?: boolean;
    slots?: Slot[] | undefined;
    functionType?: FunctionType;
    systemType?: SystemType;
    componentTypes?: ComponentType[] | undefined;
    isDoubleDimmer?: boolean;
    canHandleDoubleDimmer?: boolean;
    thermoSystemControlType?: SystemControlType[] | undefined;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    deviceIconsVisibility?: DeviceIconsVisibility;
    ledIntensity?: number;
    interface?: number;
    ledModality?: DeviceLedModality;
    hasRefresherFeedback?: boolean;
    hasChanges?: boolean;
    fwVersion?: string | undefined;
    deviceConfiguration?: { [key: string]: string; } | undefined;
    firmwareVersion?: string | undefined;
}

/** 0 = None 1 = Min 2 = Max 3 = Med 4 = Off */
export enum DeviceBrightness {
    None = 0,
    Min = 1,
    Max = 2,
    Med = 3,
    Off = 4,
}

export class DeviceDTO implements IDeviceDTO {
    uid?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    model?: string | undefined;
    modelObject?: string | undefined;
    isManaged?: boolean;
    isShutterWithPosition?: boolean;
    canHandlePreset?: boolean;
    isAnomaly?: boolean;
    isBlocking?: boolean;
    isIgnored?: boolean;
    slots?: Slot[] | undefined;
    functionType?: FunctionType;
    systemType?: SystemType;
    componentTypes?: ComponentType[] | undefined;
    isDoubleDimmer?: boolean;
    canHandleDoubleDimmer?: boolean;
    problemType?: ProblemType;
    readonly isActuatorDevice?: boolean;
    readonly isCommandDevice?: boolean;
    readonly isThermostatDevice?: boolean;
    readonly isThermoProbeDevice?: boolean;
    readonly isAssigned?: boolean;
    readonly isAssignedCommand?: boolean;
    readonly isAssignedActuator?: boolean;
    readonly isAssignedActuatorAndCommand?: boolean;
    selectedComponentType?: ComponentType;
    settingsVisibility?: DeviceSettingsVisibilityDTO;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    deviceIconsVisibility?: DeviceIconsVisibility;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    hasRefresherFeedback?: boolean;
    fwVersion?: string | undefined;
    deviceConfiguration?: { [key: string]: string; } | undefined;
    defaultSettings?: DefaultDevicesSettingsDTO[] | undefined;

    constructor(data?: IDeviceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.model = _data["model"];
            this.modelObject = _data["modelObject"];
            this.isManaged = _data["isManaged"];
            this.isShutterWithPosition = _data["isShutterWithPosition"];
            this.canHandlePreset = _data["canHandlePreset"];
            this.isAnomaly = _data["isAnomaly"];
            this.isBlocking = _data["isBlocking"];
            this.isIgnored = _data["isIgnored"];
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots!.push(Slot.fromJS(item));
            }
            this.functionType = _data["functionType"];
            this.systemType = _data["systemType"];
            if (Array.isArray(_data["componentTypes"])) {
                this.componentTypes = [] as any;
                for (let item of _data["componentTypes"])
                    this.componentTypes!.push(item);
            }
            this.isDoubleDimmer = _data["isDoubleDimmer"];
            this.canHandleDoubleDimmer = _data["canHandleDoubleDimmer"];
            this.problemType = _data["problemType"];
            (<any>this).isActuatorDevice = _data["isActuatorDevice"];
            (<any>this).isCommandDevice = _data["isCommandDevice"];
            (<any>this).isThermostatDevice = _data["isThermostatDevice"];
            (<any>this).isThermoProbeDevice = _data["isThermoProbeDevice"];
            (<any>this).isAssigned = _data["isAssigned"];
            (<any>this).isAssignedCommand = _data["isAssignedCommand"];
            (<any>this).isAssignedActuator = _data["isAssignedActuator"];
            (<any>this).isAssignedActuatorAndCommand = _data["isAssignedActuatorAndCommand"];
            this.selectedComponentType = _data["selectedComponentType"];
            this.settingsVisibility = _data["settingsVisibility"] ? DeviceSettingsVisibilityDTO.fromJS(_data["settingsVisibility"]) : <any>undefined;
            this.deviceBrightness = _data["deviceBrightness"];
            this.showLedsInStandby = _data["showLedsInStandby"];
            this.isProximityEnabled = _data["isProximityEnabled"];
            this.deviceProximity = _data["deviceProximity"];
            this.deviceIconsVisibility = _data["deviceIconsVisibility"];
            this.ledIntensity = _data["ledIntensity"];
            this.ledModality = _data["ledModality"];
            this.hasRefresherFeedback = _data["hasRefresherFeedback"];
            this.fwVersion = _data["fwVersion"];
            if (_data["deviceConfiguration"]) {
                this.deviceConfiguration = {} as any;
                for (let key in _data["deviceConfiguration"]) {
                    if (_data["deviceConfiguration"].hasOwnProperty(key))
                        (<any>this.deviceConfiguration)![key] = _data["deviceConfiguration"][key];
                }
            }
            if (Array.isArray(_data["defaultSettings"])) {
                this.defaultSettings = [] as any;
                for (let item of _data["defaultSettings"])
                    this.defaultSettings!.push(DefaultDevicesSettingsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["id"] = this.id;
        data["name"] = this.name;
        data["model"] = this.model;
        data["modelObject"] = this.modelObject;
        data["isManaged"] = this.isManaged;
        data["isShutterWithPosition"] = this.isShutterWithPosition;
        data["canHandlePreset"] = this.canHandlePreset;
        data["isAnomaly"] = this.isAnomaly;
        data["isBlocking"] = this.isBlocking;
        data["isIgnored"] = this.isIgnored;
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item.toJSON());
        }
        data["functionType"] = this.functionType;
        data["systemType"] = this.systemType;
        if (Array.isArray(this.componentTypes)) {
            data["componentTypes"] = [];
            for (let item of this.componentTypes)
                data["componentTypes"].push(item);
        }
        data["isDoubleDimmer"] = this.isDoubleDimmer;
        data["canHandleDoubleDimmer"] = this.canHandleDoubleDimmer;
        data["problemType"] = this.problemType;
        data["isActuatorDevice"] = this.isActuatorDevice;
        data["isCommandDevice"] = this.isCommandDevice;
        data["isThermostatDevice"] = this.isThermostatDevice;
        data["isThermoProbeDevice"] = this.isThermoProbeDevice;
        data["isAssigned"] = this.isAssigned;
        data["isAssignedCommand"] = this.isAssignedCommand;
        data["isAssignedActuator"] = this.isAssignedActuator;
        data["isAssignedActuatorAndCommand"] = this.isAssignedActuatorAndCommand;
        data["selectedComponentType"] = this.selectedComponentType;
        data["settingsVisibility"] = this.settingsVisibility ? this.settingsVisibility.toJSON() : <any>undefined;
        data["deviceBrightness"] = this.deviceBrightness;
        data["showLedsInStandby"] = this.showLedsInStandby;
        data["isProximityEnabled"] = this.isProximityEnabled;
        data["deviceProximity"] = this.deviceProximity;
        data["deviceIconsVisibility"] = this.deviceIconsVisibility;
        data["ledIntensity"] = this.ledIntensity;
        data["ledModality"] = this.ledModality;
        data["hasRefresherFeedback"] = this.hasRefresherFeedback;
        data["fwVersion"] = this.fwVersion;
        if (this.deviceConfiguration) {
            data["deviceConfiguration"] = {};
            for (let key in this.deviceConfiguration) {
                if (this.deviceConfiguration.hasOwnProperty(key))
                    (<any>data["deviceConfiguration"])[key] = (<any>this.deviceConfiguration)[key];
            }
        }
        if (Array.isArray(this.defaultSettings)) {
            data["defaultSettings"] = [];
            for (let item of this.defaultSettings)
                data["defaultSettings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDeviceDTO {
    uid?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    model?: string | undefined;
    modelObject?: string | undefined;
    isManaged?: boolean;
    isShutterWithPosition?: boolean;
    canHandlePreset?: boolean;
    isAnomaly?: boolean;
    isBlocking?: boolean;
    isIgnored?: boolean;
    slots?: Slot[] | undefined;
    functionType?: FunctionType;
    systemType?: SystemType;
    componentTypes?: ComponentType[] | undefined;
    isDoubleDimmer?: boolean;
    canHandleDoubleDimmer?: boolean;
    problemType?: ProblemType;
    isActuatorDevice?: boolean;
    isCommandDevice?: boolean;
    isThermostatDevice?: boolean;
    isThermoProbeDevice?: boolean;
    isAssigned?: boolean;
    isAssignedCommand?: boolean;
    isAssignedActuator?: boolean;
    isAssignedActuatorAndCommand?: boolean;
    selectedComponentType?: ComponentType;
    settingsVisibility?: DeviceSettingsVisibilityDTO;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    deviceIconsVisibility?: DeviceIconsVisibility;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    hasRefresherFeedback?: boolean;
    fwVersion?: string | undefined;
    deviceConfiguration?: { [key: string]: string; } | undefined;
    defaultSettings?: DefaultDevicesSettingsDTO[] | undefined;
}

export class DeviceGlobalSettingsDTO implements IDeviceGlobalSettingsDTO {
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    deviceIconsVisibility?: DeviceIconsVisibility;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    hasRefresherFeedback?: boolean;

    constructor(data?: IDeviceGlobalSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceBrightness = _data["deviceBrightness"];
            this.showLedsInStandby = _data["showLedsInStandby"];
            this.isProximityEnabled = _data["isProximityEnabled"];
            this.deviceProximity = _data["deviceProximity"];
            this.deviceIconsVisibility = _data["deviceIconsVisibility"];
            this.ledIntensity = _data["ledIntensity"];
            this.ledModality = _data["ledModality"];
            this.hasRefresherFeedback = _data["hasRefresherFeedback"];
        }
    }

    static fromJS(data: any): DeviceGlobalSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceGlobalSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceBrightness"] = this.deviceBrightness;
        data["showLedsInStandby"] = this.showLedsInStandby;
        data["isProximityEnabled"] = this.isProximityEnabled;
        data["deviceProximity"] = this.deviceProximity;
        data["deviceIconsVisibility"] = this.deviceIconsVisibility;
        data["ledIntensity"] = this.ledIntensity;
        data["ledModality"] = this.ledModality;
        data["hasRefresherFeedback"] = this.hasRefresherFeedback;
        return data;
    }
}

export interface IDeviceGlobalSettingsDTO {
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    deviceIconsVisibility?: DeviceIconsVisibility;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    hasRefresherFeedback?: boolean;
}

/** 0 = None 1 = AtTouch 2 = Always */
export enum DeviceIconsVisibility {
    None = 0,
    AtTouch = 1,
    Always = 2,
}

/** 0 = On 1 = OnDuringUpdate 2 = Off */
export enum DeviceLedModality {
    On = 0,
    OnDuringUpdate = 1,
    Off = 2,
}

/** 0 = None 1 = Min 2 = Med 3 = Max */
export enum DeviceProximity {
    None = 0,
    Min = 1,
    Med = 2,
    Max = 3,
}

export class DeviceSettingsDTO implements IDeviceSettingsDTO {
    deviceId?: string | undefined;
    lightsActuatorSettings?: LightsActuatorSettingsResultList;
    lightsCommandSettings?: LightsCommandSettingsResultList;
    lockActuatorSettings?: LockActuatorSettingsResult;
    lockCommandSettingsResult?: LockCommandSettingsResultList;
    shutterActuatorSettings?: ShutterActuatorSettingsResult;
    shutterCommandSettings?: ShutterCommandSettingsResultList;
    thermoProbeSettings?: ThermoProbeSettingsResult;
    commandIcon?: CommandIcon;

    constructor(data?: IDeviceSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.lightsActuatorSettings = _data["lightsActuatorSettings"] ? LightsActuatorSettingsResultList.fromJS(_data["lightsActuatorSettings"]) : <any>undefined;
            this.lightsCommandSettings = _data["lightsCommandSettings"] ? LightsCommandSettingsResultList.fromJS(_data["lightsCommandSettings"]) : <any>undefined;
            this.lockActuatorSettings = _data["lockActuatorSettings"] ? LockActuatorSettingsResult.fromJS(_data["lockActuatorSettings"]) : <any>undefined;
            this.lockCommandSettingsResult = _data["lockCommandSettingsResult"] ? LockCommandSettingsResultList.fromJS(_data["lockCommandSettingsResult"]) : <any>undefined;
            this.shutterActuatorSettings = _data["shutterActuatorSettings"] ? ShutterActuatorSettingsResult.fromJS(_data["shutterActuatorSettings"]) : <any>undefined;
            this.shutterCommandSettings = _data["shutterCommandSettings"] ? ShutterCommandSettingsResultList.fromJS(_data["shutterCommandSettings"]) : <any>undefined;
            this.thermoProbeSettings = _data["thermoProbeSettings"] ? ThermoProbeSettingsResult.fromJS(_data["thermoProbeSettings"]) : <any>undefined;
            this.commandIcon = _data["commandIcon"];
        }
    }

    static fromJS(data: any): DeviceSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["lightsActuatorSettings"] = this.lightsActuatorSettings ? this.lightsActuatorSettings.toJSON() : <any>undefined;
        data["lightsCommandSettings"] = this.lightsCommandSettings ? this.lightsCommandSettings.toJSON() : <any>undefined;
        data["lockActuatorSettings"] = this.lockActuatorSettings ? this.lockActuatorSettings.toJSON() : <any>undefined;
        data["lockCommandSettingsResult"] = this.lockCommandSettingsResult ? this.lockCommandSettingsResult.toJSON() : <any>undefined;
        data["shutterActuatorSettings"] = this.shutterActuatorSettings ? this.shutterActuatorSettings.toJSON() : <any>undefined;
        data["shutterCommandSettings"] = this.shutterCommandSettings ? this.shutterCommandSettings.toJSON() : <any>undefined;
        data["thermoProbeSettings"] = this.thermoProbeSettings ? this.thermoProbeSettings.toJSON() : <any>undefined;
        data["commandIcon"] = this.commandIcon;
        return data;
    }
}

export interface IDeviceSettingsDTO {
    deviceId?: string | undefined;
    lightsActuatorSettings?: LightsActuatorSettingsResultList;
    lightsCommandSettings?: LightsCommandSettingsResultList;
    lockActuatorSettings?: LockActuatorSettingsResult;
    lockCommandSettingsResult?: LockCommandSettingsResultList;
    shutterActuatorSettings?: ShutterActuatorSettingsResult;
    shutterCommandSettings?: ShutterCommandSettingsResultList;
    thermoProbeSettings?: ThermoProbeSettingsResult;
    commandIcon?: CommandIcon;
}

export class DeviceSettingsVisibilityDTO implements IDeviceSettingsVisibilityDTO {
    hasSettings?: boolean;
    hasBrightness?: boolean;
    hasProximity?: boolean;
    hasStandby?: boolean;
    hasLedIntensity?: boolean;
    hasLedModality?: boolean;
    hasRefreshFeedback?: boolean;

    constructor(data?: IDeviceSettingsVisibilityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasSettings = _data["hasSettings"];
            this.hasBrightness = _data["hasBrightness"];
            this.hasProximity = _data["hasProximity"];
            this.hasStandby = _data["hasStandby"];
            this.hasLedIntensity = _data["hasLedIntensity"];
            this.hasLedModality = _data["hasLedModality"];
            this.hasRefreshFeedback = _data["hasRefreshFeedback"];
        }
    }

    static fromJS(data: any): DeviceSettingsVisibilityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSettingsVisibilityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasSettings"] = this.hasSettings;
        data["hasBrightness"] = this.hasBrightness;
        data["hasProximity"] = this.hasProximity;
        data["hasStandby"] = this.hasStandby;
        data["hasLedIntensity"] = this.hasLedIntensity;
        data["hasLedModality"] = this.hasLedModality;
        data["hasRefreshFeedback"] = this.hasRefreshFeedback;
        return data;
    }
}

export interface IDeviceSettingsVisibilityDTO {
    hasSettings?: boolean;
    hasBrightness?: boolean;
    hasProximity?: boolean;
    hasStandby?: boolean;
    hasLedIntensity?: boolean;
    hasLedModality?: boolean;
    hasRefreshFeedback?: boolean;
}

/** 0 = ALL 1 = ACTUATORS 2 = COMMANDS 3 = THERMO 4 = THERMO_PROBE 5 = THERMO_HEATING_ACTUATORS 6 = THERMO_COOLING_ACTUATORS 7 = THERMO_HEATING_PUMPS 8 = THERMO_COOLING_PUMPS 9 = THERMO_SHARED_ACTUATORS 10 = THERMO_SHARED_PUMPS */
export enum DevicesFilterByType {
    ALL = 0,
    ACTUATORS = 1,
    COMMANDS = 2,
    THERMO = 3,
    THERMO_PROBE = 4,
    THERMO_HEATING_ACTUATORS = 5,
    THERMO_COOLING_ACTUATORS = 6,
    THERMO_HEATING_PUMPS = 7,
    THERMO_COOLING_PUMPS = 8,
    THERMO_SHARED_ACTUATORS = 9,
    THERMO_SHARED_PUMPS = 10,
}

export class DimmerDaliActuatorSettings extends ActuatorSettings implements IDimmerDaliActuatorSettings {
    isRestoreStateAfterResetEnabled?: boolean;
    isMinimumregulationLevelEnabled?: boolean;
    minimumRegulationLevelValue?: number;
    loadType?: LightsLoadTypes;
    hasPUL?: boolean;
    loadDaliTypes?: BitmaskDaliLoadTypes[] | undefined;

    constructor(data?: IDimmerDaliActuatorSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isRestoreStateAfterResetEnabled = _data["isRestoreStateAfterResetEnabled"];
            this.isMinimumregulationLevelEnabled = _data["isMinimumregulationLevelEnabled"];
            this.minimumRegulationLevelValue = _data["minimumRegulationLevelValue"];
            this.loadType = _data["loadType"];
            this.hasPUL = _data["hasPUL"];
            if (Array.isArray(_data["loadDaliTypes"])) {
                this.loadDaliTypes = [] as any;
                for (let item of _data["loadDaliTypes"])
                    this.loadDaliTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): DimmerDaliActuatorSettings {
        data = typeof data === 'object' ? data : {};
        let result = new DimmerDaliActuatorSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRestoreStateAfterResetEnabled"] = this.isRestoreStateAfterResetEnabled;
        data["isMinimumregulationLevelEnabled"] = this.isMinimumregulationLevelEnabled;
        data["minimumRegulationLevelValue"] = this.minimumRegulationLevelValue;
        data["loadType"] = this.loadType;
        data["hasPUL"] = this.hasPUL;
        if (Array.isArray(this.loadDaliTypes)) {
            data["loadDaliTypes"] = [];
            for (let item of this.loadDaliTypes)
                data["loadDaliTypes"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDimmerDaliActuatorSettings extends IActuatorSettings {
    isRestoreStateAfterResetEnabled?: boolean;
    isMinimumregulationLevelEnabled?: boolean;
    minimumRegulationLevelValue?: number;
    loadType?: LightsLoadTypes;
    hasPUL?: boolean;
    loadDaliTypes?: BitmaskDaliLoadTypes[] | undefined;
}

/** 0 = None 1 = On 2 = Off 3 = Dimmer */
export enum DimmerStatus {
    None = 0,
    On = 1,
    Off = 2,
    Dimmer = 3,
}

/** 0 = None 1 = Any 2 = WhiteTemperature 3 = ColorTemperature */
export enum DimmerWorkingMode {
    None = 0,
    Any = 1,
    WhiteTemperature = 2,
    ColorTemperature = 3,
}

export class EMailAction extends Action implements IEMailAction {

    constructor(data?: IEMailAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): EMailAction {
        data = typeof data === 'object' ? data : {};
        let result = new EMailAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEMailAction extends IAction {
}

export class EPDeviceConfigAccessory implements IEPDeviceConfigAccessory {
    lockTimingValue?: number;
    hasLockPushButton?: boolean;

    constructor(data?: IEPDeviceConfigAccessory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lockTimingValue = _data["lockTimingValue"];
            this.hasLockPushButton = _data["hasLockPushButton"];
        }
    }

    static fromJS(data: any): EPDeviceConfigAccessory {
        data = typeof data === 'object' ? data : {};
        let result = new EPDeviceConfigAccessory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lockTimingValue"] = this.lockTimingValue;
        data["hasLockPushButton"] = this.hasLockPushButton;
        return data;
    }
}

export interface IEPDeviceConfigAccessory {
    lockTimingValue?: number;
    hasLockPushButton?: boolean;
}

export class EPDeviceConfigDTO implements IEPDeviceConfigDTO {
    riserAddr?: number;
    secLockAddr?: number;
    lockTimingValue?: number;
    hasMultipleCall?: boolean;
    callRepetitions?: number;
    isSelectedStaircaseLight?: boolean;
    isSelectedGeneral?: boolean;
    callAndLockTonesMode?: EpDeviceCallAndLockTonesMode;
    typeOfCallSignalValue?: number;
    screenInterface?: EpDeviceScreenMode;
    isSelectedLedCameraLightingAlwaysOn?: boolean;
    isSelectedLedCameraLightingDuringTheCall?: boolean;
    homePageMessage?: string | undefined;
    welcomePage?: EpDeviceWelcomePage;
    enableProximity?: boolean;
    welcomePageImageBase64?: string | undefined;
    welcomePageImageName?: string | undefined;
    welcomePageImageSetDateTime?: Date | undefined;
    readonly hasSecondaryLock?: boolean;

    constructor(data?: IEPDeviceConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.riserAddr = _data["riserAddr"];
            this.secLockAddr = _data["secLockAddr"];
            this.lockTimingValue = _data["lockTimingValue"];
            this.hasMultipleCall = _data["hasMultipleCall"];
            this.callRepetitions = _data["callRepetitions"];
            this.isSelectedStaircaseLight = _data["isSelectedStaircaseLight"];
            this.isSelectedGeneral = _data["isSelectedGeneral"];
            this.callAndLockTonesMode = _data["callAndLockTonesMode"];
            this.typeOfCallSignalValue = _data["typeOfCallSignalValue"];
            this.screenInterface = _data["screenInterface"];
            this.isSelectedLedCameraLightingAlwaysOn = _data["isSelectedLedCameraLightingAlwaysOn"];
            this.isSelectedLedCameraLightingDuringTheCall = _data["isSelectedLedCameraLightingDuringTheCall"];
            this.homePageMessage = _data["homePageMessage"];
            this.welcomePage = _data["welcomePage"];
            this.enableProximity = _data["enableProximity"];
            this.welcomePageImageBase64 = _data["welcomePageImageBase64"];
            this.welcomePageImageName = _data["welcomePageImageName"];
            this.welcomePageImageSetDateTime = _data["welcomePageImageSetDateTime"] ? new Date(_data["welcomePageImageSetDateTime"].toString()) : <any>undefined;
            (<any>this).hasSecondaryLock = _data["hasSecondaryLock"];
        }
    }

    static fromJS(data: any): EPDeviceConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EPDeviceConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riserAddr"] = this.riserAddr;
        data["secLockAddr"] = this.secLockAddr;
        data["lockTimingValue"] = this.lockTimingValue;
        data["hasMultipleCall"] = this.hasMultipleCall;
        data["callRepetitions"] = this.callRepetitions;
        data["isSelectedStaircaseLight"] = this.isSelectedStaircaseLight;
        data["isSelectedGeneral"] = this.isSelectedGeneral;
        data["callAndLockTonesMode"] = this.callAndLockTonesMode;
        data["typeOfCallSignalValue"] = this.typeOfCallSignalValue;
        data["screenInterface"] = this.screenInterface;
        data["isSelectedLedCameraLightingAlwaysOn"] = this.isSelectedLedCameraLightingAlwaysOn;
        data["isSelectedLedCameraLightingDuringTheCall"] = this.isSelectedLedCameraLightingDuringTheCall;
        data["homePageMessage"] = this.homePageMessage;
        data["welcomePage"] = this.welcomePage;
        data["enableProximity"] = this.enableProximity;
        data["welcomePageImageBase64"] = this.welcomePageImageBase64;
        data["welcomePageImageName"] = this.welcomePageImageName;
        data["welcomePageImageSetDateTime"] = this.welcomePageImageSetDateTime ? this.welcomePageImageSetDateTime.toISOString() : <any>undefined;
        data["hasSecondaryLock"] = this.hasSecondaryLock;
        return data;
    }
}

export interface IEPDeviceConfigDTO {
    riserAddr?: number;
    secLockAddr?: number;
    lockTimingValue?: number;
    hasMultipleCall?: boolean;
    callRepetitions?: number;
    isSelectedStaircaseLight?: boolean;
    isSelectedGeneral?: boolean;
    callAndLockTonesMode?: EpDeviceCallAndLockTonesMode;
    typeOfCallSignalValue?: number;
    screenInterface?: EpDeviceScreenMode;
    isSelectedLedCameraLightingAlwaysOn?: boolean;
    isSelectedLedCameraLightingDuringTheCall?: boolean;
    homePageMessage?: string | undefined;
    welcomePage?: EpDeviceWelcomePage;
    enableProximity?: boolean;
    welcomePageImageBase64?: string | undefined;
    welcomePageImageName?: string | undefined;
    welcomePageImageSetDateTime?: Date | undefined;
    hasSecondaryLock?: boolean;
}

export class EPDeviceConfigNetwork implements IEPDeviceConfigNetwork {
    isConnectedToEliot?: boolean;
    isReferenceRemote?: boolean;
    isWiFiNetwork?: boolean;
    isDhcpEnabled?: boolean;
    ipAddress?: string | undefined;
    submask?: string | undefined;
    gateway?: string | undefined;
    primaryDns?: string | undefined;
    secondaryDns?: string | undefined;
    macAddress?: string | undefined;
    networkName?: string | undefined;

    constructor(data?: IEPDeviceConfigNetwork) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isConnectedToEliot = _data["isConnectedToEliot"];
            this.isReferenceRemote = _data["isReferenceRemote"];
            this.isWiFiNetwork = _data["isWiFiNetwork"];
            this.isDhcpEnabled = _data["isDhcpEnabled"];
            this.ipAddress = _data["ipAddress"];
            this.submask = _data["submask"];
            this.gateway = _data["gateway"];
            this.primaryDns = _data["primaryDns"];
            this.secondaryDns = _data["secondaryDns"];
            this.macAddress = _data["macAddress"];
            this.networkName = _data["networkName"];
        }
    }

    static fromJS(data: any): EPDeviceConfigNetwork {
        data = typeof data === 'object' ? data : {};
        let result = new EPDeviceConfigNetwork();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isConnectedToEliot"] = this.isConnectedToEliot;
        data["isReferenceRemote"] = this.isReferenceRemote;
        data["isWiFiNetwork"] = this.isWiFiNetwork;
        data["isDhcpEnabled"] = this.isDhcpEnabled;
        data["ipAddress"] = this.ipAddress;
        data["submask"] = this.submask;
        data["gateway"] = this.gateway;
        data["primaryDns"] = this.primaryDns;
        data["secondaryDns"] = this.secondaryDns;
        data["macAddress"] = this.macAddress;
        data["networkName"] = this.networkName;
        return data;
    }
}

export interface IEPDeviceConfigNetwork {
    isConnectedToEliot?: boolean;
    isReferenceRemote?: boolean;
    isWiFiNetwork?: boolean;
    isDhcpEnabled?: boolean;
    ipAddress?: string | undefined;
    submask?: string | undefined;
    gateway?: string | undefined;
    primaryDns?: string | undefined;
    secondaryDns?: string | undefined;
    macAddress?: string | undefined;
    networkName?: string | undefined;
}

export class EPDeviceDTO implements IEPDeviceDTO {
    deviceId?: string;
    scsAddr?: number;
    type?: EpDeviceType;
    readonly isConfigured?: boolean;
    readonly isCommissioned?: boolean;
    cloudId?: string | undefined;
    dspMacAddress?: string | undefined;
    cloudPublicKey?: string | undefined;
    masterSecretKey?: string | undefined;
    firmwareVersion?: string | undefined;
    config?: EPDeviceConfigDTO;
    switchboardId?: string;
    deviceName?: string | undefined;
    needsToSyncManually?: boolean;
    activationStatus?: EpDeviceActivationStatus;
    lastSyncDateTime?: Date | undefined;
    configNetwork?: EPDeviceConfigNetwork;
    configAccessory?: EPDeviceConfigAccessory;

    constructor(data?: IEPDeviceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.scsAddr = _data["scsAddr"];
            this.type = _data["type"];
            (<any>this).isConfigured = _data["isConfigured"];
            (<any>this).isCommissioned = _data["isCommissioned"];
            this.cloudId = _data["cloudId"];
            this.dspMacAddress = _data["dspMacAddress"];
            this.cloudPublicKey = _data["cloudPublicKey"];
            this.masterSecretKey = _data["masterSecretKey"];
            this.firmwareVersion = _data["firmwareVersion"];
            this.config = _data["config"] ? EPDeviceConfigDTO.fromJS(_data["config"]) : <any>undefined;
            this.switchboardId = _data["switchboardId"];
            this.deviceName = _data["deviceName"];
            this.needsToSyncManually = _data["needsToSyncManually"];
            this.activationStatus = _data["activationStatus"];
            this.lastSyncDateTime = _data["lastSyncDateTime"] ? new Date(_data["lastSyncDateTime"].toString()) : <any>undefined;
            this.configNetwork = _data["configNetwork"] ? EPDeviceConfigNetwork.fromJS(_data["configNetwork"]) : <any>undefined;
            this.configAccessory = _data["configAccessory"] ? EPDeviceConfigAccessory.fromJS(_data["configAccessory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EPDeviceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EPDeviceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["scsAddr"] = this.scsAddr;
        data["type"] = this.type;
        data["isConfigured"] = this.isConfigured;
        data["isCommissioned"] = this.isCommissioned;
        data["cloudId"] = this.cloudId;
        data["dspMacAddress"] = this.dspMacAddress;
        data["cloudPublicKey"] = this.cloudPublicKey;
        data["masterSecretKey"] = this.masterSecretKey;
        data["firmwareVersion"] = this.firmwareVersion;
        data["config"] = this.config ? this.config.toJSON() : <any>undefined;
        data["switchboardId"] = this.switchboardId;
        data["deviceName"] = this.deviceName;
        data["needsToSyncManually"] = this.needsToSyncManually;
        data["activationStatus"] = this.activationStatus;
        data["lastSyncDateTime"] = this.lastSyncDateTime ? this.lastSyncDateTime.toISOString() : <any>undefined;
        data["configNetwork"] = this.configNetwork ? this.configNetwork.toJSON() : <any>undefined;
        data["configAccessory"] = this.configAccessory ? this.configAccessory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEPDeviceDTO {
    deviceId?: string;
    scsAddr?: number;
    type?: EpDeviceType;
    isConfigured?: boolean;
    isCommissioned?: boolean;
    cloudId?: string | undefined;
    dspMacAddress?: string | undefined;
    cloudPublicKey?: string | undefined;
    masterSecretKey?: string | undefined;
    firmwareVersion?: string | undefined;
    config?: EPDeviceConfigDTO;
    switchboardId?: string;
    deviceName?: string | undefined;
    needsToSyncManually?: boolean;
    activationStatus?: EpDeviceActivationStatus;
    lastSyncDateTime?: Date | undefined;
    configNetwork?: EPDeviceConfigNetwork;
    configAccessory?: EPDeviceConfigAccessory;
}

export class EditAggregateCommandDTO implements IEditAggregateCommandDTO {
    aggregateCommand?: AggregateCommandDTO;
    deviceSettings?: DeviceSettingsDTO[] | undefined;

    constructor(data?: IEditAggregateCommandDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aggregateCommand = _data["aggregateCommand"] ? AggregateCommandDTO.fromJS(_data["aggregateCommand"]) : <any>undefined;
            if (Array.isArray(_data["deviceSettings"])) {
                this.deviceSettings = [] as any;
                for (let item of _data["deviceSettings"])
                    this.deviceSettings!.push(DeviceSettingsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditAggregateCommandDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EditAggregateCommandDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aggregateCommand"] = this.aggregateCommand ? this.aggregateCommand.toJSON() : <any>undefined;
        if (Array.isArray(this.deviceSettings)) {
            data["deviceSettings"] = [];
            for (let item of this.deviceSettings)
                data["deviceSettings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditAggregateCommandDTO {
    aggregateCommand?: AggregateCommandDTO;
    deviceSettings?: DeviceSettingsDTO[] | undefined;
}

export class EditRoomObjectDTO implements IEditRoomObjectDTO {
    roomObject?: AddRoomObjectDTO;
    deviceSettings?: DeviceSettingsDTO[] | undefined;

    constructor(data?: IEditRoomObjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roomObject = _data["roomObject"] ? AddRoomObjectDTO.fromJS(_data["roomObject"]) : <any>undefined;
            if (Array.isArray(_data["deviceSettings"])) {
                this.deviceSettings = [] as any;
                for (let item of _data["deviceSettings"])
                    this.deviceSettings!.push(DeviceSettingsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditRoomObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EditRoomObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roomObject"] = this.roomObject ? this.roomObject.toJSON() : <any>undefined;
        if (Array.isArray(this.deviceSettings)) {
            data["deviceSettings"] = [];
            for (let item of this.deviceSettings)
                data["deviceSettings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditRoomObjectDTO {
    roomObject?: AddRoomObjectDTO;
    deviceSettings?: DeviceSettingsDTO[] | undefined;
}

export class EditThermoRoomObjectDTO implements IEditThermoRoomObjectDTO {
    thermoRoomObject?: ThermoRoomObjectDTO;
    deviceSettings?: DeviceSettingsDTO[] | undefined;

    constructor(data?: IEditThermoRoomObjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.thermoRoomObject = _data["thermoRoomObject"] ? ThermoRoomObjectDTO.fromJS(_data["thermoRoomObject"]) : <any>undefined;
            if (Array.isArray(_data["deviceSettings"])) {
                this.deviceSettings = [] as any;
                for (let item of _data["deviceSettings"])
                    this.deviceSettings!.push(DeviceSettingsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditThermoRoomObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EditThermoRoomObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thermoRoomObject"] = this.thermoRoomObject ? this.thermoRoomObject.toJSON() : <any>undefined;
        if (Array.isArray(this.deviceSettings)) {
            data["deviceSettings"] = [];
            for (let item of this.deviceSettings)
                data["deviceSettings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditThermoRoomObjectDTO {
    thermoRoomObject?: ThermoRoomObjectDTO;
    deviceSettings?: DeviceSettingsDTO[] | undefined;
}

/** 0 = None 1 = Socket 2 = Light 3 = Kitchenappliances 4 = Shutter 5 = Heating 6 = Boiler 7 = Airconditioner 8 = Other 9 = Fridge 10 = Oven 11 = Washingmachine 12 = Dryer 13 = Dishwasher 14 = Multimedia 15 = Internetbox 16 = SwimmingPool 17 = Machine */
export enum EnergyMeterAndLoadControlType {
    None = 0,
    Socket = 1,
    Light = 2,
    Kitchenappliances = 3,
    Shutter = 4,
    Heating = 5,
    Boiler = 6,
    Airconditioner = 7,
    Other = 8,
    Fridge = 9,
    Oven = 10,
    Washingmachine = 11,
    Dryer = 12,
    Dishwasher = 13,
    Multimedia = 14,
    Internetbox = 15,
    SwimmingPool = 16,
    Machine = 17,
}

export class EntrancePlantDetailDTO implements IEntrancePlantDetailDTO {
    desktopId?: number;
    name?: string | undefined;
    address?: string | undefined;
    country?: string | undefined;
    tags?: PlantTagDTO[] | undefined;
    icon?: PlantIconEnum;
    customIconImageUrl?: string | undefined;
    customIconDataUrl?: string | undefined;
    lastModify?: Date;
    lastModifyByDesktop?: boolean;
    lastModifyBy?: UserDTO;
    sharedWith?: PlantSharingDTO[] | undefined;
    isFavourite?: boolean;
    owner?: UserDTO;
    usersIdFavorites?: string[] | undefined;
    plantType?: PlantType;
    addressBookSorting?: AddressBookSorting;
    language?: Language;
    addressingType?: AddressingType;
    keypadCodePasspartoutMode?: PasspartoutModes;
    keypadCodePasspartoutCode?: string | undefined;
    keypadCodeRequiredLength?: number;
    maxNumberOfLabelsForApartment?: number;
    denominationBuildings?: DenominationMode;
    denominationRisers?: DenominationMode;
    denominationFloors?: DenominationMode;
    denominationApartments?: DenominationMode;
    wizardState?: number;
    gates?: GateDTO[] | undefined;
    buildings?: BuildingDTO[] | undefined;
    switchboards?: SwitchboardDTO[] | undefined;
    gateGuests?: GateGuestDTO[] | undefined;
    hiddenGuests?: HiddenGuestDTO[] | undefined;
    apartmentInvitations?: ApartmentInvitationDTO[] | undefined;
    brfaBlockDigits?: number;
    brfaRiserDigits?: number;
    brfaFloorDigits?: number;
    brfaApartmentDigits?: number;
    gateMessages?: GateMessageDTO[] | undefined;
    callingCodeShowAddressBook?: boolean;
    syncStatus?: PlantSyncStatusDTO;
    scsAddressHelper?: ScsAddressHelperDTO;
    timeZone?: string | undefined;
    hasRiserInterface?: boolean;

    constructor(data?: IEntrancePlantDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desktopId = _data["desktopId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.country = _data["country"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(PlantTagDTO.fromJS(item));
            }
            this.icon = _data["icon"];
            this.customIconImageUrl = _data["customIconImageUrl"];
            this.customIconDataUrl = _data["customIconDataUrl"];
            this.lastModify = _data["lastModify"] ? new Date(_data["lastModify"].toString()) : <any>undefined;
            this.lastModifyByDesktop = _data["lastModifyByDesktop"];
            this.lastModifyBy = _data["lastModifyBy"] ? UserDTO.fromJS(_data["lastModifyBy"]) : <any>undefined;
            if (Array.isArray(_data["sharedWith"])) {
                this.sharedWith = [] as any;
                for (let item of _data["sharedWith"])
                    this.sharedWith!.push(PlantSharingDTO.fromJS(item));
            }
            this.isFavourite = _data["isFavourite"];
            this.owner = _data["owner"] ? UserDTO.fromJS(_data["owner"]) : <any>undefined;
            if (Array.isArray(_data["usersIdFavorites"])) {
                this.usersIdFavorites = [] as any;
                for (let item of _data["usersIdFavorites"])
                    this.usersIdFavorites!.push(item);
            }
            this.plantType = _data["plantType"];
            this.addressBookSorting = _data["addressBookSorting"];
            this.language = _data["language"];
            this.addressingType = _data["addressingType"];
            this.keypadCodePasspartoutMode = _data["keypadCodePasspartoutMode"];
            this.keypadCodePasspartoutCode = _data["keypadCodePasspartoutCode"];
            this.keypadCodeRequiredLength = _data["keypadCodeRequiredLength"];
            this.maxNumberOfLabelsForApartment = _data["maxNumberOfLabelsForApartment"];
            this.denominationBuildings = _data["denominationBuildings"];
            this.denominationRisers = _data["denominationRisers"];
            this.denominationFloors = _data["denominationFloors"];
            this.denominationApartments = _data["denominationApartments"];
            this.wizardState = _data["wizardState"];
            if (Array.isArray(_data["gates"])) {
                this.gates = [] as any;
                for (let item of _data["gates"])
                    this.gates!.push(GateDTO.fromJS(item));
            }
            if (Array.isArray(_data["buildings"])) {
                this.buildings = [] as any;
                for (let item of _data["buildings"])
                    this.buildings!.push(BuildingDTO.fromJS(item));
            }
            if (Array.isArray(_data["switchboards"])) {
                this.switchboards = [] as any;
                for (let item of _data["switchboards"])
                    this.switchboards!.push(SwitchboardDTO.fromJS(item));
            }
            if (Array.isArray(_data["gateGuests"])) {
                this.gateGuests = [] as any;
                for (let item of _data["gateGuests"])
                    this.gateGuests!.push(GateGuestDTO.fromJS(item));
            }
            if (Array.isArray(_data["hiddenGuests"])) {
                this.hiddenGuests = [] as any;
                for (let item of _data["hiddenGuests"])
                    this.hiddenGuests!.push(HiddenGuestDTO.fromJS(item));
            }
            if (Array.isArray(_data["apartmentInvitations"])) {
                this.apartmentInvitations = [] as any;
                for (let item of _data["apartmentInvitations"])
                    this.apartmentInvitations!.push(ApartmentInvitationDTO.fromJS(item));
            }
            this.brfaBlockDigits = _data["brfaBlockDigits"];
            this.brfaRiserDigits = _data["brfaRiserDigits"];
            this.brfaFloorDigits = _data["brfaFloorDigits"];
            this.brfaApartmentDigits = _data["brfaApartmentDigits"];
            if (Array.isArray(_data["gateMessages"])) {
                this.gateMessages = [] as any;
                for (let item of _data["gateMessages"])
                    this.gateMessages!.push(GateMessageDTO.fromJS(item));
            }
            this.callingCodeShowAddressBook = _data["callingCodeShowAddressBook"];
            this.syncStatus = _data["syncStatus"] ? PlantSyncStatusDTO.fromJS(_data["syncStatus"]) : <any>undefined;
            this.scsAddressHelper = _data["scsAddressHelper"] ? ScsAddressHelperDTO.fromJS(_data["scsAddressHelper"]) : <any>undefined;
            this.timeZone = _data["timeZone"];
            this.hasRiserInterface = _data["hasRiserInterface"];
        }
    }

    static fromJS(data: any): EntrancePlantDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EntrancePlantDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopId"] = this.desktopId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["country"] = this.country;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["icon"] = this.icon;
        data["customIconImageUrl"] = this.customIconImageUrl;
        data["customIconDataUrl"] = this.customIconDataUrl;
        data["lastModify"] = this.lastModify ? this.lastModify.toISOString() : <any>undefined;
        data["lastModifyByDesktop"] = this.lastModifyByDesktop;
        data["lastModifyBy"] = this.lastModifyBy ? this.lastModifyBy.toJSON() : <any>undefined;
        if (Array.isArray(this.sharedWith)) {
            data["sharedWith"] = [];
            for (let item of this.sharedWith)
                data["sharedWith"].push(item.toJSON());
        }
        data["isFavourite"] = this.isFavourite;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        if (Array.isArray(this.usersIdFavorites)) {
            data["usersIdFavorites"] = [];
            for (let item of this.usersIdFavorites)
                data["usersIdFavorites"].push(item);
        }
        data["plantType"] = this.plantType;
        data["addressBookSorting"] = this.addressBookSorting;
        data["language"] = this.language;
        data["addressingType"] = this.addressingType;
        data["keypadCodePasspartoutMode"] = this.keypadCodePasspartoutMode;
        data["keypadCodePasspartoutCode"] = this.keypadCodePasspartoutCode;
        data["keypadCodeRequiredLength"] = this.keypadCodeRequiredLength;
        data["maxNumberOfLabelsForApartment"] = this.maxNumberOfLabelsForApartment;
        data["denominationBuildings"] = this.denominationBuildings;
        data["denominationRisers"] = this.denominationRisers;
        data["denominationFloors"] = this.denominationFloors;
        data["denominationApartments"] = this.denominationApartments;
        data["wizardState"] = this.wizardState;
        if (Array.isArray(this.gates)) {
            data["gates"] = [];
            for (let item of this.gates)
                data["gates"].push(item.toJSON());
        }
        if (Array.isArray(this.buildings)) {
            data["buildings"] = [];
            for (let item of this.buildings)
                data["buildings"].push(item.toJSON());
        }
        if (Array.isArray(this.switchboards)) {
            data["switchboards"] = [];
            for (let item of this.switchboards)
                data["switchboards"].push(item.toJSON());
        }
        if (Array.isArray(this.gateGuests)) {
            data["gateGuests"] = [];
            for (let item of this.gateGuests)
                data["gateGuests"].push(item.toJSON());
        }
        if (Array.isArray(this.hiddenGuests)) {
            data["hiddenGuests"] = [];
            for (let item of this.hiddenGuests)
                data["hiddenGuests"].push(item.toJSON());
        }
        if (Array.isArray(this.apartmentInvitations)) {
            data["apartmentInvitations"] = [];
            for (let item of this.apartmentInvitations)
                data["apartmentInvitations"].push(item.toJSON());
        }
        data["brfaBlockDigits"] = this.brfaBlockDigits;
        data["brfaRiserDigits"] = this.brfaRiserDigits;
        data["brfaFloorDigits"] = this.brfaFloorDigits;
        data["brfaApartmentDigits"] = this.brfaApartmentDigits;
        if (Array.isArray(this.gateMessages)) {
            data["gateMessages"] = [];
            for (let item of this.gateMessages)
                data["gateMessages"].push(item.toJSON());
        }
        data["callingCodeShowAddressBook"] = this.callingCodeShowAddressBook;
        data["syncStatus"] = this.syncStatus ? this.syncStatus.toJSON() : <any>undefined;
        data["scsAddressHelper"] = this.scsAddressHelper ? this.scsAddressHelper.toJSON() : <any>undefined;
        data["timeZone"] = this.timeZone;
        data["hasRiserInterface"] = this.hasRiserInterface;
        return data;
    }
}

export interface IEntrancePlantDetailDTO {
    desktopId?: number;
    name?: string | undefined;
    address?: string | undefined;
    country?: string | undefined;
    tags?: PlantTagDTO[] | undefined;
    icon?: PlantIconEnum;
    customIconImageUrl?: string | undefined;
    customIconDataUrl?: string | undefined;
    lastModify?: Date;
    lastModifyByDesktop?: boolean;
    lastModifyBy?: UserDTO;
    sharedWith?: PlantSharingDTO[] | undefined;
    isFavourite?: boolean;
    owner?: UserDTO;
    usersIdFavorites?: string[] | undefined;
    plantType?: PlantType;
    addressBookSorting?: AddressBookSorting;
    language?: Language;
    addressingType?: AddressingType;
    keypadCodePasspartoutMode?: PasspartoutModes;
    keypadCodePasspartoutCode?: string | undefined;
    keypadCodeRequiredLength?: number;
    maxNumberOfLabelsForApartment?: number;
    denominationBuildings?: DenominationMode;
    denominationRisers?: DenominationMode;
    denominationFloors?: DenominationMode;
    denominationApartments?: DenominationMode;
    wizardState?: number;
    gates?: GateDTO[] | undefined;
    buildings?: BuildingDTO[] | undefined;
    switchboards?: SwitchboardDTO[] | undefined;
    gateGuests?: GateGuestDTO[] | undefined;
    hiddenGuests?: HiddenGuestDTO[] | undefined;
    apartmentInvitations?: ApartmentInvitationDTO[] | undefined;
    brfaBlockDigits?: number;
    brfaRiserDigits?: number;
    brfaFloorDigits?: number;
    brfaApartmentDigits?: number;
    gateMessages?: GateMessageDTO[] | undefined;
    callingCodeShowAddressBook?: boolean;
    syncStatus?: PlantSyncStatusDTO;
    scsAddressHelper?: ScsAddressHelperDTO;
    timeZone?: string | undefined;
    hasRiserInterface?: boolean;
}

export class EntrancePlantHeadCreateDTO implements IEntrancePlantHeadCreateDTO {
    desktopId?: number;
    name?: string | undefined;
    address?: string | undefined;
    country?: string | undefined;
    timeZone?: string | undefined;
    tags?: PlantTagDTO[] | undefined;
    icon?: PlantIconEnum;
    customIconImageUrl?: string | undefined;
    customIconDataUrl?: string | undefined;
    plantType?: PlantType;

    constructor(data?: IEntrancePlantHeadCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desktopId = _data["desktopId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.country = _data["country"];
            this.timeZone = _data["timeZone"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(PlantTagDTO.fromJS(item));
            }
            this.icon = _data["icon"];
            this.customIconImageUrl = _data["customIconImageUrl"];
            this.customIconDataUrl = _data["customIconDataUrl"];
            this.plantType = _data["plantType"];
        }
    }

    static fromJS(data: any): EntrancePlantHeadCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EntrancePlantHeadCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopId"] = this.desktopId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["country"] = this.country;
        data["timeZone"] = this.timeZone;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["icon"] = this.icon;
        data["customIconImageUrl"] = this.customIconImageUrl;
        data["customIconDataUrl"] = this.customIconDataUrl;
        data["plantType"] = this.plantType;
        return data;
    }
}

export interface IEntrancePlantHeadCreateDTO {
    desktopId?: number;
    name?: string | undefined;
    address?: string | undefined;
    country?: string | undefined;
    timeZone?: string | undefined;
    tags?: PlantTagDTO[] | undefined;
    icon?: PlantIconEnum;
    customIconImageUrl?: string | undefined;
    customIconDataUrl?: string | undefined;
    plantType?: PlantType;
}

export class EntrancePlantInfoCreateDTO implements IEntrancePlantInfoCreateDTO {
    addressBookSorting?: AddressBookSorting;
    language?: Language;
    addressingType?: AddressingType;
    denominationBuildings?: DenominationMode;
    denominationRisers?: DenominationMode;
    denominationFloors?: DenominationMode;
    denominationApartments?: DenominationMode;
    callingCodeShowAddressBook?: boolean;
    keypadCodePasspartoutMode?: PasspartoutModes;
    keypadCodePasspartoutCode?: string | undefined;
    keypadCodeRequiredLength?: number;
    buildings?: BuildingImportDto[] | undefined;

    constructor(data?: IEntrancePlantInfoCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressBookSorting = _data["addressBookSorting"];
            this.language = _data["language"];
            this.addressingType = _data["addressingType"];
            this.denominationBuildings = _data["denominationBuildings"];
            this.denominationRisers = _data["denominationRisers"];
            this.denominationFloors = _data["denominationFloors"];
            this.denominationApartments = _data["denominationApartments"];
            this.callingCodeShowAddressBook = _data["callingCodeShowAddressBook"];
            this.keypadCodePasspartoutMode = _data["keypadCodePasspartoutMode"];
            this.keypadCodePasspartoutCode = _data["keypadCodePasspartoutCode"];
            this.keypadCodeRequiredLength = _data["keypadCodeRequiredLength"];
            if (Array.isArray(_data["buildings"])) {
                this.buildings = [] as any;
                for (let item of _data["buildings"])
                    this.buildings!.push(BuildingImportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntrancePlantInfoCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EntrancePlantInfoCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressBookSorting"] = this.addressBookSorting;
        data["language"] = this.language;
        data["addressingType"] = this.addressingType;
        data["denominationBuildings"] = this.denominationBuildings;
        data["denominationRisers"] = this.denominationRisers;
        data["denominationFloors"] = this.denominationFloors;
        data["denominationApartments"] = this.denominationApartments;
        data["callingCodeShowAddressBook"] = this.callingCodeShowAddressBook;
        data["keypadCodePasspartoutMode"] = this.keypadCodePasspartoutMode;
        data["keypadCodePasspartoutCode"] = this.keypadCodePasspartoutCode;
        data["keypadCodeRequiredLength"] = this.keypadCodeRequiredLength;
        if (Array.isArray(this.buildings)) {
            data["buildings"] = [];
            for (let item of this.buildings)
                data["buildings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEntrancePlantInfoCreateDTO {
    addressBookSorting?: AddressBookSorting;
    language?: Language;
    addressingType?: AddressingType;
    denominationBuildings?: DenominationMode;
    denominationRisers?: DenominationMode;
    denominationFloors?: DenominationMode;
    denominationApartments?: DenominationMode;
    callingCodeShowAddressBook?: boolean;
    keypadCodePasspartoutMode?: PasspartoutModes;
    keypadCodePasspartoutCode?: string | undefined;
    keypadCodeRequiredLength?: number;
    buildings?: BuildingImportDto[] | undefined;
}

/** 0 = DeviceManager 1 = BuildingManager */
export enum EntrancePlantProRoles {
    DeviceManager = 0,
    BuildingManager = 1,
}

export class EntrancePlantStructureCreateDTO implements IEntrancePlantStructureCreateDTO {
    riserFlow?: boolean;
    wizardStep?: number;
    previousWizardPage?: string | undefined;
    headCreate?: EntrancePlantHeadCreateDTO;
    infoCreate?: EntrancePlantInfoCreateDTO;
    buildingsCreate?: BuildingCreateDTO[] | undefined;
    gateCreate?: GateDTO[] | undefined;
    plantConfigStructure?: { [key: string]: RFAConfigDTO; } | undefined;
    gateConfigStructure?: { [key: string]: GateConfigDTO; } | undefined;
    pePlantConfig?: PePlantConfigDTO;

    constructor(data?: IEntrancePlantStructureCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.riserFlow = _data["riserFlow"];
            this.wizardStep = _data["wizardStep"];
            this.previousWizardPage = _data["previousWizardPage"];
            this.headCreate = _data["headCreate"] ? EntrancePlantHeadCreateDTO.fromJS(_data["headCreate"]) : <any>undefined;
            this.infoCreate = _data["infoCreate"] ? EntrancePlantInfoCreateDTO.fromJS(_data["infoCreate"]) : <any>undefined;
            if (Array.isArray(_data["buildingsCreate"])) {
                this.buildingsCreate = [] as any;
                for (let item of _data["buildingsCreate"])
                    this.buildingsCreate!.push(BuildingCreateDTO.fromJS(item));
            }
            if (Array.isArray(_data["gateCreate"])) {
                this.gateCreate = [] as any;
                for (let item of _data["gateCreate"])
                    this.gateCreate!.push(GateDTO.fromJS(item));
            }
            if (_data["plantConfigStructure"]) {
                this.plantConfigStructure = {} as any;
                for (let key in _data["plantConfigStructure"]) {
                    if (_data["plantConfigStructure"].hasOwnProperty(key))
                        (<any>this.plantConfigStructure)![key] = _data["plantConfigStructure"][key] ? RFAConfigDTO.fromJS(_data["plantConfigStructure"][key]) : new RFAConfigDTO();
                }
            }
            if (_data["gateConfigStructure"]) {
                this.gateConfigStructure = {} as any;
                for (let key in _data["gateConfigStructure"]) {
                    if (_data["gateConfigStructure"].hasOwnProperty(key))
                        (<any>this.gateConfigStructure)![key] = _data["gateConfigStructure"][key] ? GateConfigDTO.fromJS(_data["gateConfigStructure"][key]) : new GateConfigDTO();
                }
            }
            this.pePlantConfig = _data["pePlantConfig"] ? PePlantConfigDTO.fromJS(_data["pePlantConfig"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EntrancePlantStructureCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EntrancePlantStructureCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riserFlow"] = this.riserFlow;
        data["wizardStep"] = this.wizardStep;
        data["previousWizardPage"] = this.previousWizardPage;
        data["headCreate"] = this.headCreate ? this.headCreate.toJSON() : <any>undefined;
        data["infoCreate"] = this.infoCreate ? this.infoCreate.toJSON() : <any>undefined;
        if (Array.isArray(this.buildingsCreate)) {
            data["buildingsCreate"] = [];
            for (let item of this.buildingsCreate)
                data["buildingsCreate"].push(item.toJSON());
        }
        if (Array.isArray(this.gateCreate)) {
            data["gateCreate"] = [];
            for (let item of this.gateCreate)
                data["gateCreate"].push(item.toJSON());
        }
        if (this.plantConfigStructure) {
            data["plantConfigStructure"] = {};
            for (let key in this.plantConfigStructure) {
                if (this.plantConfigStructure.hasOwnProperty(key))
                    (<any>data["plantConfigStructure"])[key] = this.plantConfigStructure[key] ? this.plantConfigStructure[key].toJSON() : <any>undefined;
            }
        }
        if (this.gateConfigStructure) {
            data["gateConfigStructure"] = {};
            for (let key in this.gateConfigStructure) {
                if (this.gateConfigStructure.hasOwnProperty(key))
                    (<any>data["gateConfigStructure"])[key] = this.gateConfigStructure[key] ? this.gateConfigStructure[key].toJSON() : <any>undefined;
            }
        }
        data["pePlantConfig"] = this.pePlantConfig ? this.pePlantConfig.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEntrancePlantStructureCreateDTO {
    riserFlow?: boolean;
    wizardStep?: number;
    previousWizardPage?: string | undefined;
    headCreate?: EntrancePlantHeadCreateDTO;
    infoCreate?: EntrancePlantInfoCreateDTO;
    buildingsCreate?: BuildingCreateDTO[] | undefined;
    gateCreate?: GateDTO[] | undefined;
    plantConfigStructure?: { [key: string]: RFAConfigDTO; } | undefined;
    gateConfigStructure?: { [key: string]: GateConfigDTO; } | undefined;
    pePlantConfig?: PePlantConfigDTO;
}

/** 0 = Ignore 1 = Required 2 = Activated */
export enum EpDeviceActivationStatus {
    Ignore = 0,
    Required = 1,
    Activated = 2,
}

/** 0 = AcousticTones 1 = VocalMessage 2 = None */
export enum EpDeviceCallAndLockTonesMode {
    AcousticTones = 0,
    VocalMessage = 1,
    None = 2,
}

/** 0 = Auto 1 = Dark 2 = Light */
export enum EpDeviceScreenMode {
    Auto = 0,
    Dark = 1,
    Light = 2,
}

/** 0 = Linea5000 1 = KeyPad 2 = SmartAccess */
export enum EpDeviceType {
    Linea5000 = 0,
    KeyPad = 1,
    SmartAccess = 2,
}

/** 0 = Disabled 1 = Message 2 = Image */
export enum EpDeviceWelcomePage {
    Disabled = 0,
    Message = 1,
    Image = 2,
}

export class EpUserRole implements IEpUserRole {
    email?: string | undefined;
    roles?: EntrancePlantProRoles[] | undefined;
    readonly isOnlyBuildingAdmin?: boolean;

    constructor(data?: IEpUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            (<any>this).isOnlyBuildingAdmin = _data["isOnlyBuildingAdmin"];
        }
    }

    static fromJS(data: any): EpUserRole {
        data = typeof data === 'object' ? data : {};
        let result = new EpUserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["isOnlyBuildingAdmin"] = this.isOnlyBuildingAdmin;
        return data;
    }
}

export interface IEpUserRole {
    email?: string | undefined;
    roles?: EntrancePlantProRoles[] | undefined;
    isOnlyBuildingAdmin?: boolean;
}

/** 0 = ColoredLight 1 = Xmeter 2 = Player 3 = AlarmCentralUnit 4 = AlarmSensor 5 = DimmerDmx */
export enum ExtComponentType {
    ColoredLight = 0,
    Xmeter = 1,
    Player = 2,
    AlarmCentralUnit = 3,
    AlarmSensor = 4,
    DimmerDmx = 5,
}

/** 0 = Bticino 1 = Vantage */
export enum ExternalSensorType {
    Bticino = 0,
    Vantage = 1,
}

export class FloorConfigDTO implements IFloorConfigDTO {
    index?: number;
    name?: string | undefined;
    numberOfApartments?: number;
    linkedInterfaces?: PeInterfaceConfig[] | undefined;

    constructor(data?: IFloorConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.name = _data["name"];
            this.numberOfApartments = _data["numberOfApartments"];
            if (Array.isArray(_data["linkedInterfaces"])) {
                this.linkedInterfaces = [] as any;
                for (let item of _data["linkedInterfaces"])
                    this.linkedInterfaces!.push(PeInterfaceConfig.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FloorConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FloorConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["name"] = this.name;
        data["numberOfApartments"] = this.numberOfApartments;
        if (Array.isArray(this.linkedInterfaces)) {
            data["linkedInterfaces"] = [];
            for (let item of this.linkedInterfaces)
                data["linkedInterfaces"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFloorConfigDTO {
    index?: number;
    name?: string | undefined;
    numberOfApartments?: number;
    linkedInterfaces?: PeInterfaceConfig[] | undefined;
}

export class FloorDTO implements IFloorDTO {
    floorId?: string;
    buildingId?: string;
    riserId?: string | undefined;
    index?: number;
    name?: string | undefined;
    code?: string | undefined;

    constructor(data?: IFloorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.floorId = _data["floorId"];
            this.buildingId = _data["buildingId"];
            this.riserId = _data["riserId"];
            this.index = _data["index"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): FloorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FloorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["floorId"] = this.floorId;
        data["buildingId"] = this.buildingId;
        data["riserId"] = this.riserId;
        data["index"] = this.index;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IFloorDTO {
    floorId?: string;
    buildingId?: string;
    riserId?: string | undefined;
    index?: number;
    name?: string | undefined;
    code?: string | undefined;
}

/** 0 = All 1 = Thermo 2 = Automation 3 = Energy 4 = Security 5 = Integration 6 = AllAndGateway 7 = OnlyGateway 8 = Nd 9 = NewChanges 10 = ID */
export enum FunctionType {
    All = 0,
    Thermo = 1,
    Automation = 2,
    Energy = 3,
    Security = 4,
    Integration = 5,
    AllAndGateway = 6,
    OnlyGateway = 7,
    Nd = 8,
    NewChanges = 9,
    ID = 10,
}

export class GateConfigDTO implements IGateConfigDTO {
    scsAddress?: number;
    gateName?: string | undefined;
    newPeSelected?: boolean;
    keypadSelected?: boolean;
    smartReaderSelected?: boolean;
    isOnBackbone?: boolean;
    connectedBuildingIds?: string[] | undefined;
    connectedRiserIds?: string[] | undefined;
    connectedApartmentsIds?: string[] | undefined;
    connectedRiserInterfaceId?: string | undefined;

    constructor(data?: IGateConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scsAddress = _data["scsAddress"];
            this.gateName = _data["gateName"];
            this.newPeSelected = _data["newPeSelected"];
            this.keypadSelected = _data["keypadSelected"];
            this.smartReaderSelected = _data["smartReaderSelected"];
            this.isOnBackbone = _data["isOnBackbone"];
            if (Array.isArray(_data["connectedBuildingIds"])) {
                this.connectedBuildingIds = [] as any;
                for (let item of _data["connectedBuildingIds"])
                    this.connectedBuildingIds!.push(item);
            }
            if (Array.isArray(_data["connectedRiserIds"])) {
                this.connectedRiserIds = [] as any;
                for (let item of _data["connectedRiserIds"])
                    this.connectedRiserIds!.push(item);
            }
            if (Array.isArray(_data["connectedApartmentsIds"])) {
                this.connectedApartmentsIds = [] as any;
                for (let item of _data["connectedApartmentsIds"])
                    this.connectedApartmentsIds!.push(item);
            }
            this.connectedRiserInterfaceId = _data["connectedRiserInterfaceId"];
        }
    }

    static fromJS(data: any): GateConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GateConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scsAddress"] = this.scsAddress;
        data["gateName"] = this.gateName;
        data["newPeSelected"] = this.newPeSelected;
        data["keypadSelected"] = this.keypadSelected;
        data["smartReaderSelected"] = this.smartReaderSelected;
        data["isOnBackbone"] = this.isOnBackbone;
        if (Array.isArray(this.connectedBuildingIds)) {
            data["connectedBuildingIds"] = [];
            for (let item of this.connectedBuildingIds)
                data["connectedBuildingIds"].push(item);
        }
        if (Array.isArray(this.connectedRiserIds)) {
            data["connectedRiserIds"] = [];
            for (let item of this.connectedRiserIds)
                data["connectedRiserIds"].push(item);
        }
        if (Array.isArray(this.connectedApartmentsIds)) {
            data["connectedApartmentsIds"] = [];
            for (let item of this.connectedApartmentsIds)
                data["connectedApartmentsIds"].push(item);
        }
        data["connectedRiserInterfaceId"] = this.connectedRiserInterfaceId;
        return data;
    }
}

export interface IGateConfigDTO {
    scsAddress?: number;
    gateName?: string | undefined;
    newPeSelected?: boolean;
    keypadSelected?: boolean;
    smartReaderSelected?: boolean;
    isOnBackbone?: boolean;
    connectedBuildingIds?: string[] | undefined;
    connectedRiserIds?: string[] | undefined;
    connectedApartmentsIds?: string[] | undefined;
    connectedRiserInterfaceId?: string | undefined;
}

export class GateDTO implements IGateDTO {
    gateId?: string;
    name?: string | undefined;
    scsAddress?: number;
    apartments?: string[] | undefined;
    connectedBuildingIds?: string[] | undefined;
    connectedRiserIds?: string[] | undefined;
    devices?: EPDeviceDTO[] | undefined;
    virtualDevicesApt?: string[] | undefined;
    index?: number;
    riserInterfaceId?: string;

    constructor(data?: IGateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gateId = _data["gateId"];
            this.name = _data["name"];
            this.scsAddress = _data["scsAddress"];
            if (Array.isArray(_data["apartments"])) {
                this.apartments = [] as any;
                for (let item of _data["apartments"])
                    this.apartments!.push(item);
            }
            if (Array.isArray(_data["connectedBuildingIds"])) {
                this.connectedBuildingIds = [] as any;
                for (let item of _data["connectedBuildingIds"])
                    this.connectedBuildingIds!.push(item);
            }
            if (Array.isArray(_data["connectedRiserIds"])) {
                this.connectedRiserIds = [] as any;
                for (let item of _data["connectedRiserIds"])
                    this.connectedRiserIds!.push(item);
            }
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(EPDeviceDTO.fromJS(item));
            }
            if (Array.isArray(_data["virtualDevicesApt"])) {
                this.virtualDevicesApt = [] as any;
                for (let item of _data["virtualDevicesApt"])
                    this.virtualDevicesApt!.push(item);
            }
            this.index = _data["index"];
            this.riserInterfaceId = _data["riserInterfaceId"];
        }
    }

    static fromJS(data: any): GateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateId"] = this.gateId;
        data["name"] = this.name;
        data["scsAddress"] = this.scsAddress;
        if (Array.isArray(this.apartments)) {
            data["apartments"] = [];
            for (let item of this.apartments)
                data["apartments"].push(item);
        }
        if (Array.isArray(this.connectedBuildingIds)) {
            data["connectedBuildingIds"] = [];
            for (let item of this.connectedBuildingIds)
                data["connectedBuildingIds"].push(item);
        }
        if (Array.isArray(this.connectedRiserIds)) {
            data["connectedRiserIds"] = [];
            for (let item of this.connectedRiserIds)
                data["connectedRiserIds"].push(item);
        }
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        if (Array.isArray(this.virtualDevicesApt)) {
            data["virtualDevicesApt"] = [];
            for (let item of this.virtualDevicesApt)
                data["virtualDevicesApt"].push(item);
        }
        data["index"] = this.index;
        data["riserInterfaceId"] = this.riserInterfaceId;
        return data;
    }
}

export interface IGateDTO {
    gateId?: string;
    name?: string | undefined;
    scsAddress?: number;
    apartments?: string[] | undefined;
    connectedBuildingIds?: string[] | undefined;
    connectedRiserIds?: string[] | undefined;
    devices?: EPDeviceDTO[] | undefined;
    virtualDevicesApt?: string[] | undefined;
    index?: number;
    riserInterfaceId?: string;
}

export class GateGuestDTO implements IGateGuestDTO {
    id?: string;
    description?: string | undefined;
    isDateAlways?: boolean;
    durationSince?: Date | undefined;
    durationUntil?: Date | undefined;
    isTimeAlways?: boolean;
    timesSlots?: TimeSlot[] | undefined;
    repetitionDays?: WeekDay[] | undefined;
    gateIds?: string[] | undefined;
    isRecurrent?: boolean;
    isOneTimeGuest?: boolean;
    keypadCode?: string | undefined;
    badgeCode?: string | undefined;

    constructor(data?: IGateGuestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.isDateAlways = _data["isDateAlways"];
            this.durationSince = _data["durationSince"] ? new Date(_data["durationSince"].toString()) : <any>undefined;
            this.durationUntil = _data["durationUntil"] ? new Date(_data["durationUntil"].toString()) : <any>undefined;
            this.isTimeAlways = _data["isTimeAlways"];
            if (Array.isArray(_data["timesSlots"])) {
                this.timesSlots = [] as any;
                for (let item of _data["timesSlots"])
                    this.timesSlots!.push(TimeSlot.fromJS(item));
            }
            if (Array.isArray(_data["repetitionDays"])) {
                this.repetitionDays = [] as any;
                for (let item of _data["repetitionDays"])
                    this.repetitionDays!.push(item);
            }
            if (Array.isArray(_data["gateIds"])) {
                this.gateIds = [] as any;
                for (let item of _data["gateIds"])
                    this.gateIds!.push(item);
            }
            this.isRecurrent = _data["isRecurrent"];
            this.isOneTimeGuest = _data["isOneTimeGuest"];
            this.keypadCode = _data["keypadCode"];
            this.badgeCode = _data["badgeCode"];
        }
    }

    static fromJS(data: any): GateGuestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GateGuestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["isDateAlways"] = this.isDateAlways;
        data["durationSince"] = this.durationSince ? this.durationSince.toISOString() : <any>undefined;
        data["durationUntil"] = this.durationUntil ? this.durationUntil.toISOString() : <any>undefined;
        data["isTimeAlways"] = this.isTimeAlways;
        if (Array.isArray(this.timesSlots)) {
            data["timesSlots"] = [];
            for (let item of this.timesSlots)
                data["timesSlots"].push(item.toJSON());
        }
        if (Array.isArray(this.repetitionDays)) {
            data["repetitionDays"] = [];
            for (let item of this.repetitionDays)
                data["repetitionDays"].push(item);
        }
        if (Array.isArray(this.gateIds)) {
            data["gateIds"] = [];
            for (let item of this.gateIds)
                data["gateIds"].push(item);
        }
        data["isRecurrent"] = this.isRecurrent;
        data["isOneTimeGuest"] = this.isOneTimeGuest;
        data["keypadCode"] = this.keypadCode;
        data["badgeCode"] = this.badgeCode;
        return data;
    }
}

export interface IGateGuestDTO {
    id?: string;
    description?: string | undefined;
    isDateAlways?: boolean;
    durationSince?: Date | undefined;
    durationUntil?: Date | undefined;
    isTimeAlways?: boolean;
    timesSlots?: TimeSlot[] | undefined;
    repetitionDays?: WeekDay[] | undefined;
    gateIds?: string[] | undefined;
    isRecurrent?: boolean;
    isOneTimeGuest?: boolean;
    keypadCode?: string | undefined;
    badgeCode?: string | undefined;
}

export class GateMessageDTO implements IGateMessageDTO {
    id?: string;
    title?: string | undefined;
    text?: string | undefined;
    durationSince?: Date;
    durationUntil?: Date;
    gateIds?: string[] | undefined;

    constructor(data?: IGateMessageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.text = _data["text"];
            this.durationSince = _data["durationSince"] ? new Date(_data["durationSince"].toString()) : <any>undefined;
            this.durationUntil = _data["durationUntil"] ? new Date(_data["durationUntil"].toString()) : <any>undefined;
            if (Array.isArray(_data["gateIds"])) {
                this.gateIds = [] as any;
                for (let item of _data["gateIds"])
                    this.gateIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GateMessageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GateMessageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["text"] = this.text;
        data["durationSince"] = this.durationSince ? this.durationSince.toISOString() : <any>undefined;
        data["durationUntil"] = this.durationUntil ? this.durationUntil.toISOString() : <any>undefined;
        if (Array.isArray(this.gateIds)) {
            data["gateIds"] = [];
            for (let item of this.gateIds)
                data["gateIds"].push(item);
        }
        return data;
    }
}

export interface IGateMessageDTO {
    id?: string;
    title?: string | undefined;
    text?: string | undefined;
    durationSince?: Date;
    durationUntil?: Date;
    gateIds?: string[] | undefined;
}

export class GeneralCommandsAndGroupsAction extends Action implements IGeneralCommandsAndGroupsAction {
    linkableObjectId?: string | undefined;
    sceneLightState?: SceneLightState;
    sceneShutterState?: SceneShutterState;
    sceneBlindState?: SceneBlindState;
    sceneSocketState?: SceneSocketState;

    constructor(data?: IGeneralCommandsAndGroupsAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.linkableObjectId = _data["linkableObjectId"];
            this.sceneLightState = _data["sceneLightState"];
            this.sceneShutterState = _data["sceneShutterState"];
            this.sceneBlindState = _data["sceneBlindState"];
            this.sceneSocketState = _data["sceneSocketState"];
        }
    }

    static fromJS(data: any): GeneralCommandsAndGroupsAction {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralCommandsAndGroupsAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkableObjectId"] = this.linkableObjectId;
        data["sceneLightState"] = this.sceneLightState;
        data["sceneShutterState"] = this.sceneShutterState;
        data["sceneBlindState"] = this.sceneBlindState;
        data["sceneSocketState"] = this.sceneSocketState;
        super.toJSON(data);
        return data;
    }
}

export interface IGeneralCommandsAndGroupsAction extends IAction {
    linkableObjectId?: string | undefined;
    sceneLightState?: SceneLightState;
    sceneShutterState?: SceneShutterState;
    sceneBlindState?: SceneBlindState;
    sceneSocketState?: SceneSocketState;
}

export class GraylogEntrancePanelMessageDTO implements IGraylogEntrancePanelMessageDTO {
    userMessage?: string | undefined;
    plantDesktopId?: number;
    deviceId?: string | undefined;
    frontendVersion?: string | undefined;

    constructor(data?: IGraylogEntrancePanelMessageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userMessage = _data["userMessage"];
            this.plantDesktopId = _data["plantDesktopId"];
            this.deviceId = _data["deviceId"];
            this.frontendVersion = _data["frontendVersion"];
        }
    }

    static fromJS(data: any): GraylogEntrancePanelMessageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GraylogEntrancePanelMessageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userMessage"] = this.userMessage;
        data["plantDesktopId"] = this.plantDesktopId;
        data["deviceId"] = this.deviceId;
        data["frontendVersion"] = this.frontendVersion;
        return data;
    }
}

export interface IGraylogEntrancePanelMessageDTO {
    userMessage?: string | undefined;
    plantDesktopId?: number;
    deviceId?: string | undefined;
    frontendVersion?: string | undefined;
}

export class HiddenGuestDTO implements IHiddenGuestDTO {
    guid?: string;
    scsAddr?: number;
    description?: string | undefined;
    keyCode?: string | undefined;

    constructor(data?: IHiddenGuestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.scsAddr = _data["scsAddr"];
            this.description = _data["description"];
            this.keyCode = _data["keyCode"];
        }
    }

    static fromJS(data: any): HiddenGuestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HiddenGuestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["scsAddr"] = this.scsAddr;
        data["description"] = this.description;
        data["keyCode"] = this.keyCode;
        return data;
    }
}

export interface IHiddenGuestDTO {
    guid?: string;
    scsAddr?: number;
    description?: string | undefined;
    keyCode?: string | undefined;
}

export class IntercomFunction extends VdeFunction implements IIntercomFunction {
    type?: IntercomType;

    constructor(data?: IIntercomFunction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): IntercomFunction {
        data = typeof data === 'object' ? data : {};
        let result = new IntercomFunction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IIntercomFunction extends IVdeFunction {
    type?: IntercomType;
}

/** 0 = Inner 1 = Outer 2 = Pager 3 = General */
export enum IntercomType {
    Inner = 0,
    Outer = 1,
    Pager = 2,
    General = 3,
}

/** 0 = Private 1 = Business */
export enum LabelType {
    Private = 0,
    Business = 1,
}

/** 0 = English 1 = Italian 2 = German 3 = Dutch 4 = French 5 = Portuguese 6 = Spanish 7 = Czech 8 = Polish 9 = Catalan */
export enum Language {
    English = 0,
    Italian = 1,
    German = 2,
    Dutch = 3,
    French = 4,
    Portuguese = 5,
    Spanish = 6,
    Czech = 7,
    Polish = 8,
    Catalan = 9,
}

/** 0 = None 1 = OnOff 2 = Dimmer 3 = Unknown 4 = DimmerDali */
export enum LightType {
    None = 0,
    OnOff = 1,
    Dimmer = 2,
    Unknown = 3,
    DimmerDali = 4,
}

export class LightsActuatorItemSettingsDTO implements ILightsActuatorItemSettingsDTO {
    isZeroCrossingEnabled?: boolean;
    relayStatusAfterReset?: RelayStatusAfterResetOptions;
    isRestoreStateAfterResetEnabled?: boolean;
    isMinimumregulationLevelEnabled?: boolean;
    minimumRegulationLevelValue?: number;
    minimumRegulationLevelSelectedPickerValue?: SimpleIntPickerValue;
    loadType?: LightsLoadTypes;
    voltageType?: LightsVoltageOptions;
    hasPUL?: boolean;
    hasMoreThanOneSlotSettings?: boolean;
    indexes?: number[] | undefined;
    isGroupZeroCrossingVisible?: boolean;
    isZeroCrossing1EnabledFollow2?: boolean;
    isZeroCrossing1DisabledFollow2?: boolean;
    isZeroCrossing2EnabledFollow1?: boolean;
    isZeroCrossing2DisabledFollow1?: boolean;
    isGroupRelayStatusAfterResetVisible?: boolean;
    isGroupRestoreStatusAfterResetVisible?: boolean;
    isGroupMinimumRegulationLevelVisible?: boolean;
    isGroupLoadTypeVisible?: boolean;
    hasLoadTypesForGroup7?: boolean;
    hasLoadTypesForGroup9?: boolean;
    isGroupVoltageVisible?: boolean;
    isGroupPULVisible?: boolean;
    saveTo?: number[] | undefined;
    minimumRegulationLevelPickerValues?: SimpleIntPickerValue[] | undefined;
    isGroupMinimumRegulationLevelToggleVisible?: boolean;
    isZeroCrossingWarningVisible?: boolean;

    constructor(data?: ILightsActuatorItemSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isZeroCrossingEnabled = _data["isZeroCrossingEnabled"];
            this.relayStatusAfterReset = _data["relayStatusAfterReset"];
            this.isRestoreStateAfterResetEnabled = _data["isRestoreStateAfterResetEnabled"];
            this.isMinimumregulationLevelEnabled = _data["isMinimumregulationLevelEnabled"];
            this.minimumRegulationLevelValue = _data["minimumRegulationLevelValue"];
            this.minimumRegulationLevelSelectedPickerValue = _data["minimumRegulationLevelSelectedPickerValue"] ? SimpleIntPickerValue.fromJS(_data["minimumRegulationLevelSelectedPickerValue"]) : <any>undefined;
            this.loadType = _data["loadType"];
            this.voltageType = _data["voltageType"];
            this.hasPUL = _data["hasPUL"];
            this.hasMoreThanOneSlotSettings = _data["hasMoreThanOneSlotSettings"];
            if (Array.isArray(_data["indexes"])) {
                this.indexes = [] as any;
                for (let item of _data["indexes"])
                    this.indexes!.push(item);
            }
            this.isGroupZeroCrossingVisible = _data["isGroupZeroCrossingVisible"];
            this.isZeroCrossing1EnabledFollow2 = _data["isZeroCrossing1EnabledFollow2"];
            this.isZeroCrossing1DisabledFollow2 = _data["isZeroCrossing1DisabledFollow2"];
            this.isZeroCrossing2EnabledFollow1 = _data["isZeroCrossing2EnabledFollow1"];
            this.isZeroCrossing2DisabledFollow1 = _data["isZeroCrossing2DisabledFollow1"];
            this.isGroupRelayStatusAfterResetVisible = _data["isGroupRelayStatusAfterResetVisible"];
            this.isGroupRestoreStatusAfterResetVisible = _data["isGroupRestoreStatusAfterResetVisible"];
            this.isGroupMinimumRegulationLevelVisible = _data["isGroupMinimumRegulationLevelVisible"];
            this.isGroupLoadTypeVisible = _data["isGroupLoadTypeVisible"];
            this.hasLoadTypesForGroup7 = _data["hasLoadTypesForGroup7"];
            this.hasLoadTypesForGroup9 = _data["hasLoadTypesForGroup9"];
            this.isGroupVoltageVisible = _data["isGroupVoltageVisible"];
            this.isGroupPULVisible = _data["isGroupPULVisible"];
            if (Array.isArray(_data["saveTo"])) {
                this.saveTo = [] as any;
                for (let item of _data["saveTo"])
                    this.saveTo!.push(item);
            }
            if (Array.isArray(_data["minimumRegulationLevelPickerValues"])) {
                this.minimumRegulationLevelPickerValues = [] as any;
                for (let item of _data["minimumRegulationLevelPickerValues"])
                    this.minimumRegulationLevelPickerValues!.push(SimpleIntPickerValue.fromJS(item));
            }
            this.isGroupMinimumRegulationLevelToggleVisible = _data["isGroupMinimumRegulationLevelToggleVisible"];
            this.isZeroCrossingWarningVisible = _data["isZeroCrossingWarningVisible"];
        }
    }

    static fromJS(data: any): LightsActuatorItemSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LightsActuatorItemSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isZeroCrossingEnabled"] = this.isZeroCrossingEnabled;
        data["relayStatusAfterReset"] = this.relayStatusAfterReset;
        data["isRestoreStateAfterResetEnabled"] = this.isRestoreStateAfterResetEnabled;
        data["isMinimumregulationLevelEnabled"] = this.isMinimumregulationLevelEnabled;
        data["minimumRegulationLevelValue"] = this.minimumRegulationLevelValue;
        data["minimumRegulationLevelSelectedPickerValue"] = this.minimumRegulationLevelSelectedPickerValue ? this.minimumRegulationLevelSelectedPickerValue.toJSON() : <any>undefined;
        data["loadType"] = this.loadType;
        data["voltageType"] = this.voltageType;
        data["hasPUL"] = this.hasPUL;
        data["hasMoreThanOneSlotSettings"] = this.hasMoreThanOneSlotSettings;
        if (Array.isArray(this.indexes)) {
            data["indexes"] = [];
            for (let item of this.indexes)
                data["indexes"].push(item);
        }
        data["isGroupZeroCrossingVisible"] = this.isGroupZeroCrossingVisible;
        data["isZeroCrossing1EnabledFollow2"] = this.isZeroCrossing1EnabledFollow2;
        data["isZeroCrossing1DisabledFollow2"] = this.isZeroCrossing1DisabledFollow2;
        data["isZeroCrossing2EnabledFollow1"] = this.isZeroCrossing2EnabledFollow1;
        data["isZeroCrossing2DisabledFollow1"] = this.isZeroCrossing2DisabledFollow1;
        data["isGroupRelayStatusAfterResetVisible"] = this.isGroupRelayStatusAfterResetVisible;
        data["isGroupRestoreStatusAfterResetVisible"] = this.isGroupRestoreStatusAfterResetVisible;
        data["isGroupMinimumRegulationLevelVisible"] = this.isGroupMinimumRegulationLevelVisible;
        data["isGroupLoadTypeVisible"] = this.isGroupLoadTypeVisible;
        data["hasLoadTypesForGroup7"] = this.hasLoadTypesForGroup7;
        data["hasLoadTypesForGroup9"] = this.hasLoadTypesForGroup9;
        data["isGroupVoltageVisible"] = this.isGroupVoltageVisible;
        data["isGroupPULVisible"] = this.isGroupPULVisible;
        if (Array.isArray(this.saveTo)) {
            data["saveTo"] = [];
            for (let item of this.saveTo)
                data["saveTo"].push(item);
        }
        if (Array.isArray(this.minimumRegulationLevelPickerValues)) {
            data["minimumRegulationLevelPickerValues"] = [];
            for (let item of this.minimumRegulationLevelPickerValues)
                data["minimumRegulationLevelPickerValues"].push(item.toJSON());
        }
        data["isGroupMinimumRegulationLevelToggleVisible"] = this.isGroupMinimumRegulationLevelToggleVisible;
        data["isZeroCrossingWarningVisible"] = this.isZeroCrossingWarningVisible;
        return data;
    }
}

export interface ILightsActuatorItemSettingsDTO {
    isZeroCrossingEnabled?: boolean;
    relayStatusAfterReset?: RelayStatusAfterResetOptions;
    isRestoreStateAfterResetEnabled?: boolean;
    isMinimumregulationLevelEnabled?: boolean;
    minimumRegulationLevelValue?: number;
    minimumRegulationLevelSelectedPickerValue?: SimpleIntPickerValue;
    loadType?: LightsLoadTypes;
    voltageType?: LightsVoltageOptions;
    hasPUL?: boolean;
    hasMoreThanOneSlotSettings?: boolean;
    indexes?: number[] | undefined;
    isGroupZeroCrossingVisible?: boolean;
    isZeroCrossing1EnabledFollow2?: boolean;
    isZeroCrossing1DisabledFollow2?: boolean;
    isZeroCrossing2EnabledFollow1?: boolean;
    isZeroCrossing2DisabledFollow1?: boolean;
    isGroupRelayStatusAfterResetVisible?: boolean;
    isGroupRestoreStatusAfterResetVisible?: boolean;
    isGroupMinimumRegulationLevelVisible?: boolean;
    isGroupLoadTypeVisible?: boolean;
    hasLoadTypesForGroup7?: boolean;
    hasLoadTypesForGroup9?: boolean;
    isGroupVoltageVisible?: boolean;
    isGroupPULVisible?: boolean;
    saveTo?: number[] | undefined;
    minimumRegulationLevelPickerValues?: SimpleIntPickerValue[] | undefined;
    isGroupMinimumRegulationLevelToggleVisible?: boolean;
    isZeroCrossingWarningVisible?: boolean;
}

export class LightsActuatorSettings extends ActuatorSettings implements ILightsActuatorSettings {
    isZeroCrossingEnabled?: boolean;
    relayStatusAfterReset?: RelayStatusAfterResetOptions;
    isRestoreStateAfterResetEnabled?: boolean;
    isMinimumregulationLevelEnabled?: boolean;
    minimumRegulationLevelValue?: number;
    minimumRegulationLevelValueAdvanced?: number;
    loadType?: LightsLoadTypes;
    voltageType?: LightsVoltageOptions;
    hasPUL?: boolean;

    constructor(data?: ILightsActuatorSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isZeroCrossingEnabled = _data["isZeroCrossingEnabled"];
            this.relayStatusAfterReset = _data["relayStatusAfterReset"];
            this.isRestoreStateAfterResetEnabled = _data["isRestoreStateAfterResetEnabled"];
            this.isMinimumregulationLevelEnabled = _data["isMinimumregulationLevelEnabled"];
            this.minimumRegulationLevelValue = _data["minimumRegulationLevelValue"];
            this.minimumRegulationLevelValueAdvanced = _data["minimumRegulationLevelValueAdvanced"];
            this.loadType = _data["loadType"];
            this.voltageType = _data["voltageType"];
            this.hasPUL = _data["hasPUL"];
        }
    }

    static fromJS(data: any): LightsActuatorSettings {
        data = typeof data === 'object' ? data : {};
        let result = new LightsActuatorSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isZeroCrossingEnabled"] = this.isZeroCrossingEnabled;
        data["relayStatusAfterReset"] = this.relayStatusAfterReset;
        data["isRestoreStateAfterResetEnabled"] = this.isRestoreStateAfterResetEnabled;
        data["isMinimumregulationLevelEnabled"] = this.isMinimumregulationLevelEnabled;
        data["minimumRegulationLevelValue"] = this.minimumRegulationLevelValue;
        data["minimumRegulationLevelValueAdvanced"] = this.minimumRegulationLevelValueAdvanced;
        data["loadType"] = this.loadType;
        data["voltageType"] = this.voltageType;
        data["hasPUL"] = this.hasPUL;
        super.toJSON(data);
        return data;
    }
}

export interface ILightsActuatorSettings extends IActuatorSettings {
    isZeroCrossingEnabled?: boolean;
    relayStatusAfterReset?: RelayStatusAfterResetOptions;
    isRestoreStateAfterResetEnabled?: boolean;
    isMinimumregulationLevelEnabled?: boolean;
    minimumRegulationLevelValue?: number;
    minimumRegulationLevelValueAdvanced?: number;
    loadType?: LightsLoadTypes;
    voltageType?: LightsVoltageOptions;
    hasPUL?: boolean;
}

export class LightsActuatorSettingsObjectDTO implements ILightsActuatorSettingsObjectDTO {
    slots?: LightsActuatorItemSettingsDTO[] | undefined;

    constructor(data?: ILightsActuatorSettingsObjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots!.push(LightsActuatorItemSettingsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LightsActuatorSettingsObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LightsActuatorSettingsObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILightsActuatorSettingsObjectDTO {
    slots?: LightsActuatorItemSettingsDTO[] | undefined;
}

export class LightsActuatorSettingsResult implements ILightsActuatorSettingsResult {
    index?: number;
    isZeroCrossingEnabled?: boolean;
    relayStatusAfterReset?: RelayStatusAfterResetOptions;
    isRestoreStateAfterResetEnabled?: boolean;
    isMinimumregulationLevelEnabled?: boolean;
    minimumRegulationLevelValue?: number;
    loadType?: LightsLoadTypes;
    voltageType?: LightsVoltageOptions;
    hasPUL?: boolean;

    constructor(data?: ILightsActuatorSettingsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.isZeroCrossingEnabled = _data["isZeroCrossingEnabled"];
            this.relayStatusAfterReset = _data["relayStatusAfterReset"];
            this.isRestoreStateAfterResetEnabled = _data["isRestoreStateAfterResetEnabled"];
            this.isMinimumregulationLevelEnabled = _data["isMinimumregulationLevelEnabled"];
            this.minimumRegulationLevelValue = _data["minimumRegulationLevelValue"];
            this.loadType = _data["loadType"];
            this.voltageType = _data["voltageType"];
            this.hasPUL = _data["hasPUL"];
        }
    }

    static fromJS(data: any): LightsActuatorSettingsResult {
        data = typeof data === 'object' ? data : {};
        let result = new LightsActuatorSettingsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["isZeroCrossingEnabled"] = this.isZeroCrossingEnabled;
        data["relayStatusAfterReset"] = this.relayStatusAfterReset;
        data["isRestoreStateAfterResetEnabled"] = this.isRestoreStateAfterResetEnabled;
        data["isMinimumregulationLevelEnabled"] = this.isMinimumregulationLevelEnabled;
        data["minimumRegulationLevelValue"] = this.minimumRegulationLevelValue;
        data["loadType"] = this.loadType;
        data["voltageType"] = this.voltageType;
        data["hasPUL"] = this.hasPUL;
        return data;
    }
}

export interface ILightsActuatorSettingsResult {
    index?: number;
    isZeroCrossingEnabled?: boolean;
    relayStatusAfterReset?: RelayStatusAfterResetOptions;
    isRestoreStateAfterResetEnabled?: boolean;
    isMinimumregulationLevelEnabled?: boolean;
    minimumRegulationLevelValue?: number;
    loadType?: LightsLoadTypes;
    voltageType?: LightsVoltageOptions;
    hasPUL?: boolean;
}

export class LightsActuatorSettingsResultList implements ILightsActuatorSettingsResultList {
    results?: LightsActuatorSettingsResult[] | undefined;

    constructor(data?: ILightsActuatorSettingsResultList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(LightsActuatorSettingsResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LightsActuatorSettingsResultList {
        data = typeof data === 'object' ? data : {};
        let result = new LightsActuatorSettingsResultList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILightsActuatorSettingsResultList {
    results?: LightsActuatorSettingsResult[] | undefined;
}

export class LightsCommandItemSettingsDTO implements ILightsCommandItemSettingsDTO {
    saveTo?: number[] | undefined;
    timedDelayPickerValues?: DelayValue[] | undefined;
    lightsOnOffMode?: LightsOnOffMode;
    minimumRegulationLevel?: number;
    timedDelayPickerSelectedValue?: DelayValue;
    isTimedDelayVisible?: boolean;
    defaultSettings?: LigthsCommandSettings;
    currentSettings?: LigthsCommandSettings;
    isOptionOnOffVisible?: boolean;
    isOptionOffVisible?: boolean;
    isOptionOnVisible?: boolean;
    isOptionOnMinimumVisible?: boolean;
    isOptionToggleVisible?: boolean;
    isOptionToggleOnOffVisible?: boolean;
    isOptionButtonVisible?: boolean;
    isOptionTimedVisible?: boolean;
    hasMoreThanOneSlotSettings?: boolean;
    availableDelayValues?: DelayValue[] | undefined;
    isContactTypeVisibile?: boolean;
    indexes?: number[] | undefined;
    conctactType?: ConctactType;
    isConctactTypeVisibile?: boolean;
    isOnAndRegulationVisible?: boolean;
    isOffAndRegulationVisible?: boolean;
    isOnAndOffAndRegulationVisible?: boolean;

    constructor(data?: ILightsCommandItemSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["saveTo"])) {
                this.saveTo = [] as any;
                for (let item of _data["saveTo"])
                    this.saveTo!.push(item);
            }
            if (Array.isArray(_data["timedDelayPickerValues"])) {
                this.timedDelayPickerValues = [] as any;
                for (let item of _data["timedDelayPickerValues"])
                    this.timedDelayPickerValues!.push(DelayValue.fromJS(item));
            }
            this.lightsOnOffMode = _data["lightsOnOffMode"];
            this.minimumRegulationLevel = _data["minimumRegulationLevel"];
            this.timedDelayPickerSelectedValue = _data["timedDelayPickerSelectedValue"] ? DelayValue.fromJS(_data["timedDelayPickerSelectedValue"]) : <any>undefined;
            this.isTimedDelayVisible = _data["isTimedDelayVisible"];
            this.defaultSettings = _data["defaultSettings"] ? LigthsCommandSettings.fromJS(_data["defaultSettings"]) : <any>undefined;
            this.currentSettings = _data["currentSettings"] ? LigthsCommandSettings.fromJS(_data["currentSettings"]) : <any>undefined;
            this.isOptionOnOffVisible = _data["isOptionOnOffVisible"];
            this.isOptionOffVisible = _data["isOptionOffVisible"];
            this.isOptionOnVisible = _data["isOptionOnVisible"];
            this.isOptionOnMinimumVisible = _data["isOptionOnMinimumVisible"];
            this.isOptionToggleVisible = _data["isOptionToggleVisible"];
            this.isOptionToggleOnOffVisible = _data["isOptionToggleOnOffVisible"];
            this.isOptionButtonVisible = _data["isOptionButtonVisible"];
            this.isOptionTimedVisible = _data["isOptionTimedVisible"];
            this.hasMoreThanOneSlotSettings = _data["hasMoreThanOneSlotSettings"];
            if (Array.isArray(_data["availableDelayValues"])) {
                this.availableDelayValues = [] as any;
                for (let item of _data["availableDelayValues"])
                    this.availableDelayValues!.push(DelayValue.fromJS(item));
            }
            this.isContactTypeVisibile = _data["isContactTypeVisibile"];
            if (Array.isArray(_data["indexes"])) {
                this.indexes = [] as any;
                for (let item of _data["indexes"])
                    this.indexes!.push(item);
            }
            this.conctactType = _data["conctactType"];
            this.isConctactTypeVisibile = _data["isConctactTypeVisibile"];
            this.isOnAndRegulationVisible = _data["isOnAndRegulationVisible"];
            this.isOffAndRegulationVisible = _data["isOffAndRegulationVisible"];
            this.isOnAndOffAndRegulationVisible = _data["isOnAndOffAndRegulationVisible"];
        }
    }

    static fromJS(data: any): LightsCommandItemSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LightsCommandItemSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.saveTo)) {
            data["saveTo"] = [];
            for (let item of this.saveTo)
                data["saveTo"].push(item);
        }
        if (Array.isArray(this.timedDelayPickerValues)) {
            data["timedDelayPickerValues"] = [];
            for (let item of this.timedDelayPickerValues)
                data["timedDelayPickerValues"].push(item.toJSON());
        }
        data["lightsOnOffMode"] = this.lightsOnOffMode;
        data["minimumRegulationLevel"] = this.minimumRegulationLevel;
        data["timedDelayPickerSelectedValue"] = this.timedDelayPickerSelectedValue ? this.timedDelayPickerSelectedValue.toJSON() : <any>undefined;
        data["isTimedDelayVisible"] = this.isTimedDelayVisible;
        data["defaultSettings"] = this.defaultSettings ? this.defaultSettings.toJSON() : <any>undefined;
        data["currentSettings"] = this.currentSettings ? this.currentSettings.toJSON() : <any>undefined;
        data["isOptionOnOffVisible"] = this.isOptionOnOffVisible;
        data["isOptionOffVisible"] = this.isOptionOffVisible;
        data["isOptionOnVisible"] = this.isOptionOnVisible;
        data["isOptionOnMinimumVisible"] = this.isOptionOnMinimumVisible;
        data["isOptionToggleVisible"] = this.isOptionToggleVisible;
        data["isOptionToggleOnOffVisible"] = this.isOptionToggleOnOffVisible;
        data["isOptionButtonVisible"] = this.isOptionButtonVisible;
        data["isOptionTimedVisible"] = this.isOptionTimedVisible;
        data["hasMoreThanOneSlotSettings"] = this.hasMoreThanOneSlotSettings;
        if (Array.isArray(this.availableDelayValues)) {
            data["availableDelayValues"] = [];
            for (let item of this.availableDelayValues)
                data["availableDelayValues"].push(item.toJSON());
        }
        data["isContactTypeVisibile"] = this.isContactTypeVisibile;
        if (Array.isArray(this.indexes)) {
            data["indexes"] = [];
            for (let item of this.indexes)
                data["indexes"].push(item);
        }
        data["conctactType"] = this.conctactType;
        data["isConctactTypeVisibile"] = this.isConctactTypeVisibile;
        data["isOnAndRegulationVisible"] = this.isOnAndRegulationVisible;
        data["isOffAndRegulationVisible"] = this.isOffAndRegulationVisible;
        data["isOnAndOffAndRegulationVisible"] = this.isOnAndOffAndRegulationVisible;
        return data;
    }
}

export interface ILightsCommandItemSettingsDTO {
    saveTo?: number[] | undefined;
    timedDelayPickerValues?: DelayValue[] | undefined;
    lightsOnOffMode?: LightsOnOffMode;
    minimumRegulationLevel?: number;
    timedDelayPickerSelectedValue?: DelayValue;
    isTimedDelayVisible?: boolean;
    defaultSettings?: LigthsCommandSettings;
    currentSettings?: LigthsCommandSettings;
    isOptionOnOffVisible?: boolean;
    isOptionOffVisible?: boolean;
    isOptionOnVisible?: boolean;
    isOptionOnMinimumVisible?: boolean;
    isOptionToggleVisible?: boolean;
    isOptionToggleOnOffVisible?: boolean;
    isOptionButtonVisible?: boolean;
    isOptionTimedVisible?: boolean;
    hasMoreThanOneSlotSettings?: boolean;
    availableDelayValues?: DelayValue[] | undefined;
    isContactTypeVisibile?: boolean;
    indexes?: number[] | undefined;
    conctactType?: ConctactType;
    isConctactTypeVisibile?: boolean;
    isOnAndRegulationVisible?: boolean;
    isOffAndRegulationVisible?: boolean;
    isOnAndOffAndRegulationVisible?: boolean;
}

export class LightsCommandSettingsObjectDTO implements ILightsCommandSettingsObjectDTO {
    slots?: LightsCommandItemSettingsDTO[] | undefined;
    hasBrightness?: boolean;
    hasBrightness4Params?: boolean;
    hasProximity?: boolean;
    hasStandby?: boolean;
    hasLedIntensity?: boolean;
    hasLedModality?: boolean;
    hasRefreshFeedback?: boolean;
    hasSettings?: boolean;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    readonly disabledModules?: boolean;

    constructor(data?: ILightsCommandSettingsObjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots!.push(LightsCommandItemSettingsDTO.fromJS(item));
            }
            this.hasBrightness = _data["hasBrightness"];
            this.hasBrightness4Params = _data["hasBrightness4Params"];
            this.hasProximity = _data["hasProximity"];
            this.hasStandby = _data["hasStandby"];
            this.hasLedIntensity = _data["hasLedIntensity"];
            this.hasLedModality = _data["hasLedModality"];
            this.hasRefreshFeedback = _data["hasRefreshFeedback"];
            this.hasSettings = _data["hasSettings"];
            this.deviceBrightness = _data["deviceBrightness"];
            this.showLedsInStandby = _data["showLedsInStandby"];
            this.isProximityEnabled = _data["isProximityEnabled"];
            this.deviceProximity = _data["deviceProximity"];
            this.ledIntensity = _data["ledIntensity"];
            this.ledModality = _data["ledModality"];
            this.deviceIconsVisibility = _data["deviceIconsVisibility"];
            (<any>this).disabledModules = _data["disabledModules"];
        }
    }

    static fromJS(data: any): LightsCommandSettingsObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LightsCommandSettingsObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item.toJSON());
        }
        data["hasBrightness"] = this.hasBrightness;
        data["hasBrightness4Params"] = this.hasBrightness4Params;
        data["hasProximity"] = this.hasProximity;
        data["hasStandby"] = this.hasStandby;
        data["hasLedIntensity"] = this.hasLedIntensity;
        data["hasLedModality"] = this.hasLedModality;
        data["hasRefreshFeedback"] = this.hasRefreshFeedback;
        data["hasSettings"] = this.hasSettings;
        data["deviceBrightness"] = this.deviceBrightness;
        data["showLedsInStandby"] = this.showLedsInStandby;
        data["isProximityEnabled"] = this.isProximityEnabled;
        data["deviceProximity"] = this.deviceProximity;
        data["ledIntensity"] = this.ledIntensity;
        data["ledModality"] = this.ledModality;
        data["deviceIconsVisibility"] = this.deviceIconsVisibility;
        data["disabledModules"] = this.disabledModules;
        return data;
    }
}

export interface ILightsCommandSettingsObjectDTO {
    slots?: LightsCommandItemSettingsDTO[] | undefined;
    hasBrightness?: boolean;
    hasBrightness4Params?: boolean;
    hasProximity?: boolean;
    hasStandby?: boolean;
    hasLedIntensity?: boolean;
    hasLedModality?: boolean;
    hasRefreshFeedback?: boolean;
    hasSettings?: boolean;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    disabledModules?: boolean;
}

export class LightsCommandSettingsResult implements ILightsCommandSettingsResult {
    lightsOnOffMode?: LightsOnOffMode;
    lightsOnOffTimedDelay?: number;
    minimumRegulationLevel?: number;
    index?: number;
    conctactType?: ConctactType;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    hasChanges?: boolean;

    constructor(data?: ILightsCommandSettingsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lightsOnOffMode = _data["lightsOnOffMode"];
            this.lightsOnOffTimedDelay = _data["lightsOnOffTimedDelay"];
            this.minimumRegulationLevel = _data["minimumRegulationLevel"];
            this.index = _data["index"];
            this.conctactType = _data["conctactType"];
            this.deviceBrightness = _data["deviceBrightness"];
            this.showLedsInStandby = _data["showLedsInStandby"];
            this.isProximityEnabled = _data["isProximityEnabled"];
            this.deviceProximity = _data["deviceProximity"];
            this.ledIntensity = _data["ledIntensity"];
            this.ledModality = _data["ledModality"];
            this.deviceIconsVisibility = _data["deviceIconsVisibility"];
            this.hasChanges = _data["hasChanges"];
        }
    }

    static fromJS(data: any): LightsCommandSettingsResult {
        data = typeof data === 'object' ? data : {};
        let result = new LightsCommandSettingsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lightsOnOffMode"] = this.lightsOnOffMode;
        data["lightsOnOffTimedDelay"] = this.lightsOnOffTimedDelay;
        data["minimumRegulationLevel"] = this.minimumRegulationLevel;
        data["index"] = this.index;
        data["conctactType"] = this.conctactType;
        data["deviceBrightness"] = this.deviceBrightness;
        data["showLedsInStandby"] = this.showLedsInStandby;
        data["isProximityEnabled"] = this.isProximityEnabled;
        data["deviceProximity"] = this.deviceProximity;
        data["ledIntensity"] = this.ledIntensity;
        data["ledModality"] = this.ledModality;
        data["deviceIconsVisibility"] = this.deviceIconsVisibility;
        data["hasChanges"] = this.hasChanges;
        return data;
    }
}

export interface ILightsCommandSettingsResult {
    lightsOnOffMode?: LightsOnOffMode;
    lightsOnOffTimedDelay?: number;
    minimumRegulationLevel?: number;
    index?: number;
    conctactType?: ConctactType;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    hasChanges?: boolean;
}

export class LightsCommandSettingsResultList implements ILightsCommandSettingsResultList {
    results?: LightsCommandSettingsResult[] | undefined;

    constructor(data?: ILightsCommandSettingsResultList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(LightsCommandSettingsResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LightsCommandSettingsResultList {
        data = typeof data === 'object' ? data : {};
        let result = new LightsCommandSettingsResultList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILightsCommandSettingsResultList {
    results?: LightsCommandSettingsResult[] | undefined;
}

/** 0 = Fluorescent 1 = Led 2 = Halogen 3 = LedTrailingEdgeOrElectronicTransformer 4 = LedLeadingEdge 5 = CFLTrailingEdge 6 = CFLLeadingEdge 7 = DaliStandard */
export enum LightsLoadTypes {
    Fluorescent = 0,
    Led = 1,
    Halogen = 2,
    LedTrailingEdgeOrElectronicTransformer = 3,
    LedLeadingEdge = 4,
    CFLTrailingEdge = 5,
    CFLLeadingEdge = 6,
    DaliStandard = 7,
}

/** 0 = Off 1 = OnOffRegulation 2 = Toggle 3 = Button 4 = Timed 5 = On 6 = OnMinimum 7 = ToggleOnOff 8 = CustomizedOn 9 = CustomizedOff 10 = CustomizedOnOff 11 = CustomizedOnOffRegulation 12 = CustomizedToggle 13 = CustomizedToggleRegulation 14 = CustomizedOnRegulation 15 = CustomizedOffRegulation 16 = OnAndRegulation 17 = OffAndRegulation */
export enum LightsOnOffMode {
    Off = 0,
    OnOffRegulation = 1,
    Toggle = 2,
    Button = 3,
    Timed = 4,
    On = 5,
    OnMinimum = 6,
    ToggleOnOff = 7,
    CustomizedOn = 8,
    CustomizedOff = 9,
    CustomizedOnOff = 10,
    CustomizedOnOffRegulation = 11,
    CustomizedToggle = 12,
    CustomizedToggleRegulation = 13,
    CustomizedOnRegulation = 14,
    CustomizedOffRegulation = 15,
    OnAndRegulation = 16,
    OffAndRegulation = 17,
}

/** 0 = AutoOnOff 1 = ManualOnAutoOff */
export enum LightsSensorOperatingMode {
    AutoOnOff = 0,
    ManualOnAutoOff = 1,
}

/** 0 = Low 1 = Medium 2 = High 3 = Maximum */
export enum LightsSensorSensitivity {
    Low = 0,
    Medium = 1,
    High = 2,
    Maximum = 3,
}

/** 0 = V_0_10 1 = V_1_10 */
export enum LightsVoltageOptions {
    V_0_10 = 0,
    V_1_10 = 1,
}

export class LigthsCommandSettings extends CommandSettings implements ILigthsCommandSettings {
    lightsOnOffMode?: LightsOnOffMode;
    lightsOnOffTimedDelay?: number;
    minimumRegulationLevel?: number;
    typeofContact?: ConctactType;
    powerON?: number;
    fadeIn?: number;
    fadeOut?: number;
    dimmingSpeed?: number;

    constructor(data?: ILigthsCommandSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lightsOnOffMode = _data["lightsOnOffMode"];
            this.lightsOnOffTimedDelay = _data["lightsOnOffTimedDelay"];
            this.minimumRegulationLevel = _data["minimumRegulationLevel"];
            this.typeofContact = _data["typeofContact"];
            this.powerON = _data["powerON"];
            this.fadeIn = _data["fadeIn"];
            this.fadeOut = _data["fadeOut"];
            this.dimmingSpeed = _data["dimmingSpeed"];
        }
    }

    static fromJS(data: any): LigthsCommandSettings {
        data = typeof data === 'object' ? data : {};
        let result = new LigthsCommandSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lightsOnOffMode"] = this.lightsOnOffMode;
        data["lightsOnOffTimedDelay"] = this.lightsOnOffTimedDelay;
        data["minimumRegulationLevel"] = this.minimumRegulationLevel;
        data["typeofContact"] = this.typeofContact;
        data["powerON"] = this.powerON;
        data["fadeIn"] = this.fadeIn;
        data["fadeOut"] = this.fadeOut;
        data["dimmingSpeed"] = this.dimmingSpeed;
        super.toJSON(data);
        return data;
    }
}

export interface ILigthsCommandSettings extends ICommandSettings {
    lightsOnOffMode?: LightsOnOffMode;
    lightsOnOffTimedDelay?: number;
    minimumRegulationLevel?: number;
    typeofContact?: ConctactType;
    powerON?: number;
    fadeIn?: number;
    fadeOut?: number;
    dimmingSpeed?: number;
}

export class LigthsSensorCommandSettings extends CommandSettings implements ILigthsSensorCommandSettings {
    operationgfMode?: LightsSensorOperatingMode;
    daylightSetPoint?: number;
    timingOff?: number;
    pirSensitivity?: LightsSensorSensitivity;
    usSensitivity?: LightsSensorSensitivity;

    constructor(data?: ILigthsSensorCommandSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operationgfMode = _data["operationgfMode"];
            this.daylightSetPoint = _data["daylightSetPoint"];
            this.timingOff = _data["timingOff"];
            this.pirSensitivity = _data["pirSensitivity"];
            this.usSensitivity = _data["usSensitivity"];
        }
    }

    static fromJS(data: any): LigthsSensorCommandSettings {
        data = typeof data === 'object' ? data : {};
        let result = new LigthsSensorCommandSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationgfMode"] = this.operationgfMode;
        data["daylightSetPoint"] = this.daylightSetPoint;
        data["timingOff"] = this.timingOff;
        data["pirSensitivity"] = this.pirSensitivity;
        data["usSensitivity"] = this.usSensitivity;
        super.toJSON(data);
        return data;
    }
}

export interface ILigthsSensorCommandSettings extends ICommandSettings {
    operationgfMode?: LightsSensorOperatingMode;
    daylightSetPoint?: number;
    timingOff?: number;
    pirSensitivity?: LightsSensorSensitivity;
    usSensitivity?: LightsSensorSensitivity;
}

/** 0 = None 1 = Partial 2 = Total */
export enum Line {
    None = 0,
    Partial = 1,
    Total = 2,
}

/** 0 = None 1 = Production 2 = Consumption */
export enum LineMisuration {
    None = 0,
    Production = 1,
    Consumption = 2,
}

export class LockActuatorSettings extends ActuatorSettings implements ILockActuatorSettings {
    isZeroCrossingEnabled?: boolean;

    constructor(data?: ILockActuatorSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isZeroCrossingEnabled = _data["isZeroCrossingEnabled"];
        }
    }

    static fromJS(data: any): LockActuatorSettings {
        data = typeof data === 'object' ? data : {};
        let result = new LockActuatorSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isZeroCrossingEnabled"] = this.isZeroCrossingEnabled;
        super.toJSON(data);
        return data;
    }
}

export interface ILockActuatorSettings extends IActuatorSettings {
    isZeroCrossingEnabled?: boolean;
}

export class LockActuatorSettingsObjectParam implements ILockActuatorSettingsObjectParam {
    isZeroCrossingEnabled?: boolean;

    constructor(data?: ILockActuatorSettingsObjectParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isZeroCrossingEnabled = _data["isZeroCrossingEnabled"];
        }
    }

    static fromJS(data: any): LockActuatorSettingsObjectParam {
        data = typeof data === 'object' ? data : {};
        let result = new LockActuatorSettingsObjectParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isZeroCrossingEnabled"] = this.isZeroCrossingEnabled;
        return data;
    }
}

export interface ILockActuatorSettingsObjectParam {
    isZeroCrossingEnabled?: boolean;
}

export class LockActuatorSettingsResult implements ILockActuatorSettingsResult {
    isZeroCrossingEnabled?: boolean;

    constructor(data?: ILockActuatorSettingsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isZeroCrossingEnabled = _data["isZeroCrossingEnabled"];
        }
    }

    static fromJS(data: any): LockActuatorSettingsResult {
        data = typeof data === 'object' ? data : {};
        let result = new LockActuatorSettingsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isZeroCrossingEnabled"] = this.isZeroCrossingEnabled;
        return data;
    }
}

export interface ILockActuatorSettingsResult {
    isZeroCrossingEnabled?: boolean;
}

export class LockCommandSettings extends CommandSettings implements ILockCommandSettings {
    commandOpeningTime?: CommandOpeningTime;
    typeofContact?: ConctactType;
    scsLevel?: ScsLevel;

    constructor(data?: ILockCommandSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.commandOpeningTime = _data["commandOpeningTime"];
            this.typeofContact = _data["typeofContact"];
            this.scsLevel = _data["scsLevel"];
        }
    }

    static fromJS(data: any): LockCommandSettings {
        data = typeof data === 'object' ? data : {};
        let result = new LockCommandSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commandOpeningTime"] = this.commandOpeningTime;
        data["typeofContact"] = this.typeofContact;
        data["scsLevel"] = this.scsLevel;
        super.toJSON(data);
        return data;
    }
}

export interface ILockCommandSettings extends ICommandSettings {
    commandOpeningTime?: CommandOpeningTime;
    typeofContact?: ConctactType;
    scsLevel?: ScsLevel;
}

export class LockCommandSettingsObjectDTO implements ILockCommandSettingsObjectDTO {
    hasBrightness?: boolean;
    hasBrightness4Params?: boolean;
    hasProximity?: boolean;
    hasStandby?: boolean;
    hasLedIntensity?: boolean;
    hasLedModality?: boolean;
    hasRefreshFeedback?: boolean;
    hasSettings?: boolean;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    slots?: LocksCommandItemSettingsDTO[] | undefined;
    isVde?: boolean;

    constructor(data?: ILockCommandSettingsObjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasBrightness = _data["hasBrightness"];
            this.hasBrightness4Params = _data["hasBrightness4Params"];
            this.hasProximity = _data["hasProximity"];
            this.hasStandby = _data["hasStandby"];
            this.hasLedIntensity = _data["hasLedIntensity"];
            this.hasLedModality = _data["hasLedModality"];
            this.hasRefreshFeedback = _data["hasRefreshFeedback"];
            this.hasSettings = _data["hasSettings"];
            this.deviceBrightness = _data["deviceBrightness"];
            this.showLedsInStandby = _data["showLedsInStandby"];
            this.isProximityEnabled = _data["isProximityEnabled"];
            this.deviceProximity = _data["deviceProximity"];
            this.ledIntensity = _data["ledIntensity"];
            this.ledModality = _data["ledModality"];
            this.deviceIconsVisibility = _data["deviceIconsVisibility"];
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots!.push(LocksCommandItemSettingsDTO.fromJS(item));
            }
            this.isVde = _data["isVde"];
        }
    }

    static fromJS(data: any): LockCommandSettingsObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LockCommandSettingsObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasBrightness"] = this.hasBrightness;
        data["hasBrightness4Params"] = this.hasBrightness4Params;
        data["hasProximity"] = this.hasProximity;
        data["hasStandby"] = this.hasStandby;
        data["hasLedIntensity"] = this.hasLedIntensity;
        data["hasLedModality"] = this.hasLedModality;
        data["hasRefreshFeedback"] = this.hasRefreshFeedback;
        data["hasSettings"] = this.hasSettings;
        data["deviceBrightness"] = this.deviceBrightness;
        data["showLedsInStandby"] = this.showLedsInStandby;
        data["isProximityEnabled"] = this.isProximityEnabled;
        data["deviceProximity"] = this.deviceProximity;
        data["ledIntensity"] = this.ledIntensity;
        data["ledModality"] = this.ledModality;
        data["deviceIconsVisibility"] = this.deviceIconsVisibility;
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item.toJSON());
        }
        data["isVde"] = this.isVde;
        return data;
    }
}

export interface ILockCommandSettingsObjectDTO {
    hasBrightness?: boolean;
    hasBrightness4Params?: boolean;
    hasProximity?: boolean;
    hasStandby?: boolean;
    hasLedIntensity?: boolean;
    hasLedModality?: boolean;
    hasRefreshFeedback?: boolean;
    hasSettings?: boolean;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    slots?: LocksCommandItemSettingsDTO[] | undefined;
    isVde?: boolean;
}

export class LockCommandSettingsResult implements ILockCommandSettingsResult {
    commandOpeningTime?: CommandOpeningTime;
    index?: number;
    conctactType?: ConctactType;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    hasChanges?: boolean;
    scsLevel?: ScsLevel;

    constructor(data?: ILockCommandSettingsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commandOpeningTime = _data["commandOpeningTime"];
            this.index = _data["index"];
            this.conctactType = _data["conctactType"];
            this.deviceBrightness = _data["deviceBrightness"];
            this.showLedsInStandby = _data["showLedsInStandby"];
            this.isProximityEnabled = _data["isProximityEnabled"];
            this.deviceProximity = _data["deviceProximity"];
            this.ledIntensity = _data["ledIntensity"];
            this.ledModality = _data["ledModality"];
            this.deviceIconsVisibility = _data["deviceIconsVisibility"];
            this.hasChanges = _data["hasChanges"];
            this.scsLevel = _data["scsLevel"];
        }
    }

    static fromJS(data: any): LockCommandSettingsResult {
        data = typeof data === 'object' ? data : {};
        let result = new LockCommandSettingsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commandOpeningTime"] = this.commandOpeningTime;
        data["index"] = this.index;
        data["conctactType"] = this.conctactType;
        data["deviceBrightness"] = this.deviceBrightness;
        data["showLedsInStandby"] = this.showLedsInStandby;
        data["isProximityEnabled"] = this.isProximityEnabled;
        data["deviceProximity"] = this.deviceProximity;
        data["ledIntensity"] = this.ledIntensity;
        data["ledModality"] = this.ledModality;
        data["deviceIconsVisibility"] = this.deviceIconsVisibility;
        data["hasChanges"] = this.hasChanges;
        data["scsLevel"] = this.scsLevel;
        return data;
    }
}

export interface ILockCommandSettingsResult {
    commandOpeningTime?: CommandOpeningTime;
    index?: number;
    conctactType?: ConctactType;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    hasChanges?: boolean;
    scsLevel?: ScsLevel;
}

export class LockCommandSettingsResultList implements ILockCommandSettingsResultList {
    results?: LockCommandSettingsResult[] | undefined;

    constructor(data?: ILockCommandSettingsResultList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(LockCommandSettingsResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LockCommandSettingsResultList {
        data = typeof data === 'object' ? data : {};
        let result = new LockCommandSettingsResultList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILockCommandSettingsResultList {
    results?: LockCommandSettingsResult[] | undefined;
}

export class LocksCommandItemSettingsDTO implements ILocksCommandItemSettingsDTO {
    saveTo?: number[] | undefined;
    lightType?: LightType;
    isManagePosition?: boolean;
    isAppliedToAllSameTypeCommands?: boolean;
    hasMoreThanOneSlotSettings?: boolean;
    indexes?: number[] | undefined;
    commandOpeningTime?: CommandOpeningTime;
    isContactTypeVisibile?: boolean;
    conctactType?: ConctactType;
    isVde?: boolean;
    scsLevel?: ScsLevel;

    constructor(data?: ILocksCommandItemSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["saveTo"])) {
                this.saveTo = [] as any;
                for (let item of _data["saveTo"])
                    this.saveTo!.push(item);
            }
            this.lightType = _data["lightType"];
            this.isManagePosition = _data["isManagePosition"];
            this.isAppliedToAllSameTypeCommands = _data["isAppliedToAllSameTypeCommands"];
            this.hasMoreThanOneSlotSettings = _data["hasMoreThanOneSlotSettings"];
            if (Array.isArray(_data["indexes"])) {
                this.indexes = [] as any;
                for (let item of _data["indexes"])
                    this.indexes!.push(item);
            }
            this.commandOpeningTime = _data["commandOpeningTime"];
            this.isContactTypeVisibile = _data["isContactTypeVisibile"];
            this.conctactType = _data["conctactType"];
            this.isVde = _data["isVde"];
            this.scsLevel = _data["scsLevel"];
        }
    }

    static fromJS(data: any): LocksCommandItemSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocksCommandItemSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.saveTo)) {
            data["saveTo"] = [];
            for (let item of this.saveTo)
                data["saveTo"].push(item);
        }
        data["lightType"] = this.lightType;
        data["isManagePosition"] = this.isManagePosition;
        data["isAppliedToAllSameTypeCommands"] = this.isAppliedToAllSameTypeCommands;
        data["hasMoreThanOneSlotSettings"] = this.hasMoreThanOneSlotSettings;
        if (Array.isArray(this.indexes)) {
            data["indexes"] = [];
            for (let item of this.indexes)
                data["indexes"].push(item);
        }
        data["commandOpeningTime"] = this.commandOpeningTime;
        data["isContactTypeVisibile"] = this.isContactTypeVisibile;
        data["conctactType"] = this.conctactType;
        data["isVde"] = this.isVde;
        data["scsLevel"] = this.scsLevel;
        return data;
    }
}

export interface ILocksCommandItemSettingsDTO {
    saveTo?: number[] | undefined;
    lightType?: LightType;
    isManagePosition?: boolean;
    isAppliedToAllSameTypeCommands?: boolean;
    hasMoreThanOneSlotSettings?: boolean;
    indexes?: number[] | undefined;
    commandOpeningTime?: CommandOpeningTime;
    isContactTypeVisibile?: boolean;
    conctactType?: ConctactType;
    isVde?: boolean;
    scsLevel?: ScsLevel;
}

export class ObjectCondition extends Condition implements IObjectCondition {
    isGroup?: boolean;
    linkableObjectId?: string | undefined;
    stateComparer?: SceneStateComparer;
    lightState?: SceneLightState;
    dimmerState?: SceneDimmerState;
    dimmerPowerState?: SceneDimmerPowerState;
    dimmerPercent?: number;
    workingMode?: DimmerWorkingMode;
    selectedColor?: Color;
    temperature?: number;
    isShutterPositionManaged?: boolean;
    shutterModality?: SceneShutterModality;
    shutterState?: SceneShutterState;
    shutterPosition?: number;
    sceneShutterOrientation?: SceneShutterOrientation;
    blindState?: SceneBlindState;
    socketState?: SceneSocketState;
    lockState?: SceneLockState;
    thermostatState?: SceneThermostatState;
    thermostatModalityState?: SceneThermostatModalityState;
    thermostatConditionState?: SceneThermostatConditionState;
    thermostatTemperature?: number;
    thermostatHumidity?: number;
    towelWarmerState?: SceneTowelWarmerState;
    fancoilState?: SceneFancoilState;
    fancoilSpeedState?: SceneFancoilSpeedState;
    coloredLightsState?: SceneColoredLightsState;
    coloredLightStateComparer?: SceneStateComparer;
    sceneColoredLightsColor?: SceneColoredLightsColor;
    playerTriggerMode?: ScenePlayerTriggerMode;
    playerTriggerPowerState?: ScenePlayerState;
    playerVolume?: number;
    energyMeterKw?: number;
    energyMeterLine?: number;
    alarmPartitionState?: AlarmPartitionState;
    alarmSensorState?: AlarmSensorStatus;
    alarmSensorObjectStatus?: AlarmSensorStatusScene;
    sceneLoadManagementStatus?: SceneLoadManagementState;
    sceneLoadManagementPower?: number | undefined;

    constructor(data?: IObjectCondition) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isGroup = _data["isGroup"];
            this.linkableObjectId = _data["linkableObjectId"];
            this.stateComparer = _data["stateComparer"];
            this.lightState = _data["lightState"];
            this.dimmerState = _data["dimmerState"];
            this.dimmerPowerState = _data["dimmerPowerState"];
            this.dimmerPercent = _data["dimmerPercent"];
            this.workingMode = _data["workingMode"];
            this.selectedColor = _data["selectedColor"] ? Color.fromJS(_data["selectedColor"]) : <any>undefined;
            this.temperature = _data["temperature"];
            this.isShutterPositionManaged = _data["isShutterPositionManaged"];
            this.shutterModality = _data["shutterModality"];
            this.shutterState = _data["shutterState"];
            this.shutterPosition = _data["shutterPosition"];
            this.sceneShutterOrientation = _data["sceneShutterOrientation"];
            this.blindState = _data["blindState"];
            this.socketState = _data["socketState"];
            this.lockState = _data["lockState"];
            this.thermostatState = _data["thermostatState"];
            this.thermostatModalityState = _data["thermostatModalityState"];
            this.thermostatConditionState = _data["thermostatConditionState"];
            this.thermostatTemperature = _data["thermostatTemperature"];
            this.thermostatHumidity = _data["thermostatHumidity"];
            this.towelWarmerState = _data["towelWarmerState"];
            this.fancoilState = _data["fancoilState"];
            this.fancoilSpeedState = _data["fancoilSpeedState"];
            this.coloredLightsState = _data["coloredLightsState"];
            this.coloredLightStateComparer = _data["coloredLightStateComparer"];
            this.sceneColoredLightsColor = _data["sceneColoredLightsColor"];
            this.playerTriggerMode = _data["playerTriggerMode"];
            this.playerTriggerPowerState = _data["playerTriggerPowerState"];
            this.playerVolume = _data["playerVolume"];
            this.energyMeterKw = _data["energyMeterKw"];
            this.energyMeterLine = _data["energyMeterLine"];
            this.alarmPartitionState = _data["alarmPartitionState"];
            this.alarmSensorState = _data["alarmSensorState"];
            this.alarmSensorObjectStatus = _data["alarmSensorObjectStatus"];
            this.sceneLoadManagementStatus = _data["sceneLoadManagementStatus"];
            this.sceneLoadManagementPower = _data["sceneLoadManagementPower"];
        }
    }

    static fromJS(data: any): ObjectCondition {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isGroup"] = this.isGroup;
        data["linkableObjectId"] = this.linkableObjectId;
        data["stateComparer"] = this.stateComparer;
        data["lightState"] = this.lightState;
        data["dimmerState"] = this.dimmerState;
        data["dimmerPowerState"] = this.dimmerPowerState;
        data["dimmerPercent"] = this.dimmerPercent;
        data["workingMode"] = this.workingMode;
        data["selectedColor"] = this.selectedColor ? this.selectedColor.toJSON() : <any>undefined;
        data["temperature"] = this.temperature;
        data["isShutterPositionManaged"] = this.isShutterPositionManaged;
        data["shutterModality"] = this.shutterModality;
        data["shutterState"] = this.shutterState;
        data["shutterPosition"] = this.shutterPosition;
        data["sceneShutterOrientation"] = this.sceneShutterOrientation;
        data["blindState"] = this.blindState;
        data["socketState"] = this.socketState;
        data["lockState"] = this.lockState;
        data["thermostatState"] = this.thermostatState;
        data["thermostatModalityState"] = this.thermostatModalityState;
        data["thermostatConditionState"] = this.thermostatConditionState;
        data["thermostatTemperature"] = this.thermostatTemperature;
        data["thermostatHumidity"] = this.thermostatHumidity;
        data["towelWarmerState"] = this.towelWarmerState;
        data["fancoilState"] = this.fancoilState;
        data["fancoilSpeedState"] = this.fancoilSpeedState;
        data["coloredLightsState"] = this.coloredLightsState;
        data["coloredLightStateComparer"] = this.coloredLightStateComparer;
        data["sceneColoredLightsColor"] = this.sceneColoredLightsColor;
        data["playerTriggerMode"] = this.playerTriggerMode;
        data["playerTriggerPowerState"] = this.playerTriggerPowerState;
        data["playerVolume"] = this.playerVolume;
        data["energyMeterKw"] = this.energyMeterKw;
        data["energyMeterLine"] = this.energyMeterLine;
        data["alarmPartitionState"] = this.alarmPartitionState;
        data["alarmSensorState"] = this.alarmSensorState;
        data["alarmSensorObjectStatus"] = this.alarmSensorObjectStatus;
        data["sceneLoadManagementStatus"] = this.sceneLoadManagementStatus;
        data["sceneLoadManagementPower"] = this.sceneLoadManagementPower;
        super.toJSON(data);
        return data;
    }
}

export interface IObjectCondition extends ICondition {
    isGroup?: boolean;
    linkableObjectId?: string | undefined;
    stateComparer?: SceneStateComparer;
    lightState?: SceneLightState;
    dimmerState?: SceneDimmerState;
    dimmerPowerState?: SceneDimmerPowerState;
    dimmerPercent?: number;
    workingMode?: DimmerWorkingMode;
    selectedColor?: Color;
    temperature?: number;
    isShutterPositionManaged?: boolean;
    shutterModality?: SceneShutterModality;
    shutterState?: SceneShutterState;
    shutterPosition?: number;
    sceneShutterOrientation?: SceneShutterOrientation;
    blindState?: SceneBlindState;
    socketState?: SceneSocketState;
    lockState?: SceneLockState;
    thermostatState?: SceneThermostatState;
    thermostatModalityState?: SceneThermostatModalityState;
    thermostatConditionState?: SceneThermostatConditionState;
    thermostatTemperature?: number;
    thermostatHumidity?: number;
    towelWarmerState?: SceneTowelWarmerState;
    fancoilState?: SceneFancoilState;
    fancoilSpeedState?: SceneFancoilSpeedState;
    coloredLightsState?: SceneColoredLightsState;
    coloredLightStateComparer?: SceneStateComparer;
    sceneColoredLightsColor?: SceneColoredLightsColor;
    playerTriggerMode?: ScenePlayerTriggerMode;
    playerTriggerPowerState?: ScenePlayerState;
    playerVolume?: number;
    energyMeterKw?: number;
    energyMeterLine?: number;
    alarmPartitionState?: AlarmPartitionState;
    alarmSensorState?: AlarmSensorStatus;
    alarmSensorObjectStatus?: AlarmSensorStatusScene;
    sceneLoadManagementStatus?: SceneLoadManagementState;
    sceneLoadManagementPower?: number | undefined;
}

/** 0 = None 1 = NewDuplication 2 = OldDuplication */
export enum ObjectDuplication {
    None = 0,
    NewDuplication = 1,
    OldDuplication = 2,
}

export class ObjectTrigger extends Trigger implements IObjectTrigger {
    isGroup?: boolean;
    linkableObjectId?: string | undefined;
    stateComparer?: SceneStateComparer;
    lightState?: SceneLightState;
    dimmerState?: SceneDimmerState;
    dimmerPowerState?: SceneDimmerPowerState;
    dimmerPercent?: number;
    workingMode?: DimmerWorkingMode;
    selectedColor?: Color;
    temperature?: number;
    isShutterPositionManaged?: boolean;
    shutterModality?: SceneShutterModality;
    shutterState?: SceneShutterState;
    shutterPosition?: number;
    sceneShutterOrientation?: SceneShutterOrientation;
    blindState?: SceneBlindState;
    socketState?: SceneSocketState;
    lockState?: SceneLockState;
    thermostatState?: SceneThermostatState;
    thermostatModalityState?: SceneThermostatModalityState;
    thermostatConditionState?: SceneThermostatConditionState;
    thermostatTemperature?: number;
    thermostatHumidity?: number;
    towelWarmerState?: SceneTowelWarmerState;
    fancoilState?: SceneFancoilState;
    fancoilSpeedState?: SceneFancoilSpeedState;
    coloredLightsState?: SceneColoredLightsState;
    coloredLightStateComparer?: SceneStateComparer;
    sceneColoredLightsColor?: SceneColoredLightsColor;
    playerTriggerMode?: ScenePlayerTriggerMode;
    playerTriggerPowerState?: ScenePlayerState;
    playerVolume?: number;
    energyMeterKw?: number;
    energyMeterLine?: number;
    alarmPartitionState?: AlarmPartitionState;
    alarmSensorState?: AlarmSensorStatus;
    alarmSensorObjectStatus?: AlarmSensorStatusScene;
    sceneLoadManagementStatus?: SceneLoadManagementState;
    sceneLoadManagementPower?: number | undefined;

    constructor(data?: IObjectTrigger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isGroup = _data["isGroup"];
            this.linkableObjectId = _data["linkableObjectId"];
            this.stateComparer = _data["stateComparer"];
            this.lightState = _data["lightState"];
            this.dimmerState = _data["dimmerState"];
            this.dimmerPowerState = _data["dimmerPowerState"];
            this.dimmerPercent = _data["dimmerPercent"];
            this.workingMode = _data["workingMode"];
            this.selectedColor = _data["selectedColor"] ? Color.fromJS(_data["selectedColor"]) : <any>undefined;
            this.temperature = _data["temperature"];
            this.isShutterPositionManaged = _data["isShutterPositionManaged"];
            this.shutterModality = _data["shutterModality"];
            this.shutterState = _data["shutterState"];
            this.shutterPosition = _data["shutterPosition"];
            this.sceneShutterOrientation = _data["sceneShutterOrientation"];
            this.blindState = _data["blindState"];
            this.socketState = _data["socketState"];
            this.lockState = _data["lockState"];
            this.thermostatState = _data["thermostatState"];
            this.thermostatModalityState = _data["thermostatModalityState"];
            this.thermostatConditionState = _data["thermostatConditionState"];
            this.thermostatTemperature = _data["thermostatTemperature"];
            this.thermostatHumidity = _data["thermostatHumidity"];
            this.towelWarmerState = _data["towelWarmerState"];
            this.fancoilState = _data["fancoilState"];
            this.fancoilSpeedState = _data["fancoilSpeedState"];
            this.coloredLightsState = _data["coloredLightsState"];
            this.coloredLightStateComparer = _data["coloredLightStateComparer"];
            this.sceneColoredLightsColor = _data["sceneColoredLightsColor"];
            this.playerTriggerMode = _data["playerTriggerMode"];
            this.playerTriggerPowerState = _data["playerTriggerPowerState"];
            this.playerVolume = _data["playerVolume"];
            this.energyMeterKw = _data["energyMeterKw"];
            this.energyMeterLine = _data["energyMeterLine"];
            this.alarmPartitionState = _data["alarmPartitionState"];
            this.alarmSensorState = _data["alarmSensorState"];
            this.alarmSensorObjectStatus = _data["alarmSensorObjectStatus"];
            this.sceneLoadManagementStatus = _data["sceneLoadManagementStatus"];
            this.sceneLoadManagementPower = _data["sceneLoadManagementPower"];
        }
    }

    static fromJS(data: any): ObjectTrigger {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectTrigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isGroup"] = this.isGroup;
        data["linkableObjectId"] = this.linkableObjectId;
        data["stateComparer"] = this.stateComparer;
        data["lightState"] = this.lightState;
        data["dimmerState"] = this.dimmerState;
        data["dimmerPowerState"] = this.dimmerPowerState;
        data["dimmerPercent"] = this.dimmerPercent;
        data["workingMode"] = this.workingMode;
        data["selectedColor"] = this.selectedColor ? this.selectedColor.toJSON() : <any>undefined;
        data["temperature"] = this.temperature;
        data["isShutterPositionManaged"] = this.isShutterPositionManaged;
        data["shutterModality"] = this.shutterModality;
        data["shutterState"] = this.shutterState;
        data["shutterPosition"] = this.shutterPosition;
        data["sceneShutterOrientation"] = this.sceneShutterOrientation;
        data["blindState"] = this.blindState;
        data["socketState"] = this.socketState;
        data["lockState"] = this.lockState;
        data["thermostatState"] = this.thermostatState;
        data["thermostatModalityState"] = this.thermostatModalityState;
        data["thermostatConditionState"] = this.thermostatConditionState;
        data["thermostatTemperature"] = this.thermostatTemperature;
        data["thermostatHumidity"] = this.thermostatHumidity;
        data["towelWarmerState"] = this.towelWarmerState;
        data["fancoilState"] = this.fancoilState;
        data["fancoilSpeedState"] = this.fancoilSpeedState;
        data["coloredLightsState"] = this.coloredLightsState;
        data["coloredLightStateComparer"] = this.coloredLightStateComparer;
        data["sceneColoredLightsColor"] = this.sceneColoredLightsColor;
        data["playerTriggerMode"] = this.playerTriggerMode;
        data["playerTriggerPowerState"] = this.playerTriggerPowerState;
        data["playerVolume"] = this.playerVolume;
        data["energyMeterKw"] = this.energyMeterKw;
        data["energyMeterLine"] = this.energyMeterLine;
        data["alarmPartitionState"] = this.alarmPartitionState;
        data["alarmSensorState"] = this.alarmSensorState;
        data["alarmSensorObjectStatus"] = this.alarmSensorObjectStatus;
        data["sceneLoadManagementStatus"] = this.sceneLoadManagementStatus;
        data["sceneLoadManagementPower"] = this.sceneLoadManagementPower;
        super.toJSON(data);
        return data;
    }
}

export interface IObjectTrigger extends ITrigger {
    isGroup?: boolean;
    linkableObjectId?: string | undefined;
    stateComparer?: SceneStateComparer;
    lightState?: SceneLightState;
    dimmerState?: SceneDimmerState;
    dimmerPowerState?: SceneDimmerPowerState;
    dimmerPercent?: number;
    workingMode?: DimmerWorkingMode;
    selectedColor?: Color;
    temperature?: number;
    isShutterPositionManaged?: boolean;
    shutterModality?: SceneShutterModality;
    shutterState?: SceneShutterState;
    shutterPosition?: number;
    sceneShutterOrientation?: SceneShutterOrientation;
    blindState?: SceneBlindState;
    socketState?: SceneSocketState;
    lockState?: SceneLockState;
    thermostatState?: SceneThermostatState;
    thermostatModalityState?: SceneThermostatModalityState;
    thermostatConditionState?: SceneThermostatConditionState;
    thermostatTemperature?: number;
    thermostatHumidity?: number;
    towelWarmerState?: SceneTowelWarmerState;
    fancoilState?: SceneFancoilState;
    fancoilSpeedState?: SceneFancoilSpeedState;
    coloredLightsState?: SceneColoredLightsState;
    coloredLightStateComparer?: SceneStateComparer;
    sceneColoredLightsColor?: SceneColoredLightsColor;
    playerTriggerMode?: ScenePlayerTriggerMode;
    playerTriggerPowerState?: ScenePlayerState;
    playerVolume?: number;
    energyMeterKw?: number;
    energyMeterLine?: number;
    alarmPartitionState?: AlarmPartitionState;
    alarmSensorState?: AlarmSensorStatus;
    alarmSensorObjectStatus?: AlarmSensorStatusScene;
    sceneLoadManagementStatus?: SceneLoadManagementState;
    sceneLoadManagementPower?: number | undefined;
}

export class ParamCreateLinkModule implements IParamCreateLinkModule {
    index?: number;
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IParamCreateLinkModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ParamCreateLinkModule {
        data = typeof data === 'object' ? data : {};
        let result = new ParamCreateLinkModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IParamCreateLinkModule {
    index?: number;
    name?: string | undefined;
    value?: string | undefined;
}

export class ParamsScenesId implements IParamsScenesId {
    id?: string | undefined;
    button?: number;
    enabled?: boolean;

    constructor(data?: IParamsScenesId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.button = _data["button"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): ParamsScenesId {
        data = typeof data === 'object' ? data : {};
        let result = new ParamsScenesId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["button"] = this.button;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IParamsScenesId {
    id?: string | undefined;
    button?: number;
    enabled?: boolean;
}

/** 0 = Disabled 1 = SameEntirePlant 2 = DifferentEachBuilding */
export enum PasspartoutModes {
    Disabled = 0,
    SameEntirePlant = 1,
    DifferentEachBuilding = 2,
}

export class PeApartmentConfig implements IPeApartmentConfig {
    id?: string;
    index?: number;
    peBuildingConfigId?: string;
    peRiserConfigId?: string;
    peFloorConfigId?: string;
    peInterfaceConfigId?: string;
    name?: string | undefined;
    scsAddress?: number;

    constructor(data?: IPeApartmentConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.index = _data["index"];
            this.peBuildingConfigId = _data["peBuildingConfigId"];
            this.peRiserConfigId = _data["peRiserConfigId"];
            this.peFloorConfigId = _data["peFloorConfigId"];
            this.peInterfaceConfigId = _data["peInterfaceConfigId"];
            this.name = _data["name"];
            this.scsAddress = _data["scsAddress"];
        }
    }

    static fromJS(data: any): PeApartmentConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PeApartmentConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["index"] = this.index;
        data["peBuildingConfigId"] = this.peBuildingConfigId;
        data["peRiserConfigId"] = this.peRiserConfigId;
        data["peFloorConfigId"] = this.peFloorConfigId;
        data["peInterfaceConfigId"] = this.peInterfaceConfigId;
        data["name"] = this.name;
        data["scsAddress"] = this.scsAddress;
        return data;
    }
}

export interface IPeApartmentConfig {
    id?: string;
    index?: number;
    peBuildingConfigId?: string;
    peRiserConfigId?: string;
    peFloorConfigId?: string;
    peInterfaceConfigId?: string;
    name?: string | undefined;
    scsAddress?: number;
}

export class PeElementConfig implements IPeElementConfig {
    index?: number;
    id?: string;
    name?: string | undefined;

    constructor(data?: IPeElementConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PeElementConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PeElementConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPeElementConfig {
    index?: number;
    id?: string;
    name?: string | undefined;
}

export class PeElementApartmentsConfig extends PeElementConfig implements IPeElementApartmentsConfig {
    numberOfApartments?: number;

    constructor(data?: IPeElementApartmentsConfig) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.numberOfApartments = _data["numberOfApartments"];
        }
    }

    static fromJS(data: any): PeElementApartmentsConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PeElementApartmentsConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfApartments"] = this.numberOfApartments;
        super.toJSON(data);
        return data;
    }
}

export interface IPeElementApartmentsConfig extends IPeElementConfig {
    numberOfApartments?: number;
}

export class PeBuildingConfig extends PeElementApartmentsConfig implements IPeBuildingConfig {

    constructor(data?: IPeBuildingConfig) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PeBuildingConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PeBuildingConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPeBuildingConfig extends IPeElementApartmentsConfig {
}

export class PeDeviceConfig extends PeElementConfig implements IPeDeviceConfig {
    scsAddress?: number;
    secLockAddr?: number;
    type?: EpDeviceType;
    switchboardId?: string;
    activationStatus?: EpDeviceActivationStatus;

    constructor(data?: IPeDeviceConfig) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.scsAddress = _data["scsAddress"];
            this.secLockAddr = _data["secLockAddr"];
            this.type = _data["type"];
            this.switchboardId = _data["switchboardId"];
            this.activationStatus = _data["activationStatus"];
        }
    }

    static fromJS(data: any): PeDeviceConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PeDeviceConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scsAddress"] = this.scsAddress;
        data["secLockAddr"] = this.secLockAddr;
        data["type"] = this.type;
        data["switchboardId"] = this.switchboardId;
        data["activationStatus"] = this.activationStatus;
        super.toJSON(data);
        return data;
    }
}

export interface IPeDeviceConfig extends IPeElementConfig {
    scsAddress?: number;
    secLockAddr?: number;
    type?: EpDeviceType;
    switchboardId?: string;
    activationStatus?: EpDeviceActivationStatus;
}

export class PeDeviceGateLinkConfig extends PeElementConfig implements IPeDeviceGateLinkConfig {
    peGateConfigId?: string;
    peDeviceConfigId?: string;

    constructor(data?: IPeDeviceGateLinkConfig) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.peGateConfigId = _data["peGateConfigId"];
            this.peDeviceConfigId = _data["peDeviceConfigId"];
        }
    }

    static fromJS(data: any): PeDeviceGateLinkConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PeDeviceGateLinkConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["peGateConfigId"] = this.peGateConfigId;
        data["peDeviceConfigId"] = this.peDeviceConfigId;
        super.toJSON(data);
        return data;
    }
}

export interface IPeDeviceGateLinkConfig extends IPeElementConfig {
    peGateConfigId?: string;
    peDeviceConfigId?: string;
}

export class PeFloorConfig extends PeElementApartmentsConfig implements IPeFloorConfig {
    peBuildingConfigId?: string;
    peRiserConfigId?: string;
    code?: string | undefined;

    constructor(data?: IPeFloorConfig) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.peBuildingConfigId = _data["peBuildingConfigId"];
            this.peRiserConfigId = _data["peRiserConfigId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): PeFloorConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PeFloorConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["peBuildingConfigId"] = this.peBuildingConfigId;
        data["peRiserConfigId"] = this.peRiserConfigId;
        data["code"] = this.code;
        super.toJSON(data);
        return data;
    }
}

export interface IPeFloorConfig extends IPeElementApartmentsConfig {
    peBuildingConfigId?: string;
    peRiserConfigId?: string;
    code?: string | undefined;
}

export class PeGateConfig extends PeElementConfig implements IPeGateConfig {
    gateOrder?: number;
    peInterfaceConfigId?: string;
    readonly inBackboneInterface?: boolean;
    scsAddress?: number;

    constructor(data?: IPeGateConfig) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.gateOrder = _data["gateOrder"];
            this.peInterfaceConfigId = _data["peInterfaceConfigId"];
            (<any>this).inBackboneInterface = _data["inBackboneInterface"];
            this.scsAddress = _data["scsAddress"];
        }
    }

    static fromJS(data: any): PeGateConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PeGateConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateOrder"] = this.gateOrder;
        data["peInterfaceConfigId"] = this.peInterfaceConfigId;
        data["inBackboneInterface"] = this.inBackboneInterface;
        data["scsAddress"] = this.scsAddress;
        super.toJSON(data);
        return data;
    }
}

export interface IPeGateConfig extends IPeElementConfig {
    gateOrder?: number;
    peInterfaceConfigId?: string;
    inBackboneInterface?: boolean;
    scsAddress?: number;
}

export class PeInterfaceConfig extends PeElementApartmentsConfig implements IPeInterfaceConfig {
    peBuildingConfigId?: string;
    peRiserConfigId?: string;
    readonly isBackboneInterface?: boolean;
    mode?: RiserInterfaceMode;
    switchboardsCount?: number;
    gatesCount?: number;
    scsAddress?: number;

    constructor(data?: IPeInterfaceConfig) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.peBuildingConfigId = _data["peBuildingConfigId"];
            this.peRiserConfigId = _data["peRiserConfigId"];
            (<any>this).isBackboneInterface = _data["isBackboneInterface"];
            this.mode = _data["mode"];
            this.switchboardsCount = _data["switchboardsCount"];
            this.gatesCount = _data["gatesCount"];
            this.scsAddress = _data["scsAddress"];
        }
    }

    static fromJS(data: any): PeInterfaceConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PeInterfaceConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["peBuildingConfigId"] = this.peBuildingConfigId;
        data["peRiserConfigId"] = this.peRiserConfigId;
        data["isBackboneInterface"] = this.isBackboneInterface;
        data["mode"] = this.mode;
        data["switchboardsCount"] = this.switchboardsCount;
        data["gatesCount"] = this.gatesCount;
        data["scsAddress"] = this.scsAddress;
        super.toJSON(data);
        return data;
    }
}

export interface IPeInterfaceConfig extends IPeElementApartmentsConfig {
    peBuildingConfigId?: string;
    peRiserConfigId?: string;
    isBackboneInterface?: boolean;
    mode?: RiserInterfaceMode;
    switchboardsCount?: number;
    gatesCount?: number;
    scsAddress?: number;
}

export class PePlantConfig extends PeElementConfig implements IPePlantConfig {
    readonly riserConfigId?: string;
    plantId?: string | undefined;
    denominationBuildings?: DenominationMode;
    denominationRisers?: DenominationMode;
    denominationFloors?: DenominationMode;
    denominationApartments?: DenominationMode;
    buildings?: PeBuildingConfig[] | undefined;
    risers?: PeRiserConfig[] | undefined;
    interfaces?: PeInterfaceConfig[] | undefined;
    floors?: PeFloorConfig[] | undefined;
    apartments?: PeApartmentConfig[] | undefined;
    gates?: PeGateConfig[] | undefined;
    switchboards?: PeSwitchboardConfig[] | undefined;
    devices?: PeDeviceConfig[] | undefined;
    deviceGateLinks?: PeDeviceGateLinkConfig[] | undefined;
    addressingType?: AddressingType;

    constructor(data?: IPePlantConfig) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            (<any>this).riserConfigId = _data["riserConfigId"];
            this.plantId = _data["plantId"];
            this.denominationBuildings = _data["denominationBuildings"];
            this.denominationRisers = _data["denominationRisers"];
            this.denominationFloors = _data["denominationFloors"];
            this.denominationApartments = _data["denominationApartments"];
            if (Array.isArray(_data["buildings"])) {
                this.buildings = [] as any;
                for (let item of _data["buildings"])
                    this.buildings!.push(PeBuildingConfig.fromJS(item));
            }
            if (Array.isArray(_data["risers"])) {
                this.risers = [] as any;
                for (let item of _data["risers"])
                    this.risers!.push(PeRiserConfig.fromJS(item));
            }
            if (Array.isArray(_data["interfaces"])) {
                this.interfaces = [] as any;
                for (let item of _data["interfaces"])
                    this.interfaces!.push(PeInterfaceConfig.fromJS(item));
            }
            if (Array.isArray(_data["floors"])) {
                this.floors = [] as any;
                for (let item of _data["floors"])
                    this.floors!.push(PeFloorConfig.fromJS(item));
            }
            if (Array.isArray(_data["apartments"])) {
                this.apartments = [] as any;
                for (let item of _data["apartments"])
                    this.apartments!.push(PeApartmentConfig.fromJS(item));
            }
            if (Array.isArray(_data["gates"])) {
                this.gates = [] as any;
                for (let item of _data["gates"])
                    this.gates!.push(PeGateConfig.fromJS(item));
            }
            if (Array.isArray(_data["switchboards"])) {
                this.switchboards = [] as any;
                for (let item of _data["switchboards"])
                    this.switchboards!.push(PeSwitchboardConfig.fromJS(item));
            }
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(PeDeviceConfig.fromJS(item));
            }
            if (Array.isArray(_data["deviceGateLinks"])) {
                this.deviceGateLinks = [] as any;
                for (let item of _data["deviceGateLinks"])
                    this.deviceGateLinks!.push(PeDeviceGateLinkConfig.fromJS(item));
            }
            this.addressingType = _data["addressingType"];
        }
    }

    static fromJS(data: any): PePlantConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PePlantConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riserConfigId"] = this.riserConfigId;
        data["plantId"] = this.plantId;
        data["denominationBuildings"] = this.denominationBuildings;
        data["denominationRisers"] = this.denominationRisers;
        data["denominationFloors"] = this.denominationFloors;
        data["denominationApartments"] = this.denominationApartments;
        if (Array.isArray(this.buildings)) {
            data["buildings"] = [];
            for (let item of this.buildings)
                data["buildings"].push(item.toJSON());
        }
        if (Array.isArray(this.risers)) {
            data["risers"] = [];
            for (let item of this.risers)
                data["risers"].push(item.toJSON());
        }
        if (Array.isArray(this.interfaces)) {
            data["interfaces"] = [];
            for (let item of this.interfaces)
                data["interfaces"].push(item.toJSON());
        }
        if (Array.isArray(this.floors)) {
            data["floors"] = [];
            for (let item of this.floors)
                data["floors"].push(item.toJSON());
        }
        if (Array.isArray(this.apartments)) {
            data["apartments"] = [];
            for (let item of this.apartments)
                data["apartments"].push(item.toJSON());
        }
        if (Array.isArray(this.gates)) {
            data["gates"] = [];
            for (let item of this.gates)
                data["gates"].push(item.toJSON());
        }
        if (Array.isArray(this.switchboards)) {
            data["switchboards"] = [];
            for (let item of this.switchboards)
                data["switchboards"].push(item.toJSON());
        }
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        if (Array.isArray(this.deviceGateLinks)) {
            data["deviceGateLinks"] = [];
            for (let item of this.deviceGateLinks)
                data["deviceGateLinks"].push(item.toJSON());
        }
        data["addressingType"] = this.addressingType;
        super.toJSON(data);
        return data;
    }
}

export interface IPePlantConfig extends IPeElementConfig {
    riserConfigId?: string;
    plantId?: string | undefined;
    denominationBuildings?: DenominationMode;
    denominationRisers?: DenominationMode;
    denominationFloors?: DenominationMode;
    denominationApartments?: DenominationMode;
    buildings?: PeBuildingConfig[] | undefined;
    risers?: PeRiserConfig[] | undefined;
    interfaces?: PeInterfaceConfig[] | undefined;
    floors?: PeFloorConfig[] | undefined;
    apartments?: PeApartmentConfig[] | undefined;
    gates?: PeGateConfig[] | undefined;
    switchboards?: PeSwitchboardConfig[] | undefined;
    devices?: PeDeviceConfig[] | undefined;
    deviceGateLinks?: PeDeviceGateLinkConfig[] | undefined;
    addressingType?: AddressingType;
}

export class PePlantConfigDTO implements IPePlantConfigDTO {
    numberOfRisers?: number;
    riserInterfacesConfig?: { [key: string]: PeInterfaceConfig[]; } | undefined;
    numbersOfBackboneSwitchboards?: number;
    numbersOfBackboneApartments?: number;
    numbersOfBackboneGates?: number;
    pePlantConfig?: PePlantConfig;
    currentStep?: PlantConfigStep;

    constructor(data?: IPePlantConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfRisers = _data["numberOfRisers"];
            if (_data["riserInterfacesConfig"]) {
                this.riserInterfacesConfig = {} as any;
                for (let key in _data["riserInterfacesConfig"]) {
                    if (_data["riserInterfacesConfig"].hasOwnProperty(key))
                        (<any>this.riserInterfacesConfig)![key] = _data["riserInterfacesConfig"][key] ? _data["riserInterfacesConfig"][key].map((i: any) => PeInterfaceConfig.fromJS(i)) : <any>undefined;
                }
            }
            this.numbersOfBackboneSwitchboards = _data["numbersOfBackboneSwitchboards"];
            this.numbersOfBackboneApartments = _data["numbersOfBackboneApartments"];
            this.numbersOfBackboneGates = _data["numbersOfBackboneGates"];
            this.pePlantConfig = _data["pePlantConfig"] ? PePlantConfig.fromJS(_data["pePlantConfig"]) : <any>undefined;
            this.currentStep = _data["currentStep"];
        }
    }

    static fromJS(data: any): PePlantConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PePlantConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfRisers"] = this.numberOfRisers;
        if (this.riserInterfacesConfig) {
            data["riserInterfacesConfig"] = {};
            for (let key in this.riserInterfacesConfig) {
                if (this.riserInterfacesConfig.hasOwnProperty(key))
                    (<any>data["riserInterfacesConfig"])[key] = (<any>this.riserInterfacesConfig)[key];
            }
        }
        data["numbersOfBackboneSwitchboards"] = this.numbersOfBackboneSwitchboards;
        data["numbersOfBackboneApartments"] = this.numbersOfBackboneApartments;
        data["numbersOfBackboneGates"] = this.numbersOfBackboneGates;
        data["pePlantConfig"] = this.pePlantConfig ? this.pePlantConfig.toJSON() : <any>undefined;
        data["currentStep"] = this.currentStep;
        return data;
    }
}

export interface IPePlantConfigDTO {
    numberOfRisers?: number;
    riserInterfacesConfig?: { [key: string]: PeInterfaceConfig[]; } | undefined;
    numbersOfBackboneSwitchboards?: number;
    numbersOfBackboneApartments?: number;
    numbersOfBackboneGates?: number;
    pePlantConfig?: PePlantConfig;
    currentStep?: PlantConfigStep;
}

export class PeRiserConfig extends PeElementApartmentsConfig implements IPeRiserConfig {
    code?: string | undefined;
    peBuildingConfigId?: string;

    constructor(data?: IPeRiserConfig) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.peBuildingConfigId = _data["peBuildingConfigId"];
        }
    }

    static fromJS(data: any): PeRiserConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PeRiserConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["peBuildingConfigId"] = this.peBuildingConfigId;
        super.toJSON(data);
        return data;
    }
}

export interface IPeRiserConfig extends IPeElementApartmentsConfig {
    code?: string | undefined;
    peBuildingConfigId?: string;
}

export class PeSwitchboardConfig extends PeElementConfig implements IPeSwitchboardConfig {
    peInterfaceConfigId?: string;
    readonly inBackboneInterface?: boolean;
    scsAddress?: number;
    switchboardOrder?: number;

    constructor(data?: IPeSwitchboardConfig) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.peInterfaceConfigId = _data["peInterfaceConfigId"];
            (<any>this).inBackboneInterface = _data["inBackboneInterface"];
            this.scsAddress = _data["scsAddress"];
            this.switchboardOrder = _data["switchboardOrder"];
        }
    }

    static fromJS(data: any): PeSwitchboardConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PeSwitchboardConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["peInterfaceConfigId"] = this.peInterfaceConfigId;
        data["inBackboneInterface"] = this.inBackboneInterface;
        data["scsAddress"] = this.scsAddress;
        data["switchboardOrder"] = this.switchboardOrder;
        super.toJSON(data);
        return data;
    }
}

export interface IPeSwitchboardConfig extends IPeElementConfig {
    peInterfaceConfigId?: string;
    inBackboneInterface?: boolean;
    scsAddress?: number;
    switchboardOrder?: number;
}

export class PlantAlarmSystemDTO implements IPlantAlarmSystemDTO {
    partitions?: PlantAlarmSystemPartitionDTO[] | undefined;
    scenes?: PlantAlarmSystemSceneDTO[] | undefined;
    roomName?: string | undefined;
    sensors?: AlarmSystemSensorDTO[] | undefined;

    constructor(data?: IPlantAlarmSystemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["partitions"])) {
                this.partitions = [] as any;
                for (let item of _data["partitions"])
                    this.partitions!.push(PlantAlarmSystemPartitionDTO.fromJS(item));
            }
            if (Array.isArray(_data["scenes"])) {
                this.scenes = [] as any;
                for (let item of _data["scenes"])
                    this.scenes!.push(PlantAlarmSystemSceneDTO.fromJS(item));
            }
            this.roomName = _data["roomName"];
            if (Array.isArray(_data["sensors"])) {
                this.sensors = [] as any;
                for (let item of _data["sensors"])
                    this.sensors!.push(AlarmSystemSensorDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlantAlarmSystemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlantAlarmSystemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.partitions)) {
            data["partitions"] = [];
            for (let item of this.partitions)
                data["partitions"].push(item.toJSON());
        }
        if (Array.isArray(this.scenes)) {
            data["scenes"] = [];
            for (let item of this.scenes)
                data["scenes"].push(item.toJSON());
        }
        data["roomName"] = this.roomName;
        if (Array.isArray(this.sensors)) {
            data["sensors"] = [];
            for (let item of this.sensors)
                data["sensors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlantAlarmSystemDTO {
    partitions?: PlantAlarmSystemPartitionDTO[] | undefined;
    scenes?: PlantAlarmSystemSceneDTO[] | undefined;
    roomName?: string | undefined;
    sensors?: AlarmSystemSensorDTO[] | undefined;
}

export class PlantAlarmSystemPartitionDTO implements IPlantAlarmSystemPartitionDTO {
    partitionId?: string | undefined;
    partitionName?: string | undefined;

    constructor(data?: IPlantAlarmSystemPartitionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partitionId = _data["partitionId"];
            this.partitionName = _data["partitionName"];
        }
    }

    static fromJS(data: any): PlantAlarmSystemPartitionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlantAlarmSystemPartitionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partitionId"] = this.partitionId;
        data["partitionName"] = this.partitionName;
        return data;
    }
}

export interface IPlantAlarmSystemPartitionDTO {
    partitionId?: string | undefined;
    partitionName?: string | undefined;
}

export class PlantAlarmSystemSceneDTO implements IPlantAlarmSystemSceneDTO {
    sceneId?: string | undefined;
    sceneName?: string | undefined;

    constructor(data?: IPlantAlarmSystemSceneDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sceneId = _data["sceneId"];
            this.sceneName = _data["sceneName"];
        }
    }

    static fromJS(data: any): PlantAlarmSystemSceneDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlantAlarmSystemSceneDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sceneId"] = this.sceneId;
        data["sceneName"] = this.sceneName;
        return data;
    }
}

export interface IPlantAlarmSystemSceneDTO {
    sceneId?: string | undefined;
    sceneName?: string | undefined;
}

export class PlantC300EOSSettingsDTO implements IPlantC300EOSSettingsDTO {
    gwId?: string | undefined;
    gwIpAddress?: string | undefined;
    gwSubnetMask?: string | undefined;
    gwPrimaryDNS?: string | undefined;
    gwSecondaryDNS?: string | undefined;
    gwDefaultGateway?: string | undefined;
    gwMacAddress?: string | undefined;
    language?: Language;
    isAutoSetupEnabled?: boolean;
    isTemperatureDisplayed?: boolean;
    ntpServer?: string | undefined;
    dateTime?: Date;
    timeZone?: string | undefined;
    temperatureType?: TemperatureType;
    model?: ServerModel;
    firmwareVersion?: string | undefined;
    isPhysicalConfig?: boolean;
    nValue?: number;
    pValue?: number;
    mValue?: number;
    isAnsweringMachineEnabled?: boolean;
    isProfessionalStudioEnabled?: boolean;
    isWaterCycleEnabled?: boolean;
    openAutomaticallyDaysDelay?: number;
    minutesToKeepOpen?: number;
    arePumpsOpenedAutomatically?: boolean;
    isInterlockSystemEnabled?: boolean;
    interlockExcludedDevices?: string[] | undefined;
    vdeIntercomFunctions?: IntercomFunction[] | undefined;
    vdeCameraFunctions?: CameraFunction[] | undefined;
    vdeActivationFunctions?: ActivationFunction[] | undefined;
    isThermoExternalCentralUnit?: boolean;
    selectedThermostat?: string | undefined;
    seasonChange3477Mode?: SeasonChange3477Mode;
    isSeasonModeAuto?: boolean;
    isKeypadLockOutSeason?: boolean;
    seasonChangeAutoType?: SeasonChangeAutoType;
    selected3477Device?: DeviceDTO;
    seasonChangeAutoStartWinterDate?: Date | undefined;
    seasonChangeAutoStartSummerDate?: Date | undefined;
    hasOneSeason?: boolean;

    constructor(data?: IPlantC300EOSSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gwId = _data["gwId"];
            this.gwIpAddress = _data["gwIpAddress"];
            this.gwSubnetMask = _data["gwSubnetMask"];
            this.gwPrimaryDNS = _data["gwPrimaryDNS"];
            this.gwSecondaryDNS = _data["gwSecondaryDNS"];
            this.gwDefaultGateway = _data["gwDefaultGateway"];
            this.gwMacAddress = _data["gwMacAddress"];
            this.language = _data["language"];
            this.isAutoSetupEnabled = _data["isAutoSetupEnabled"];
            this.isTemperatureDisplayed = _data["isTemperatureDisplayed"];
            this.ntpServer = _data["ntpServer"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.timeZone = _data["timeZone"];
            this.temperatureType = _data["temperatureType"];
            this.model = _data["model"];
            this.firmwareVersion = _data["firmwareVersion"];
            this.isPhysicalConfig = _data["isPhysicalConfig"];
            this.nValue = _data["nValue"];
            this.pValue = _data["pValue"];
            this.mValue = _data["mValue"];
            this.isAnsweringMachineEnabled = _data["isAnsweringMachineEnabled"];
            this.isProfessionalStudioEnabled = _data["isProfessionalStudioEnabled"];
            this.isWaterCycleEnabled = _data["isWaterCycleEnabled"];
            this.openAutomaticallyDaysDelay = _data["openAutomaticallyDaysDelay"];
            this.minutesToKeepOpen = _data["minutesToKeepOpen"];
            this.arePumpsOpenedAutomatically = _data["arePumpsOpenedAutomatically"];
            this.isInterlockSystemEnabled = _data["isInterlockSystemEnabled"];
            if (Array.isArray(_data["interlockExcludedDevices"])) {
                this.interlockExcludedDevices = [] as any;
                for (let item of _data["interlockExcludedDevices"])
                    this.interlockExcludedDevices!.push(item);
            }
            if (Array.isArray(_data["vdeIntercomFunctions"])) {
                this.vdeIntercomFunctions = [] as any;
                for (let item of _data["vdeIntercomFunctions"])
                    this.vdeIntercomFunctions!.push(IntercomFunction.fromJS(item));
            }
            if (Array.isArray(_data["vdeCameraFunctions"])) {
                this.vdeCameraFunctions = [] as any;
                for (let item of _data["vdeCameraFunctions"])
                    this.vdeCameraFunctions!.push(CameraFunction.fromJS(item));
            }
            if (Array.isArray(_data["vdeActivationFunctions"])) {
                this.vdeActivationFunctions = [] as any;
                for (let item of _data["vdeActivationFunctions"])
                    this.vdeActivationFunctions!.push(ActivationFunction.fromJS(item));
            }
            this.isThermoExternalCentralUnit = _data["isThermoExternalCentralUnit"];
            this.selectedThermostat = _data["selectedThermostat"];
            this.seasonChange3477Mode = _data["seasonChange3477Mode"];
            this.isSeasonModeAuto = _data["isSeasonModeAuto"];
            this.isKeypadLockOutSeason = _data["isKeypadLockOutSeason"];
            this.seasonChangeAutoType = _data["seasonChangeAutoType"];
            this.selected3477Device = _data["selected3477Device"] ? DeviceDTO.fromJS(_data["selected3477Device"]) : <any>undefined;
            this.seasonChangeAutoStartWinterDate = _data["seasonChangeAutoStartWinterDate"] ? new Date(_data["seasonChangeAutoStartWinterDate"].toString()) : <any>undefined;
            this.seasonChangeAutoStartSummerDate = _data["seasonChangeAutoStartSummerDate"] ? new Date(_data["seasonChangeAutoStartSummerDate"].toString()) : <any>undefined;
            this.hasOneSeason = _data["hasOneSeason"];
        }
    }

    static fromJS(data: any): PlantC300EOSSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlantC300EOSSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gwId"] = this.gwId;
        data["gwIpAddress"] = this.gwIpAddress;
        data["gwSubnetMask"] = this.gwSubnetMask;
        data["gwPrimaryDNS"] = this.gwPrimaryDNS;
        data["gwSecondaryDNS"] = this.gwSecondaryDNS;
        data["gwDefaultGateway"] = this.gwDefaultGateway;
        data["gwMacAddress"] = this.gwMacAddress;
        data["language"] = this.language;
        data["isAutoSetupEnabled"] = this.isAutoSetupEnabled;
        data["isTemperatureDisplayed"] = this.isTemperatureDisplayed;
        data["ntpServer"] = this.ntpServer;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["timeZone"] = this.timeZone;
        data["temperatureType"] = this.temperatureType;
        data["model"] = this.model;
        data["firmwareVersion"] = this.firmwareVersion;
        data["isPhysicalConfig"] = this.isPhysicalConfig;
        data["nValue"] = this.nValue;
        data["pValue"] = this.pValue;
        data["mValue"] = this.mValue;
        data["isAnsweringMachineEnabled"] = this.isAnsweringMachineEnabled;
        data["isProfessionalStudioEnabled"] = this.isProfessionalStudioEnabled;
        data["isWaterCycleEnabled"] = this.isWaterCycleEnabled;
        data["openAutomaticallyDaysDelay"] = this.openAutomaticallyDaysDelay;
        data["minutesToKeepOpen"] = this.minutesToKeepOpen;
        data["arePumpsOpenedAutomatically"] = this.arePumpsOpenedAutomatically;
        data["isInterlockSystemEnabled"] = this.isInterlockSystemEnabled;
        if (Array.isArray(this.interlockExcludedDevices)) {
            data["interlockExcludedDevices"] = [];
            for (let item of this.interlockExcludedDevices)
                data["interlockExcludedDevices"].push(item);
        }
        if (Array.isArray(this.vdeIntercomFunctions)) {
            data["vdeIntercomFunctions"] = [];
            for (let item of this.vdeIntercomFunctions)
                data["vdeIntercomFunctions"].push(item.toJSON());
        }
        if (Array.isArray(this.vdeCameraFunctions)) {
            data["vdeCameraFunctions"] = [];
            for (let item of this.vdeCameraFunctions)
                data["vdeCameraFunctions"].push(item.toJSON());
        }
        if (Array.isArray(this.vdeActivationFunctions)) {
            data["vdeActivationFunctions"] = [];
            for (let item of this.vdeActivationFunctions)
                data["vdeActivationFunctions"].push(item.toJSON());
        }
        data["isThermoExternalCentralUnit"] = this.isThermoExternalCentralUnit;
        data["selectedThermostat"] = this.selectedThermostat;
        data["seasonChange3477Mode"] = this.seasonChange3477Mode;
        data["isSeasonModeAuto"] = this.isSeasonModeAuto;
        data["isKeypadLockOutSeason"] = this.isKeypadLockOutSeason;
        data["seasonChangeAutoType"] = this.seasonChangeAutoType;
        data["selected3477Device"] = this.selected3477Device ? this.selected3477Device.toJSON() : <any>undefined;
        data["seasonChangeAutoStartWinterDate"] = this.seasonChangeAutoStartWinterDate ? this.seasonChangeAutoStartWinterDate.toISOString() : <any>undefined;
        data["seasonChangeAutoStartSummerDate"] = this.seasonChangeAutoStartSummerDate ? this.seasonChangeAutoStartSummerDate.toISOString() : <any>undefined;
        data["hasOneSeason"] = this.hasOneSeason;
        return data;
    }
}

export interface IPlantC300EOSSettingsDTO {
    gwId?: string | undefined;
    gwIpAddress?: string | undefined;
    gwSubnetMask?: string | undefined;
    gwPrimaryDNS?: string | undefined;
    gwSecondaryDNS?: string | undefined;
    gwDefaultGateway?: string | undefined;
    gwMacAddress?: string | undefined;
    language?: Language;
    isAutoSetupEnabled?: boolean;
    isTemperatureDisplayed?: boolean;
    ntpServer?: string | undefined;
    dateTime?: Date;
    timeZone?: string | undefined;
    temperatureType?: TemperatureType;
    model?: ServerModel;
    firmwareVersion?: string | undefined;
    isPhysicalConfig?: boolean;
    nValue?: number;
    pValue?: number;
    mValue?: number;
    isAnsweringMachineEnabled?: boolean;
    isProfessionalStudioEnabled?: boolean;
    isWaterCycleEnabled?: boolean;
    openAutomaticallyDaysDelay?: number;
    minutesToKeepOpen?: number;
    arePumpsOpenedAutomatically?: boolean;
    isInterlockSystemEnabled?: boolean;
    interlockExcludedDevices?: string[] | undefined;
    vdeIntercomFunctions?: IntercomFunction[] | undefined;
    vdeCameraFunctions?: CameraFunction[] | undefined;
    vdeActivationFunctions?: ActivationFunction[] | undefined;
    isThermoExternalCentralUnit?: boolean;
    selectedThermostat?: string | undefined;
    seasonChange3477Mode?: SeasonChange3477Mode;
    isSeasonModeAuto?: boolean;
    isKeypadLockOutSeason?: boolean;
    seasonChangeAutoType?: SeasonChangeAutoType;
    selected3477Device?: DeviceDTO;
    seasonChangeAutoStartWinterDate?: Date | undefined;
    seasonChangeAutoStartSummerDate?: Date | undefined;
    hasOneSeason?: boolean;
}

/** 0 = RISER_AND_BACKBONE_CONFIG 1 = BACKBONE_GATES_CONFIG 2 = RISERS_CONFIG 3 = RISER_GATES_CONFIG 4 = BUILDINGS_CONFIG 5 = BUILDINGS_RISERS_LINK 6 = END_CONFIG */
export enum PlantConfigStep {
    RISER_AND_BACKBONE_CONFIG = 0,
    BACKBONE_GATES_CONFIG = 1,
    RISERS_CONFIG = 2,
    RISER_GATES_CONFIG = 3,
    BUILDINGS_CONFIG = 4,
    BUILDINGS_RISERS_LINK = 5,
    END_CONFIG = 6,
}

export class PlantDTO implements IPlantDTO {
    name?: string | undefined;
    address?: string | undefined;
    country?: string | undefined;
    tags?: PlantTagDTO[] | undefined;
    icon?: PlantIconEnum;
    mxServer?: PlantMxServerDTO;
    customIconDataUrl?: string | undefined;
    roomsCounts?: PlantRoomCount[] | undefined;
    isGatewayNotConfigured?: boolean;
    plantType?: PlantType;

    constructor(data?: IPlantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"];
            this.country = _data["country"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(PlantTagDTO.fromJS(item));
            }
            this.icon = _data["icon"];
            this.mxServer = _data["mxServer"] ? PlantMxServerDTO.fromJS(_data["mxServer"]) : <any>undefined;
            this.customIconDataUrl = _data["customIconDataUrl"];
            if (Array.isArray(_data["roomsCounts"])) {
                this.roomsCounts = [] as any;
                for (let item of _data["roomsCounts"])
                    this.roomsCounts!.push(PlantRoomCount.fromJS(item));
            }
            this.isGatewayNotConfigured = _data["isGatewayNotConfigured"];
            this.plantType = _data["plantType"];
        }
    }

    static fromJS(data: any): PlantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address;
        data["country"] = this.country;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["icon"] = this.icon;
        data["mxServer"] = this.mxServer ? this.mxServer.toJSON() : <any>undefined;
        data["customIconDataUrl"] = this.customIconDataUrl;
        if (Array.isArray(this.roomsCounts)) {
            data["roomsCounts"] = [];
            for (let item of this.roomsCounts)
                data["roomsCounts"].push(item.toJSON());
        }
        data["isGatewayNotConfigured"] = this.isGatewayNotConfigured;
        data["plantType"] = this.plantType;
        return data;
    }
}

export interface IPlantDTO {
    name?: string | undefined;
    address?: string | undefined;
    country?: string | undefined;
    tags?: PlantTagDTO[] | undefined;
    icon?: PlantIconEnum;
    mxServer?: PlantMxServerDTO;
    customIconDataUrl?: string | undefined;
    roomsCounts?: PlantRoomCount[] | undefined;
    isGatewayNotConfigured?: boolean;
    plantType?: PlantType;
}

export class PlantDetailDTO implements IPlantDetailDTO {
    desktopId?: number;
    name?: string | undefined;
    address?: string | undefined;
    country?: string | undefined;
    tags?: PlantTagDTO[] | undefined;
    icon?: PlantIconEnum;
    customIconImageUrl?: string | undefined;
    customIconDataUrl?: string | undefined;
    lastModify?: Date;
    lastModifyByDesktop?: boolean;
    lastModifyBy?: UserDTO;
    sharedWith?: PlantSharingDTO[] | undefined;
    isFavourite?: boolean;
    owner?: UserDTO;
    usersIdFavorites?: string[] | undefined;
    plantType?: PlantType;
    mxServer?: PlantMxServerDTO;
    rooms?: RoomDTO[] | undefined;
    lastScanDate?: Date | undefined;
    aggregateCommandsCount?: number;
    scenesCount?: number;
    gwId?: string | undefined;
    isGatewayNotConfigured?: boolean;
    isF422Present?: boolean;
    availableAutomationAddresses?: number;

    constructor(data?: IPlantDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desktopId = _data["desktopId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.country = _data["country"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(PlantTagDTO.fromJS(item));
            }
            this.icon = _data["icon"];
            this.customIconImageUrl = _data["customIconImageUrl"];
            this.customIconDataUrl = _data["customIconDataUrl"];
            this.lastModify = _data["lastModify"] ? new Date(_data["lastModify"].toString()) : <any>undefined;
            this.lastModifyByDesktop = _data["lastModifyByDesktop"];
            this.lastModifyBy = _data["lastModifyBy"] ? UserDTO.fromJS(_data["lastModifyBy"]) : <any>undefined;
            if (Array.isArray(_data["sharedWith"])) {
                this.sharedWith = [] as any;
                for (let item of _data["sharedWith"])
                    this.sharedWith!.push(PlantSharingDTO.fromJS(item));
            }
            this.isFavourite = _data["isFavourite"];
            this.owner = _data["owner"] ? UserDTO.fromJS(_data["owner"]) : <any>undefined;
            if (Array.isArray(_data["usersIdFavorites"])) {
                this.usersIdFavorites = [] as any;
                for (let item of _data["usersIdFavorites"])
                    this.usersIdFavorites!.push(item);
            }
            this.plantType = _data["plantType"];
            this.mxServer = _data["mxServer"] ? PlantMxServerDTO.fromJS(_data["mxServer"]) : <any>undefined;
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(RoomDTO.fromJS(item));
            }
            this.lastScanDate = _data["lastScanDate"] ? new Date(_data["lastScanDate"].toString()) : <any>undefined;
            this.aggregateCommandsCount = _data["aggregateCommandsCount"];
            this.scenesCount = _data["scenesCount"];
            this.gwId = _data["gwId"];
            this.isGatewayNotConfigured = _data["isGatewayNotConfigured"];
            this.isF422Present = _data["isF422Present"];
            this.availableAutomationAddresses = _data["availableAutomationAddresses"];
        }
    }

    static fromJS(data: any): PlantDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlantDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopId"] = this.desktopId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["country"] = this.country;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["icon"] = this.icon;
        data["customIconImageUrl"] = this.customIconImageUrl;
        data["customIconDataUrl"] = this.customIconDataUrl;
        data["lastModify"] = this.lastModify ? this.lastModify.toISOString() : <any>undefined;
        data["lastModifyByDesktop"] = this.lastModifyByDesktop;
        data["lastModifyBy"] = this.lastModifyBy ? this.lastModifyBy.toJSON() : <any>undefined;
        if (Array.isArray(this.sharedWith)) {
            data["sharedWith"] = [];
            for (let item of this.sharedWith)
                data["sharedWith"].push(item.toJSON());
        }
        data["isFavourite"] = this.isFavourite;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        if (Array.isArray(this.usersIdFavorites)) {
            data["usersIdFavorites"] = [];
            for (let item of this.usersIdFavorites)
                data["usersIdFavorites"].push(item);
        }
        data["plantType"] = this.plantType;
        data["mxServer"] = this.mxServer ? this.mxServer.toJSON() : <any>undefined;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        data["lastScanDate"] = this.lastScanDate ? this.lastScanDate.toISOString() : <any>undefined;
        data["aggregateCommandsCount"] = this.aggregateCommandsCount;
        data["scenesCount"] = this.scenesCount;
        data["gwId"] = this.gwId;
        data["isGatewayNotConfigured"] = this.isGatewayNotConfigured;
        data["isF422Present"] = this.isF422Present;
        data["availableAutomationAddresses"] = this.availableAutomationAddresses;
        return data;
    }
}

export interface IPlantDetailDTO {
    desktopId?: number;
    name?: string | undefined;
    address?: string | undefined;
    country?: string | undefined;
    tags?: PlantTagDTO[] | undefined;
    icon?: PlantIconEnum;
    customIconImageUrl?: string | undefined;
    customIconDataUrl?: string | undefined;
    lastModify?: Date;
    lastModifyByDesktop?: boolean;
    lastModifyBy?: UserDTO;
    sharedWith?: PlantSharingDTO[] | undefined;
    isFavourite?: boolean;
    owner?: UserDTO;
    usersIdFavorites?: string[] | undefined;
    plantType?: PlantType;
    mxServer?: PlantMxServerDTO;
    rooms?: RoomDTO[] | undefined;
    lastScanDate?: Date | undefined;
    aggregateCommandsCount?: number;
    scenesCount?: number;
    gwId?: string | undefined;
    isGatewayNotConfigured?: boolean;
    isF422Present?: boolean;
    availableAutomationAddresses?: number;
}

/** 0 = ICON_1 1 = ICON_2 2 = ICON_3 3 = ICON_4 4 = ICON_5 5 = ICON_CUSTOM */
export enum PlantIconEnum {
    ICON_1 = 0,
    ICON_2 = 1,
    ICON_3 = 2,
    ICON_4 = 3,
    ICON_5 = 4,
    ICON_CUSTOM = 5,
}

export class PlantListDTO implements IPlantListDTO {
    desktopId?: number;
    id?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    country?: string | undefined;
    tags?: PlantTagDTO[] | undefined;
    status?: PlantStatus;
    lastModify?: Date | undefined;
    lastModifyByDesktop?: boolean;
    lastModifyBy?: UserDTO;
    isFavourite?: boolean;
    justSynchronized?: boolean;
    lastSessionDateTime?: Date | undefined;
    sessionLocked?: boolean;
    sessionLockedBy?: UserDTO;
    plantTypeIcon?: PlantIconEnum;
    customIconImageUrl?: string | undefined;
    usersIdFavorites?: string[] | undefined;
    isGatewayNotConfigured?: boolean;
    plantType?: PlantType;
    canBeDeleted?: boolean;

    constructor(data?: IPlantListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desktopId = _data["desktopId"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.country = _data["country"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(PlantTagDTO.fromJS(item));
            }
            this.status = _data["status"];
            this.lastModify = _data["lastModify"] ? new Date(_data["lastModify"].toString()) : <any>undefined;
            this.lastModifyByDesktop = _data["lastModifyByDesktop"];
            this.lastModifyBy = _data["lastModifyBy"] ? UserDTO.fromJS(_data["lastModifyBy"]) : <any>undefined;
            this.isFavourite = _data["isFavourite"];
            this.justSynchronized = _data["justSynchronized"];
            this.lastSessionDateTime = _data["lastSessionDateTime"] ? new Date(_data["lastSessionDateTime"].toString()) : <any>undefined;
            this.sessionLocked = _data["sessionLocked"];
            this.sessionLockedBy = _data["sessionLockedBy"] ? UserDTO.fromJS(_data["sessionLockedBy"]) : <any>undefined;
            this.plantTypeIcon = _data["plantTypeIcon"];
            this.customIconImageUrl = _data["customIconImageUrl"];
            if (Array.isArray(_data["usersIdFavorites"])) {
                this.usersIdFavorites = [] as any;
                for (let item of _data["usersIdFavorites"])
                    this.usersIdFavorites!.push(item);
            }
            this.isGatewayNotConfigured = _data["isGatewayNotConfigured"];
            this.plantType = _data["plantType"];
            this.canBeDeleted = _data["canBeDeleted"];
        }
    }

    static fromJS(data: any): PlantListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlantListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopId"] = this.desktopId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["country"] = this.country;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["lastModify"] = this.lastModify ? this.lastModify.toISOString() : <any>undefined;
        data["lastModifyByDesktop"] = this.lastModifyByDesktop;
        data["lastModifyBy"] = this.lastModifyBy ? this.lastModifyBy.toJSON() : <any>undefined;
        data["isFavourite"] = this.isFavourite;
        data["justSynchronized"] = this.justSynchronized;
        data["lastSessionDateTime"] = this.lastSessionDateTime ? this.lastSessionDateTime.toISOString() : <any>undefined;
        data["sessionLocked"] = this.sessionLocked;
        data["sessionLockedBy"] = this.sessionLockedBy ? this.sessionLockedBy.toJSON() : <any>undefined;
        data["plantTypeIcon"] = this.plantTypeIcon;
        data["customIconImageUrl"] = this.customIconImageUrl;
        if (Array.isArray(this.usersIdFavorites)) {
            data["usersIdFavorites"] = [];
            for (let item of this.usersIdFavorites)
                data["usersIdFavorites"].push(item);
        }
        data["isGatewayNotConfigured"] = this.isGatewayNotConfigured;
        data["plantType"] = this.plantType;
        data["canBeDeleted"] = this.canBeDeleted;
        return data;
    }
}

export interface IPlantListDTO {
    desktopId?: number;
    id?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    country?: string | undefined;
    tags?: PlantTagDTO[] | undefined;
    status?: PlantStatus;
    lastModify?: Date | undefined;
    lastModifyByDesktop?: boolean;
    lastModifyBy?: UserDTO;
    isFavourite?: boolean;
    justSynchronized?: boolean;
    lastSessionDateTime?: Date | undefined;
    sessionLocked?: boolean;
    sessionLockedBy?: UserDTO;
    plantTypeIcon?: PlantIconEnum;
    customIconImageUrl?: string | undefined;
    usersIdFavorites?: string[] | undefined;
    isGatewayNotConfigured?: boolean;
    plantType?: PlantType;
    canBeDeleted?: boolean;
}

export class PlantListDTOPaginatedResult implements IPlantListDTOPaginatedResult {
    data?: PlantListDTO[] | undefined;
    total?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IPlantListDTOPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PlantListDTO.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PlantListDTOPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new PlantListDTOPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPlantListDTOPaginatedResult {
    data?: PlantListDTO[] | undefined;
    total?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class PlantMxServerDTO implements IPlantMxServerDTO {
    model?: ServerModel;
    temperatureType?: TemperatureType;
    isAlarmConfigured?: boolean;
    alarmConfiguration?: PlantAlarmSystemDTO;

    constructor(data?: IPlantMxServerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"];
            this.temperatureType = _data["temperatureType"];
            this.isAlarmConfigured = _data["isAlarmConfigured"];
            this.alarmConfiguration = _data["alarmConfiguration"] ? PlantAlarmSystemDTO.fromJS(_data["alarmConfiguration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlantMxServerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlantMxServerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model;
        data["temperatureType"] = this.temperatureType;
        data["isAlarmConfigured"] = this.isAlarmConfigured;
        data["alarmConfiguration"] = this.alarmConfiguration ? this.alarmConfiguration.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPlantMxServerDTO {
    model?: ServerModel;
    temperatureType?: TemperatureType;
    isAlarmConfigured?: boolean;
    alarmConfiguration?: PlantAlarmSystemDTO;
}

export class PlantRoomCount implements IPlantRoomCount {
    type?: RoomType;
    count?: number;
    label?: string | undefined;

    constructor(data?: IPlantRoomCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.count = _data["count"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): PlantRoomCount {
        data = typeof data === 'object' ? data : {};
        let result = new PlantRoomCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["count"] = this.count;
        data["label"] = this.label;
        return data;
    }
}

export interface IPlantRoomCount {
    type?: RoomType;
    count?: number;
    label?: string | undefined;
}

export class PlantSessionDTO implements IPlantSessionDTO {
    renewSessionSeconds?: number;

    constructor(data?: IPlantSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.renewSessionSeconds = _data["renewSessionSeconds"];
        }
    }

    static fromJS(data: any): PlantSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlantSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["renewSessionSeconds"] = this.renewSessionSeconds;
        return data;
    }
}

export interface IPlantSessionDTO {
    renewSessionSeconds?: number;
}

export class PlantSharingDTO implements IPlantSharingDTO {
    userId?: string | undefined;
    invitedEmail?: string | undefined;
    confirmed?: boolean;
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;

    constructor(data?: IPlantSharingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.invitedEmail = _data["invitedEmail"];
            this.confirmed = _data["confirmed"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): PlantSharingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlantSharingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["invitedEmail"] = this.invitedEmail;
        data["confirmed"] = this.confirmed;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        return data;
    }
}

export interface IPlantSharingDTO {
    userId?: string | undefined;
    invitedEmail?: string | undefined;
    confirmed?: boolean;
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
}

/** 0 = PROJECT 1 = INSTALLED 2 = COMMISSIONED */
export enum PlantStatus {
    PROJECT = 0,
    INSTALLED = 1,
    COMMISSIONED = 2,
}

export class PlantSyncStatusDTO implements IPlantSyncStatusDTO {
    isPlantActive?: boolean;
    isFullyConfigured?: boolean;
    synchronized?: boolean;
    connected?: boolean;
    areVirtualDevicesSentToEliot?: boolean;
    areVirtualDevicesChanged?: boolean;
    lastSyncDateTime?: Date | undefined;
    changesToSyncCount?: number;
    canSyncRemotely?: boolean;
    isRemoteSyncFailedAndRetryIsAllowed?: boolean;
    syncInfo?: SyncInfo;

    constructor(data?: IPlantSyncStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPlantActive = _data["isPlantActive"];
            this.isFullyConfigured = _data["isFullyConfigured"];
            this.synchronized = _data["synchronized"];
            this.connected = _data["connected"];
            this.areVirtualDevicesSentToEliot = _data["areVirtualDevicesSentToEliot"];
            this.areVirtualDevicesChanged = _data["areVirtualDevicesChanged"];
            this.lastSyncDateTime = _data["lastSyncDateTime"] ? new Date(_data["lastSyncDateTime"].toString()) : <any>undefined;
            this.changesToSyncCount = _data["changesToSyncCount"];
            this.canSyncRemotely = _data["canSyncRemotely"];
            this.isRemoteSyncFailedAndRetryIsAllowed = _data["isRemoteSyncFailedAndRetryIsAllowed"];
            this.syncInfo = _data["syncInfo"] ? SyncInfo.fromJS(_data["syncInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlantSyncStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlantSyncStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPlantActive"] = this.isPlantActive;
        data["isFullyConfigured"] = this.isFullyConfigured;
        data["synchronized"] = this.synchronized;
        data["connected"] = this.connected;
        data["areVirtualDevicesSentToEliot"] = this.areVirtualDevicesSentToEliot;
        data["areVirtualDevicesChanged"] = this.areVirtualDevicesChanged;
        data["lastSyncDateTime"] = this.lastSyncDateTime ? this.lastSyncDateTime.toISOString() : <any>undefined;
        data["changesToSyncCount"] = this.changesToSyncCount;
        data["canSyncRemotely"] = this.canSyncRemotely;
        data["isRemoteSyncFailedAndRetryIsAllowed"] = this.isRemoteSyncFailedAndRetryIsAllowed;
        data["syncInfo"] = this.syncInfo ? this.syncInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPlantSyncStatusDTO {
    isPlantActive?: boolean;
    isFullyConfigured?: boolean;
    synchronized?: boolean;
    connected?: boolean;
    areVirtualDevicesSentToEliot?: boolean;
    areVirtualDevicesChanged?: boolean;
    lastSyncDateTime?: Date | undefined;
    changesToSyncCount?: number;
    canSyncRemotely?: boolean;
    isRemoteSyncFailedAndRetryIsAllowed?: boolean;
    syncInfo?: SyncInfo;
}

export class PlantTagDTO implements IPlantTagDTO {
    key?: string | undefined;
    value?: string | undefined;
    isImportant?: boolean;
    usages?: number;

    constructor(data?: IPlantTagDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.isImportant = _data["isImportant"];
            this.usages = _data["usages"];
        }
    }

    static fromJS(data: any): PlantTagDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlantTagDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["isImportant"] = this.isImportant;
        data["usages"] = this.usages;
        return data;
    }
}

export interface IPlantTagDTO {
    key?: string | undefined;
    value?: string | undefined;
    isImportant?: boolean;
    usages?: number;
}

/** 0 = AUTOMATION_PLANT 1 = ENTRANCE_PLANT */
export enum PlantType {
    AUTOMATION_PLANT = 0,
    ENTRANCE_PLANT = 1,
}

/** 0 = PLANT_NAME 1 = MODIFIED_DATE */
export enum PlantsOrderBy {
    PLANT_NAME = 0,
    MODIFIED_DATE = 1,
}

export class PlayerExtDevice extends ExtDevice implements IPlayerExtDevice {
    playerSystem?: PlayerSystem;
    readonly macAddress?: string | undefined;
    readonly name?: string | undefined;

    constructor(data?: IPlayerExtDevice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.playerSystem = _data["playerSystem"];
            (<any>this).macAddress = _data["macAddress"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): PlayerExtDevice {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerExtDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerSystem"] = this.playerSystem;
        data["macAddress"] = this.macAddress;
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

export interface IPlayerExtDevice extends IExtDevice {
    playerSystem?: PlayerSystem;
    macAddress?: string | undefined;
    name?: string | undefined;
}

/** 0 = Nuvo 1 = Sonos */
export enum PlayerSystem {
    Nuvo = 0,
    Sonos = 1,
}

export class Preset implements IPreset {
    isSet?: boolean;
    colorI?: Color;
    colorII?: Color;
    colorIII?: Color;
    temperatureI?: number;
    temperatureII?: number;
    temperatureIII?: number;
    dimmerPercentageI?: number;
    dimmerPercentageII?: number;
    dimmerPercentageIII?: number;

    constructor(data?: IPreset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSet = _data["isSet"];
            this.colorI = _data["colorI"] ? Color.fromJS(_data["colorI"]) : <any>undefined;
            this.colorII = _data["colorII"] ? Color.fromJS(_data["colorII"]) : <any>undefined;
            this.colorIII = _data["colorIII"] ? Color.fromJS(_data["colorIII"]) : <any>undefined;
            this.temperatureI = _data["temperatureI"];
            this.temperatureII = _data["temperatureII"];
            this.temperatureIII = _data["temperatureIII"];
            this.dimmerPercentageI = _data["dimmerPercentageI"];
            this.dimmerPercentageII = _data["dimmerPercentageII"];
            this.dimmerPercentageIII = _data["dimmerPercentageIII"];
        }
    }

    static fromJS(data: any): Preset {
        data = typeof data === 'object' ? data : {};
        let result = new Preset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSet"] = this.isSet;
        data["colorI"] = this.colorI ? this.colorI.toJSON() : <any>undefined;
        data["colorII"] = this.colorII ? this.colorII.toJSON() : <any>undefined;
        data["colorIII"] = this.colorIII ? this.colorIII.toJSON() : <any>undefined;
        data["temperatureI"] = this.temperatureI;
        data["temperatureII"] = this.temperatureII;
        data["temperatureIII"] = this.temperatureIII;
        data["dimmerPercentageI"] = this.dimmerPercentageI;
        data["dimmerPercentageII"] = this.dimmerPercentageII;
        data["dimmerPercentageIII"] = this.dimmerPercentageIII;
        return data;
    }
}

export interface IPreset {
    isSet?: boolean;
    colorI?: Color;
    colorII?: Color;
    colorIII?: Color;
    temperatureI?: number;
    temperatureII?: number;
    temperatureIII?: number;
    dimmerPercentageI?: number;
    dimmerPercentageII?: number;
    dimmerPercentageIII?: number;
}

export class ProbeSettings implements IProbeSettings {
    isLedmanaged?: boolean;
    externalSensorType?: ExternalSensorType;

    constructor(data?: IProbeSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isLedmanaged = _data["isLedmanaged"];
            this.externalSensorType = _data["externalSensorType"];
        }
    }

    static fromJS(data: any): ProbeSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ProbeSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isLedmanaged"] = this.isLedmanaged;
        data["externalSensorType"] = this.externalSensorType;
        return data;
    }
}

export interface IProbeSettings {
    isLedmanaged?: boolean;
    externalSensorType?: ExternalSensorType;
}

/** 0 = None 1 = PhisicallyConfigured 2 = DeviceRemoved 3 = DeviceUnmanage 4 = DeviceChanged */
export enum ProblemType {
    None = 0,
    PhisicallyConfigured = 1,
    DeviceRemoved = 2,
    DeviceUnmanage = 3,
    DeviceChanged = 4,
}

export class PushNotificationAction extends Action implements IPushNotificationAction {

    constructor(data?: IPushNotificationAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PushNotificationAction {
        data = typeof data === 'object' ? data : {};
        let result = new PushNotificationAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPushNotificationAction extends IAction {
}

export class RFAConfigDTO implements IRFAConfigDTO {
    numberOfApartments?: number;
    floorsWithoutRiser?: FloorConfigDTO[] | undefined;
    risers?: RiserConfigDTO[] | undefined;

    constructor(data?: IRFAConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfApartments = _data["numberOfApartments"];
            if (Array.isArray(_data["floorsWithoutRiser"])) {
                this.floorsWithoutRiser = [] as any;
                for (let item of _data["floorsWithoutRiser"])
                    this.floorsWithoutRiser!.push(FloorConfigDTO.fromJS(item));
            }
            if (Array.isArray(_data["risers"])) {
                this.risers = [] as any;
                for (let item of _data["risers"])
                    this.risers!.push(RiserConfigDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RFAConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RFAConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfApartments"] = this.numberOfApartments;
        if (Array.isArray(this.floorsWithoutRiser)) {
            data["floorsWithoutRiser"] = [];
            for (let item of this.floorsWithoutRiser)
                data["floorsWithoutRiser"].push(item.toJSON());
        }
        if (Array.isArray(this.risers)) {
            data["risers"] = [];
            for (let item of this.risers)
                data["risers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRFAConfigDTO {
    numberOfApartments?: number;
    floorsWithoutRiser?: FloorConfigDTO[] | undefined;
    risers?: RiserConfigDTO[] | undefined;
}

/** 0 = LastStatus 1 = Opened 2 = Closed */
export enum RelayStatusAfterResetOptions {
    LastStatus = 0,
    Opened = 1,
    Closed = 2,
}

/** 0 = None 1 = Global 2 = Actuator */
export enum ResetType {
    None = 0,
    Global = 1,
    Actuator = 2,
}

export class RiserConfigDTO implements IRiserConfigDTO {
    index?: number;
    name?: string | undefined;
    floors?: FloorConfigDTO[] | undefined;
    riserId?: string | undefined;

    constructor(data?: IRiserConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.name = _data["name"];
            if (Array.isArray(_data["floors"])) {
                this.floors = [] as any;
                for (let item of _data["floors"])
                    this.floors!.push(FloorConfigDTO.fromJS(item));
            }
            this.riserId = _data["riserId"];
        }
    }

    static fromJS(data: any): RiserConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RiserConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["name"] = this.name;
        if (Array.isArray(this.floors)) {
            data["floors"] = [];
            for (let item of this.floors)
                data["floors"].push(item.toJSON());
        }
        data["riserId"] = this.riserId;
        return data;
    }
}

export interface IRiserConfigDTO {
    index?: number;
    name?: string | undefined;
    floors?: FloorConfigDTO[] | undefined;
    riserId?: string | undefined;
}

export class RiserDTO implements IRiserDTO {
    riserId?: string;
    buildingId?: string;
    code?: string | undefined;
    index?: number;
    name?: string | undefined;
    interfaces?: RiserInterfaceDTO[] | undefined;

    constructor(data?: IRiserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.riserId = _data["riserId"];
            this.buildingId = _data["buildingId"];
            this.code = _data["code"];
            this.index = _data["index"];
            this.name = _data["name"];
            if (Array.isArray(_data["interfaces"])) {
                this.interfaces = [] as any;
                for (let item of _data["interfaces"])
                    this.interfaces!.push(RiserInterfaceDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RiserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RiserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riserId"] = this.riserId;
        data["buildingId"] = this.buildingId;
        data["code"] = this.code;
        data["index"] = this.index;
        data["name"] = this.name;
        if (Array.isArray(this.interfaces)) {
            data["interfaces"] = [];
            for (let item of this.interfaces)
                data["interfaces"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRiserDTO {
    riserId?: string;
    buildingId?: string;
    code?: string | undefined;
    index?: number;
    name?: string | undefined;
    interfaces?: RiserInterfaceDTO[] | undefined;
}

export class RiserInterfaceDTO implements IRiserInterfaceDTO {
    riserInterfaceId?: string;
    riserId?: string;
    buildingId?: string;
    index?: number;
    mode?: RiserInterfaceMode;
    scsAddress?: number;
    numberOfApartments?: number;
    gatesCount?: number;
    switchboardsCount?: number;

    constructor(data?: IRiserInterfaceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.riserInterfaceId = _data["riserInterfaceId"];
            this.riserId = _data["riserId"];
            this.buildingId = _data["buildingId"];
            this.index = _data["index"];
            this.mode = _data["mode"];
            this.scsAddress = _data["scsAddress"];
            this.numberOfApartments = _data["numberOfApartments"];
            this.gatesCount = _data["gatesCount"];
            this.switchboardsCount = _data["switchboardsCount"];
        }
    }

    static fromJS(data: any): RiserInterfaceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RiserInterfaceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riserInterfaceId"] = this.riserInterfaceId;
        data["riserId"] = this.riserId;
        data["buildingId"] = this.buildingId;
        data["index"] = this.index;
        data["mode"] = this.mode;
        data["scsAddress"] = this.scsAddress;
        data["numberOfApartments"] = this.numberOfApartments;
        data["gatesCount"] = this.gatesCount;
        data["switchboardsCount"] = this.switchboardsCount;
        return data;
    }
}

export interface IRiserInterfaceDTO {
    riserInterfaceId?: string;
    riserId?: string;
    buildingId?: string;
    index?: number;
    mode?: RiserInterfaceMode;
    scsAddress?: number;
    numberOfApartments?: number;
    gatesCount?: number;
    switchboardsCount?: number;
}

/** 5 = Mode5IndipendentRiser 6 = Mode6ExtendedRiser 7 = Mode7ExtendedRiserExpansion */
export enum RiserInterfaceMode {
    Mode5IndipendentRiser = 5,
    Mode6ExtendedRiser = 6,
    Mode7ExtendedRiserExpansion = 7,
}

export class Room implements IRoom {
    id?: string | undefined;
    name?: string | undefined;
    type?: RoomType;
    roomObjects?: RoomObject[] | undefined;

    constructor(data?: IRoom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["roomObjects"])) {
                this.roomObjects = [] as any;
                for (let item of _data["roomObjects"])
                    this.roomObjects!.push(RoomObject.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Room {
        data = typeof data === 'object' ? data : {};
        let result = new Room();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.roomObjects)) {
            data["roomObjects"] = [];
            for (let item of this.roomObjects)
                data["roomObjects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoom {
    id?: string | undefined;
    name?: string | undefined;
    type?: RoomType;
    roomObjects?: RoomObject[] | undefined;
}

export class RoomDTO implements IRoomDTO {
    id?: string | undefined;
    name?: string | undefined;
    type?: RoomType;
    roomObjects?: RoomObjectDTO[] | undefined;

    constructor(data?: IRoomDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["roomObjects"])) {
                this.roomObjects = [] as any;
                for (let item of _data["roomObjects"])
                    this.roomObjects!.push(RoomObjectDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoomDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoomDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.roomObjects)) {
            data["roomObjects"] = [];
            for (let item of this.roomObjects)
                data["roomObjects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoomDTO {
    id?: string | undefined;
    name?: string | undefined;
    type?: RoomType;
    roomObjects?: RoomObjectDTO[] | undefined;
}

export class RoomObject extends LinkableObject implements IRoomObject {
    type?: RoomObjectType;
    systemType?: SystemType;
    isHidden?: boolean;
    hasCommands?: boolean;
    roomId?: string | undefined;
    typeofProblem?: CompromisedType;
    preset?: Preset;
    lightType?: LightType;
    isManagePosition?: boolean;
    isManagePositionWithSlat?: boolean;
    shutterPositionMode?: ShutterPositionMode;
    commandOpeningTime?: CommandOpeningTime;
    isAppliedToAllSameTypeCommands?: boolean;
    energyMeterAndLoadControlType?: EnergyMeterAndLoadControlType;
    isEnergyMeter?: boolean;
    toroidDirectionType?: ToroidDirection;
    tolerance?: string | undefined;
    priority?: number;
    supplyPower?: string | undefined;
    lineType?: Line;
    lineMisurationType?: LineMisuration;
    isThreePhase?: boolean;
    nameLine1?: string | undefined;
    nameLine2?: string | undefined;
    nameLine3?: string | undefined;
    thermoTypeOfObject?: ThermoTypeOfObject;
    thermoAssociatedPump?: ThermoAssociatedPump;
    actuatorModalityType?: ActuatorModalityType;
    coolingSystemControlType?: SystemControlType;
    heatingSystemControlType?: SystemControlType;
    sharedSystemControlType?: SystemControlType;
    thermo?: ThermoActuactor[] | undefined;
    isContactInError?: boolean;
    isTemperatureDisplayed?: boolean;
    isWaterCycleEnabled?: boolean;
    arePumpsOpenedAutomatically?: boolean;
    minutesToKeepOpen?: string;
    openAutomaticallyDaysDelay?: number;
    isInterlockSystemEnabled?: boolean;
    isSeasonModeAuto?: boolean;
    isSeasonChangeModifiable?: boolean;
    seasonChangeAutoType?: SeasonChangeAutoType;
    selected3477Device?: Device;
    seasonChangeAutoStartWinterDate?: Date;
    seasonChangeAutoStartSummerDate?: Date;
    isThermo99Zone?: boolean;
    thermo99SelectedZone?: string | undefined;
    thermo99HasFancoil?: boolean;
    heatingSetpointLow?: number;
    heatingSetpointHigh?: number;
    heatingAntifreeze?: number;
    heatingThermalProtection?: number;
    coolingSetpointLow?: number;
    coolingSetpointHigh?: number;
    coolingThermalProtection?: number;
    isAutoCommutation?: boolean;
    delayHeatingPumps?: string;
    delayCoolingPumps?: string;
    temperatureType?: TemperatureType;
    areButtonsEnabled?: boolean;
    externalSensorType?: ExternalSensorType;
    isBacklightEnabled?: boolean;
    backlightLevel?: number;
    isManualHeatingOverrideEnabled?: boolean;
    heatingRegulationBand?: number;
    fanSpeed2ForHeating?: number;
    fanSpeed3ForHeating?: number;
    valvesTimeForHeatingFanCoil?: string;
    isManualCoolingOverrideEnabled?: boolean;
    coolingRegulationBand?: number;
    fanSpeed2ForCooling?: number;
    fanSpeed3ForCooling?: number;
    valvesTimeForCoolingFanCoil?: string;
    isIconAlwaysOff?: boolean;
    isLocalContactNumberEnabled?: boolean;
    numberOfWindowsContact?: number;
    openingContactTypeHeating?: ContactType;
    openingContactTempHeating?: number;
    openingContactDelayHeating?: string;
    timeoutOpeningHeating?: string;
    closingContactTypeHeating?: ContactType;
    closingContactTempHeating?: number;
    closingContactDelayHeating?: string;
    timeoutClosingHeating?: string;
    openingContactTypeCooling?: ContactType;
    openingContactTempCooling?: number;
    openingContactDelayCooling?: string;
    timeoutOpeningCooling?: string;
    closingContactTypeCooling?: ContactType;
    closingContactTempCooling?: number;
    closingContactDelayCooling?: string;
    timeoutClosingCooling?: string;
    isCoolingVentilationEnabled?: boolean;
    isHeatingVentilationEnabled?: boolean;
    timeoutCoolingVentilation?: string;
    timeoutHeatingVentilation?: string;
    isInterlockingExcluded?: boolean;
    pumpsDelay?: string;
    thermoUkFanSpeed?: number;
    thermoUkFanSpeed2?: number;
    thermoUkFanSpeed3?: number;
    coloredLightType?: ColoredLightType;
    daliType?: DaliType;
    isColor?: boolean;
    isTemperatureColor?: boolean;
    address?: string | undefined;
    callType?: CallType;
    readonly isToChangeIntoID?: string | undefined;
    readonly isAddressConflict?: boolean;
    addressWithInterface?: string | undefined;
    pul?: boolean;
    readonly problemDescription?: string | undefined;

    constructor(data?: IRoomObject) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.systemType = _data["systemType"];
            this.isHidden = _data["isHidden"];
            this.hasCommands = _data["hasCommands"];
            this.roomId = _data["roomId"];
            this.typeofProblem = _data["typeofProblem"];
            this.preset = _data["preset"] ? Preset.fromJS(_data["preset"]) : <any>undefined;
            this.lightType = _data["lightType"];
            this.isManagePosition = _data["isManagePosition"];
            this.isManagePositionWithSlat = _data["isManagePositionWithSlat"];
            this.shutterPositionMode = _data["shutterPositionMode"];
            this.commandOpeningTime = _data["commandOpeningTime"];
            this.isAppliedToAllSameTypeCommands = _data["isAppliedToAllSameTypeCommands"];
            this.energyMeterAndLoadControlType = _data["energyMeterAndLoadControlType"];
            this.isEnergyMeter = _data["isEnergyMeter"];
            this.toroidDirectionType = _data["toroidDirectionType"];
            this.tolerance = _data["tolerance"];
            this.priority = _data["priority"];
            this.supplyPower = _data["supplyPower"];
            this.lineType = _data["lineType"];
            this.lineMisurationType = _data["lineMisurationType"];
            this.isThreePhase = _data["isThreePhase"];
            this.nameLine1 = _data["nameLine1"];
            this.nameLine2 = _data["nameLine2"];
            this.nameLine3 = _data["nameLine3"];
            this.thermoTypeOfObject = _data["thermoTypeOfObject"];
            this.thermoAssociatedPump = _data["thermoAssociatedPump"];
            this.actuatorModalityType = _data["actuatorModalityType"];
            this.coolingSystemControlType = _data["coolingSystemControlType"];
            this.heatingSystemControlType = _data["heatingSystemControlType"];
            this.sharedSystemControlType = _data["sharedSystemControlType"];
            if (Array.isArray(_data["thermo"])) {
                this.thermo = [] as any;
                for (let item of _data["thermo"])
                    this.thermo!.push(ThermoActuactor.fromJS(item));
            }
            this.isContactInError = _data["isContactInError"];
            this.isTemperatureDisplayed = _data["isTemperatureDisplayed"];
            this.isWaterCycleEnabled = _data["isWaterCycleEnabled"];
            this.arePumpsOpenedAutomatically = _data["arePumpsOpenedAutomatically"];
            this.minutesToKeepOpen = _data["minutesToKeepOpen"];
            this.openAutomaticallyDaysDelay = _data["openAutomaticallyDaysDelay"];
            this.isInterlockSystemEnabled = _data["isInterlockSystemEnabled"];
            this.isSeasonModeAuto = _data["isSeasonModeAuto"];
            this.isSeasonChangeModifiable = _data["isSeasonChangeModifiable"];
            this.seasonChangeAutoType = _data["seasonChangeAutoType"];
            this.selected3477Device = _data["selected3477Device"] ? Device.fromJS(_data["selected3477Device"]) : <any>undefined;
            this.seasonChangeAutoStartWinterDate = _data["seasonChangeAutoStartWinterDate"] ? new Date(_data["seasonChangeAutoStartWinterDate"].toString()) : <any>undefined;
            this.seasonChangeAutoStartSummerDate = _data["seasonChangeAutoStartSummerDate"] ? new Date(_data["seasonChangeAutoStartSummerDate"].toString()) : <any>undefined;
            this.isThermo99Zone = _data["isThermo99Zone"];
            this.thermo99SelectedZone = _data["thermo99SelectedZone"];
            this.thermo99HasFancoil = _data["thermo99HasFancoil"];
            this.heatingSetpointLow = _data["heatingSetpointLow"];
            this.heatingSetpointHigh = _data["heatingSetpointHigh"];
            this.heatingAntifreeze = _data["heatingAntifreeze"];
            this.heatingThermalProtection = _data["heatingThermalProtection"];
            this.coolingSetpointLow = _data["coolingSetpointLow"];
            this.coolingSetpointHigh = _data["coolingSetpointHigh"];
            this.coolingThermalProtection = _data["coolingThermalProtection"];
            this.isAutoCommutation = _data["isAutoCommutation"];
            this.delayHeatingPumps = _data["delayHeatingPumps"];
            this.delayCoolingPumps = _data["delayCoolingPumps"];
            this.temperatureType = _data["temperatureType"];
            this.areButtonsEnabled = _data["areButtonsEnabled"];
            this.externalSensorType = _data["externalSensorType"];
            this.isBacklightEnabled = _data["isBacklightEnabled"];
            this.backlightLevel = _data["backlightLevel"];
            this.isManualHeatingOverrideEnabled = _data["isManualHeatingOverrideEnabled"];
            this.heatingRegulationBand = _data["heatingRegulationBand"];
            this.fanSpeed2ForHeating = _data["fanSpeed2ForHeating"];
            this.fanSpeed3ForHeating = _data["fanSpeed3ForHeating"];
            this.valvesTimeForHeatingFanCoil = _data["valvesTimeForHeatingFanCoil"];
            this.isManualCoolingOverrideEnabled = _data["isManualCoolingOverrideEnabled"];
            this.coolingRegulationBand = _data["coolingRegulationBand"];
            this.fanSpeed2ForCooling = _data["fanSpeed2ForCooling"];
            this.fanSpeed3ForCooling = _data["fanSpeed3ForCooling"];
            this.valvesTimeForCoolingFanCoil = _data["valvesTimeForCoolingFanCoil"];
            this.isIconAlwaysOff = _data["isIconAlwaysOff"];
            this.isLocalContactNumberEnabled = _data["isLocalContactNumberEnabled"];
            this.numberOfWindowsContact = _data["numberOfWindowsContact"];
            this.openingContactTypeHeating = _data["openingContactTypeHeating"];
            this.openingContactTempHeating = _data["openingContactTempHeating"];
            this.openingContactDelayHeating = _data["openingContactDelayHeating"];
            this.timeoutOpeningHeating = _data["timeoutOpeningHeating"];
            this.closingContactTypeHeating = _data["closingContactTypeHeating"];
            this.closingContactTempHeating = _data["closingContactTempHeating"];
            this.closingContactDelayHeating = _data["closingContactDelayHeating"];
            this.timeoutClosingHeating = _data["timeoutClosingHeating"];
            this.openingContactTypeCooling = _data["openingContactTypeCooling"];
            this.openingContactTempCooling = _data["openingContactTempCooling"];
            this.openingContactDelayCooling = _data["openingContactDelayCooling"];
            this.timeoutOpeningCooling = _data["timeoutOpeningCooling"];
            this.closingContactTypeCooling = _data["closingContactTypeCooling"];
            this.closingContactTempCooling = _data["closingContactTempCooling"];
            this.closingContactDelayCooling = _data["closingContactDelayCooling"];
            this.timeoutClosingCooling = _data["timeoutClosingCooling"];
            this.isCoolingVentilationEnabled = _data["isCoolingVentilationEnabled"];
            this.isHeatingVentilationEnabled = _data["isHeatingVentilationEnabled"];
            this.timeoutCoolingVentilation = _data["timeoutCoolingVentilation"];
            this.timeoutHeatingVentilation = _data["timeoutHeatingVentilation"];
            this.isInterlockingExcluded = _data["isInterlockingExcluded"];
            this.pumpsDelay = _data["pumpsDelay"];
            this.thermoUkFanSpeed = _data["thermoUkFanSpeed"];
            this.thermoUkFanSpeed2 = _data["thermoUkFanSpeed2"];
            this.thermoUkFanSpeed3 = _data["thermoUkFanSpeed3"];
            this.coloredLightType = _data["coloredLightType"];
            this.daliType = _data["daliType"];
            this.isColor = _data["isColor"];
            this.isTemperatureColor = _data["isTemperatureColor"];
            this.address = _data["address"];
            this.callType = _data["callType"];
            (<any>this).isToChangeIntoID = _data["isToChangeIntoID"];
            (<any>this).isAddressConflict = _data["isAddressConflict"];
            this.addressWithInterface = _data["addressWithInterface"];
            this.pul = _data["pul"];
            (<any>this).problemDescription = _data["problemDescription"];
        }
    }

    static fromJS(data: any): RoomObject {
        data = typeof data === 'object' ? data : {};
        let result = new RoomObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["systemType"] = this.systemType;
        data["isHidden"] = this.isHidden;
        data["hasCommands"] = this.hasCommands;
        data["roomId"] = this.roomId;
        data["typeofProblem"] = this.typeofProblem;
        data["preset"] = this.preset ? this.preset.toJSON() : <any>undefined;
        data["lightType"] = this.lightType;
        data["isManagePosition"] = this.isManagePosition;
        data["isManagePositionWithSlat"] = this.isManagePositionWithSlat;
        data["shutterPositionMode"] = this.shutterPositionMode;
        data["commandOpeningTime"] = this.commandOpeningTime;
        data["isAppliedToAllSameTypeCommands"] = this.isAppliedToAllSameTypeCommands;
        data["energyMeterAndLoadControlType"] = this.energyMeterAndLoadControlType;
        data["isEnergyMeter"] = this.isEnergyMeter;
        data["toroidDirectionType"] = this.toroidDirectionType;
        data["tolerance"] = this.tolerance;
        data["priority"] = this.priority;
        data["supplyPower"] = this.supplyPower;
        data["lineType"] = this.lineType;
        data["lineMisurationType"] = this.lineMisurationType;
        data["isThreePhase"] = this.isThreePhase;
        data["nameLine1"] = this.nameLine1;
        data["nameLine2"] = this.nameLine2;
        data["nameLine3"] = this.nameLine3;
        data["thermoTypeOfObject"] = this.thermoTypeOfObject;
        data["thermoAssociatedPump"] = this.thermoAssociatedPump;
        data["actuatorModalityType"] = this.actuatorModalityType;
        data["coolingSystemControlType"] = this.coolingSystemControlType;
        data["heatingSystemControlType"] = this.heatingSystemControlType;
        data["sharedSystemControlType"] = this.sharedSystemControlType;
        if (Array.isArray(this.thermo)) {
            data["thermo"] = [];
            for (let item of this.thermo)
                data["thermo"].push(item.toJSON());
        }
        data["isContactInError"] = this.isContactInError;
        data["isTemperatureDisplayed"] = this.isTemperatureDisplayed;
        data["isWaterCycleEnabled"] = this.isWaterCycleEnabled;
        data["arePumpsOpenedAutomatically"] = this.arePumpsOpenedAutomatically;
        data["minutesToKeepOpen"] = this.minutesToKeepOpen;
        data["openAutomaticallyDaysDelay"] = this.openAutomaticallyDaysDelay;
        data["isInterlockSystemEnabled"] = this.isInterlockSystemEnabled;
        data["isSeasonModeAuto"] = this.isSeasonModeAuto;
        data["isSeasonChangeModifiable"] = this.isSeasonChangeModifiable;
        data["seasonChangeAutoType"] = this.seasonChangeAutoType;
        data["selected3477Device"] = this.selected3477Device ? this.selected3477Device.toJSON() : <any>undefined;
        data["seasonChangeAutoStartWinterDate"] = this.seasonChangeAutoStartWinterDate ? this.seasonChangeAutoStartWinterDate.toISOString() : <any>undefined;
        data["seasonChangeAutoStartSummerDate"] = this.seasonChangeAutoStartSummerDate ? this.seasonChangeAutoStartSummerDate.toISOString() : <any>undefined;
        data["isThermo99Zone"] = this.isThermo99Zone;
        data["thermo99SelectedZone"] = this.thermo99SelectedZone;
        data["thermo99HasFancoil"] = this.thermo99HasFancoil;
        data["heatingSetpointLow"] = this.heatingSetpointLow;
        data["heatingSetpointHigh"] = this.heatingSetpointHigh;
        data["heatingAntifreeze"] = this.heatingAntifreeze;
        data["heatingThermalProtection"] = this.heatingThermalProtection;
        data["coolingSetpointLow"] = this.coolingSetpointLow;
        data["coolingSetpointHigh"] = this.coolingSetpointHigh;
        data["coolingThermalProtection"] = this.coolingThermalProtection;
        data["isAutoCommutation"] = this.isAutoCommutation;
        data["delayHeatingPumps"] = this.delayHeatingPumps;
        data["delayCoolingPumps"] = this.delayCoolingPumps;
        data["temperatureType"] = this.temperatureType;
        data["areButtonsEnabled"] = this.areButtonsEnabled;
        data["externalSensorType"] = this.externalSensorType;
        data["isBacklightEnabled"] = this.isBacklightEnabled;
        data["backlightLevel"] = this.backlightLevel;
        data["isManualHeatingOverrideEnabled"] = this.isManualHeatingOverrideEnabled;
        data["heatingRegulationBand"] = this.heatingRegulationBand;
        data["fanSpeed2ForHeating"] = this.fanSpeed2ForHeating;
        data["fanSpeed3ForHeating"] = this.fanSpeed3ForHeating;
        data["valvesTimeForHeatingFanCoil"] = this.valvesTimeForHeatingFanCoil;
        data["isManualCoolingOverrideEnabled"] = this.isManualCoolingOverrideEnabled;
        data["coolingRegulationBand"] = this.coolingRegulationBand;
        data["fanSpeed2ForCooling"] = this.fanSpeed2ForCooling;
        data["fanSpeed3ForCooling"] = this.fanSpeed3ForCooling;
        data["valvesTimeForCoolingFanCoil"] = this.valvesTimeForCoolingFanCoil;
        data["isIconAlwaysOff"] = this.isIconAlwaysOff;
        data["isLocalContactNumberEnabled"] = this.isLocalContactNumberEnabled;
        data["numberOfWindowsContact"] = this.numberOfWindowsContact;
        data["openingContactTypeHeating"] = this.openingContactTypeHeating;
        data["openingContactTempHeating"] = this.openingContactTempHeating;
        data["openingContactDelayHeating"] = this.openingContactDelayHeating;
        data["timeoutOpeningHeating"] = this.timeoutOpeningHeating;
        data["closingContactTypeHeating"] = this.closingContactTypeHeating;
        data["closingContactTempHeating"] = this.closingContactTempHeating;
        data["closingContactDelayHeating"] = this.closingContactDelayHeating;
        data["timeoutClosingHeating"] = this.timeoutClosingHeating;
        data["openingContactTypeCooling"] = this.openingContactTypeCooling;
        data["openingContactTempCooling"] = this.openingContactTempCooling;
        data["openingContactDelayCooling"] = this.openingContactDelayCooling;
        data["timeoutOpeningCooling"] = this.timeoutOpeningCooling;
        data["closingContactTypeCooling"] = this.closingContactTypeCooling;
        data["closingContactTempCooling"] = this.closingContactTempCooling;
        data["closingContactDelayCooling"] = this.closingContactDelayCooling;
        data["timeoutClosingCooling"] = this.timeoutClosingCooling;
        data["isCoolingVentilationEnabled"] = this.isCoolingVentilationEnabled;
        data["isHeatingVentilationEnabled"] = this.isHeatingVentilationEnabled;
        data["timeoutCoolingVentilation"] = this.timeoutCoolingVentilation;
        data["timeoutHeatingVentilation"] = this.timeoutHeatingVentilation;
        data["isInterlockingExcluded"] = this.isInterlockingExcluded;
        data["pumpsDelay"] = this.pumpsDelay;
        data["thermoUkFanSpeed"] = this.thermoUkFanSpeed;
        data["thermoUkFanSpeed2"] = this.thermoUkFanSpeed2;
        data["thermoUkFanSpeed3"] = this.thermoUkFanSpeed3;
        data["coloredLightType"] = this.coloredLightType;
        data["daliType"] = this.daliType;
        data["isColor"] = this.isColor;
        data["isTemperatureColor"] = this.isTemperatureColor;
        data["address"] = this.address;
        data["callType"] = this.callType;
        data["isToChangeIntoID"] = this.isToChangeIntoID;
        data["isAddressConflict"] = this.isAddressConflict;
        data["addressWithInterface"] = this.addressWithInterface;
        data["pul"] = this.pul;
        data["problemDescription"] = this.problemDescription;
        super.toJSON(data);
        return data;
    }
}

export interface IRoomObject extends ILinkableObject {
    type?: RoomObjectType;
    systemType?: SystemType;
    isHidden?: boolean;
    hasCommands?: boolean;
    roomId?: string | undefined;
    typeofProblem?: CompromisedType;
    preset?: Preset;
    lightType?: LightType;
    isManagePosition?: boolean;
    isManagePositionWithSlat?: boolean;
    shutterPositionMode?: ShutterPositionMode;
    commandOpeningTime?: CommandOpeningTime;
    isAppliedToAllSameTypeCommands?: boolean;
    energyMeterAndLoadControlType?: EnergyMeterAndLoadControlType;
    isEnergyMeter?: boolean;
    toroidDirectionType?: ToroidDirection;
    tolerance?: string | undefined;
    priority?: number;
    supplyPower?: string | undefined;
    lineType?: Line;
    lineMisurationType?: LineMisuration;
    isThreePhase?: boolean;
    nameLine1?: string | undefined;
    nameLine2?: string | undefined;
    nameLine3?: string | undefined;
    thermoTypeOfObject?: ThermoTypeOfObject;
    thermoAssociatedPump?: ThermoAssociatedPump;
    actuatorModalityType?: ActuatorModalityType;
    coolingSystemControlType?: SystemControlType;
    heatingSystemControlType?: SystemControlType;
    sharedSystemControlType?: SystemControlType;
    thermo?: ThermoActuactor[] | undefined;
    isContactInError?: boolean;
    isTemperatureDisplayed?: boolean;
    isWaterCycleEnabled?: boolean;
    arePumpsOpenedAutomatically?: boolean;
    minutesToKeepOpen?: string;
    openAutomaticallyDaysDelay?: number;
    isInterlockSystemEnabled?: boolean;
    isSeasonModeAuto?: boolean;
    isSeasonChangeModifiable?: boolean;
    seasonChangeAutoType?: SeasonChangeAutoType;
    selected3477Device?: Device;
    seasonChangeAutoStartWinterDate?: Date;
    seasonChangeAutoStartSummerDate?: Date;
    isThermo99Zone?: boolean;
    thermo99SelectedZone?: string | undefined;
    thermo99HasFancoil?: boolean;
    heatingSetpointLow?: number;
    heatingSetpointHigh?: number;
    heatingAntifreeze?: number;
    heatingThermalProtection?: number;
    coolingSetpointLow?: number;
    coolingSetpointHigh?: number;
    coolingThermalProtection?: number;
    isAutoCommutation?: boolean;
    delayHeatingPumps?: string;
    delayCoolingPumps?: string;
    temperatureType?: TemperatureType;
    areButtonsEnabled?: boolean;
    externalSensorType?: ExternalSensorType;
    isBacklightEnabled?: boolean;
    backlightLevel?: number;
    isManualHeatingOverrideEnabled?: boolean;
    heatingRegulationBand?: number;
    fanSpeed2ForHeating?: number;
    fanSpeed3ForHeating?: number;
    valvesTimeForHeatingFanCoil?: string;
    isManualCoolingOverrideEnabled?: boolean;
    coolingRegulationBand?: number;
    fanSpeed2ForCooling?: number;
    fanSpeed3ForCooling?: number;
    valvesTimeForCoolingFanCoil?: string;
    isIconAlwaysOff?: boolean;
    isLocalContactNumberEnabled?: boolean;
    numberOfWindowsContact?: number;
    openingContactTypeHeating?: ContactType;
    openingContactTempHeating?: number;
    openingContactDelayHeating?: string;
    timeoutOpeningHeating?: string;
    closingContactTypeHeating?: ContactType;
    closingContactTempHeating?: number;
    closingContactDelayHeating?: string;
    timeoutClosingHeating?: string;
    openingContactTypeCooling?: ContactType;
    openingContactTempCooling?: number;
    openingContactDelayCooling?: string;
    timeoutOpeningCooling?: string;
    closingContactTypeCooling?: ContactType;
    closingContactTempCooling?: number;
    closingContactDelayCooling?: string;
    timeoutClosingCooling?: string;
    isCoolingVentilationEnabled?: boolean;
    isHeatingVentilationEnabled?: boolean;
    timeoutCoolingVentilation?: string;
    timeoutHeatingVentilation?: string;
    isInterlockingExcluded?: boolean;
    pumpsDelay?: string;
    thermoUkFanSpeed?: number;
    thermoUkFanSpeed2?: number;
    thermoUkFanSpeed3?: number;
    coloredLightType?: ColoredLightType;
    daliType?: DaliType;
    isColor?: boolean;
    isTemperatureColor?: boolean;
    address?: string | undefined;
    callType?: CallType;
    isToChangeIntoID?: string | undefined;
    isAddressConflict?: boolean;
    addressWithInterface?: string | undefined;
    pul?: boolean;
    problemDescription?: string | undefined;
}

export class RoomObjectActionListItemDTO implements IRoomObjectActionListItemDTO {
    roomObjects?: SceneActionListItemDTO[] | undefined;
    name?: string | undefined;
    type?: RoomType;

    constructor(data?: IRoomObjectActionListItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roomObjects"])) {
                this.roomObjects = [] as any;
                for (let item of _data["roomObjects"])
                    this.roomObjects!.push(SceneActionListItemDTO.fromJS(item));
            }
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): RoomObjectActionListItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoomObjectActionListItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roomObjects)) {
            data["roomObjects"] = [];
            for (let item of this.roomObjects)
                data["roomObjects"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IRoomObjectActionListItemDTO {
    roomObjects?: SceneActionListItemDTO[] | undefined;
    name?: string | undefined;
    type?: RoomType;
}

export class RoomObjectDTO implements IRoomObjectDTO {
    id?: string | undefined;
    name?: string | undefined;
    devices?: DeviceDTO[] | undefined;
    type?: RoomObjectType;
    systemType?: SystemType;
    isHidden?: boolean;
    lightType?: LightType;
    isManagePosition?: boolean;
    thermoTypeOfObject?: ThermoTypeOfObject;
    thermoAssociatedPump?: ThermoAssociatedPump;
    thermo99SelectedZone?: string | undefined;
    thermo99HasFancoil?: boolean;
    energyMeterAndLoadControlType?: EnergyMeterAndLoadControlType;
    isEnergyMeter?: boolean;
    toroidDirectionType?: ToroidDirection;
    tolerance?: string | undefined;
    priority?: number;
    supplyPower?: string | undefined;
    lineType?: Line;
    lineMisurationType?: LineMisuration;
    coloredLightType?: ColoredLightType;
    daliType?: DaliType;
    isColor?: boolean;
    isTemperatureColor?: boolean;
    hasConfigurationToEnd?: boolean;
    extDevices?: ExtDevice[] | undefined;

    constructor(data?: IRoomObjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(DeviceDTO.fromJS(item));
            }
            this.type = _data["type"];
            this.systemType = _data["systemType"];
            this.isHidden = _data["isHidden"];
            this.lightType = _data["lightType"];
            this.isManagePosition = _data["isManagePosition"];
            this.thermoTypeOfObject = _data["thermoTypeOfObject"];
            this.thermoAssociatedPump = _data["thermoAssociatedPump"];
            this.thermo99SelectedZone = _data["thermo99SelectedZone"];
            this.thermo99HasFancoil = _data["thermo99HasFancoil"];
            this.energyMeterAndLoadControlType = _data["energyMeterAndLoadControlType"];
            this.isEnergyMeter = _data["isEnergyMeter"];
            this.toroidDirectionType = _data["toroidDirectionType"];
            this.tolerance = _data["tolerance"];
            this.priority = _data["priority"];
            this.supplyPower = _data["supplyPower"];
            this.lineType = _data["lineType"];
            this.lineMisurationType = _data["lineMisurationType"];
            this.coloredLightType = _data["coloredLightType"];
            this.daliType = _data["daliType"];
            this.isColor = _data["isColor"];
            this.isTemperatureColor = _data["isTemperatureColor"];
            this.hasConfigurationToEnd = _data["hasConfigurationToEnd"];
            if (Array.isArray(_data["extDevices"])) {
                this.extDevices = [] as any;
                for (let item of _data["extDevices"])
                    this.extDevices!.push(ExtDevice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoomObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoomObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["type"] = this.type;
        data["systemType"] = this.systemType;
        data["isHidden"] = this.isHidden;
        data["lightType"] = this.lightType;
        data["isManagePosition"] = this.isManagePosition;
        data["thermoTypeOfObject"] = this.thermoTypeOfObject;
        data["thermoAssociatedPump"] = this.thermoAssociatedPump;
        data["thermo99SelectedZone"] = this.thermo99SelectedZone;
        data["thermo99HasFancoil"] = this.thermo99HasFancoil;
        data["energyMeterAndLoadControlType"] = this.energyMeterAndLoadControlType;
        data["isEnergyMeter"] = this.isEnergyMeter;
        data["toroidDirectionType"] = this.toroidDirectionType;
        data["tolerance"] = this.tolerance;
        data["priority"] = this.priority;
        data["supplyPower"] = this.supplyPower;
        data["lineType"] = this.lineType;
        data["lineMisurationType"] = this.lineMisurationType;
        data["coloredLightType"] = this.coloredLightType;
        data["daliType"] = this.daliType;
        data["isColor"] = this.isColor;
        data["isTemperatureColor"] = this.isTemperatureColor;
        data["hasConfigurationToEnd"] = this.hasConfigurationToEnd;
        if (Array.isArray(this.extDevices)) {
            data["extDevices"] = [];
            for (let item of this.extDevices)
                data["extDevices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoomObjectDTO {
    id?: string | undefined;
    name?: string | undefined;
    devices?: DeviceDTO[] | undefined;
    type?: RoomObjectType;
    systemType?: SystemType;
    isHidden?: boolean;
    lightType?: LightType;
    isManagePosition?: boolean;
    thermoTypeOfObject?: ThermoTypeOfObject;
    thermoAssociatedPump?: ThermoAssociatedPump;
    thermo99SelectedZone?: string | undefined;
    thermo99HasFancoil?: boolean;
    energyMeterAndLoadControlType?: EnergyMeterAndLoadControlType;
    isEnergyMeter?: boolean;
    toroidDirectionType?: ToroidDirection;
    tolerance?: string | undefined;
    priority?: number;
    supplyPower?: string | undefined;
    lineType?: Line;
    lineMisurationType?: LineMisuration;
    coloredLightType?: ColoredLightType;
    daliType?: DaliType;
    isColor?: boolean;
    isTemperatureColor?: boolean;
    hasConfigurationToEnd?: boolean;
    extDevices?: ExtDevice[] | undefined;
}

/** 0 = Light 1 = Shutter 2 = Socket 3 = Lock 4 = Thermostat 5 = Fancoil 6 = TowelWarmer 7 = WirelessCommand 8 = Blind 9 = Player 10 = Xmeter 11 = Alarm 12 = ColoredLight 13 = ScheduledScenarioPlus 14 = None 15 = Contact 16 = AlarmSensor 17 = Thermostat99zones 18 = DimmerDmx 19 = DimmerDali 20 = Actuactor 21 = CentralLoadControl 22 = ActuactorLoadControl 23 = VdeLock 24 = StaircaseLight 25 = FloorCall 26 = Unknown */
export enum RoomObjectType {
    Light = 0,
    Shutter = 1,
    Socket = 2,
    Lock = 3,
    Thermostat = 4,
    Fancoil = 5,
    TowelWarmer = 6,
    WirelessCommand = 7,
    Blind = 8,
    Player = 9,
    Xmeter = 10,
    Alarm = 11,
    ColoredLight = 12,
    ScheduledScenarioPlus = 13,
    None = 14,
    Contact = 15,
    AlarmSensor = 16,
    Thermostat99zones = 17,
    DimmerDmx = 18,
    DimmerDali = 19,
    Actuactor = 20,
    CentralLoadControl = 21,
    ActuactorLoadControl = 22,
    VdeLock = 23,
    StaircaseLight = 24,
    FloorCall = 25,
    Unknown = 26,
}

/** 0 = Livingroom 1 = Bathroom 2 = Kitchen 3 = Bedroom 4 = Dining_room 5 = Toilets 6 = Lobby 7 = Corridor 8 = Garage 9 = Outdoor 10 = Home_office 11 = Stairs 12 = Electrical_cabinet 13 = Custom 14 = Unknown */
export enum RoomType {
    Livingroom = 0,
    Bathroom = 1,
    Kitchen = 2,
    Bedroom = 3,
    Dining_room = 4,
    Toilets = 5,
    Lobby = 6,
    Corridor = 7,
    Garage = 8,
    Outdoor = 9,
    Home_office = 10,
    Stairs = 11,
    Electrical_cabinet = 12,
    Custom = 13,
    Unknown = 14,
}

export class RoomUpdateDTO implements IRoomUpdateDTO {
    name?: string | undefined;
    type?: RoomType;

    constructor(data?: IRoomUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): RoomUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoomUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IRoomUpdateDTO {
    name?: string | undefined;
    type?: RoomType;
}

export class RotationTime implements IRotationTime {
    highByte?: string | undefined;
    lowByte?: string | undefined;
    value?: number;

    constructor(data?: IRotationTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.highByte = _data["highByte"];
            this.lowByte = _data["lowByte"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): RotationTime {
        data = typeof data === 'object' ? data : {};
        let result = new RotationTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["highByte"] = this.highByte;
        data["lowByte"] = this.lowByte;
        data["value"] = this.value;
        return data;
    }
}

export interface IRotationTime {
    highByte?: string | undefined;
    lowByte?: string | undefined;
    value?: number;
}

export class Scene extends LinkableObject implements IScene {
    type?: SceneType;
    isDisabled?: boolean;
    isHidden?: boolean;
    isEditable?: boolean;
    isSceneFromServer?: boolean;
    actions?: Action[] | undefined;
    triggers?: Trigger[] | undefined;
    conditions?: Condition[] | undefined;
    room_id?: string | undefined;
    share?: boolean;
    user?: string | undefined;
    category?: string | undefined;
    preconditionSelected?: SceneThermostatModalityState;
    isColorChanged?: boolean;
    hasButtonTrigger?: boolean | undefined;
    typeofProblem?: CompromisedType;

    constructor(data?: IScene) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.isDisabled = _data["isDisabled"];
            this.isHidden = _data["isHidden"];
            this.isEditable = _data["isEditable"];
            this.isSceneFromServer = _data["isSceneFromServer"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(Action.fromJS(item));
            }
            if (Array.isArray(_data["triggers"])) {
                this.triggers = [] as any;
                for (let item of _data["triggers"])
                    this.triggers!.push(Trigger.fromJS(item));
            }
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(Condition.fromJS(item));
            }
            this.room_id = _data["room_id"];
            this.share = _data["share"];
            this.user = _data["user"];
            this.category = _data["category"];
            this.preconditionSelected = _data["preconditionSelected"];
            this.isColorChanged = _data["isColorChanged"];
            this.hasButtonTrigger = _data["hasButtonTrigger"];
            this.typeofProblem = _data["typeofProblem"];
        }
    }

    static fromJS(data: any): Scene {
        data = typeof data === 'object' ? data : {};
        let result = new Scene();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["isDisabled"] = this.isDisabled;
        data["isHidden"] = this.isHidden;
        data["isEditable"] = this.isEditable;
        data["isSceneFromServer"] = this.isSceneFromServer;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        if (Array.isArray(this.triggers)) {
            data["triggers"] = [];
            for (let item of this.triggers)
                data["triggers"].push(item.toJSON());
        }
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        data["room_id"] = this.room_id;
        data["share"] = this.share;
        data["user"] = this.user;
        data["category"] = this.category;
        data["preconditionSelected"] = this.preconditionSelected;
        data["isColorChanged"] = this.isColorChanged;
        data["hasButtonTrigger"] = this.hasButtonTrigger;
        data["typeofProblem"] = this.typeofProblem;
        super.toJSON(data);
        return data;
    }
}

export interface IScene extends ILinkableObject {
    type?: SceneType;
    isDisabled?: boolean;
    isHidden?: boolean;
    isEditable?: boolean;
    isSceneFromServer?: boolean;
    actions?: Action[] | undefined;
    triggers?: Trigger[] | undefined;
    conditions?: Condition[] | undefined;
    room_id?: string | undefined;
    share?: boolean;
    user?: string | undefined;
    category?: string | undefined;
    preconditionSelected?: SceneThermostatModalityState;
    isColorChanged?: boolean;
    hasButtonTrigger?: boolean | undefined;
    typeofProblem?: CompromisedType;
}

export class SceneActionListItemDTO implements ISceneActionListItemDTO {
    isAddAction?: boolean;
    linkableObjectId?: string | undefined;
    isUnselectEnabled?: boolean;
    id?: number;
    aggregateCommandType?: AggregateCommandType;
    sceneObjectType?: SceneObjectType;
    energyObjectType?: EnergyMeterAndLoadControlType;
    sceneLockState?: SceneLockState;
    isStateChanged?: boolean;
    name?: string | undefined;
    waitTime?: string;
    isSelected?: boolean;
    sceneLightState?: SceneLightState;
    dimmerStatus?: DimmerStatus;
    sceneShutterState?: SceneShutterState;
    sceneBlindState?: SceneBlindState;
    sceneSocketState?: SceneSocketState;
    thermostatStatus?: ThermostatStatus;
    heatingSetpointLow?: number;
    heatingSetpointHigh?: number;
    coolingSetpointLow?: number;
    coolingSetpointHigh?: number;
    minRange?: number;
    maxRange?: number;
    sceneFancoilState?: SceneFancoilState;
    sceneTowelWarmerState?: SceneTowelWarmerState;
    dimmerPercentage?: number;
    dimmerFadeIn?: number;
    dimmerFadeOut?: number;
    workingMode?: DimmerWorkingMode;
    oldTemperature?: number;
    thermostatTriggerTemperature?: number;
    fancoilSpeed?: number;
    sceneColoredLightsState?: SceneColoredLightsState;
    coloredLightsIntensity?: number;
    coloredLightsTemperature?: number;
    coloredLightsColor?: number;
    scenePlayerState?: ScenePlayerState;
    playerVolume?: number;
    playerSourceId?: string | undefined;
    playerSourceDescription?: string | undefined;
    sceneLoadManagementStatus?: SceneLoadManagementState;
    temperature?: number;

    constructor(data?: ISceneActionListItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAddAction = _data["isAddAction"];
            this.linkableObjectId = _data["linkableObjectId"];
            this.isUnselectEnabled = _data["isUnselectEnabled"];
            this.id = _data["id"];
            this.aggregateCommandType = _data["aggregateCommandType"];
            this.sceneObjectType = _data["sceneObjectType"];
            this.energyObjectType = _data["energyObjectType"];
            this.sceneLockState = _data["sceneLockState"];
            this.isStateChanged = _data["isStateChanged"];
            this.name = _data["name"];
            this.waitTime = _data["waitTime"];
            this.isSelected = _data["isSelected"];
            this.sceneLightState = _data["sceneLightState"];
            this.dimmerStatus = _data["dimmerStatus"];
            this.sceneShutterState = _data["sceneShutterState"];
            this.sceneBlindState = _data["sceneBlindState"];
            this.sceneSocketState = _data["sceneSocketState"];
            this.thermostatStatus = _data["thermostatStatus"];
            this.heatingSetpointLow = _data["heatingSetpointLow"];
            this.heatingSetpointHigh = _data["heatingSetpointHigh"];
            this.coolingSetpointLow = _data["coolingSetpointLow"];
            this.coolingSetpointHigh = _data["coolingSetpointHigh"];
            this.minRange = _data["minRange"];
            this.maxRange = _data["maxRange"];
            this.sceneFancoilState = _data["sceneFancoilState"];
            this.sceneTowelWarmerState = _data["sceneTowelWarmerState"];
            this.dimmerPercentage = _data["dimmerPercentage"];
            this.dimmerFadeIn = _data["dimmerFadeIn"];
            this.dimmerFadeOut = _data["dimmerFadeOut"];
            this.workingMode = _data["workingMode"];
            this.oldTemperature = _data["oldTemperature"];
            this.thermostatTriggerTemperature = _data["thermostatTriggerTemperature"];
            this.fancoilSpeed = _data["fancoilSpeed"];
            this.sceneColoredLightsState = _data["sceneColoredLightsState"];
            this.coloredLightsIntensity = _data["coloredLightsIntensity"];
            this.coloredLightsTemperature = _data["coloredLightsTemperature"];
            this.coloredLightsColor = _data["coloredLightsColor"];
            this.scenePlayerState = _data["scenePlayerState"];
            this.playerVolume = _data["playerVolume"];
            this.playerSourceId = _data["playerSourceId"];
            this.playerSourceDescription = _data["playerSourceDescription"];
            this.sceneLoadManagementStatus = _data["sceneLoadManagementStatus"];
            this.temperature = _data["temperature"];
        }
    }

    static fromJS(data: any): SceneActionListItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SceneActionListItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAddAction"] = this.isAddAction;
        data["linkableObjectId"] = this.linkableObjectId;
        data["isUnselectEnabled"] = this.isUnselectEnabled;
        data["id"] = this.id;
        data["aggregateCommandType"] = this.aggregateCommandType;
        data["sceneObjectType"] = this.sceneObjectType;
        data["energyObjectType"] = this.energyObjectType;
        data["sceneLockState"] = this.sceneLockState;
        data["isStateChanged"] = this.isStateChanged;
        data["name"] = this.name;
        data["waitTime"] = this.waitTime;
        data["isSelected"] = this.isSelected;
        data["sceneLightState"] = this.sceneLightState;
        data["dimmerStatus"] = this.dimmerStatus;
        data["sceneShutterState"] = this.sceneShutterState;
        data["sceneBlindState"] = this.sceneBlindState;
        data["sceneSocketState"] = this.sceneSocketState;
        data["thermostatStatus"] = this.thermostatStatus;
        data["heatingSetpointLow"] = this.heatingSetpointLow;
        data["heatingSetpointHigh"] = this.heatingSetpointHigh;
        data["coolingSetpointLow"] = this.coolingSetpointLow;
        data["coolingSetpointHigh"] = this.coolingSetpointHigh;
        data["minRange"] = this.minRange;
        data["maxRange"] = this.maxRange;
        data["sceneFancoilState"] = this.sceneFancoilState;
        data["sceneTowelWarmerState"] = this.sceneTowelWarmerState;
        data["dimmerPercentage"] = this.dimmerPercentage;
        data["dimmerFadeIn"] = this.dimmerFadeIn;
        data["dimmerFadeOut"] = this.dimmerFadeOut;
        data["workingMode"] = this.workingMode;
        data["oldTemperature"] = this.oldTemperature;
        data["thermostatTriggerTemperature"] = this.thermostatTriggerTemperature;
        data["fancoilSpeed"] = this.fancoilSpeed;
        data["sceneColoredLightsState"] = this.sceneColoredLightsState;
        data["coloredLightsIntensity"] = this.coloredLightsIntensity;
        data["coloredLightsTemperature"] = this.coloredLightsTemperature;
        data["coloredLightsColor"] = this.coloredLightsColor;
        data["scenePlayerState"] = this.scenePlayerState;
        data["playerVolume"] = this.playerVolume;
        data["playerSourceId"] = this.playerSourceId;
        data["playerSourceDescription"] = this.playerSourceDescription;
        data["sceneLoadManagementStatus"] = this.sceneLoadManagementStatus;
        data["temperature"] = this.temperature;
        return data;
    }
}

export interface ISceneActionListItemDTO {
    isAddAction?: boolean;
    linkableObjectId?: string | undefined;
    isUnselectEnabled?: boolean;
    id?: number;
    aggregateCommandType?: AggregateCommandType;
    sceneObjectType?: SceneObjectType;
    energyObjectType?: EnergyMeterAndLoadControlType;
    sceneLockState?: SceneLockState;
    isStateChanged?: boolean;
    name?: string | undefined;
    waitTime?: string;
    isSelected?: boolean;
    sceneLightState?: SceneLightState;
    dimmerStatus?: DimmerStatus;
    sceneShutterState?: SceneShutterState;
    sceneBlindState?: SceneBlindState;
    sceneSocketState?: SceneSocketState;
    thermostatStatus?: ThermostatStatus;
    heatingSetpointLow?: number;
    heatingSetpointHigh?: number;
    coolingSetpointLow?: number;
    coolingSetpointHigh?: number;
    minRange?: number;
    maxRange?: number;
    sceneFancoilState?: SceneFancoilState;
    sceneTowelWarmerState?: SceneTowelWarmerState;
    dimmerPercentage?: number;
    dimmerFadeIn?: number;
    dimmerFadeOut?: number;
    workingMode?: DimmerWorkingMode;
    oldTemperature?: number;
    thermostatTriggerTemperature?: number;
    fancoilSpeed?: number;
    sceneColoredLightsState?: SceneColoredLightsState;
    coloredLightsIntensity?: number;
    coloredLightsTemperature?: number;
    coloredLightsColor?: number;
    scenePlayerState?: ScenePlayerState;
    playerVolume?: number;
    playerSourceId?: string | undefined;
    playerSourceDescription?: string | undefined;
    sceneLoadManagementStatus?: SceneLoadManagementState;
    temperature?: number;
}

export class SceneActionsListsDTO implements ISceneActionsListsDTO {
    aggregateCommandsActions?: AggregateCommandActionListItemDTO[] | undefined;
    roomObjectsActions?: RoomObjectActionListItemDTO[] | undefined;

    constructor(data?: ISceneActionsListsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["aggregateCommandsActions"])) {
                this.aggregateCommandsActions = [] as any;
                for (let item of _data["aggregateCommandsActions"])
                    this.aggregateCommandsActions!.push(AggregateCommandActionListItemDTO.fromJS(item));
            }
            if (Array.isArray(_data["roomObjectsActions"])) {
                this.roomObjectsActions = [] as any;
                for (let item of _data["roomObjectsActions"])
                    this.roomObjectsActions!.push(RoomObjectActionListItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SceneActionsListsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SceneActionsListsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.aggregateCommandsActions)) {
            data["aggregateCommandsActions"] = [];
            for (let item of this.aggregateCommandsActions)
                data["aggregateCommandsActions"].push(item.toJSON());
        }
        if (Array.isArray(this.roomObjectsActions)) {
            data["roomObjectsActions"] = [];
            for (let item of this.roomObjectsActions)
                data["roomObjectsActions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISceneActionsListsDTO {
    aggregateCommandsActions?: AggregateCommandActionListItemDTO[] | undefined;
    roomObjectsActions?: RoomObjectActionListItemDTO[] | undefined;
}

/** 0 = None 1 = Open 2 = Close */
export enum SceneBlindState {
    None = 0,
    Open = 1,
    Close = 2,
}

/** 0 = Blue 1 = LightPurple 2 = Magenta 3 = Fuchsia 4 = Red 5 = Orange 6 = Yellow 7 = Lime 8 = Green 9 = AcquaGreen 10 = LightBlue 11 = LightBlueSky */
export enum SceneColoredLightsColor {
    Blue = 0,
    LightPurple = 1,
    Magenta = 2,
    Fuchsia = 3,
    Red = 4,
    Orange = 5,
    Yellow = 6,
    Lime = 7,
    Green = 8,
    AcquaGreen = 9,
    LightBlue = 10,
    LightBlueSky = 11,
}

/** 0 = None 1 = On 2 = Off */
export enum SceneColoredLightsState {
    None = 0,
    On = 1,
    Off = 2,
}

export class SceneConditionsListsDTO implements ISceneConditionsListsDTO {
    conditionsRoomsList?: TriggersAndConditionsRoomItemDTO[] | undefined;

    constructor(data?: ISceneConditionsListsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["conditionsRoomsList"])) {
                this.conditionsRoomsList = [] as any;
                for (let item of _data["conditionsRoomsList"])
                    this.conditionsRoomsList!.push(TriggersAndConditionsRoomItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SceneConditionsListsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SceneConditionsListsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conditionsRoomsList)) {
            data["conditionsRoomsList"] = [];
            for (let item of this.conditionsRoomsList)
                data["conditionsRoomsList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISceneConditionsListsDTO {
    conditionsRoomsList?: TriggersAndConditionsRoomItemDTO[] | undefined;
}

export class SceneDTO implements ISceneDTO {
    id?: string | undefined;
    name?: string | undefined;
    devices?: DeviceDTO[] | undefined;
    type?: SceneType;
    isDisabled?: boolean;
    isHidden?: boolean;
    isEditable?: boolean;
    actions?: ActionDTO[] | undefined;
    triggers?: TriggerDTO[] | undefined;
    conditions?: ConditionDTO[] | undefined;

    constructor(data?: ISceneDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(DeviceDTO.fromJS(item));
            }
            this.type = _data["type"];
            this.isDisabled = _data["isDisabled"];
            this.isHidden = _data["isHidden"];
            this.isEditable = _data["isEditable"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(ActionDTO.fromJS(item));
            }
            if (Array.isArray(_data["triggers"])) {
                this.triggers = [] as any;
                for (let item of _data["triggers"])
                    this.triggers!.push(TriggerDTO.fromJS(item));
            }
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(ConditionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SceneDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SceneDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["type"] = this.type;
        data["isDisabled"] = this.isDisabled;
        data["isHidden"] = this.isHidden;
        data["isEditable"] = this.isEditable;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        if (Array.isArray(this.triggers)) {
            data["triggers"] = [];
            for (let item of this.triggers)
                data["triggers"].push(item.toJSON());
        }
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISceneDTO {
    id?: string | undefined;
    name?: string | undefined;
    devices?: DeviceDTO[] | undefined;
    type?: SceneType;
    isDisabled?: boolean;
    isHidden?: boolean;
    isEditable?: boolean;
    actions?: ActionDTO[] | undefined;
    triggers?: TriggerDTO[] | undefined;
    conditions?: ConditionDTO[] | undefined;
}

/** 0 = None 1 = On 2 = Off */
export enum SceneDimmerPowerState {
    None = 0,
    On = 1,
    Off = 2,
}

/** 0 = None 1 = Dimmer 2 = Power */
export enum SceneDimmerState {
    None = 0,
    Dimmer = 1,
    Power = 2,
}

/** 0 = None 1 = One 2 = Two 3 = Three */
export enum SceneFancoilSpeedState {
    None = 0,
    One = 1,
    Two = 2,
    Three = 3,
}

/** 0 = Off 1 = On 2 = None */
export enum SceneFancoilState {
    Off = 0,
    On = 1,
    None = 2,
}

/** 0 = None 1 = On 2 = Off */
export enum SceneLightState {
    None = 0,
    On = 1,
    Off = 2,
}

/** 0 = None 1 = On 2 = Off 3 = Force 4 = Shedded 5 = Power 6 = UnForce */
export enum SceneLoadManagementState {
    None = 0,
    On = 1,
    Off = 2,
    Force = 3,
    Shedded = 4,
    Power = 5,
    UnForce = 6,
}

/** 0 = None 1 = On */
export enum SceneLockState {
    None = 0,
    On = 1,
}

/** 0 = None 1 = Light 2 = Dimmer 3 = Shutter 4 = Lock 5 = Thermostat 6 = Socket 7 = Fancoil 8 = TowelWarmer 9 = GroupOfLights 10 = GroupOfShutters 11 = GeneralCommandsLights 12 = GeneralCommandsShutters 13 = Command 14 = DateTime 15 = Blind 16 = ColoredLights 17 = Email 18 = Weather 19 = PushNotificationAction 20 = Player 21 = Xmeter 22 = Alarm 23 = AlarmSensor 24 = DimmerDmx 25 = Dali 26 = ActuactorLoadControl 27 = GroupOfBlinds */
export enum SceneObjectType {
    None = 0,
    Light = 1,
    Dimmer = 2,
    Shutter = 3,
    Lock = 4,
    Thermostat = 5,
    Socket = 6,
    Fancoil = 7,
    TowelWarmer = 8,
    GroupOfLights = 9,
    GroupOfShutters = 10,
    GeneralCommandsLights = 11,
    GeneralCommandsShutters = 12,
    Command = 13,
    DateTime = 14,
    Blind = 15,
    ColoredLights = 16,
    Email = 17,
    Weather = 18,
    PushNotificationAction = 19,
    Player = 20,
    Xmeter = 21,
    Alarm = 22,
    AlarmSensor = 23,
    DimmerDmx = 24,
    Dali = 25,
    ActuactorLoadControl = 26,
    GroupOfBlinds = 27,
}

/** 0 = None 1 = Stop 2 = Play 3 = Pause */
export enum ScenePlayerState {
    None = 0,
    Stop = 1,
    Play = 2,
    Pause = 3,
}

/** 0 = None 1 = Power 2 = Volume */
export enum ScenePlayerTriggerMode {
    None = 0,
    Power = 1,
    Volume = 2,
}

/** 0 = None 1 = Movement 2 = Position 3 = TiltAngle */
export enum SceneShutterModality {
    None = 0,
    Movement = 1,
    Position = 2,
    TiltAngle = 3,
}

/** 0 = Vertical 1 = TwentyDegree 2 = FortyFiveDegree 3 = SeventyDegree 4 = Horizontal 5 = None */
export enum SceneShutterOrientation {
    Vertical = 0,
    TwentyDegree = 1,
    FortyFiveDegree = 2,
    SeventyDegree = 3,
    Horizontal = 4,
    None = 5,
}

/** 0 = None 1 = Up 2 = Stop 3 = Down */
export enum SceneShutterState {
    None = 0,
    Up = 1,
    Stop = 2,
    Down = 3,
}

/** 0 = None 1 = Position 2 = TiltAngle 3 = Both */
export enum SceneShutterWithSlatState {
    None = 0,
    Position = 1,
    TiltAngle = 2,
    Both = 3,
}

/** 0 = None 1 = On 2 = Off */
export enum SceneSocketState {
    None = 0,
    On = 1,
    Off = 2,
}

/** 0 = None 1 = Equal 2 = Different 3 = Higher 4 = Lower 5 = Any */
export enum SceneStateComparer {
    None = 0,
    Equal = 1,
    Different = 2,
    Higher = 3,
    Lower = 4,
    Any = 5,
}

/** 0 = Off 1 = On 2 = None */
export enum SceneThermostatConditionState {
    Off = 0,
    On = 1,
    None = 2,
}

/** 0 = None 1 = Heating 2 = Cooling 3 = Auto 5 = Off */
export enum SceneThermostatModalityState {
    None = 0,
    Heating = 1,
    Cooling = 2,
    Auto = 3,
    Off = 5,
}

/** 0 = None 1 = Modality 2 = Temperature 3 = DesiredTemperature 4 = Condition 5 = Humidity */
export enum SceneThermostatState {
    None = 0,
    Modality = 1,
    Temperature = 2,
    DesiredTemperature = 3,
    Condition = 4,
    Humidity = 5,
}

/** 0 = Off 1 = On 2 = None */
export enum SceneTowelWarmerState {
    Off = 0,
    On = 1,
    None = 2,
}

export class SceneTriggersListsDTO implements ISceneTriggersListsDTO {
    triggersRoomsList?: TriggersAndConditionsRoomItemDTO[] | undefined;
    compatibleDevices?: DeviceDTO[] | undefined;

    constructor(data?: ISceneTriggersListsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["triggersRoomsList"])) {
                this.triggersRoomsList = [] as any;
                for (let item of _data["triggersRoomsList"])
                    this.triggersRoomsList!.push(TriggersAndConditionsRoomItemDTO.fromJS(item));
            }
            if (Array.isArray(_data["compatibleDevices"])) {
                this.compatibleDevices = [] as any;
                for (let item of _data["compatibleDevices"])
                    this.compatibleDevices!.push(DeviceDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SceneTriggersListsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SceneTriggersListsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.triggersRoomsList)) {
            data["triggersRoomsList"] = [];
            for (let item of this.triggersRoomsList)
                data["triggersRoomsList"].push(item.toJSON());
        }
        if (Array.isArray(this.compatibleDevices)) {
            data["compatibleDevices"] = [];
            for (let item of this.compatibleDevices)
                data["compatibleDevices"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISceneTriggersListsDTO {
    triggersRoomsList?: TriggersAndConditionsRoomItemDTO[] | undefined;
    compatibleDevices?: DeviceDTO[] | undefined;
}

/** 0 = Wake_Up 1 = BedTime 2 = Home 3 = Away 4 = Custom */
export enum SceneType {
    Wake_Up = 0,
    BedTime = 1,
    Home = 2,
    Away = 3,
    Custom = 4,
}

/** 0 = None 1 = Sunrise 2 = Sunset */
export enum SceneWeatherCrepuscular {
    None = 0,
    Sunrise = 1,
    Sunset = 2,
}

/** 0 = None 1 = Sunny 2 = Rain 3 = Storm 4 = Cloudy 5 = Snow 6 = Foggy */
export enum SceneWeatherForecastState {
    None = 0,
    Sunny = 1,
    Rain = 2,
    Storm = 3,
    Cloudy = 4,
    Snow = 5,
    Foggy = 6,
}

/** 0 = None 1 = Temperature 2 = Wind 3 = Humidity 4 = WeatherForecast 5 = Crepuscular */
export enum SceneWeatherModality {
    None = 0,
    Temperature = 1,
    Wind = 2,
    Humidity = 3,
    WeatherForecast = 4,
    Crepuscular = 5,
}

export class ScsAddressHelperDTO implements IScsAddressHelperDTO {
    availableScsAddressSwitchboard?: number[] | undefined;
    availableScsAddressGate?: number[] | undefined;
    firstAvailableScsAddressSwitchboard?: number;
    firstAvailableScsAddressGate?: number;

    constructor(data?: IScsAddressHelperDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["availableScsAddressSwitchboard"])) {
                this.availableScsAddressSwitchboard = [] as any;
                for (let item of _data["availableScsAddressSwitchboard"])
                    this.availableScsAddressSwitchboard!.push(item);
            }
            if (Array.isArray(_data["availableScsAddressGate"])) {
                this.availableScsAddressGate = [] as any;
                for (let item of _data["availableScsAddressGate"])
                    this.availableScsAddressGate!.push(item);
            }
            this.firstAvailableScsAddressSwitchboard = _data["firstAvailableScsAddressSwitchboard"];
            this.firstAvailableScsAddressGate = _data["firstAvailableScsAddressGate"];
        }
    }

    static fromJS(data: any): ScsAddressHelperDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScsAddressHelperDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.availableScsAddressSwitchboard)) {
            data["availableScsAddressSwitchboard"] = [];
            for (let item of this.availableScsAddressSwitchboard)
                data["availableScsAddressSwitchboard"].push(item);
        }
        if (Array.isArray(this.availableScsAddressGate)) {
            data["availableScsAddressGate"] = [];
            for (let item of this.availableScsAddressGate)
                data["availableScsAddressGate"].push(item);
        }
        data["firstAvailableScsAddressSwitchboard"] = this.firstAvailableScsAddressSwitchboard;
        data["firstAvailableScsAddressGate"] = this.firstAvailableScsAddressGate;
        return data;
    }
}

export interface IScsAddressHelperDTO {
    availableScsAddressSwitchboard?: number[] | undefined;
    availableScsAddressGate?: number[] | undefined;
    firstAvailableScsAddressSwitchboard?: number;
    firstAvailableScsAddressGate?: number;
}

/** 0 = Samelevel 1 = Riser 2 = Building 3 = Backbone */
export enum ScsLevel {
    Samelevel = 0,
    Riser = 1,
    Building = 2,
    Backbone = 3,
}

/** 0 = Heating 1 = Cooling */
export enum SeasonChange3477Mode {
    Heating = 0,
    Cooling = 1,
}

/** 0 = None 1 = WithDate 2 = WithDevice 3 = WithTemperature */
export enum SeasonChangeAutoType {
    None = 0,
    WithDate = 1,
    WithDevice = 2,
    WithTemperature = 3,
}

export class SelectColorAction extends Action implements ISelectColorAction {
    hasTemperature?: boolean;
    hasColor?: boolean;
    name?: string | undefined;
    selectedColor?: Color;
    dimmerPercentage?: number;
    workingMode?: DimmerWorkingMode;
    temperature?: number;
    isAmbience?: boolean;

    constructor(data?: ISelectColorAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasTemperature = _data["hasTemperature"];
            this.hasColor = _data["hasColor"];
            this.name = _data["name"];
            this.selectedColor = _data["selectedColor"] ? Color.fromJS(_data["selectedColor"]) : <any>undefined;
            this.dimmerPercentage = _data["dimmerPercentage"];
            this.workingMode = _data["workingMode"];
            this.temperature = _data["temperature"];
            this.isAmbience = _data["isAmbience"];
        }
    }

    static fromJS(data: any): SelectColorAction {
        data = typeof data === 'object' ? data : {};
        let result = new SelectColorAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasTemperature"] = this.hasTemperature;
        data["hasColor"] = this.hasColor;
        data["name"] = this.name;
        data["selectedColor"] = this.selectedColor ? this.selectedColor.toJSON() : <any>undefined;
        data["dimmerPercentage"] = this.dimmerPercentage;
        data["workingMode"] = this.workingMode;
        data["temperature"] = this.temperature;
        data["isAmbience"] = this.isAmbience;
        super.toJSON(data);
        return data;
    }
}

export interface ISelectColorAction extends IAction {
    hasTemperature?: boolean;
    hasColor?: boolean;
    name?: string | undefined;
    selectedColor?: Color;
    dimmerPercentage?: number;
    workingMode?: DimmerWorkingMode;
    temperature?: number;
    isAmbience?: boolean;
}

/** 0 = Classe300EOS 1 = MyHomeServer1 2 = F460 3 = F461 4 = MyHomeServer1Native */
export enum ServerModel {
    Classe300EOS = 0,
    MyHomeServer1 = 1,
    F460 = 2,
    F461 = 3,
    MyHomeServer1Native = 4,
}

export class ShutterActuatorSettings extends ActuatorSettings implements IShutterActuatorSettings {
    hasPUL?: boolean;
    shutterMotorType?: ShutterMotorType;
    shutterMode?: ShutterMode;
    hasPreset?: boolean;
    presetValue?: number;
    stopPulseDuration?: number;
    upDownPulseDuration?: number;
    stopTime?: number;
    delayBetweenDoorsTime?: number;
    shutterUpTime?: ShutterMoveTime;
    shutterDownTime?: ShutterMoveTime;
    slatRotationTimeWhenShutterClosed?: RotationTime;
    slatRotationTimeWhenShutterPartiallyOpened?: RotationTime;

    constructor(data?: IShutterActuatorSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasPUL = _data["hasPUL"];
            this.shutterMotorType = _data["shutterMotorType"];
            this.shutterMode = _data["shutterMode"];
            this.hasPreset = _data["hasPreset"];
            this.presetValue = _data["presetValue"];
            this.stopPulseDuration = _data["stopPulseDuration"];
            this.upDownPulseDuration = _data["upDownPulseDuration"];
            this.stopTime = _data["stopTime"];
            this.delayBetweenDoorsTime = _data["delayBetweenDoorsTime"];
            this.shutterUpTime = _data["shutterUpTime"] ? ShutterMoveTime.fromJS(_data["shutterUpTime"]) : <any>undefined;
            this.shutterDownTime = _data["shutterDownTime"] ? ShutterMoveTime.fromJS(_data["shutterDownTime"]) : <any>undefined;
            this.slatRotationTimeWhenShutterClosed = _data["slatRotationTimeWhenShutterClosed"] ? RotationTime.fromJS(_data["slatRotationTimeWhenShutterClosed"]) : <any>undefined;
            this.slatRotationTimeWhenShutterPartiallyOpened = _data["slatRotationTimeWhenShutterPartiallyOpened"] ? RotationTime.fromJS(_data["slatRotationTimeWhenShutterPartiallyOpened"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ShutterActuatorSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ShutterActuatorSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasPUL"] = this.hasPUL;
        data["shutterMotorType"] = this.shutterMotorType;
        data["shutterMode"] = this.shutterMode;
        data["hasPreset"] = this.hasPreset;
        data["presetValue"] = this.presetValue;
        data["stopPulseDuration"] = this.stopPulseDuration;
        data["upDownPulseDuration"] = this.upDownPulseDuration;
        data["stopTime"] = this.stopTime;
        data["delayBetweenDoorsTime"] = this.delayBetweenDoorsTime;
        data["shutterUpTime"] = this.shutterUpTime ? this.shutterUpTime.toJSON() : <any>undefined;
        data["shutterDownTime"] = this.shutterDownTime ? this.shutterDownTime.toJSON() : <any>undefined;
        data["slatRotationTimeWhenShutterClosed"] = this.slatRotationTimeWhenShutterClosed ? this.slatRotationTimeWhenShutterClosed.toJSON() : <any>undefined;
        data["slatRotationTimeWhenShutterPartiallyOpened"] = this.slatRotationTimeWhenShutterPartiallyOpened ? this.slatRotationTimeWhenShutterPartiallyOpened.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IShutterActuatorSettings extends IActuatorSettings {
    hasPUL?: boolean;
    shutterMotorType?: ShutterMotorType;
    shutterMode?: ShutterMode;
    hasPreset?: boolean;
    presetValue?: number;
    stopPulseDuration?: number;
    upDownPulseDuration?: number;
    stopTime?: number;
    delayBetweenDoorsTime?: number;
    shutterUpTime?: ShutterMoveTime;
    shutterDownTime?: ShutterMoveTime;
    slatRotationTimeWhenShutterClosed?: RotationTime;
    slatRotationTimeWhenShutterPartiallyOpened?: RotationTime;
}

export class ShutterActuatorSettingsResult implements IShutterActuatorSettingsResult {
    hasPUL?: boolean;
    shutterMotorType?: ShutterMotorType;
    stopPulseDuration?: number;
    upDownPulseDuration?: number;
    shutterMode?: ShutterMode;
    hasPreset?: boolean;
    presetValue?: number;
    stopTime?: number;
    delayBetweenDoorsTime?: number;
    index?: number;

    constructor(data?: IShutterActuatorSettingsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasPUL = _data["hasPUL"];
            this.shutterMotorType = _data["shutterMotorType"];
            this.stopPulseDuration = _data["stopPulseDuration"];
            this.upDownPulseDuration = _data["upDownPulseDuration"];
            this.shutterMode = _data["shutterMode"];
            this.hasPreset = _data["hasPreset"];
            this.presetValue = _data["presetValue"];
            this.stopTime = _data["stopTime"];
            this.delayBetweenDoorsTime = _data["delayBetweenDoorsTime"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): ShutterActuatorSettingsResult {
        data = typeof data === 'object' ? data : {};
        let result = new ShutterActuatorSettingsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasPUL"] = this.hasPUL;
        data["shutterMotorType"] = this.shutterMotorType;
        data["stopPulseDuration"] = this.stopPulseDuration;
        data["upDownPulseDuration"] = this.upDownPulseDuration;
        data["shutterMode"] = this.shutterMode;
        data["hasPreset"] = this.hasPreset;
        data["presetValue"] = this.presetValue;
        data["stopTime"] = this.stopTime;
        data["delayBetweenDoorsTime"] = this.delayBetweenDoorsTime;
        data["index"] = this.index;
        return data;
    }
}

export interface IShutterActuatorSettingsResult {
    hasPUL?: boolean;
    shutterMotorType?: ShutterMotorType;
    stopPulseDuration?: number;
    upDownPulseDuration?: number;
    shutterMode?: ShutterMode;
    hasPreset?: boolean;
    presetValue?: number;
    stopTime?: number;
    delayBetweenDoorsTime?: number;
    index?: number;
}

export class ShutterCommandItemSettingsDTO implements IShutterCommandItemSettingsDTO {
    hasMoreThanOneSlotSettings?: boolean;
    indexes?: number[] | undefined;
    presetValue?: number;
    shutterMode?: ShutterMode;
    shutterPositionMode?: ShutterPositionMode;
    commandDirection?: CommandDirection;
    hasPreset?: boolean;
    saveTo?: number[] | undefined;
    showMonostableAndBistable?: boolean;
    showMonostableAndBistableWithBladesAndBistableValue?: boolean;
    showBistableAndMonostable?: boolean;
    showPreset?: boolean;
    showCommandDirection?: boolean;
    isContactTypeVisibile?: boolean;
    conctactType?: ConctactType;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    hasChanges?: boolean;

    constructor(data?: IShutterCommandItemSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasMoreThanOneSlotSettings = _data["hasMoreThanOneSlotSettings"];
            if (Array.isArray(_data["indexes"])) {
                this.indexes = [] as any;
                for (let item of _data["indexes"])
                    this.indexes!.push(item);
            }
            this.presetValue = _data["presetValue"];
            this.shutterMode = _data["shutterMode"];
            this.shutterPositionMode = _data["shutterPositionMode"];
            this.commandDirection = _data["commandDirection"];
            this.hasPreset = _data["hasPreset"];
            if (Array.isArray(_data["saveTo"])) {
                this.saveTo = [] as any;
                for (let item of _data["saveTo"])
                    this.saveTo!.push(item);
            }
            this.showMonostableAndBistable = _data["showMonostableAndBistable"];
            this.showMonostableAndBistableWithBladesAndBistableValue = _data["showMonostableAndBistableWithBladesAndBistableValue"];
            this.showBistableAndMonostable = _data["showBistableAndMonostable"];
            this.showPreset = _data["showPreset"];
            this.showCommandDirection = _data["showCommandDirection"];
            this.isContactTypeVisibile = _data["isContactTypeVisibile"];
            this.conctactType = _data["conctactType"];
            this.deviceBrightness = _data["deviceBrightness"];
            this.showLedsInStandby = _data["showLedsInStandby"];
            this.isProximityEnabled = _data["isProximityEnabled"];
            this.deviceProximity = _data["deviceProximity"];
            this.ledIntensity = _data["ledIntensity"];
            this.ledModality = _data["ledModality"];
            this.deviceIconsVisibility = _data["deviceIconsVisibility"];
            this.hasChanges = _data["hasChanges"];
        }
    }

    static fromJS(data: any): ShutterCommandItemSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShutterCommandItemSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasMoreThanOneSlotSettings"] = this.hasMoreThanOneSlotSettings;
        if (Array.isArray(this.indexes)) {
            data["indexes"] = [];
            for (let item of this.indexes)
                data["indexes"].push(item);
        }
        data["presetValue"] = this.presetValue;
        data["shutterMode"] = this.shutterMode;
        data["shutterPositionMode"] = this.shutterPositionMode;
        data["commandDirection"] = this.commandDirection;
        data["hasPreset"] = this.hasPreset;
        if (Array.isArray(this.saveTo)) {
            data["saveTo"] = [];
            for (let item of this.saveTo)
                data["saveTo"].push(item);
        }
        data["showMonostableAndBistable"] = this.showMonostableAndBistable;
        data["showMonostableAndBistableWithBladesAndBistableValue"] = this.showMonostableAndBistableWithBladesAndBistableValue;
        data["showBistableAndMonostable"] = this.showBistableAndMonostable;
        data["showPreset"] = this.showPreset;
        data["showCommandDirection"] = this.showCommandDirection;
        data["isContactTypeVisibile"] = this.isContactTypeVisibile;
        data["conctactType"] = this.conctactType;
        data["deviceBrightness"] = this.deviceBrightness;
        data["showLedsInStandby"] = this.showLedsInStandby;
        data["isProximityEnabled"] = this.isProximityEnabled;
        data["deviceProximity"] = this.deviceProximity;
        data["ledIntensity"] = this.ledIntensity;
        data["ledModality"] = this.ledModality;
        data["deviceIconsVisibility"] = this.deviceIconsVisibility;
        data["hasChanges"] = this.hasChanges;
        return data;
    }
}

export interface IShutterCommandItemSettingsDTO {
    hasMoreThanOneSlotSettings?: boolean;
    indexes?: number[] | undefined;
    presetValue?: number;
    shutterMode?: ShutterMode;
    shutterPositionMode?: ShutterPositionMode;
    commandDirection?: CommandDirection;
    hasPreset?: boolean;
    saveTo?: number[] | undefined;
    showMonostableAndBistable?: boolean;
    showMonostableAndBistableWithBladesAndBistableValue?: boolean;
    showBistableAndMonostable?: boolean;
    showPreset?: boolean;
    showCommandDirection?: boolean;
    isContactTypeVisibile?: boolean;
    conctactType?: ConctactType;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    hasChanges?: boolean;
}

export class ShutterCommandSettings extends CommandSettings implements IShutterCommandSettings {
    shutterMode?: ShutterMode;
    hasPreset?: boolean;
    presetValue?: number;
    commandDirection?: CommandDirection;
    typeofContact?: ConctactType;

    constructor(data?: IShutterCommandSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.shutterMode = _data["shutterMode"];
            this.hasPreset = _data["hasPreset"];
            this.presetValue = _data["presetValue"];
            this.commandDirection = _data["commandDirection"];
            this.typeofContact = _data["typeofContact"];
        }
    }

    static fromJS(data: any): ShutterCommandSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ShutterCommandSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shutterMode"] = this.shutterMode;
        data["hasPreset"] = this.hasPreset;
        data["presetValue"] = this.presetValue;
        data["commandDirection"] = this.commandDirection;
        data["typeofContact"] = this.typeofContact;
        super.toJSON(data);
        return data;
    }
}

export interface IShutterCommandSettings extends ICommandSettings {
    shutterMode?: ShutterMode;
    hasPreset?: boolean;
    presetValue?: number;
    commandDirection?: CommandDirection;
    typeofContact?: ConctactType;
}

export class ShutterCommandSettingsResult extends BaseShuttersCommandSettingsResult implements IShutterCommandSettingsResult {
    hasPreset?: boolean;
    presetValue?: number;
    conctactType?: ConctactType;
    commandDirection?: CommandDirection;
    index?: number;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    hasChanges?: boolean;

    constructor(data?: IShutterCommandSettingsResult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasPreset = _data["hasPreset"];
            this.presetValue = _data["presetValue"];
            this.conctactType = _data["conctactType"];
            this.commandDirection = _data["commandDirection"];
            this.index = _data["index"];
            this.deviceBrightness = _data["deviceBrightness"];
            this.showLedsInStandby = _data["showLedsInStandby"];
            this.isProximityEnabled = _data["isProximityEnabled"];
            this.deviceProximity = _data["deviceProximity"];
            this.ledIntensity = _data["ledIntensity"];
            this.ledModality = _data["ledModality"];
            this.deviceIconsVisibility = _data["deviceIconsVisibility"];
            this.hasChanges = _data["hasChanges"];
        }
    }

    static fromJS(data: any): ShutterCommandSettingsResult {
        data = typeof data === 'object' ? data : {};
        let result = new ShutterCommandSettingsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasPreset"] = this.hasPreset;
        data["presetValue"] = this.presetValue;
        data["conctactType"] = this.conctactType;
        data["commandDirection"] = this.commandDirection;
        data["index"] = this.index;
        data["deviceBrightness"] = this.deviceBrightness;
        data["showLedsInStandby"] = this.showLedsInStandby;
        data["isProximityEnabled"] = this.isProximityEnabled;
        data["deviceProximity"] = this.deviceProximity;
        data["ledIntensity"] = this.ledIntensity;
        data["ledModality"] = this.ledModality;
        data["deviceIconsVisibility"] = this.deviceIconsVisibility;
        data["hasChanges"] = this.hasChanges;
        super.toJSON(data);
        return data;
    }
}

export interface IShutterCommandSettingsResult extends IBaseShuttersCommandSettingsResult {
    hasPreset?: boolean;
    presetValue?: number;
    conctactType?: ConctactType;
    commandDirection?: CommandDirection;
    index?: number;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    hasChanges?: boolean;
}

export class ShutterCommandSettingsResultList implements IShutterCommandSettingsResultList {
    results?: ShutterCommandSettingsResult[] | undefined;

    constructor(data?: IShutterCommandSettingsResultList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ShutterCommandSettingsResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShutterCommandSettingsResultList {
        data = typeof data === 'object' ? data : {};
        let result = new ShutterCommandSettingsResultList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IShutterCommandSettingsResultList {
    results?: ShutterCommandSettingsResult[] | undefined;
}

/** 0 = Monostable 1 = Bistable 2 = BistableWithBladesControl 3 = BladesAndBistable 4 = MonostableBistable */
export enum ShutterMode {
    Monostable = 0,
    Bistable = 1,
    BistableWithBladesControl = 2,
    BladesAndBistable = 3,
    MonostableBistable = 4,
}

/** 0 = StandardAutomatic 1 = Standard 2 = Pulse 3 = StandardWithSlat */
export enum ShutterMotorType {
    StandardAutomatic = 0,
    Standard = 1,
    Pulse = 2,
    StandardWithSlat = 3,
}

export class ShutterMoveTime implements IShutterMoveTime {
    minutes?: number;
    seconds?: number;
    value?: number;

    constructor(data?: IShutterMoveTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minutes = _data["minutes"];
            this.seconds = _data["seconds"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ShutterMoveTime {
        data = typeof data === 'object' ? data : {};
        let result = new ShutterMoveTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["value"] = this.value;
        return data;
    }
}

export interface IShutterMoveTime {
    minutes?: number;
    seconds?: number;
    value?: number;
}

/** 0 = NoPosition 1 = WithPosition 2 = WithPositionSlat */
export enum ShutterPositionMode {
    NoPosition = 0,
    WithPosition = 1,
    WithPositionSlat = 2,
}

export class ShuttersActuatorSettingsObjectParam implements IShuttersActuatorSettingsObjectParam {
    shutterPositionMode?: ShutterPositionMode;
    hasPUL?: boolean;
    shutterMotorType?: ShutterMotorType;
    stopPulseDuration?: number;
    upDownPulseDuration?: number;
    shutterMode?: ShutterMode;
    hasPreset?: boolean;
    presetValue?: number;
    stopTime?: number;
    delayBetweenDoorsTime?: number;
    isGroupPULVisible?: boolean;
    isGroupMotorTypeVisible?: boolean;
    canHaveStandardAutomaticMotorType?: boolean;
    isGroupModeVisible?: boolean;
    isGroupPresetVisible?: boolean;
    isGroupStopTimeTypeVisible?: boolean;
    isGroupDelayBetweenDoorsVisible?: boolean;
    stopPulseDurationPickerValues?: DelayValue[] | undefined;
    upDownPulseDurationPickerValues?: DelayValue[] | undefined;
    stopTimePickerValues?: DelayValue[] | undefined;
    delayBetweenDoorsTimePickerValues?: DelayValue[] | undefined;

    constructor(data?: IShuttersActuatorSettingsObjectParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shutterPositionMode = _data["shutterPositionMode"];
            this.hasPUL = _data["hasPUL"];
            this.shutterMotorType = _data["shutterMotorType"];
            this.stopPulseDuration = _data["stopPulseDuration"];
            this.upDownPulseDuration = _data["upDownPulseDuration"];
            this.shutterMode = _data["shutterMode"];
            this.hasPreset = _data["hasPreset"];
            this.presetValue = _data["presetValue"];
            this.stopTime = _data["stopTime"];
            this.delayBetweenDoorsTime = _data["delayBetweenDoorsTime"];
            this.isGroupPULVisible = _data["isGroupPULVisible"];
            this.isGroupMotorTypeVisible = _data["isGroupMotorTypeVisible"];
            this.canHaveStandardAutomaticMotorType = _data["canHaveStandardAutomaticMotorType"];
            this.isGroupModeVisible = _data["isGroupModeVisible"];
            this.isGroupPresetVisible = _data["isGroupPresetVisible"];
            this.isGroupStopTimeTypeVisible = _data["isGroupStopTimeTypeVisible"];
            this.isGroupDelayBetweenDoorsVisible = _data["isGroupDelayBetweenDoorsVisible"];
            if (Array.isArray(_data["stopPulseDurationPickerValues"])) {
                this.stopPulseDurationPickerValues = [] as any;
                for (let item of _data["stopPulseDurationPickerValues"])
                    this.stopPulseDurationPickerValues!.push(DelayValue.fromJS(item));
            }
            if (Array.isArray(_data["upDownPulseDurationPickerValues"])) {
                this.upDownPulseDurationPickerValues = [] as any;
                for (let item of _data["upDownPulseDurationPickerValues"])
                    this.upDownPulseDurationPickerValues!.push(DelayValue.fromJS(item));
            }
            if (Array.isArray(_data["stopTimePickerValues"])) {
                this.stopTimePickerValues = [] as any;
                for (let item of _data["stopTimePickerValues"])
                    this.stopTimePickerValues!.push(DelayValue.fromJS(item));
            }
            if (Array.isArray(_data["delayBetweenDoorsTimePickerValues"])) {
                this.delayBetweenDoorsTimePickerValues = [] as any;
                for (let item of _data["delayBetweenDoorsTimePickerValues"])
                    this.delayBetweenDoorsTimePickerValues!.push(DelayValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShuttersActuatorSettingsObjectParam {
        data = typeof data === 'object' ? data : {};
        let result = new ShuttersActuatorSettingsObjectParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shutterPositionMode"] = this.shutterPositionMode;
        data["hasPUL"] = this.hasPUL;
        data["shutterMotorType"] = this.shutterMotorType;
        data["stopPulseDuration"] = this.stopPulseDuration;
        data["upDownPulseDuration"] = this.upDownPulseDuration;
        data["shutterMode"] = this.shutterMode;
        data["hasPreset"] = this.hasPreset;
        data["presetValue"] = this.presetValue;
        data["stopTime"] = this.stopTime;
        data["delayBetweenDoorsTime"] = this.delayBetweenDoorsTime;
        data["isGroupPULVisible"] = this.isGroupPULVisible;
        data["isGroupMotorTypeVisible"] = this.isGroupMotorTypeVisible;
        data["canHaveStandardAutomaticMotorType"] = this.canHaveStandardAutomaticMotorType;
        data["isGroupModeVisible"] = this.isGroupModeVisible;
        data["isGroupPresetVisible"] = this.isGroupPresetVisible;
        data["isGroupStopTimeTypeVisible"] = this.isGroupStopTimeTypeVisible;
        data["isGroupDelayBetweenDoorsVisible"] = this.isGroupDelayBetweenDoorsVisible;
        if (Array.isArray(this.stopPulseDurationPickerValues)) {
            data["stopPulseDurationPickerValues"] = [];
            for (let item of this.stopPulseDurationPickerValues)
                data["stopPulseDurationPickerValues"].push(item.toJSON());
        }
        if (Array.isArray(this.upDownPulseDurationPickerValues)) {
            data["upDownPulseDurationPickerValues"] = [];
            for (let item of this.upDownPulseDurationPickerValues)
                data["upDownPulseDurationPickerValues"].push(item.toJSON());
        }
        if (Array.isArray(this.stopTimePickerValues)) {
            data["stopTimePickerValues"] = [];
            for (let item of this.stopTimePickerValues)
                data["stopTimePickerValues"].push(item.toJSON());
        }
        if (Array.isArray(this.delayBetweenDoorsTimePickerValues)) {
            data["delayBetweenDoorsTimePickerValues"] = [];
            for (let item of this.delayBetweenDoorsTimePickerValues)
                data["delayBetweenDoorsTimePickerValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IShuttersActuatorSettingsObjectParam {
    shutterPositionMode?: ShutterPositionMode;
    hasPUL?: boolean;
    shutterMotorType?: ShutterMotorType;
    stopPulseDuration?: number;
    upDownPulseDuration?: number;
    shutterMode?: ShutterMode;
    hasPreset?: boolean;
    presetValue?: number;
    stopTime?: number;
    delayBetweenDoorsTime?: number;
    isGroupPULVisible?: boolean;
    isGroupMotorTypeVisible?: boolean;
    canHaveStandardAutomaticMotorType?: boolean;
    isGroupModeVisible?: boolean;
    isGroupPresetVisible?: boolean;
    isGroupStopTimeTypeVisible?: boolean;
    isGroupDelayBetweenDoorsVisible?: boolean;
    stopPulseDurationPickerValues?: DelayValue[] | undefined;
    upDownPulseDurationPickerValues?: DelayValue[] | undefined;
    stopTimePickerValues?: DelayValue[] | undefined;
    delayBetweenDoorsTimePickerValues?: DelayValue[] | undefined;
}

export class ShuttersCommandSettingsObjectDTO extends BaseShuttersCommandSettingsObjectDTO implements IShuttersCommandSettingsObjectDTO {
    slots?: ShutterCommandItemSettingsDTO[] | undefined;
    hasBrightness?: boolean;
    hasBrightness4Params?: boolean;
    hasProximity?: boolean;
    hasStandby?: boolean;
    hasLedIntensity?: boolean;
    hasLedModality?: boolean;
    hasRefreshFeedback?: boolean;
    hasSettings?: boolean;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    isBlind?: boolean;

    constructor(data?: IShuttersCommandSettingsObjectDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots!.push(ShutterCommandItemSettingsDTO.fromJS(item));
            }
            this.hasBrightness = _data["hasBrightness"];
            this.hasBrightness4Params = _data["hasBrightness4Params"];
            this.hasProximity = _data["hasProximity"];
            this.hasStandby = _data["hasStandby"];
            this.hasLedIntensity = _data["hasLedIntensity"];
            this.hasLedModality = _data["hasLedModality"];
            this.hasRefreshFeedback = _data["hasRefreshFeedback"];
            this.hasSettings = _data["hasSettings"];
            this.deviceBrightness = _data["deviceBrightness"];
            this.showLedsInStandby = _data["showLedsInStandby"];
            this.isProximityEnabled = _data["isProximityEnabled"];
            this.deviceProximity = _data["deviceProximity"];
            this.ledIntensity = _data["ledIntensity"];
            this.ledModality = _data["ledModality"];
            this.deviceIconsVisibility = _data["deviceIconsVisibility"];
            this.isBlind = _data["isBlind"];
        }
    }

    static fromJS(data: any): ShuttersCommandSettingsObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShuttersCommandSettingsObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item.toJSON());
        }
        data["hasBrightness"] = this.hasBrightness;
        data["hasBrightness4Params"] = this.hasBrightness4Params;
        data["hasProximity"] = this.hasProximity;
        data["hasStandby"] = this.hasStandby;
        data["hasLedIntensity"] = this.hasLedIntensity;
        data["hasLedModality"] = this.hasLedModality;
        data["hasRefreshFeedback"] = this.hasRefreshFeedback;
        data["hasSettings"] = this.hasSettings;
        data["deviceBrightness"] = this.deviceBrightness;
        data["showLedsInStandby"] = this.showLedsInStandby;
        data["isProximityEnabled"] = this.isProximityEnabled;
        data["deviceProximity"] = this.deviceProximity;
        data["ledIntensity"] = this.ledIntensity;
        data["ledModality"] = this.ledModality;
        data["deviceIconsVisibility"] = this.deviceIconsVisibility;
        data["isBlind"] = this.isBlind;
        super.toJSON(data);
        return data;
    }
}

export interface IShuttersCommandSettingsObjectDTO extends IBaseShuttersCommandSettingsObjectDTO {
    slots?: ShutterCommandItemSettingsDTO[] | undefined;
    hasBrightness?: boolean;
    hasBrightness4Params?: boolean;
    hasProximity?: boolean;
    hasStandby?: boolean;
    hasLedIntensity?: boolean;
    hasLedModality?: boolean;
    hasRefreshFeedback?: boolean;
    hasSettings?: boolean;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    isBlind?: boolean;
}

export class SimpleIntPickerValue implements ISimpleIntPickerValue {
    value?: number;
    readonly description?: string | undefined;

    constructor(data?: ISimpleIntPickerValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            (<any>this).description = _data["description"];
        }
    }

    static fromJS(data: any): SimpleIntPickerValue {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleIntPickerValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["description"] = this.description;
        return data;
    }
}

export interface ISimpleIntPickerValue {
    value?: number;
    description?: string | undefined;
}

export class Slot implements ISlot {
    configured?: boolean;
    id?: string | undefined;
    keyObject?: number;
    links_id?: string[] | undefined;
    groups_id?: string[] | undefined;
    index?: number;
    address?: string | undefined;
    status?: SlotStatus;
    linkedObjects?: LinkableObject[] | undefined;
    configurationType?: ConfigurationType;
    modalityTypeConfiguration?: ActuatorModalityType;
    thermoActuatorTypes?: { [key: string]: ThermoActuatorType; } | undefined;
    assignedComponentType?: ComponentType;
    isSetting?: boolean;
    commandIcon?: CommandIcon;
    paramsKo?: ParamCreateLinkModule[] | undefined;
    scenes_id?: ParamsScenesId[] | undefined;
    commandSettings?: CommandSettings | undefined;
    probeSettings?: ProbeSettings;
    actuatorSettings?: ActuatorSettings | undefined;
    isShutterSelfCommandActuatorSlot?: boolean;
    mX_Id_ThermoCU?: string | undefined;
    destinationLevel?: number;
    indexFather?: number;
    overWrite?: boolean;
    blockOverwiteEnabled?: boolean;

    constructor(data?: ISlot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configured = _data["configured"];
            this.id = _data["id"];
            this.keyObject = _data["keyObject"];
            if (Array.isArray(_data["links_id"])) {
                this.links_id = [] as any;
                for (let item of _data["links_id"])
                    this.links_id!.push(item);
            }
            if (Array.isArray(_data["groups_id"])) {
                this.groups_id = [] as any;
                for (let item of _data["groups_id"])
                    this.groups_id!.push(item);
            }
            this.index = _data["index"];
            this.address = _data["address"];
            this.status = _data["status"];
            if (Array.isArray(_data["linkedObjects"])) {
                this.linkedObjects = [] as any;
                for (let item of _data["linkedObjects"])
                    this.linkedObjects!.push(LinkableObject.fromJS(item));
            }
            this.configurationType = _data["configurationType"];
            this.modalityTypeConfiguration = _data["modalityTypeConfiguration"];
            if (_data["thermoActuatorTypes"]) {
                this.thermoActuatorTypes = {} as any;
                for (let key in _data["thermoActuatorTypes"]) {
                    if (_data["thermoActuatorTypes"].hasOwnProperty(key))
                        (<any>this.thermoActuatorTypes)![key] = _data["thermoActuatorTypes"][key];
                }
            }
            this.assignedComponentType = _data["assignedComponentType"];
            this.isSetting = _data["isSetting"];
            this.commandIcon = _data["commandIcon"];
            if (Array.isArray(_data["paramsKo"])) {
                this.paramsKo = [] as any;
                for (let item of _data["paramsKo"])
                    this.paramsKo!.push(ParamCreateLinkModule.fromJS(item));
            }
            if (Array.isArray(_data["scenes_id"])) {
                this.scenes_id = [] as any;
                for (let item of _data["scenes_id"])
                    this.scenes_id!.push(ParamsScenesId.fromJS(item));
            }
            this.commandSettings = _data["commandSettings"] ? CommandSettings.fromJS(_data["commandSettings"]) : <any>undefined;
            this.probeSettings = _data["probeSettings"] ? ProbeSettings.fromJS(_data["probeSettings"]) : <any>undefined;
            this.actuatorSettings = _data["actuatorSettings"] ? ActuatorSettings.fromJS(_data["actuatorSettings"]) : <any>undefined;
            this.isShutterSelfCommandActuatorSlot = _data["isShutterSelfCommandActuatorSlot"];
            this.mX_Id_ThermoCU = _data["mX_Id_ThermoCU"];
            this.destinationLevel = _data["destinationLevel"];
            this.indexFather = _data["indexFather"];
            this.overWrite = _data["overWrite"];
            this.blockOverwiteEnabled = _data["blockOverwiteEnabled"];
        }
    }

    static fromJS(data: any): Slot {
        data = typeof data === 'object' ? data : {};
        let result = new Slot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configured"] = this.configured;
        data["id"] = this.id;
        data["keyObject"] = this.keyObject;
        if (Array.isArray(this.links_id)) {
            data["links_id"] = [];
            for (let item of this.links_id)
                data["links_id"].push(item);
        }
        if (Array.isArray(this.groups_id)) {
            data["groups_id"] = [];
            for (let item of this.groups_id)
                data["groups_id"].push(item);
        }
        data["index"] = this.index;
        data["address"] = this.address;
        data["status"] = this.status;
        if (Array.isArray(this.linkedObjects)) {
            data["linkedObjects"] = [];
            for (let item of this.linkedObjects)
                data["linkedObjects"].push(item.toJSON());
        }
        data["configurationType"] = this.configurationType;
        data["modalityTypeConfiguration"] = this.modalityTypeConfiguration;
        if (this.thermoActuatorTypes) {
            data["thermoActuatorTypes"] = {};
            for (let key in this.thermoActuatorTypes) {
                if (this.thermoActuatorTypes.hasOwnProperty(key))
                    (<any>data["thermoActuatorTypes"])[key] = (<any>this.thermoActuatorTypes)[key];
            }
        }
        data["assignedComponentType"] = this.assignedComponentType;
        data["isSetting"] = this.isSetting;
        data["commandIcon"] = this.commandIcon;
        if (Array.isArray(this.paramsKo)) {
            data["paramsKo"] = [];
            for (let item of this.paramsKo)
                data["paramsKo"].push(item.toJSON());
        }
        if (Array.isArray(this.scenes_id)) {
            data["scenes_id"] = [];
            for (let item of this.scenes_id)
                data["scenes_id"].push(item.toJSON());
        }
        data["commandSettings"] = this.commandSettings ? this.commandSettings.toJSON() : <any>undefined;
        data["probeSettings"] = this.probeSettings ? this.probeSettings.toJSON() : <any>undefined;
        data["actuatorSettings"] = this.actuatorSettings ? this.actuatorSettings.toJSON() : <any>undefined;
        data["isShutterSelfCommandActuatorSlot"] = this.isShutterSelfCommandActuatorSlot;
        data["mX_Id_ThermoCU"] = this.mX_Id_ThermoCU;
        data["destinationLevel"] = this.destinationLevel;
        data["indexFather"] = this.indexFather;
        data["overWrite"] = this.overWrite;
        data["blockOverwiteEnabled"] = this.blockOverwiteEnabled;
        return data;
    }
}

export interface ISlot {
    configured?: boolean;
    id?: string | undefined;
    keyObject?: number;
    links_id?: string[] | undefined;
    groups_id?: string[] | undefined;
    index?: number;
    address?: string | undefined;
    status?: SlotStatus;
    linkedObjects?: LinkableObject[] | undefined;
    configurationType?: ConfigurationType;
    modalityTypeConfiguration?: ActuatorModalityType;
    thermoActuatorTypes?: { [key: string]: ThermoActuatorType; } | undefined;
    assignedComponentType?: ComponentType;
    isSetting?: boolean;
    commandIcon?: CommandIcon;
    paramsKo?: ParamCreateLinkModule[] | undefined;
    scenes_id?: ParamsScenesId[] | undefined;
    commandSettings?: CommandSettings | undefined;
    probeSettings?: ProbeSettings;
    actuatorSettings?: ActuatorSettings | undefined;
    isShutterSelfCommandActuatorSlot?: boolean;
    mX_Id_ThermoCU?: string | undefined;
    destinationLevel?: number;
    indexFather?: number;
    overWrite?: boolean;
    blockOverwiteEnabled?: boolean;
}

/** 0 = Configured 1 = NotConfigured 2 = NotUsed 3 = MarkedForLinking 4 = MarkedAdjacent 5 = NoLoad 6 = NoCompatible */
export enum SlotStatus {
    Configured = 0,
    NotConfigured = 1,
    NotUsed = 2,
    MarkedForLinking = 3,
    MarkedAdjacent = 4,
    NoLoad = 5,
    NoCompatible = 6,
}

export class SwitchboardConfigDTO implements ISwitchboardConfigDTO {
    switchboard?: SwitchboardDTO;
    devices?: EPDeviceDTO[] | undefined;

    constructor(data?: ISwitchboardConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.switchboard = _data["switchboard"] ? SwitchboardDTO.fromJS(_data["switchboard"]) : <any>undefined;
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(EPDeviceDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SwitchboardConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchboardConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchboard"] = this.switchboard ? this.switchboard.toJSON() : <any>undefined;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISwitchboardConfigDTO {
    switchboard?: SwitchboardDTO;
    devices?: EPDeviceDTO[] | undefined;
}

export class SwitchboardDTO implements ISwitchboardDTO {
    switchboardId?: string;
    name?: string | undefined;
    scsAddr?: number;
    index?: number;
    riserInterfaceId?: string;
    readonly inBackboneInterface?: boolean;

    constructor(data?: ISwitchboardDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.switchboardId = _data["switchboardId"];
            this.name = _data["name"];
            this.scsAddr = _data["scsAddr"];
            this.index = _data["index"];
            this.riserInterfaceId = _data["riserInterfaceId"];
            (<any>this).inBackboneInterface = _data["inBackboneInterface"];
        }
    }

    static fromJS(data: any): SwitchboardDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchboardDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchboardId"] = this.switchboardId;
        data["name"] = this.name;
        data["scsAddr"] = this.scsAddr;
        data["index"] = this.index;
        data["riserInterfaceId"] = this.riserInterfaceId;
        data["inBackboneInterface"] = this.inBackboneInterface;
        return data;
    }
}

export interface ISwitchboardDTO {
    switchboardId?: string;
    name?: string | undefined;
    scsAddr?: number;
    index?: number;
    riserInterfaceId?: string;
    inBackboneInterface?: boolean;
}

export class SyncInfo implements ISyncInfo {
    currentlySyncing?: boolean;
    startTimeStamp?: string | undefined;
    isFailed?: boolean;

    constructor(data?: ISyncInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentlySyncing = _data["currentlySyncing"];
            this.startTimeStamp = _data["startTimeStamp"];
            this.isFailed = _data["isFailed"];
        }
    }

    static fromJS(data: any): SyncInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SyncInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentlySyncing"] = this.currentlySyncing;
        data["startTimeStamp"] = this.startTimeStamp;
        data["isFailed"] = this.isFailed;
        return data;
    }
}

export interface ISyncInfo {
    currentlySyncing?: boolean;
    startTimeStamp?: string | undefined;
    isFailed?: boolean;
}

/** 0 = None 1 = OneOnOffValve 2 = OneOpenCloseValve 3 = OneProportionalValve 4 = TwoTubesOnOffValve 5 = TwoTubesProportionalValve 6 = TwoTubesProportionalSpeedControlValve 7 = FourTubesOnOffValve 8 = FourTubesProportionalValve 9 = FourTubesProportionalSpeedControlValve 10 = GatewayMode 11 = Pump */
export enum SystemControlType {
    None = 0,
    OneOnOffValve = 1,
    OneOpenCloseValve = 2,
    OneProportionalValve = 3,
    TwoTubesOnOffValve = 4,
    TwoTubesProportionalValve = 5,
    TwoTubesProportionalSpeedControlValve = 6,
    FourTubesOnOffValve = 7,
    FourTubesProportionalValve = 8,
    FourTubesProportionalSpeedControlValve = 9,
    GatewayMode = 10,
    Pump = 11,
}

/** 0 = Scs 1 = Zigbee */
export enum SystemType {
    Scs = 0,
    Zigbee = 1,
}

/** 0 = Celsius 1 = Fahrenheit */
export enum TemperatureType {
    Celsius = 0,
    Fahrenheit = 1,
}

export class ThermoActuactor implements IThermoActuactor {
    number?: number;
    function?: ThermoActuatorType;
    valve?: boolean;
    id?: string[] | undefined;

    constructor(data?: IThermoActuactor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.function = _data["function"];
            this.valve = _data["valve"];
            if (Array.isArray(_data["id"])) {
                this.id = [] as any;
                for (let item of _data["id"])
                    this.id!.push(item);
            }
        }
    }

    static fromJS(data: any): ThermoActuactor {
        data = typeof data === 'object' ? data : {};
        let result = new ThermoActuactor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["function"] = this.function;
        data["valve"] = this.valve;
        if (Array.isArray(this.id)) {
            data["id"] = [];
            for (let item of this.id)
                data["id"].push(item);
        }
        return data;
    }
}

export interface IThermoActuactor {
    number?: number;
    function?: ThermoActuatorType;
    valve?: boolean;
    id?: string[] | undefined;
}

/** 0 = None 1 = HeatingValve 2 = HeatingPump 3 = CoolingValve 4 = CoolingPump 5 = SharedValve 6 = SharedPump 7 = HeatingAndCoolingPump 8 = HeatingAndCoolingValve */
export enum ThermoActuatorType {
    None = 0,
    HeatingValve = 1,
    HeatingPump = 2,
    CoolingValve = 3,
    CoolingPump = 4,
    SharedValve = 5,
    SharedPump = 6,
    HeatingAndCoolingPump = 7,
    HeatingAndCoolingValve = 8,
}

/** 0 = None 1 = Yes 2 = No */
export enum ThermoAssociatedPump {
    None = 0,
    Yes = 1,
    No = 2,
}

export class ThermoOldInformation implements IThermoOldInformation {
    address?: string | undefined;
    links_id?: string[] | undefined;

    constructor(data?: IThermoOldInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            if (Array.isArray(_data["links_id"])) {
                this.links_id = [] as any;
                for (let item of _data["links_id"])
                    this.links_id!.push(item);
            }
        }
    }

    static fromJS(data: any): ThermoOldInformation {
        data = typeof data === 'object' ? data : {};
        let result = new ThermoOldInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        if (Array.isArray(this.links_id)) {
            data["links_id"] = [];
            for (let item of this.links_id)
                data["links_id"].push(item);
        }
        return data;
    }
}

export interface IThermoOldInformation {
    address?: string | undefined;
    links_id?: string[] | undefined;
}

export class ThermoProbeSettingsObjectParam implements IThermoProbeSettingsObjectParam {
    isLedmanaged?: boolean;
    externalSensorType?: ExternalSensorType;
    isLedmanagedVisible?: boolean;
    isExternalSensorTypeVisible?: boolean;

    constructor(data?: IThermoProbeSettingsObjectParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isLedmanaged = _data["isLedmanaged"];
            this.externalSensorType = _data["externalSensorType"];
            this.isLedmanagedVisible = _data["isLedmanagedVisible"];
            this.isExternalSensorTypeVisible = _data["isExternalSensorTypeVisible"];
        }
    }

    static fromJS(data: any): ThermoProbeSettingsObjectParam {
        data = typeof data === 'object' ? data : {};
        let result = new ThermoProbeSettingsObjectParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isLedmanaged"] = this.isLedmanaged;
        data["externalSensorType"] = this.externalSensorType;
        data["isLedmanagedVisible"] = this.isLedmanagedVisible;
        data["isExternalSensorTypeVisible"] = this.isExternalSensorTypeVisible;
        return data;
    }
}

export interface IThermoProbeSettingsObjectParam {
    isLedmanaged?: boolean;
    externalSensorType?: ExternalSensorType;
    isLedmanagedVisible?: boolean;
    isExternalSensorTypeVisible?: boolean;
}

export class ThermoProbeSettingsResult implements IThermoProbeSettingsResult {
    isLedmanaged?: boolean;
    externalSensorType?: ExternalSensorType;

    constructor(data?: IThermoProbeSettingsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isLedmanaged = _data["isLedmanaged"];
            this.externalSensorType = _data["externalSensorType"];
        }
    }

    static fromJS(data: any): ThermoProbeSettingsResult {
        data = typeof data === 'object' ? data : {};
        let result = new ThermoProbeSettingsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isLedmanaged"] = this.isLedmanaged;
        data["externalSensorType"] = this.externalSensorType;
        return data;
    }
}

export interface IThermoProbeSettingsResult {
    isLedmanaged?: boolean;
    externalSensorType?: ExternalSensorType;
}

export class ThermoRoomObjectDTO implements IThermoRoomObjectDTO {
    id?: string | undefined;
    name?: string | undefined;
    devices?: DeviceDTO[] | undefined;
    type?: RoomObjectType;
    thermoTypeOfObject?: ThermoTypeOfObject;
    thermoAssociatedPump?: ThermoAssociatedPump;
    actuatorModalityType?: ActuatorModalityType;
    heatingSystemControlType?: SystemControlType;
    coolingSystemControlType?: SystemControlType;
    sharedSystemControlType?: SystemControlType;
    configurationSteps?: number;
    nextStep?: number;
    objectDuplication?: ObjectDuplication;
    resetType?: ResetType;
    newRoom?: Room;
    isDetailDeviceFlow?: boolean;
    isCompromised?: boolean;
    isApplyAllTemperatureRange?: boolean;
    heatingSetpointLow?: number;
    heatingSetpointHigh?: number;
    heatingAntifreeze?: number;
    coolingSetpointLow?: number;
    coolingSetpointHigh?: number;
    coolingThermalProtection?: number;
    isAutoCommutation?: boolean;
    isApplyAllCirculationPumpDelay?: boolean;
    delayHeatingPumps?: string;
    delayCoolingPumps?: string;
    isApplyAllCelsiusFahrenheit?: boolean;
    temperatureType?: TemperatureType;
    isApplyAllButtonsManagement?: boolean;
    areButtonsEnabled?: boolean;
    externalSensorType?: ExternalSensorType;
    isApplyAllBacklight?: boolean;
    isBacklightEnabled?: boolean;
    backlightLevel?: number;
    isManualHeatingOverrideEnabled?: boolean;
    heatingRegulationBand?: number;
    fanSpeed2ForHeating?: number;
    fanSpeed3ForHeating?: number;
    valvesTimeForHeatingFanCoil?: string;
    isManualCoolingOverrideEnabled?: boolean;
    coolingRegulationBand?: number;
    fanSpeed2ForCooling?: number;
    fanSpeed3ForCooling?: number;
    valvesTimeForCoolingFanCoil?: string;
    isApplyAllWindowsContact?: boolean;
    isIconAlwaysOff?: boolean;
    isLocalContactNumberEnabled?: boolean;
    numberOfWindowsContact?: number;
    openingContactTypeHeating?: ContactType;
    openingContactTempHeating?: number;
    openingContactDelayHeating?: string;
    timeoutOpeningHeating?: string;
    closingContactTypeHeating?: ContactType;
    closingContactTempHeating?: number;
    closingContactDelayHeating?: string;
    timeoutClosingHeating?: string;
    openingContactTypeCooling?: ContactType;
    openingContactTempCooling?: number;
    openingContactDelayCooling?: string;
    timeoutOpeningCooling?: string;
    closingContactTypeCooling?: ContactType;
    closingContactTempCooling?: number;
    closingContactDelayCooling?: string;
    timeoutClosingCooling?: string;
    isInterlockingExcluded?: boolean;
    isWaterCycleEnabled?: boolean;
    arePumpsOpenedAutomatically?: boolean;
    minutesToKeepOpen?: string;
    openAutomaticallyDaysDelay?: number;
    pumpsDelay?: string;
    thermoUKFanSpeed?: number;
    thermoUKFanSpeed2?: number;
    thermoUKFanSpeed3?: number;
    plantId?: string | undefined;
    roomId?: string | undefined;
    extDevices?: ExtDevice[] | undefined;
    roomObjectType?: RoomObjectType;
    isNotFullyConfigured?: boolean;
    isEdit?: boolean;
    isApplyAllTemperatureVisualization?: boolean;
    isTemperatureDisplayed?: boolean;
    isCoolingVentilationEnabled?: boolean;
    isHeatingVentilationEnabled?: boolean;
    timeoutCoolingVentilation?: string;
    timeoutHeatingVentilation?: string;
    thermoOldInformation?: ThermoOldInformation;
    thermo?: ThermoActuactor[] | undefined;
    tempAddressPumps?: AddressPumps[] | undefined;
    isContactInError?: boolean;
    isGroupFlow?: boolean;
    isSceneFlow?: boolean;

    constructor(data?: IThermoRoomObjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(DeviceDTO.fromJS(item));
            }
            this.type = _data["type"];
            this.thermoTypeOfObject = _data["thermoTypeOfObject"];
            this.thermoAssociatedPump = _data["thermoAssociatedPump"];
            this.actuatorModalityType = _data["actuatorModalityType"];
            this.heatingSystemControlType = _data["heatingSystemControlType"];
            this.coolingSystemControlType = _data["coolingSystemControlType"];
            this.sharedSystemControlType = _data["sharedSystemControlType"];
            this.configurationSteps = _data["configurationSteps"];
            this.nextStep = _data["nextStep"];
            this.objectDuplication = _data["objectDuplication"];
            this.resetType = _data["resetType"];
            this.newRoom = _data["newRoom"] ? Room.fromJS(_data["newRoom"]) : <any>undefined;
            this.isDetailDeviceFlow = _data["isDetailDeviceFlow"];
            this.isCompromised = _data["isCompromised"];
            this.isApplyAllTemperatureRange = _data["isApplyAllTemperatureRange"];
            this.heatingSetpointLow = _data["heatingSetpointLow"];
            this.heatingSetpointHigh = _data["heatingSetpointHigh"];
            this.heatingAntifreeze = _data["heatingAntifreeze"];
            this.coolingSetpointLow = _data["coolingSetpointLow"];
            this.coolingSetpointHigh = _data["coolingSetpointHigh"];
            this.coolingThermalProtection = _data["coolingThermalProtection"];
            this.isAutoCommutation = _data["isAutoCommutation"];
            this.isApplyAllCirculationPumpDelay = _data["isApplyAllCirculationPumpDelay"];
            this.delayHeatingPumps = _data["delayHeatingPumps"];
            this.delayCoolingPumps = _data["delayCoolingPumps"];
            this.isApplyAllCelsiusFahrenheit = _data["isApplyAllCelsiusFahrenheit"];
            this.temperatureType = _data["temperatureType"];
            this.isApplyAllButtonsManagement = _data["isApplyAllButtonsManagement"];
            this.areButtonsEnabled = _data["areButtonsEnabled"];
            this.externalSensorType = _data["externalSensorType"];
            this.isApplyAllBacklight = _data["isApplyAllBacklight"];
            this.isBacklightEnabled = _data["isBacklightEnabled"];
            this.backlightLevel = _data["backlightLevel"];
            this.isManualHeatingOverrideEnabled = _data["isManualHeatingOverrideEnabled"];
            this.heatingRegulationBand = _data["heatingRegulationBand"];
            this.fanSpeed2ForHeating = _data["fanSpeed2ForHeating"];
            this.fanSpeed3ForHeating = _data["fanSpeed3ForHeating"];
            this.valvesTimeForHeatingFanCoil = _data["valvesTimeForHeatingFanCoil"];
            this.isManualCoolingOverrideEnabled = _data["isManualCoolingOverrideEnabled"];
            this.coolingRegulationBand = _data["coolingRegulationBand"];
            this.fanSpeed2ForCooling = _data["fanSpeed2ForCooling"];
            this.fanSpeed3ForCooling = _data["fanSpeed3ForCooling"];
            this.valvesTimeForCoolingFanCoil = _data["valvesTimeForCoolingFanCoil"];
            this.isApplyAllWindowsContact = _data["isApplyAllWindowsContact"];
            this.isIconAlwaysOff = _data["isIconAlwaysOff"];
            this.isLocalContactNumberEnabled = _data["isLocalContactNumberEnabled"];
            this.numberOfWindowsContact = _data["numberOfWindowsContact"];
            this.openingContactTypeHeating = _data["openingContactTypeHeating"];
            this.openingContactTempHeating = _data["openingContactTempHeating"];
            this.openingContactDelayHeating = _data["openingContactDelayHeating"];
            this.timeoutOpeningHeating = _data["timeoutOpeningHeating"];
            this.closingContactTypeHeating = _data["closingContactTypeHeating"];
            this.closingContactTempHeating = _data["closingContactTempHeating"];
            this.closingContactDelayHeating = _data["closingContactDelayHeating"];
            this.timeoutClosingHeating = _data["timeoutClosingHeating"];
            this.openingContactTypeCooling = _data["openingContactTypeCooling"];
            this.openingContactTempCooling = _data["openingContactTempCooling"];
            this.openingContactDelayCooling = _data["openingContactDelayCooling"];
            this.timeoutOpeningCooling = _data["timeoutOpeningCooling"];
            this.closingContactTypeCooling = _data["closingContactTypeCooling"];
            this.closingContactTempCooling = _data["closingContactTempCooling"];
            this.closingContactDelayCooling = _data["closingContactDelayCooling"];
            this.timeoutClosingCooling = _data["timeoutClosingCooling"];
            this.isInterlockingExcluded = _data["isInterlockingExcluded"];
            this.isWaterCycleEnabled = _data["isWaterCycleEnabled"];
            this.arePumpsOpenedAutomatically = _data["arePumpsOpenedAutomatically"];
            this.minutesToKeepOpen = _data["minutesToKeepOpen"];
            this.openAutomaticallyDaysDelay = _data["openAutomaticallyDaysDelay"];
            this.pumpsDelay = _data["pumpsDelay"];
            this.thermoUKFanSpeed = _data["thermoUKFanSpeed"];
            this.thermoUKFanSpeed2 = _data["thermoUKFanSpeed2"];
            this.thermoUKFanSpeed3 = _data["thermoUKFanSpeed3"];
            this.plantId = _data["plantId"];
            this.roomId = _data["roomId"];
            if (Array.isArray(_data["extDevices"])) {
                this.extDevices = [] as any;
                for (let item of _data["extDevices"])
                    this.extDevices!.push(ExtDevice.fromJS(item));
            }
            this.roomObjectType = _data["roomObjectType"];
            this.isNotFullyConfigured = _data["isNotFullyConfigured"];
            this.isEdit = _data["isEdit"];
            this.isApplyAllTemperatureVisualization = _data["isApplyAllTemperatureVisualization"];
            this.isTemperatureDisplayed = _data["isTemperatureDisplayed"];
            this.isCoolingVentilationEnabled = _data["isCoolingVentilationEnabled"];
            this.isHeatingVentilationEnabled = _data["isHeatingVentilationEnabled"];
            this.timeoutCoolingVentilation = _data["timeoutCoolingVentilation"];
            this.timeoutHeatingVentilation = _data["timeoutHeatingVentilation"];
            this.thermoOldInformation = _data["thermoOldInformation"] ? ThermoOldInformation.fromJS(_data["thermoOldInformation"]) : <any>undefined;
            if (Array.isArray(_data["thermo"])) {
                this.thermo = [] as any;
                for (let item of _data["thermo"])
                    this.thermo!.push(ThermoActuactor.fromJS(item));
            }
            if (Array.isArray(_data["tempAddressPumps"])) {
                this.tempAddressPumps = [] as any;
                for (let item of _data["tempAddressPumps"])
                    this.tempAddressPumps!.push(AddressPumps.fromJS(item));
            }
            this.isContactInError = _data["isContactInError"];
            this.isGroupFlow = _data["isGroupFlow"];
            this.isSceneFlow = _data["isSceneFlow"];
        }
    }

    static fromJS(data: any): ThermoRoomObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ThermoRoomObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["type"] = this.type;
        data["thermoTypeOfObject"] = this.thermoTypeOfObject;
        data["thermoAssociatedPump"] = this.thermoAssociatedPump;
        data["actuatorModalityType"] = this.actuatorModalityType;
        data["heatingSystemControlType"] = this.heatingSystemControlType;
        data["coolingSystemControlType"] = this.coolingSystemControlType;
        data["sharedSystemControlType"] = this.sharedSystemControlType;
        data["configurationSteps"] = this.configurationSteps;
        data["nextStep"] = this.nextStep;
        data["objectDuplication"] = this.objectDuplication;
        data["resetType"] = this.resetType;
        data["newRoom"] = this.newRoom ? this.newRoom.toJSON() : <any>undefined;
        data["isDetailDeviceFlow"] = this.isDetailDeviceFlow;
        data["isCompromised"] = this.isCompromised;
        data["isApplyAllTemperatureRange"] = this.isApplyAllTemperatureRange;
        data["heatingSetpointLow"] = this.heatingSetpointLow;
        data["heatingSetpointHigh"] = this.heatingSetpointHigh;
        data["heatingAntifreeze"] = this.heatingAntifreeze;
        data["coolingSetpointLow"] = this.coolingSetpointLow;
        data["coolingSetpointHigh"] = this.coolingSetpointHigh;
        data["coolingThermalProtection"] = this.coolingThermalProtection;
        data["isAutoCommutation"] = this.isAutoCommutation;
        data["isApplyAllCirculationPumpDelay"] = this.isApplyAllCirculationPumpDelay;
        data["delayHeatingPumps"] = this.delayHeatingPumps;
        data["delayCoolingPumps"] = this.delayCoolingPumps;
        data["isApplyAllCelsiusFahrenheit"] = this.isApplyAllCelsiusFahrenheit;
        data["temperatureType"] = this.temperatureType;
        data["isApplyAllButtonsManagement"] = this.isApplyAllButtonsManagement;
        data["areButtonsEnabled"] = this.areButtonsEnabled;
        data["externalSensorType"] = this.externalSensorType;
        data["isApplyAllBacklight"] = this.isApplyAllBacklight;
        data["isBacklightEnabled"] = this.isBacklightEnabled;
        data["backlightLevel"] = this.backlightLevel;
        data["isManualHeatingOverrideEnabled"] = this.isManualHeatingOverrideEnabled;
        data["heatingRegulationBand"] = this.heatingRegulationBand;
        data["fanSpeed2ForHeating"] = this.fanSpeed2ForHeating;
        data["fanSpeed3ForHeating"] = this.fanSpeed3ForHeating;
        data["valvesTimeForHeatingFanCoil"] = this.valvesTimeForHeatingFanCoil;
        data["isManualCoolingOverrideEnabled"] = this.isManualCoolingOverrideEnabled;
        data["coolingRegulationBand"] = this.coolingRegulationBand;
        data["fanSpeed2ForCooling"] = this.fanSpeed2ForCooling;
        data["fanSpeed3ForCooling"] = this.fanSpeed3ForCooling;
        data["valvesTimeForCoolingFanCoil"] = this.valvesTimeForCoolingFanCoil;
        data["isApplyAllWindowsContact"] = this.isApplyAllWindowsContact;
        data["isIconAlwaysOff"] = this.isIconAlwaysOff;
        data["isLocalContactNumberEnabled"] = this.isLocalContactNumberEnabled;
        data["numberOfWindowsContact"] = this.numberOfWindowsContact;
        data["openingContactTypeHeating"] = this.openingContactTypeHeating;
        data["openingContactTempHeating"] = this.openingContactTempHeating;
        data["openingContactDelayHeating"] = this.openingContactDelayHeating;
        data["timeoutOpeningHeating"] = this.timeoutOpeningHeating;
        data["closingContactTypeHeating"] = this.closingContactTypeHeating;
        data["closingContactTempHeating"] = this.closingContactTempHeating;
        data["closingContactDelayHeating"] = this.closingContactDelayHeating;
        data["timeoutClosingHeating"] = this.timeoutClosingHeating;
        data["openingContactTypeCooling"] = this.openingContactTypeCooling;
        data["openingContactTempCooling"] = this.openingContactTempCooling;
        data["openingContactDelayCooling"] = this.openingContactDelayCooling;
        data["timeoutOpeningCooling"] = this.timeoutOpeningCooling;
        data["closingContactTypeCooling"] = this.closingContactTypeCooling;
        data["closingContactTempCooling"] = this.closingContactTempCooling;
        data["closingContactDelayCooling"] = this.closingContactDelayCooling;
        data["timeoutClosingCooling"] = this.timeoutClosingCooling;
        data["isInterlockingExcluded"] = this.isInterlockingExcluded;
        data["isWaterCycleEnabled"] = this.isWaterCycleEnabled;
        data["arePumpsOpenedAutomatically"] = this.arePumpsOpenedAutomatically;
        data["minutesToKeepOpen"] = this.minutesToKeepOpen;
        data["openAutomaticallyDaysDelay"] = this.openAutomaticallyDaysDelay;
        data["pumpsDelay"] = this.pumpsDelay;
        data["thermoUKFanSpeed"] = this.thermoUKFanSpeed;
        data["thermoUKFanSpeed2"] = this.thermoUKFanSpeed2;
        data["thermoUKFanSpeed3"] = this.thermoUKFanSpeed3;
        data["plantId"] = this.plantId;
        data["roomId"] = this.roomId;
        if (Array.isArray(this.extDevices)) {
            data["extDevices"] = [];
            for (let item of this.extDevices)
                data["extDevices"].push(item.toJSON());
        }
        data["roomObjectType"] = this.roomObjectType;
        data["isNotFullyConfigured"] = this.isNotFullyConfigured;
        data["isEdit"] = this.isEdit;
        data["isApplyAllTemperatureVisualization"] = this.isApplyAllTemperatureVisualization;
        data["isTemperatureDisplayed"] = this.isTemperatureDisplayed;
        data["isCoolingVentilationEnabled"] = this.isCoolingVentilationEnabled;
        data["isHeatingVentilationEnabled"] = this.isHeatingVentilationEnabled;
        data["timeoutCoolingVentilation"] = this.timeoutCoolingVentilation;
        data["timeoutHeatingVentilation"] = this.timeoutHeatingVentilation;
        data["thermoOldInformation"] = this.thermoOldInformation ? this.thermoOldInformation.toJSON() : <any>undefined;
        if (Array.isArray(this.thermo)) {
            data["thermo"] = [];
            for (let item of this.thermo)
                data["thermo"].push(item.toJSON());
        }
        if (Array.isArray(this.tempAddressPumps)) {
            data["tempAddressPumps"] = [];
            for (let item of this.tempAddressPumps)
                data["tempAddressPumps"].push(item.toJSON());
        }
        data["isContactInError"] = this.isContactInError;
        data["isGroupFlow"] = this.isGroupFlow;
        data["isSceneFlow"] = this.isSceneFlow;
        return data;
    }
}

export interface IThermoRoomObjectDTO {
    id?: string | undefined;
    name?: string | undefined;
    devices?: DeviceDTO[] | undefined;
    type?: RoomObjectType;
    thermoTypeOfObject?: ThermoTypeOfObject;
    thermoAssociatedPump?: ThermoAssociatedPump;
    actuatorModalityType?: ActuatorModalityType;
    heatingSystemControlType?: SystemControlType;
    coolingSystemControlType?: SystemControlType;
    sharedSystemControlType?: SystemControlType;
    configurationSteps?: number;
    nextStep?: number;
    objectDuplication?: ObjectDuplication;
    resetType?: ResetType;
    newRoom?: Room;
    isDetailDeviceFlow?: boolean;
    isCompromised?: boolean;
    isApplyAllTemperatureRange?: boolean;
    heatingSetpointLow?: number;
    heatingSetpointHigh?: number;
    heatingAntifreeze?: number;
    coolingSetpointLow?: number;
    coolingSetpointHigh?: number;
    coolingThermalProtection?: number;
    isAutoCommutation?: boolean;
    isApplyAllCirculationPumpDelay?: boolean;
    delayHeatingPumps?: string;
    delayCoolingPumps?: string;
    isApplyAllCelsiusFahrenheit?: boolean;
    temperatureType?: TemperatureType;
    isApplyAllButtonsManagement?: boolean;
    areButtonsEnabled?: boolean;
    externalSensorType?: ExternalSensorType;
    isApplyAllBacklight?: boolean;
    isBacklightEnabled?: boolean;
    backlightLevel?: number;
    isManualHeatingOverrideEnabled?: boolean;
    heatingRegulationBand?: number;
    fanSpeed2ForHeating?: number;
    fanSpeed3ForHeating?: number;
    valvesTimeForHeatingFanCoil?: string;
    isManualCoolingOverrideEnabled?: boolean;
    coolingRegulationBand?: number;
    fanSpeed2ForCooling?: number;
    fanSpeed3ForCooling?: number;
    valvesTimeForCoolingFanCoil?: string;
    isApplyAllWindowsContact?: boolean;
    isIconAlwaysOff?: boolean;
    isLocalContactNumberEnabled?: boolean;
    numberOfWindowsContact?: number;
    openingContactTypeHeating?: ContactType;
    openingContactTempHeating?: number;
    openingContactDelayHeating?: string;
    timeoutOpeningHeating?: string;
    closingContactTypeHeating?: ContactType;
    closingContactTempHeating?: number;
    closingContactDelayHeating?: string;
    timeoutClosingHeating?: string;
    openingContactTypeCooling?: ContactType;
    openingContactTempCooling?: number;
    openingContactDelayCooling?: string;
    timeoutOpeningCooling?: string;
    closingContactTypeCooling?: ContactType;
    closingContactTempCooling?: number;
    closingContactDelayCooling?: string;
    timeoutClosingCooling?: string;
    isInterlockingExcluded?: boolean;
    isWaterCycleEnabled?: boolean;
    arePumpsOpenedAutomatically?: boolean;
    minutesToKeepOpen?: string;
    openAutomaticallyDaysDelay?: number;
    pumpsDelay?: string;
    thermoUKFanSpeed?: number;
    thermoUKFanSpeed2?: number;
    thermoUKFanSpeed3?: number;
    plantId?: string | undefined;
    roomId?: string | undefined;
    extDevices?: ExtDevice[] | undefined;
    roomObjectType?: RoomObjectType;
    isNotFullyConfigured?: boolean;
    isEdit?: boolean;
    isApplyAllTemperatureVisualization?: boolean;
    isTemperatureDisplayed?: boolean;
    isCoolingVentilationEnabled?: boolean;
    isHeatingVentilationEnabled?: boolean;
    timeoutCoolingVentilation?: string;
    timeoutHeatingVentilation?: string;
    thermoOldInformation?: ThermoOldInformation;
    thermo?: ThermoActuactor[] | undefined;
    tempAddressPumps?: AddressPumps[] | undefined;
    isContactInError?: boolean;
    isGroupFlow?: boolean;
    isSceneFlow?: boolean;
}

/** 0 = None 1 = Heating 2 = Cooling 3 = HeatingAndCooling */
export enum ThermoTypeOfObject {
    None = 0,
    Heating = 1,
    Cooling = 2,
    HeatingAndCooling = 3,
}

/** 0 = Off 1 = Heat 2 = Cool 3 = Auto 4 = None */
export enum ThermostatStatus {
    Off = 0,
    Heat = 1,
    Cool = 2,
    Auto = 3,
    None = 4,
}

export class TimeCondition extends Condition implements ITimeCondition {
    startTime?: string;
    endTime?: string;
    weekDays?: WeekDay[] | undefined;

    constructor(data?: ITimeCondition) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            if (Array.isArray(_data["weekDays"])) {
                this.weekDays = [] as any;
                for (let item of _data["weekDays"])
                    this.weekDays!.push(item);
            }
        }
    }

    static fromJS(data: any): TimeCondition {
        data = typeof data === 'object' ? data : {};
        let result = new TimeCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        if (Array.isArray(this.weekDays)) {
            data["weekDays"] = [];
            for (let item of this.weekDays)
                data["weekDays"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITimeCondition extends ICondition {
    startTime?: string;
    endTime?: string;
    weekDays?: WeekDay[] | undefined;
}

export class TimeSlot implements ITimeSlot {
    id?: string;
    timeSince?: Date;
    timeUntil?: Date;

    constructor(data?: ITimeSlot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.timeSince = _data["timeSince"] ? new Date(_data["timeSince"].toString()) : <any>undefined;
            this.timeUntil = _data["timeUntil"] ? new Date(_data["timeUntil"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeSlot {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSlot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timeSince"] = this.timeSince ? this.timeSince.toISOString() : <any>undefined;
        data["timeUntil"] = this.timeUntil ? this.timeUntil.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITimeSlot {
    id?: string;
    timeSince?: Date;
    timeUntil?: Date;
}

/** 0 = None 1 = Onedirection 2 = Boththedirections */
export enum ToroidDirection {
    None = 0,
    Onedirection = 1,
    Boththedirections = 2,
}

export class TransferOwnershipDTO implements ITransferOwnershipDTO {
    password?: string | undefined;
    shouldCurrentUserRightsBeRemoved?: boolean | undefined;

    constructor(data?: ITransferOwnershipDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.shouldCurrentUserRightsBeRemoved = _data["shouldCurrentUserRightsBeRemoved"];
        }
    }

    static fromJS(data: any): TransferOwnershipDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TransferOwnershipDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["shouldCurrentUserRightsBeRemoved"] = this.shouldCurrentUserRightsBeRemoved;
        return data;
    }
}

export interface ITransferOwnershipDTO {
    password?: string | undefined;
    shouldCurrentUserRightsBeRemoved?: boolean | undefined;
}

export class TriggerDTO implements ITriggerDTO {
    objectName?: string | undefined;
    sceneObjectType?: SceneObjectType;
    energyObjectType?: EnergyMeterAndLoadControlType;
    triggerParams?: Trigger | undefined;

    constructor(data?: ITriggerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectName = _data["objectName"];
            this.sceneObjectType = _data["sceneObjectType"];
            this.energyObjectType = _data["energyObjectType"];
            this.triggerParams = _data["triggerParams"] ? Trigger.fromJS(_data["triggerParams"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TriggerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectName"] = this.objectName;
        data["sceneObjectType"] = this.sceneObjectType;
        data["energyObjectType"] = this.energyObjectType;
        data["triggerParams"] = this.triggerParams ? this.triggerParams.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITriggerDTO {
    objectName?: string | undefined;
    sceneObjectType?: SceneObjectType;
    energyObjectType?: EnergyMeterAndLoadControlType;
    triggerParams?: Trigger | undefined;
}

export class TriggersAndConditionsRoomItemDTO implements ITriggersAndConditionsRoomItemDTO {
    roomObjects?: TriggersAndConditionsRoomObjectItemDTO[] | undefined;
    name?: string | undefined;
    type?: RoomType;

    constructor(data?: ITriggersAndConditionsRoomItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roomObjects"])) {
                this.roomObjects = [] as any;
                for (let item of _data["roomObjects"])
                    this.roomObjects!.push(TriggersAndConditionsRoomObjectItemDTO.fromJS(item));
            }
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): TriggersAndConditionsRoomItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TriggersAndConditionsRoomItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roomObjects)) {
            data["roomObjects"] = [];
            for (let item of this.roomObjects)
                data["roomObjects"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface ITriggersAndConditionsRoomItemDTO {
    roomObjects?: TriggersAndConditionsRoomObjectItemDTO[] | undefined;
    name?: string | undefined;
    type?: RoomType;
}

export class TriggersAndConditionsRoomObjectItemDTO implements ITriggersAndConditionsRoomObjectItemDTO {
    id?: string | undefined;
    plantId?: string | undefined;
    sceneObjectType?: SceneObjectType;
    energyObjectType?: EnergyMeterAndLoadControlType;
    name?: string | undefined;

    constructor(data?: ITriggersAndConditionsRoomObjectItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plantId = _data["plantId"];
            this.sceneObjectType = _data["sceneObjectType"];
            this.energyObjectType = _data["energyObjectType"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TriggersAndConditionsRoomObjectItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TriggersAndConditionsRoomObjectItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plantId"] = this.plantId;
        data["sceneObjectType"] = this.sceneObjectType;
        data["energyObjectType"] = this.energyObjectType;
        data["name"] = this.name;
        return data;
    }
}

export interface ITriggersAndConditionsRoomObjectItemDTO {
    id?: string | undefined;
    plantId?: string | undefined;
    sceneObjectType?: SceneObjectType;
    energyObjectType?: EnergyMeterAndLoadControlType;
    name?: string | undefined;
}

export class UserDTO implements IUserDTO {
    id?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;

    constructor(data?: IUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        return data;
    }
}

export interface IUserDTO {
    id?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
}

export class WaitTimeAction extends Action implements IWaitTimeAction {
    waitTime?: string;

    constructor(data?: IWaitTimeAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.waitTime = _data["waitTime"];
        }
    }

    static fromJS(data: any): WaitTimeAction {
        data = typeof data === 'object' ? data : {};
        let result = new WaitTimeAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waitTime"] = this.waitTime;
        super.toJSON(data);
        return data;
    }
}

export interface IWaitTimeAction extends IAction {
    waitTime?: string;
}

export class WeatherCondition extends Condition implements IWeatherCondition {
    weatherStateComparer?: SceneStateComparer;
    weatherTemperature?: number;
    sceneWeatherModality?: SceneWeatherModality;
    weatherWindSpeed?: number;
    humidityPercentage?: number;
    sceneWeatherForecastState?: SceneWeatherForecastState;
    sceneWeatherCrepuscular?: SceneWeatherCrepuscular;

    constructor(data?: IWeatherCondition) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.weatherStateComparer = _data["weatherStateComparer"];
            this.weatherTemperature = _data["weatherTemperature"];
            this.sceneWeatherModality = _data["sceneWeatherModality"];
            this.weatherWindSpeed = _data["weatherWindSpeed"];
            this.humidityPercentage = _data["humidityPercentage"];
            this.sceneWeatherForecastState = _data["sceneWeatherForecastState"];
            this.sceneWeatherCrepuscular = _data["sceneWeatherCrepuscular"];
        }
    }

    static fromJS(data: any): WeatherCondition {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weatherStateComparer"] = this.weatherStateComparer;
        data["weatherTemperature"] = this.weatherTemperature;
        data["sceneWeatherModality"] = this.sceneWeatherModality;
        data["weatherWindSpeed"] = this.weatherWindSpeed;
        data["humidityPercentage"] = this.humidityPercentage;
        data["sceneWeatherForecastState"] = this.sceneWeatherForecastState;
        data["sceneWeatherCrepuscular"] = this.sceneWeatherCrepuscular;
        super.toJSON(data);
        return data;
    }
}

export interface IWeatherCondition extends ICondition {
    weatherStateComparer?: SceneStateComparer;
    weatherTemperature?: number;
    sceneWeatherModality?: SceneWeatherModality;
    weatherWindSpeed?: number;
    humidityPercentage?: number;
    sceneWeatherForecastState?: SceneWeatherForecastState;
    sceneWeatherCrepuscular?: SceneWeatherCrepuscular;
}

export class WeatherTrigger extends Trigger implements IWeatherTrigger {
    weatherStateComparer?: SceneStateComparer;
    weatherTemperature?: number;
    sceneWeatherModality?: SceneWeatherModality;
    weatherWindSpeed?: number;
    humidityPercentage?: number;
    sceneWeatherForecastState?: SceneWeatherForecastState;
    sceneWeatherCrepuscular?: SceneWeatherCrepuscular;

    constructor(data?: IWeatherTrigger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.weatherStateComparer = _data["weatherStateComparer"];
            this.weatherTemperature = _data["weatherTemperature"];
            this.sceneWeatherModality = _data["sceneWeatherModality"];
            this.weatherWindSpeed = _data["weatherWindSpeed"];
            this.humidityPercentage = _data["humidityPercentage"];
            this.sceneWeatherForecastState = _data["sceneWeatherForecastState"];
            this.sceneWeatherCrepuscular = _data["sceneWeatherCrepuscular"];
        }
    }

    static fromJS(data: any): WeatherTrigger {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherTrigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weatherStateComparer"] = this.weatherStateComparer;
        data["weatherTemperature"] = this.weatherTemperature;
        data["sceneWeatherModality"] = this.sceneWeatherModality;
        data["weatherWindSpeed"] = this.weatherWindSpeed;
        data["humidityPercentage"] = this.humidityPercentage;
        data["sceneWeatherForecastState"] = this.sceneWeatherForecastState;
        data["sceneWeatherCrepuscular"] = this.sceneWeatherCrepuscular;
        super.toJSON(data);
        return data;
    }
}

export interface IWeatherTrigger extends ITrigger {
    weatherStateComparer?: SceneStateComparer;
    weatherTemperature?: number;
    sceneWeatherModality?: SceneWeatherModality;
    weatherWindSpeed?: number;
    humidityPercentage?: number;
    sceneWeatherForecastState?: SceneWeatherForecastState;
    sceneWeatherCrepuscular?: SceneWeatherCrepuscular;
}

/** 0 = Monday 1 = Tuesday 2 = Wednesday 3 = Thursday 4 = Friday 5 = Saturday 6 = Sunday */
export enum WeekDay {
    Monday = 0,
    Tuesday = 1,
    Wednesday = 2,
    Thursday = 3,
    Friday = 4,
    Saturday = 5,
    Sunday = 6,
}

export class XmeterExtDevice extends ExtDevice implements IXmeterExtDevice {
    readonly address?: string | undefined;

    constructor(data?: IXmeterExtDevice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            (<any>this).address = _data["address"];
        }
    }

    static fromJS(data: any): XmeterExtDevice {
        data = typeof data === 'object' ? data : {};
        let result = new XmeterExtDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        super.toJSON(data);
        return data;
    }
}

export interface IXmeterExtDevice extends IExtDevice {
    address?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}